export const mockData = [
  {
    "places": [
      {
        "id": "ChIJJc1VagAtDogRzTjxHkcFlWM",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Millenium Park, 201 E Randolph St, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.882677799999996,
          "longitude": -87.6233046
        },
        "rating": 4.8,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 9,
        "displayName": {
          "text": "Cloud Gate (the bean) & Augmented Chicago",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWqM0oGGHBTrwmC-SVdF51yMYCPWGjeOS7fRnVc3jluUk0h2uQWaj9lny5nnCJ-z6b0cYCG1lwOcqoySyYqh6fRZTQ5E1sryv6aS2HV0cvLWXs8EwsXI_htb0AwBaghK6Qz4c0QJy-xYtRb47FMzbOsjU9MYYrj9-2AZ",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Henry Landsem",
                "uri": "https://maps.google.com/maps/contrib/105749723706191026388",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK7_4CJSJUaV4_tjYdm-dKBgHkGdDt-HLNMbwMfqyd-Cdgtfic=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPr_WbmTAFyErKRiFilACz7PnExHATQ_jBuC9Zg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPr_WbmTAFyErKRiFilACz7PnExHATQ_jBuC9Zg!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          },
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWpn6_zemW4xxmY4j3gK9ns8tI1Mmp16NN7PsbVpqC1NKc4_pxY_JloIbOhf2-m7EkqE8Th37uk0TwQF3CJrNjtgKwL2XTMNnNMYe0BJ9q52qOYQtxv3iOCWupu6dnnrZ9ZjKur3o_UQTOxCHs8YHefPrjF3S0SkdDor",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Henry Landsem",
                "uri": "https://maps.google.com/maps/contrib/105749723706191026388",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK7_4CJSJUaV4_tjYdm-dKBgHkGdDt-HLNMbwMfqyd-Cdgtfic=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOgHqgWn7JOuVbQl2u_14BQcqVzWgfk6sOqMRA6&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOgHqgWn7JOuVbQl2u_14BQcqVzWgfk6sOqMRA6!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          },
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWp7VL95cgFrD4SKsn-DuAHgLhJI58lBzUFzbjNfm_1hopYjEoH-X1fSqBJ_MIRWHGfWGTz7WpVF_j5537aEdNFeuFhKcYeDz4-ME9n8nB7NKTnAOyyKkaALYf7BxmTB_Tqfk-hh8cv4zp5UEi95E5zzHtlzN1FZXivP",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Henry Landsem",
                "uri": "https://maps.google.com/maps/contrib/105749723706191026388",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK7_4CJSJUaV4_tjYdm-dKBgHkGdDt-HLNMbwMfqyd-Cdgtfic=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMf34tGKFvoHa3av3AtUz1ZaS4AGMxqJMaheWph&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMf34tGKFvoHa3av3AtUz1ZaS4AGMxqJMaheWph!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          },
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWpFQhXSb_jVsjS_RIOqUipafnINIEiz9Q5o39uImo8PjfjEBuxmAWPxAXDmppr8-2jY9_Emg5RlV7MLdP8Z_S2j8E-OyEgmaXdAFrm2FMH4yw_z0CcFgwCACYv2ZFP3oObN1Td2XLfSVj9U57YyB2bY3Mee0v2i2C-s",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Jorge Teófilo",
                "uri": "https://maps.google.com/maps/contrib/105725130023957192946",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUqJnt6kDq8qKJdiX3kNce8RPEazbkkJrzIF3CWOvnh5kR_yYee=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPDVbk5HuNpOlHuRSPZfs8DOVpbKLA-T2ukBi4S&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPDVbk5HuNpOlHuRSPZfs8DOVpbKLA-T2ukBi4S!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          },
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWphovasLZAP4y5nh1uLviWimNqAtU8zEkdUiwtWjF0glchey14ugN4H1VRgtb6o2ac3wBeIo34E1AKrcYwkCKkAsChzPaRvRfUw3JglWN1s3yIrHWKymrn8twsBBToAhTgFgHw3frufZy3aIH3Mt_DL2vTXR-jt8OL2",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Jorge Teófilo",
                "uri": "https://maps.google.com/maps/contrib/105725130023957192946",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUqJnt6kDq8qKJdiX3kNce8RPEazbkkJrzIF3CWOvnh5kR_yYee=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO3klXaGlPOoDLA6lhBP-dG1U-_-Sp9W_X8pkWY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO3klXaGlPOoDLA6lhBP-dG1U-_-Sp9W_X8pkWY!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          },
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWrCnHyz-qDTqppUfFpA01fV7Wofk3H1BiSVmjGFuP3KHE5SAhyP0UL8iB17l8SHpAz_vAs3e1BSuz-XFbcE7WnEcnFABu3hCdxHSRqjcCLtsd8TtlwG30DHdWk8JVky2gkhEoLJYle4mNCiuk8BxRx2YIlAX_AYe864",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Jorge Teófilo",
                "uri": "https://maps.google.com/maps/contrib/105725130023957192946",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUqJnt6kDq8qKJdiX3kNce8RPEazbkkJrzIF3CWOvnh5kR_yYee=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNTuLwc8zn8meCv34iaTrQwL_xG6_2WB8qIeuA_&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNTuLwc8zn8meCv34iaTrQwL_xG6_2WB8qIeuA_!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          },
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWp63p8C5cg3qamioRnFcpiLk4cldGU2fq4NDHmmixVUOgLd6w6e9WudJjLYmM4gxE6GMclQFrFuf4oVASIzxLrQG54k3NVais4QUs5nIR4mkIRbe01m8blU027riGGQ9Rgcl9-9KSR2Ewq5G9_zTduY_0zOBdLIujPk",
            "widthPx": 4624,
            "heightPx": 3468,
            "authorAttributions": [
              {
                "displayName": "Francesco Solfrizzo",
                "uri": "https://maps.google.com/maps/contrib/102860914035010379921",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU0H376OFtACEU2dmsCTOA7rBBPxPgjm2YqzUz8guVjjXwHh2F6=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPY6cJByv7LJSs24ZX7ppaPw5SYwyGvWSZurFHX&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPY6cJByv7LJSs24ZX7ppaPw5SYwyGvWSZurFHX!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          },
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWqvxvHMYtbu2bxQ6zpKGJAwg96Fh1WrhV5lYJuISDOS8fcFRIPPuwbCBm2kokjPkZLPGOEqDGKn2tpDnZ-Dqp_URdYZKRoLd3fKPO7gOEZNHUU0cj31b-V20MZcxPCjr1vhwVPCZqXMtzSk4mrzBaavW5dQ2zw5GXmY",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Jorge Teófilo",
                "uri": "https://maps.google.com/maps/contrib/105725130023957192946",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUqJnt6kDq8qKJdiX3kNce8RPEazbkkJrzIF3CWOvnh5kR_yYee=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMJelHQM2umDaJqwV0HQCdRfZ93oDwlXnPgr7nF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMJelHQM2umDaJqwV0HQCdRfZ93oDwlXnPgr7nF!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          },
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWqm-bEseWhOCjnwwmOyn2pjl7rlnOnJBcNJ4mWxYxc2AhrP9DqLp0F46P9iZb5OmXnF_OJe00rc514DY88gcwQ4QaLUpahShC4TiqY1aCO2FX3K4-RUx46H1Jztc_-ZE3tDbyAMfZ5r62ABHwwvZWVJbc3QS3Q8XOvu",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Henry Landsem",
                "uri": "https://maps.google.com/maps/contrib/105749723706191026388",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK7_4CJSJUaV4_tjYdm-dKBgHkGdDt-HLNMbwMfqyd-Cdgtfic=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNneLKgVi2WR_ksEM1LlRWZI1BK9dA-uQagY-gf&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNneLKgVi2WR_ksEM1LlRWZI1BK9dA-uQagY-gf!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          },
          {
            "name": "places/ChIJJc1VagAtDogRzTjxHkcFlWM/photos/AdDdOWpPB9JKIkgnNLmenQyf-BYvcDi5cbJNzBktADHkq3JKlAgXqA9WErV8CfRUqO_59sCHWRVF7xHbWk_fHHurFxV62ZPcT--jReEg936b2MXHsTXR0JICOsshECutCCmnDr1SMbGIKfQyh68-05bg4Qa7zi8YHgn14GlD",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Henry Landsem",
                "uri": "https://maps.google.com/maps/contrib/105749723706191026388",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK7_4CJSJUaV4_tjYdm-dKBgHkGdDt-HLNMbwMfqyd-Cdgtfic=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOR9sFvWhNblgjDLxOmaPyd1bo7dXbvuY8B1d0Z&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOR9sFvWhNblgjDLxOmaPyd1bo7dXbvuY8B1d0Z!2e10!4m2!3m1!1s0x880e2d006a55cd25:0x639505471ef138cd"
          }
        ]
      },
      {
        "id": "ChIJ10MG16UsDogRJ2ij_sHpVHk",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.883239499999995,
          "longitude": -87.6237422
        },
        "rating": 4.6,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 162,
        "displayName": {
          "text": "Chicago Christmas Tree",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWqWxM__9BkDkzgNcqXDEfLZJ_vx4DuJBPLWRkGYQ5pGjaaTyOLaboGq34pP1Sq455mc7C80KSnH52Ek8GB5vFeuCxy3XeKj-kGOCI-88kYfkpNapqg8DN5V_ExDbdwCfpv9xCTRB7cVvNQ7RJyfFDkBO8plUtgvLC_Y",
            "widthPx": 3000,
            "heightPx": 4500,
            "authorAttributions": [
              {
                "displayName": "Heino Fecht",
                "uri": "https://maps.google.com/maps/contrib/110892021135184564730",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUlaODJNIqNeWDSlmXeVbmQTh5QM5yYTlP8KnqkezFonH5KCLYY_w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOsL3_8ax9jfaMzd6dS-sxU812L3VxJArHoS2Qh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOsL3_8ax9jfaMzd6dS-sxU812L3VxJArHoS2Qh!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          },
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWoXpEbxi8l4So835q8cCtpEMNn8Rkj3e-4820AbGy4jdtlwxmL2bB6eeAiSTlEDN8SsMI1eEoVeRxTjgIGM33ayigA9eOug55YTZjqrebcTZRvTc1P__obn2M8pjpvr0ZAJZUJO-ir7AgsTkTsGsRVyTYsUzrtZccTh",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Sylvia Lin",
                "uri": "https://maps.google.com/maps/contrib/103708397504409242579",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWCiijdAGqfgbtTTAeIzLMXucZjKHXnmBIuT5JfBzAXYAur--Ua=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOfkh1K2-6ohCuOG2zM4B05yL_sa8bezbkUzYRN&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOfkh1K2-6ohCuOG2zM4B05yL_sa8bezbkUzYRN!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          },
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWqJCgLn7itz0udqeNQl_g9tTGpLPTJWVxuZBe96e2KZ-K4wJSPoEuZU2pdD668dvGO4hkYWLTIudbeXPisrU3gp8KOHcpZCAXlfdEaVUohmUXWoZfn9ZWOsqYLEeibNEdGpMj5Cs6Dux9kTuQ0nY2pWHHB3Yo4K5yUu",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Bruce Johnson",
                "uri": "https://maps.google.com/maps/contrib/110259458177978635508",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVFpQy1uJU5Sdxh7F4egsfyvjsH9VySnzIdLIUeSIdOUiglFwoqWQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNV0bqZy6OnJ9y1LRHCp1kPmvEoeRxDzB_i5jK5&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNV0bqZy6OnJ9y1LRHCp1kPmvEoeRxDzB_i5jK5!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          },
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWqppFYneB3U1WyXahT25xERwOqnuZYaNT5PUC5OazmpZY562QPpKrJWY2PlFP3fO7lnLVdFz63kHwi23IhsCL8dN9QrW7DZ60MfiOQtWbyXfeQP_YifQtnf-zNrY9R6nVa2u81SYzPSw7HoSZDIS5_Ze4vfxLVwe5fN",
            "widthPx": 1616,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Chulwon Lee",
                "uri": "https://maps.google.com/maps/contrib/105416772281571033509",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVz15ILEJP41tV7zUa2OY5q3tGFzPu8P55YZiSf-nO5GN08Ntc1mw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP5RJKyApqWriTeEcAa-FRi6J-zAdvB1y83lkKz&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP5RJKyApqWriTeEcAa-FRi6J-zAdvB1y83lkKz!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          },
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWorj-nGsT0uIQ1UgRfwqG0IDB97bF6ummXxFKLY5eUaHhwwttGuMqnsieduhXNY7-MZ5EnL1ytM8piA6omA9t4XxaH7teULkAM49tQp6GtXGZE5MlUzzOcs361_-tUj9gsc-Dlk6muYgW_1h-k2G994wd_HK8oKEWaZ",
            "widthPx": 3936,
            "heightPx": 4128,
            "authorAttributions": [
              {
                "displayName": "Erick Garcia",
                "uri": "https://maps.google.com/maps/contrib/111826991310999719147",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXIF21yU3_6vh8tW4ezZ3leaI-447o46Zw2L0ILy9d_2Mvgqzc=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNTxfpUetzbXWvZJ78y1FdYMtPdd6djKCAmaAtl&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNTxfpUetzbXWvZJ78y1FdYMtPdd6djKCAmaAtl!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          },
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWo7LrY2naiHQdlTA7WzymxOrXelXe68GYfGoO1SqbmSvMWETRBwPd8aeKU1oiMdugDP3O_HTDwJkqMuby0Q-JhuSYdvhcVFUnSxcX9jGhu375krGJ-9Vo5DFaV526A98v-2K7SiW22a6ufHLD2OfRB_F88lOr74tIG0",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Ryan Conti",
                "uri": "https://maps.google.com/maps/contrib/118197359345454998911",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIf1rCV6mZYlWtXtvhWGDgBVaaE4dse2UhgEdNPbycRWaMu0Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOTQZaIZ1NOicdvSKc8vbsVY48RBRU3qOLhGW2S&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOTQZaIZ1NOicdvSKc8vbsVY48RBRU3qOLhGW2S!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          },
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWp_Vq_6etREPUJV4mhfTx_eBPL1ENANNAffg7zkzjbg2CJ2d6aADweEpZsknskZmPs6uX-wk_F3ZeeIDPlI6K7i4d4Srvr7qByq7rGeMBL34GTeOlp_Yt90MP-CiW9aorFCApLhGwBYfn-5rR8Jo2XlsW6Z0h24HWpD",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Aiden Zhao",
                "uri": "https://maps.google.com/maps/contrib/115736397998650551116",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXiH_xxQvMitmURp1jGe7EdtNhwflyc6Ied5tkmNk_mWHRJnXZW=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNqz0IjvsJs19BDXTqJstlMPmxm7Cg2oy_QKyck&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNqz0IjvsJs19BDXTqJstlMPmxm7Cg2oy_QKyck!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          },
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWo_yB4ECj5cmcQPJ41D9sW7VPeIziZAkWox5yz4o2LDpkRcWErPnD7y_-3wCZfTrrPtN3YPRUcLBcTANI8FatSJkwRsM6pqeYjk1vnJ7k65_N1wIMathoBFYl85m4-TjyvPZoZuKJ6_HedU1bmZVVD7M3miS8rrB5Aa",
            "widthPx": 1705,
            "heightPx": 2048,
            "authorAttributions": [
              {
                "displayName": "Krzysztof Witkowski",
                "uri": "https://maps.google.com/maps/contrib/117497475475297491105",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUpjodFqRWiWZUwFpzLwiSdfL9ENoAj4al_MGKWKnjFx4S2VVRb=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPzZzF5X30V7IUSfNCih2ogglmFUkwXV3MdQyTh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPzZzF5X30V7IUSfNCih2ogglmFUkwXV3MdQyTh!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          },
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWpzGP3dcl3QcxNNJ3J9Hz8_dVR9nbKR1PlOHeFp6-4yJf0hR7qRL8_CzTSJDNJ3w_paK0JXoiD-0aeBzoBHUnFenfb-PvgADPXrBp3BPqe3LMjzyoLeEGwuHsz-ATR5YnSxdQRE0XMVW7OIjgXDWd_0z8_U_9_plqM",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Andrew Lugo",
                "uri": "https://maps.google.com/maps/contrib/109638137605968953891",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWPh302fypWSVNkeTjNSCGJ1RMmVh0M46M71Gy65fRWTq9UZkc=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPU04k6NUtlLiaahtwR0tqy2An51twGVps7BAs&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPU04k6NUtlLiaahtwR0tqy2An51twGVps7BAs!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          },
          {
            "name": "places/ChIJ10MG16UsDogRJ2ij_sHpVHk/photos/AdDdOWqaAFriWGBjJ-0fI3cgJKF8emJq9dkOzKae0XzmiO16CooOtTL5o5evPDQXdAFsQD6PZyn8dgnp71GqLjLgFXh2vPBYOVvAHQRTmkbcy_mOsLurca7jJUk0etJ4YhdSk4IMEm5-ACl5srbwi9DulOoBJ2FWqWxs91Y",
            "widthPx": 3797,
            "heightPx": 2852,
            "authorAttributions": [
              {
                "displayName": "MJ Kim",
                "uri": "https://maps.google.com/maps/contrib/108840915735686260771",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJdmwghcf5jT6E0aDk2fJHBSzIgSdk8KcM6cyY-Lw3PpDziBQQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMPhugAm7yearjNXp2W2636TGjU31FAqH_yDvk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMPhugAm7yearjNXp2W2636TGjU31FAqH_yDvk!2e10!4m2!3m1!1s0x880e2ca5d70643d7:0x7954e9c1fea36827"
          }
        ],
        "goodForChildren": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJ_-pNpqUsDogRl44TAUoGqMU",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "111 N Wabash Ave STE 1514, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.883490699999996,
          "longitude": -87.62575489999999
        },
        "rating": 4.8,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 215,
        "displayName": {
          "text": "Downtown",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWoB_4CVxuyzGgo2MagiTJdhR5dSWQVqXZorho5SrpNgEZHErrNgvtoKPc2pbUnAKcNjeeTB38KhZn2T_X2mvTtZtwtNuPUf-tCH9zd6DjxwEdeTpzo92DM5Vf3R3Jh9dFs4Afvey3_efYt73BpU3jvvVAr0P9P_epxY",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Loy Jelic",
                "uri": "https://maps.google.com/maps/contrib/113724021438752899113",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV_HoGWejN6lbqdNETNwrM17KARUF8ypCmiNe3tqNd3WNVreWLROw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPL_rgLNPQsVqBcrkgMYGkrm7T5BnKVv8IavGfj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPL_rgLNPQsVqBcrkgMYGkrm7T5BnKVv8IavGfj!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          },
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWpEie2b3xWVkRDvu0Bqoq4CmNsVk8T7e_SFmjoUWwwOSBRwyB-Y-9vdjcPvBs0Rs7EMW0bDPhJocn_9Hn3k-_xUvsKvlIVfqjrh-C7DOdI667m3nG3I68qRTq3wT5iCjcCJq_01RM0kx0SICeBTnW_TLUT9WMXigdjk",
            "widthPx": 4435,
            "heightPx": 3326,
            "authorAttributions": [
              {
                "displayName": "Jishnu Mehta",
                "uri": "https://maps.google.com/maps/contrib/101336162734376052696",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXoxLJI9dtzUBR_f5YvzRepBep5fO3gDobAXCD_bYOHu0n-UiPBIA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNOBzWIwY80BEylc-XX-mW9Ou8iNq5dKjb0ARQG&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNOBzWIwY80BEylc-XX-mW9Ou8iNq5dKjb0ARQG!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          },
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWpRQe_X83zrVnu1o_4K5BNrJ_N2M7Q1i6QN9VUyt-zVNUfYfO7s0OJqQIsakXJLG4QMqEgti58hPts0amRlXZjEJrf4u4_B5LQnGhvG9dJX_exk8Fbw99toPGk9iJsb6LZkK39Zb8sdyM9PneRt182JnQ3xG9N20HDX",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Jay Aviana",
                "uri": "https://maps.google.com/maps/contrib/116364601228449896522",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUH9MJqQXsWGUc0vlsTGM0A6qzYIZ3mNonIH1Z7efql3tBSB7T9Cg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMp4xbQ199acYJPTZX_UUDlfNmUyqnfHOMY0v9r&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMp4xbQ199acYJPTZX_UUDlfNmUyqnfHOMY0v9r!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          },
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWrQSfYLh5Jac8OE9bzp_EcCBGHZeWVJEoAO0FYS-ptdurrIazE7L4fGdKMIiwqY_GwWhXHfIk31LM_CNTOEMScQFVpe7WHekqaZcGrCOHwMx1On1RfLcybLOU1yu0FdRuaMv--cikaqednCYpt6TE6JSE7HqPEnTkDP",
            "widthPx": 3024,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Sherry Borgra",
                "uri": "https://maps.google.com/maps/contrib/113507575115020441801",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWuvh2x4_8LoEatacj98-lYaOQ0DQPQMR_ZhOGT6cp6cojRk3E=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNJdctu-xEgK0GsgBtgmyYcmeL8sRxJxJgD1CWP&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNJdctu-xEgK0GsgBtgmyYcmeL8sRxJxJgD1CWP!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          },
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWqzs5Ez-CDH5PYAClWuLppuo2FW2pzy_68BWJql884d0eLa9CY7eVdKNW2usJbsVvbLTF2wOG7NzLWATxs3-mpncp64DjHkr98XnwcmCfif_HSJE75Wbs8n5-bdJAdTwt-1PfTK8D9KOq_K9HsH8KaR0cpBmrZNGLWY",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Eugene",
                "uri": "https://maps.google.com/maps/contrib/117888798068764682863",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKaC-zqU2XnXFPoK6XH_O_U7a45get0feHY7VsWk-brPn1EL-o=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN6IatdKWkOY0TQCVwCg_RcGXixyg2G5jLmLUzV&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN6IatdKWkOY0TQCVwCg_RcGXixyg2G5jLmLUzV!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          },
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWopZfRtzxMcriVQDvW-egB1PZfOaiAwuUQSMXL-uevuuHft_e3mae5L3UxTYSYr1Sd7JCDp1Y7vAOp9hyvUSpgwG-OdsbhsMi7R2v0mAPeawhUrqUwJbtfe_gXSpuL5cPqo0EInRJfaOC6g_IO3nUFPNe-15YEEtaLO",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Jay Aviana",
                "uri": "https://maps.google.com/maps/contrib/116364601228449896522",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUH9MJqQXsWGUc0vlsTGM0A6qzYIZ3mNonIH1Z7efql3tBSB7T9Cg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNWDyvsWeGZIXPgKhcqYMtGVS2r1TIDMVrtydR-&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNWDyvsWeGZIXPgKhcqYMtGVS2r1TIDMVrtydR-!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          },
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWqJ-fUI8pS_eV6GKHxsEfTFe5P5jBv0MJjRnEJqPANs5MCWj08TGhz-XkDsz-5yF_mfc9MRaeu2Cn0iY8eoOUEPiwcL48-nPy6WTehWsOnNw2R65sCHDkv9MxFwj-0C_IHTmaGeEHduauD63S1qDnCoaWP6xMLl7rOL",
            "widthPx": 3456,
            "heightPx": 4608,
            "authorAttributions": [
              {
                "displayName": "Traveller G",
                "uri": "https://maps.google.com/maps/contrib/113734047268555561644",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJASFL0T4yLgrd_872jBP86lr-nNF3vXZb1_ceNfaVyr2Pg_ux3=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPbsJeJGGEuu_8H9vlDPT88rTTBrxRx-bmONEt4&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPbsJeJGGEuu_8H9vlDPT88rTTBrxRx-bmONEt4!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          },
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWqgiW6uTHvIt00YNd2QBu3oi28ercf2gEkK9QOyYwIvOZV96K2Gim2J7dn2ae-udBEVyqIwMMU41r6qeQ_4cTI-EI3Off-GJnPoYQU6OhCGmD66x5W_FwmQrNxZFUDHOmaDIVaz2rPSPmKJjsoLN0DcyNoOqImvFHsB",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Abdelhakim Turk",
                "uri": "https://maps.google.com/maps/contrib/117967458786723742605",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXM1sw4m6grsKiTJ37cPMhjdLJbrHWftFQMrhIOVB0Q1Yhb573MlQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPpewMMiDIJjn2cZCX-fCbbPbzqHe0HTl2cQJrg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPpewMMiDIJjn2cZCX-fCbbPbzqHe0HTl2cQJrg!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          },
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWpDG8TlfnWkFk3ROV5mRwWsBuQpF16X0G6d7vWZV3I6kde-D5bzbt95jvgdpfoZx9LWc8OQmNBrelQpw2jQmDrrNlTPJS4sRMzNQyupNAXG90s8UCIfCi2LS-cr3iCN8koOB_Q5LEWejEWyo5sBn3Ibmocw5mGLdR7f",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "Mali LEVEL2FIT",
                "uri": "https://maps.google.com/maps/contrib/110612490051751665455",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVysl_XVWGqL7vLAJVko2I1rbt6CD3cxmMVgVNwJM-_EnWkorSdNA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMAd52IW-pWdcgyfDsX87bTZVSNAgt2S4KowFhL&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMAd52IW-pWdcgyfDsX87bTZVSNAgt2S4KowFhL!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          },
          {
            "name": "places/ChIJ_-pNpqUsDogRl44TAUoGqMU/photos/AdDdOWpXpATDf2Ut3gKhpcl0j7_5_l2NcB_ouie6_l5bxmpvqyx92FzxhaSnCpgjQ6bNUw89F0ZRX6YnYvN6iQHTPwH8Q20-22Nf9WOToXapUg8OoDV7W3Al6dm07o4Z8nVu3sjUSd8Fwn5sLotK-vMqN57hSNEMY8y41xW-",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Marcel Mulderij",
                "uri": "https://maps.google.com/maps/contrib/100613580457331624640",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLSgjIcGFltH49dkhjg4gU0kfYu4wJrae0qy1igAJBGQ2lq2A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNIFQxKwXHKF0tdGhpR2gZ9u01eyXRyAZudPJrN&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNIFQxKwXHKF0tdGhpR2gZ9u01eyXRyAZudPJrN!2e10!4m2!3m1!1s0x880e2ca5a64deaff:0xc5a8064a01138e97"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleRestroom": true
        }
      },
      {
        "id": "ChIJlRLcSQAtDogRFAFK-ZdXlnY",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.8834933,
          "longitude": -87.6261766
        },
        "rating": 3,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 1,
        "displayName": {
          "text": "Ememem street installation",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJlRLcSQAtDogRFAFK-ZdXlnY/photos/AdDdOWpBxIT3D_swnud4e8LlDqyNnUghYXIGgoWL6lpKnMPBqshf7sKHMyGNkWRMSL5grlZPJfuLw2tncqlHiKAdXBLjVugir26D_70QO8mYi8FaPL8wrGROS5__GzFzaefEl3Y1HINvqnAdiIMCNG6xkIQPND9u6uK3bpQz",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Jonas Forslund",
                "uri": "https://maps.google.com/maps/contrib/118351297895032674544",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVBrX3mMCcvF2g9h7OLdLTYPe85CfdWczpP0Lx0PLkxJ7wC2gJU=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPMfrXab2v8Qu26frVrnwQ2vqK5AQPJpQhzuywk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPMfrXab2v8Qu26frVrnwQ2vqK5AQPJpQhzuywk!2e10!4m2!3m1!1s0x880e2d0049dc1295:0x76965797f94a0114"
          }
        ]
      },
      {
        "id": "ChIJIQGS4WUtDogRMce1okcRbH4",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "180 N Stetson Ave suite 600-1, Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.8857718,
          "longitude": -87.6229922
        },
        "rating": 4.6,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 5,
        "displayName": {
          "text": "Chicagohenge",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWrdsU3nxXayz_m14qWriyeQHawjCYQLlG8NloJ64OEEOFISWbqrnoQ-l9PSfM6CjHZG6mzlvNFnvseZtpknUAWsbIk-f-q-dhf8oXgMPP_lHiNPp8pJMICWpoGCICBLW6ib5edpON68nle_gtMG5YLeMMRmeFhHsMc",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "isha",
                "uri": "https://maps.google.com/maps/contrib/113316360717513099181",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJMeMkMCk3IsNdlhIUmjHxLU-xPGAKB-g90N8ahRtGEPgbZ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO7nNK476wHKYMLrWEm_bmA-zmUzadpen5lP1c&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO7nNK476wHKYMLrWEm_bmA-zmUzadpen5lP1c!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          },
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWplq-az3R3fBQjj4boKeHVK96zmzseoQ0Emvgh62WnAu0j-KGcXe_pqacD7wl-bXF2YTubNvEuus7p5-mqxM_m0YPHpOZ0MYSOaI3TdkqY_LzSRdTyhZV9cff-ERFTrRF-c_-9luBpNofXCwU-_QmYt1cAol6MjjeOv",
            "widthPx": 2048,
            "heightPx": 1304,
            "authorAttributions": [
              {
                "displayName": "Ruby Tushen",
                "uri": "https://maps.google.com/maps/contrib/106489710811095493661",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIkE-zm2NBLCvkg-lY5p40yBBlCvjNP71pEg6_Of3PU2sCo_A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPdIw6qSjyAPX-OhR1ESzrzddXOBF1H3cSieF8t&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPdIw6qSjyAPX-OhR1ESzrzddXOBF1H3cSieF8t!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          },
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWpovpfeYEJFZWFgMWHdUeXyy2gpeOujjsUB_LoFxbsieZCe7eLU6wt1OIHtk0G191jJhFvHXhX3YsnkSe_Av_K5kk0ho4urInwZIXbk36YortibtNyJ0EIVN_a2h5TXXvBD6vjk2rPijx_9ph0j8r-zLOHQwiBuuHE9",
            "widthPx": 1440,
            "heightPx": 1800,
            "authorAttributions": [
              {
                "displayName": "Todd Susuphaus",
                "uri": "https://maps.google.com/maps/contrib/102920481487229848024",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVfS1ToyVlvZCzEYfec8-Z-6L4rPj6b1xUh1rRO5c3OHYTnNJM7=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPjxBxF0t1BMd893matF3kmTUYHXIpnzVv6IGmo&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPjxBxF0t1BMd893matF3kmTUYHXIpnzVv6IGmo!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          },
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWo9ddjU3cakIE9Y18jAQsPTrrY0Z8aOA_ZgpEUoT5YFhtfjI9yUizUlVjqH9XtOyHCMOMGyMcP6NXBnjMf6X7Yb6tIU_lwLAOpjdYeLLnAhgkUJFuFdvx3DrXxOD3jNYIUaWihOSsu2_kLUr6v-DMPZZX6PgDxXAyCx",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Maner Niyet",
                "uri": "https://maps.google.com/maps/contrib/110191518057526723584",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVx33SucuCWajt2diGN28yK7TVIn_S8Lma61X67Iv4iHSFZy70=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMu2iUc5yLTH-NygCPXYLomGxtF9VLT5eTKZupk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMu2iUc5yLTH-NygCPXYLomGxtF9VLT5eTKZupk!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          },
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWoQSUSsrYa4Rl5RFq8fDzMZJvB-OnlCjFKKU8sk2xH_lhkGFlIDVeU8sNcmmTrLLEQWGitVSuXJm1DGfvf3XB1H4SKKO82LtBV-SuO33bw4b4naa5fmmTMn647KTVAzAvd5MHqaecFkLkoSTEChGi1VYPUBxrbJnJss",
            "widthPx": 4800,
            "heightPx": 3200,
            "authorAttributions": [
              {
                "displayName": "Jill Stocki",
                "uri": "https://maps.google.com/maps/contrib/107561194008576951473",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWXUSshmJ_ANo-JKeasaIGp-WealoeuzXBDYaA_9n07CiQSDue5=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMyC5hIgn5qHduDxit53UnRSvHy-0kappwU21bF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMyC5hIgn5qHduDxit53UnRSvHy-0kappwU21bF!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          },
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWrJO3uUM9JsSQgv8IIR6k3eoJG2ymE86-gohYJCVCDPaZ1OX0Qs_F4jplAIy0NU9zTQtC_OfFISTmx1xgVlJOHUkRGEYhBfi8WJskXm8IYCkTpiDmwBtn68QtjOiKHO0TIJ6BTEJFyXDEO8NQjZ-xfsqjtdsySS7Vg",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "isha",
                "uri": "https://maps.google.com/maps/contrib/113316360717513099181",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJMeMkMCk3IsNdlhIUmjHxLU-xPGAKB-g90N8ahRtGEPgbZ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNvwmKIVLiKzGWNkTz2aJV8VXr_UFYbcaTRTGY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNvwmKIVLiKzGWNkTz2aJV8VXr_UFYbcaTRTGY!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          },
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWo-cQcYLIiOBGq4fSJWTy1xpcfHQQt-x7TqDXpBLyYfq3usROxKt6ATe0VGgQPD_M0i59BhvdM2_Uhysmuv7zK-noiTWHAdjWL4kL_nSAME39tVIgUzzpIgkFY49V8CxMJR8A1u2wffBbvUwaHtfuM95LcEeveQUsw9",
            "widthPx": 3770,
            "heightPx": 4522,
            "authorAttributions": [
              {
                "displayName": "Ruby Tushen",
                "uri": "https://maps.google.com/maps/contrib/106489710811095493661",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIkE-zm2NBLCvkg-lY5p40yBBlCvjNP71pEg6_Of3PU2sCo_A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMMzOT1G6UtGfvqs7DM0D-JNdkSd5ge27ZVAniJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMMzOT1G6UtGfvqs7DM0D-JNdkSd5ge27ZVAniJ!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          },
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWqtjI5BKFnH-Pkh9yUjomXm_cukey_V594gORqhMO8b7_DzLK9Tnud6845lVIcv3ubdxfvau5ray92610MrnJmLggn5HKg1o39IqSFQakGjtKDYBCAwkm3HFn1hyYQjJW7JL08UsoUQibRnfV2mO5LdlMgNlS5FtIQ",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "isha",
                "uri": "https://maps.google.com/maps/contrib/113316360717513099181",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJMeMkMCk3IsNdlhIUmjHxLU-xPGAKB-g90N8ahRtGEPgbZ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPXGu0vnm_4UldaIJhvs31Cu9cFeMMP2N-Q5To&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPXGu0vnm_4UldaIJhvs31Cu9cFeMMP2N-Q5To!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          },
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWrECtCjObEFMgamMYV3Q6pMbTjJ_npL1JDf9A7hg9QA6QdpTAyMs5smmjliAAvy1LaJjtV_vb_pHrIAIF9M5zt0mGChIp6_yDtswrAxsUXc0KVz61vFBMJr0vCnOeWUk75cp1C6ZhPqmcMEV1pcRHcZSdiiSIEfsWCj",
            "widthPx": 1170,
            "heightPx": 929,
            "authorAttributions": [
              {
                "displayName": "Ruby Tushen",
                "uri": "https://maps.google.com/maps/contrib/106489710811095493661",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIkE-zm2NBLCvkg-lY5p40yBBlCvjNP71pEg6_Of3PU2sCo_A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPVENHlfILxrxr70x_Q8f1hTbXRl8Mna1XukIiD&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPVENHlfILxrxr70x_Q8f1hTbXRl8Mna1XukIiD!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          },
          {
            "name": "places/ChIJIQGS4WUtDogRMce1okcRbH4/photos/AdDdOWqOQ61oaOglTf25QZ5s6YPCZ9pzT75J0u4a8DA7voqdquSP_v5nlO6-IP7cqAYliKnGUV6NZrj2JiZe_i0DYlWL_2UMquEBDA-qujf5gMPUDGBQtkA_anbde_N6BlRq_Wg3RUa7iPWMfTPCkEQ-pRoHBHU7OI24F5M",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "isha",
                "uri": "https://maps.google.com/maps/contrib/113316360717513099181",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJMeMkMCk3IsNdlhIUmjHxLU-xPGAKB-g90N8ahRtGEPgbZ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPG_ca3h_iENLzzb9wqpA8QzoElv3lwuEoqVqE&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPG_ca3h_iENLzzb9wqpA8QzoElv3lwuEoqVqE!2e10!4m2!3m1!1s0x880e2d65e1920121:0x7e6c1147a2b5c731"
          }
        ],
        "goodForChildren": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJp-mDGwAtDogRDZcuIm7z1vU",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "100 S Dearborn St, Chicago, IL 60604, USA",
        "location": {
          "latitude": 41.879061799999995,
          "longitude": -87.6294214
        },
        "rating": 5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 1,
        "displayName": {
          "text": "Futuristic Burnham Pavilion",
          "languageCode": "it"
        },
        "photos": [
          {
            "name": "places/ChIJp-mDGwAtDogRDZcuIm7z1vU/photos/AdDdOWosT5SbPs0RNP2ccherwQP8O74Khx1e0UbHUlQqPGMl_kep9j8eDQOfLykk5dGdHo8qCop3GbCJ3_je5kwszcjroX6pS-vrKdl6bmNYD68c2ZR2gtF7VLFrnKoeW09xdBxny5oTcyVVjVTlHmrvCIZhoKzZEI4774XN",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Marc Thayer",
                "uri": "https://maps.google.com/maps/contrib/112746735518502184463",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU1kUvohgq8Diu1MPIT6bKMGLphHeILN6SGjm1W0CK8c9O4pmyzdA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOSY84ZXaspMU_jOvuUHLbG24F7mwqTRi0zlDjs&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOSY84ZXaspMU_jOvuUHLbG24F7mwqTRi0zlDjs!2e10!4m2!3m1!1s0x880e2d001b83e9a7:0xf5d6f36e222e970d"
          }
        ]
      },
      {
        "id": "ChIJ5wk6ewAtDogRCn26UpBOT_Y",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "35 Lower Wacker Pl, Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.8868211,
          "longitude": -87.62675209999999
        },
        "rating": 4,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 2,
        "displayName": {
          "text": "Megatron and Sentinel Prime",
          "languageCode": "pt"
        },
        "photos": [
          {
            "name": "places/ChIJ5wk6ewAtDogRCn26UpBOT_Y/photos/AdDdOWrjcQ_wUsftVpnkHj_yzbrgn-anP8FCWgP1VvsW_jPOctQpCBeKg3hsVI7zwPJiU7snMeLhbaq67Kg6tuXh0OUbYPsG7kQEQ_9mlaYGFnfCuD4BMhoIbqYljPazx3QS2UPdQcnUauipyO2uZAGqMlzDko8avQ5bz6_L",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "latroy beeler",
                "uri": "https://maps.google.com/maps/contrib/112833356125836789288",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVumR0m6fV1d11lEKfszrwwJjRDZmhj3ARBvJnnQAohImru3AZFiQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNSnEpb0WmYdSkSlgI7VAHMQCh-9qmV5JYi5e5d&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNSnEpb0WmYdSkSlgI7VAHMQCh-9qmV5JYi5e5d!2e10!4m2!3m1!1s0x880e2d007b3a09e7:0xf64f4e9052ba7d0a"
          },
          {
            "name": "places/ChIJ5wk6ewAtDogRCn26UpBOT_Y/photos/AdDdOWqKU1X66aR3-CT3N5IsqynH1w1vmlurS4nJ1_ajYO6l6YrOxavLw_3OnLi2vthT5GaKqBshTMKIfzjWsdoBttEEcNeuDua761aRnVvbrY5kFJv7hkRjbIliOC_L6VBIG-2R_G6ZYf8tJ0aXwnNf9K1O9o-X-PIc-FsL",
            "widthPx": 1313,
            "heightPx": 799,
            "authorAttributions": [
              {
                "displayName": "Jean De Filippo",
                "uri": "https://maps.google.com/maps/contrib/104573548913671264499",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUB_nKeI_1ZQGVMUFlQO1yKeyDP9lBkjrVb1_VAK462P3GHgXV_-g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMZ6GLIVavlJYR1TZpPm2bp4EGKMwLHEGuoUmex&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMZ6GLIVavlJYR1TZpPm2bp4EGKMwLHEGuoUmex!2e10!4m2!3m1!1s0x880e2d007b3a09e7:0xf64f4e9052ba7d0a"
          }
        ]
      },
      {
        "id": "ChIJzSQOSwAtDogRcpN65Mo9P7E",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "233 W Wacker Dr, Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.8880322,
          "longitude": -87.62252509999999
        },
        "rating": 5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 1,
        "displayName": {
          "text": "Chicago Travel Decal",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJzSQOSwAtDogRcpN65Mo9P7E/photos/AdDdOWrXllEPj-Ct3E-2WKI8yIRS913dBfWRdwTspG_JXfSMbbCqjll5nqQ6AOh8aNdLCuBxmoMPAZ1pTsGbXRcxM0xz4vWVWyPq4gnDNBU8O-lha7dTDGeXHOSmyQtHdgMsbyVLKfdB5IudAE-jT5S8z3-PFCCRKwLbInDF",
            "widthPx": 2060,
            "heightPx": 2060,
            "authorAttributions": [
              {
                "displayName": "R Beranza",
                "uri": "https://maps.google.com/maps/contrib/110488640573457170301",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVltb-R8ys9FN8HDQJknm9DbVIKqtetlW8ZCFOX3LAOILhOToCJGw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNXd2vfu_647of0svL2aG2QRlPtkox6WcqCwxe7&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNXd2vfu_647of0svL2aG2QRlPtkox6WcqCwxe7!2e10!4m2!3m1!1s0x880e2d004b0e24cd:0xb13f3dcae47a9372"
          },
          {
            "name": "places/ChIJzSQOSwAtDogRcpN65Mo9P7E/photos/AdDdOWrXbWet0ZNVCDzwcpO2AkMn_FOgywJA4S7TunxAoOp3l1P95cTnmLFzB60WBvcRYrWl94og5mibHvKexsP7nKYEBUaX4UTvf0mLm30erbVxkDgx7V5wPjayAPB9evYrPJ6sg5V22_anaeZUS2bOeZWkCp9l5lT23i6h",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "R Beranza",
                "uri": "https://maps.google.com/maps/contrib/110488640573457170301",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVltb-R8ys9FN8HDQJknm9DbVIKqtetlW8ZCFOX3LAOILhOToCJGw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNQqtFnaGQUsSc-Mf0sV9GGrvnJKeyIxkZT7Gtl&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNQqtFnaGQUsSc-Mf0sV9GGrvnJKeyIxkZT7Gtl!2e10!4m2!3m1!1s0x880e2d004b0e24cd:0xb13f3dcae47a9372"
          }
        ]
      },
      {
        "id": "ChIJYbBpvpwtDogR9mshPcPtKkQ",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "122 W Monroe St, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.880674400000004,
          "longitude": -87.6317345
        },
        "rating": 5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 2,
        "displayName": {
          "text": "Harris Bank fountain",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJYbBpvpwtDogR9mshPcPtKkQ/photos/AdDdOWpSZxcurO80UNjiw9tUKxZSg8S1HlZfARVSM3T_CkkbiCLD620o13BbSlr4CwJFE0IVuZn_XA6-Gf4BzS9PiTsGDgKbRjk4hXqC0uSs1cHKBnBBjI-dZToUYM4E2MND4wqfR7D4ceKMNimVUvAEiPCJtatdyFQg3xTH",
            "widthPx": 2448,
            "heightPx": 3264,
            "authorAttributions": [
              {
                "displayName": "R Cusick",
                "uri": "https://maps.google.com/maps/contrib/104686778021455925536",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUoHeReoMefM4X50vFmKZ735SZbn2bIZwbg2lnytR0MMhaqqk5oVQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOKVnlNXDmuRFLsBJ1e5eojkxA159b3V4H1FGup&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOKVnlNXDmuRFLsBJ1e5eojkxA159b3V4H1FGup!2e10!4m2!3m1!1s0x880e2d9cbe69b061:0x442aedc33d216bf6"
          },
          {
            "name": "places/ChIJYbBpvpwtDogR9mshPcPtKkQ/photos/AdDdOWoKY-ALCdeGm4wO8Rnbx50ssJ-KeFUoVL4n4xQee6dUwbInC86jMDFxwnd5H3SJy1bXVzod39s5OKNEzCMzzIU5MajEf-ZqAgkOYYry1PGmOj13Iq5Fd64SdaBEjWC5A3VeJiTGGfYMMJSOl3JgO9q_p6KLx_Ow-6DE",
            "widthPx": 2448,
            "heightPx": 3264,
            "authorAttributions": [
              {
                "displayName": "R Cusick",
                "uri": "https://maps.google.com/maps/contrib/104686778021455925536",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUoHeReoMefM4X50vFmKZ735SZbn2bIZwbg2lnytR0MMhaqqk5oVQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPnhgEsXJrfcOMoFH5Eu1WBcTqKKTfAZSnBF2Ag&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPnhgEsXJrfcOMoFH5Eu1WBcTqKKTfAZSnBF2Ag!2e10!4m2!3m1!1s0x880e2d9cbe69b061:0x442aedc33d216bf6"
          }
        ],
        "goodForChildren": true
      },
      {
        "id": "ChIJX-RTBqksDogRRh_Q4ynbf_8",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.8884689,
          "longitude": -87.6232295
        },
        "rating": 4.8,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 19096,
        "displayName": {
          "text": "Riverwalk",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWrRlTjrs0Kj9KOO_W4mK6Lwn-yUXSwEg28O4vTEjXGM5ZVdfAF8COHvysx7PPdXa9-_cCtqEYz0I6ymCPeru-ol5p8aDijZ91jxSv3s4571-C26HNubI7ow7kdKxy96tyy9akcieF_QUEQ_2ESy7oYU7KNuo8EQQwmh",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Munzira Kamran",
                "uri": "https://maps.google.com/maps/contrib/110043736851962114123",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXVxjBXCbQKFTNNWQL0kzwBknHINpKRVopKXIL-TL3y_oaYUy-2=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPZmsu-61PduK1CTf0YeiO1LmuMT9B5aOif_Bf7&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPZmsu-61PduK1CTf0YeiO1LmuMT9B5aOif_Bf7!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          },
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWoLkPwBXqrG3SkCP2GV4Eos8dH_5eMKITdYBBpSMGDGcsddnv7wf_WnLRDQxgInN5BVIELgoiKihgBPuj17F1GwDiuWvbDlENMI8z5ndcUyQFLi1YP_5YXb0CaqI03M35adaxjFGwBCitRUkoTe5M5oVdX0DNnlod1_",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Dawang Wu",
                "uri": "https://maps.google.com/maps/contrib/108697551735944542899",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK8Co__vTmBRb1MOm0lLf5SZVFDtkRROzWke5DOgc9lO8SuRV4=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNPhxDkZlcyOyj-qtlilj1C0jHDJCB53qZjb5o_&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNPhxDkZlcyOyj-qtlilj1C0jHDJCB53qZjb5o_!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          },
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWqdSq0Zphi6CGiDtdo2X5oZRrmaGrUkNwdQelWO2LLnrN2QD0cGjUpay1a64xgBd_Lp3mY2JX5YthSS6Tp8UzgcYbjpAclQ4bfRR7_tcIRWVOwhhDF9ED1MfKg0wOhxfxPTmxQnrukA90OhwTkHdpzox8tenEW6EPsl",
            "widthPx": 1080,
            "heightPx": 795,
            "authorAttributions": [
              {
                "displayName": "Jim stones",
                "uri": "https://maps.google.com/maps/contrib/107656963510879659934",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWjAqqCxy-61oYdWCGSJgltHkcQ_sn75pc2C-eAcbjRqhIAXRI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP6xcoiFIsBlOquS-ClOniJwb1nphOSMylwL5ZA&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP6xcoiFIsBlOquS-ClOniJwb1nphOSMylwL5ZA!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          },
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWpOHwCYKXHjUFgw8BgMX6vM2Alm0fwqmjSizCIF-c2AwmpqYbnKPvwvCzrTLR1x0Qjz5U99KZHS8Z6RD3AUowsK1A8ilb3AvZ4UBaOdRagXWPvhlabwQecp0E5RBpFxAZguygXQF7px9ZXm4EDDtO9Ui-xT7ZwKumRF",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Jennifer Collette",
                "uri": "https://maps.google.com/maps/contrib/101739771782950678532",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUKQdy5IMKBogzOFC3hH4NVVotzy_drDx3Qv16sTg_63lHdJUEw0g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOURf6Is6Yb7Wd7wCFlSxMchBJPgrvrv6rZCxbo&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOURf6Is6Yb7Wd7wCFlSxMchBJPgrvrv6rZCxbo!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          },
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWpjFwUUe5ZQ-RZf83sHZFjlnw66NevBMzLeQZtDxL5n4e1UDZbq2MtGvR6YV5LkFtm4a5uGtx-y5c0-E3WllfxTtuONbr_sCHA-S3e6r74wvaajsTX7wQENyWfSxgAPRjZkHUTY10D4lHTo6OdXLe3E_-IjxaDliujD",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Alexander Peet",
                "uri": "https://maps.google.com/maps/contrib/109946907400111850108",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU9sz3MksxMMCCwOTCU5qTG0Gwx5yqHRiR4qZYzgleJb38zokH6Mg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNBWj4UzS63YCC5tOuVb5sFwARj01uHac6F-K1U&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNBWj4UzS63YCC5tOuVb5sFwARj01uHac6F-K1U!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          },
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWqyX0ArAUBfDyATaJbGnTTx96N-uQkuNF8ArX-7X9aP-0sjc_ygGWWDyR7s-L-p1Xm1Pq3zwOJqXeTN0sFa3rvVmhtPsNyDcsGEMiyOShpnfmX0XWMHfWfPSVxBRgteIiQl_HERh2LX_tqbrTRxIdlm6W1wKSs4MAw6",
            "widthPx": 4800,
            "heightPx": 3199,
            "authorAttributions": [
              {
                "displayName": "Stel Kepap",
                "uri": "https://maps.google.com/maps/contrib/114942957717427359780",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXKpb-FwzTjaJZRiQqxN6jZHVJfSwCDUh8cgIW3YW6BO3fY6gv06Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPdq056Bl2xlx9333RuFnVgW7dpxT60dZE5iKSu&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPdq056Bl2xlx9333RuFnVgW7dpxT60dZE5iKSu!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          },
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWqRFT0QDHul69It11ogYcqLkPWJENuHUbIMJhOPEd5gg3rXg8w1RX2YhGHQbfIWV8PkWN8Ryu4sIA-PLbVF193ePoxRAWg-fHhk6NYUUFDC23_x_CIIYziK4CfPqLI_CHIVm1_bkKrdPLV1sKF2cenoX1tWFga8sbnO",
            "widthPx": 4618,
            "heightPx": 3464,
            "authorAttributions": [
              {
                "displayName": "손윤호",
                "uri": "https://maps.google.com/maps/contrib/100163806374752138350",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLY9ZFRExFhTPy7i2eueqbP4h7AJ3MWaGKflilR3hIVXcJ7jQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNczO5oUGCGRagZYbQ1dCDcUliBviqfI9UBmtQF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNczO5oUGCGRagZYbQ1dCDcUliBviqfI9UBmtQF!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          },
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWpSF6K_G4mpkgwe4SQkUif06MPI5bYFa7_tjw6eSnZu8SdIFRI39C-YFT7FG2ZDo96Dtc2l4R4KvjNpYX2tAHwQo7RjtasGNpftgnw3BNZxh8dUMPuAZEi7d9Q45zHDtPlAVIXynH6AOHLHDB5Ju-Z939Jwxg2Fos1h",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Renaud Berthiaume",
                "uri": "https://maps.google.com/maps/contrib/110950392160095231570",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWlOu9rKnXbwAOqDppSc2uV5frw4_vgdLLKgPniD2JsFICMCxFF=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMxbS6ydfvB-ND1yMTjQoSsDCewU4GrOQBaCRk9&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMxbS6ydfvB-ND1yMTjQoSsDCewU4GrOQBaCRk9!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          },
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWqfT2PAJK-EmThNIvf6w6Qc4_wHotuqM5ILS5tbcS1WcAukJqkptDMaPCU1MrVkzRPyPSinBdEHIa72T8z0fhOOPz-TopNilXbwNicdgeZx5ok0GKRi3lunEwNfJWYE7bweprUD9RSSV5sn7kJVragT42RWX5ks8ELJ",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "MJ J",
                "uri": "https://maps.google.com/maps/contrib/112751449393459065919",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUSZoGqqSTG7FUhe4mrYP4m4wWa8HwiFBYbqVLuyQCpezOqHnYe=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMACiU6UngqeA_TJCankpBbvuZ9OnvHkg9awSHh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMACiU6UngqeA_TJCankpBbvuZ9OnvHkg9awSHh!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          },
          {
            "name": "places/ChIJX-RTBqksDogRRh_Q4ynbf_8/photos/AdDdOWrs4rN7LbPLHrPFokNfGnBS1o--SvIabSV3TU-zDpmpKCzD3wETUgTMQIQw6flnaoMyGTmxMKvU0LfJE-2YSXaA81pG1ckcY512m6HapKsRWgb21-HuaitHVdHtj0cPgTjpj3cd4_GXbr1Ekb0GtnDLHNhT9Y5RG6-Y",
            "widthPx": 2604,
            "heightPx": 2805,
            "authorAttributions": [
              {
                "displayName": "Gregg Daugherty",
                "uri": "https://maps.google.com/maps/contrib/115114243701319430761",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXsVdyf2UU2KnfcFnznW-foUY2-zxH-HnZW3ZGTqubC9zncfaVDGA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMbcKFzexYl9LsbKLpxSVn5gs4DuHXrQYF3QbQ-&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMbcKFzexYl9LsbKLpxSVn5gs4DuHXrQYF3QbQ-!2e10!4m2!3m1!1s0x880e2ca90653e45f:0xff7fdb29e3d01f46"
          }
        ],
        "goodForChildren": true,
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJrbU2qDQtDogRVUpaeaoBctk",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "33 E Congress Pkwy, Chicago, IL 60605, USA",
        "location": {
          "latitude": 41.8751931,
          "longitude": -87.6265739
        },
        "rating": 4.8,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 6,
        "displayName": {
          "text": "Moose Bubblegum Bubble Mural by Jacob Watts",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWpOqV8Ty2UosmCrlKaSXdcrBLnfb5ABpuSMyR_2Pd-mSJURZZpeYvHR-JJa6Z7qsz7bW9DN3xUCauIhEdoVfgle1DNu5E71rSnvv-kg1AI-mRWpja_y3Os614954qAnTMMcOQieKLhcghWZ7LXvZSmByBtX0hIOidrm",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOOTvGK7XjbF4dHjTZM5x52aAnLsZaqXQ0j-DOE&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOOTvGK7XjbF4dHjTZM5x52aAnLsZaqXQ0j-DOE!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          },
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWo1-m48CCIVISJIIhBveK58xKV3JFM41hMU84CSJCpm8UjG9_FHWBu8k9XGElObufA59-PGhIzO_0X_HmSsZg0-ynCRjB2secqgV1pNbBMGI15ya495hU14eXV8dQPfhkMaDvXHLSdyg8TKq9yY0sVb41KOWZO4bzr0",
            "widthPx": 2596,
            "heightPx": 3634,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNhSsV2eKlBl5ZKkuAbY57uoxQhqKvjFPdQgn57&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNhSsV2eKlBl5ZKkuAbY57uoxQhqKvjFPdQgn57!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          },
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWp7EYriJFmy-iJG4WmI3MXtFxyoi2AzLCaRtWxPHhOdk2sm4KfZ3hGUshxXcv24onSSof-pvEbEMrMA4BijTIsSNjLGKxPhO9hoQ3LubISrERAPmoSlkbSgb9KI1gy5PyYJLJn1wz_mVAj3vgpKmmFjl5T6-uUtFaKp",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNRgh7f3YscJ9TstHBxIVrTSgtfglSyKm5DeVde&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNRgh7f3YscJ9TstHBxIVrTSgtfglSyKm5DeVde!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          },
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWqrOHj-oEzuM1wE_KKAj855SGuTEQJ0EsLX-kyEttX1CoXDC3TEzMq7lMLHrZVJvrdJ2tER1mTNL_UYpqCoscxKv81gXuxFkY64NSkiKupioxh24sWzF7EHDBq6s_bSw4cxTrZmis29SSiE323ZW7ZUdnVkcDLZhQuJ",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNqbWuG1VcOLqb1avfYuo0e44oTiPRYbuJHIJzV&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNqbWuG1VcOLqb1avfYuo0e44oTiPRYbuJHIJzV!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          },
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWp_B7iJrtvO5xlEvWwbT7dIZzNT1Sk4rs78f0MH3SnL-dEWgt4eZub8qY0Lpk_yrHOMAJJRIp9fkbvBDA1_beoxYuHt0RPCuOj--59csws73Dcf0WB4_b6D608rrDh0UJTJ806kZ254CmNie-djy1Za-1JSEH_-NnjD",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Greg Sanchez",
                "uri": "https://maps.google.com/maps/contrib/104931574736569183932",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUcxDaaj2pX0oisszJXKVIWtKZyjiYt4d62TVICXsRzrXN_FAjq=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNESFk3_l83815DPGHsbZexvvDIXaiC_vs022s8&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNESFk3_l83815DPGHsbZexvvDIXaiC_vs022s8!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          },
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWpiUlbWzrBN2WtF7FZmmqp6_pnprDDYaECFuvqeN62xwzHa1wNbqoJP4rWFqbB5KTQtMpqFH6NjEu8kHJ9WXideWmb5c3nM21MeejoYqru_NA5TCStNJVbML30Ozarab9wpECs1etPlN5cldbmklVqFtlAJWw1DuFIw",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Hector De Leon",
                "uri": "https://maps.google.com/maps/contrib/106490959666986002887",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIZJ0Hn6O7-flvqD2SZlzQYMRMG_DeKhwOYcWB_ozlzLzwsAg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNu8d_5PuqBeT23A6UHX4tAxkefL53dSIfeedFW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNu8d_5PuqBeT23A6UHX4tAxkefL53dSIfeedFW!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          },
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWpe0q3RdUYXqa80BfJDOiPusZYZsveyMIbqgPJhkA8VwM8jrVMvhfFvGpHAGarwh7cJh8ehlzCnS10cBpayjRjShdtHR0giriC4R51clOdozbOtSeuHHuJYK2LGMnmCOunnklPx1xvYsipcGK6E0mTQMvekmoCIljTg",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Hector De Leon",
                "uri": "https://maps.google.com/maps/contrib/106490959666986002887",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIZJ0Hn6O7-flvqD2SZlzQYMRMG_DeKhwOYcWB_ozlzLzwsAg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOJ2lLctIf8Whc-GdFrEPgPr6eIgBB36HuFOXTe&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOJ2lLctIf8Whc-GdFrEPgPr6eIgBB36HuFOXTe!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          },
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWqOmffPzwBy65lhNIZNIN9UzvqVFYY-VdDbRZRL_YF3hgEBN7k6qkEA11Irn9RizWx33Lxyh0T_MWciFbjHiDFZ-KPun7T_6IBqbD38o3BDpmMyQsApXV_5jVBpPsIpam5Cio9FVSOHjhe2AMC1EjWQTgl9rm6hUQGV",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Hector De Leon",
                "uri": "https://maps.google.com/maps/contrib/106490959666986002887",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIZJ0Hn6O7-flvqD2SZlzQYMRMG_DeKhwOYcWB_ozlzLzwsAg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOvWB1vvNOgpZ01Q1xHnLYq7JkFo3bgJkaztkoj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOvWB1vvNOgpZ01Q1xHnLYq7JkFo3bgJkaztkoj!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          },
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWrI64WluUH83zk9GdYvZsSkEgTyph2v65hZdbUS6UHrdUJOys6P9lmf2aBCcIVSLaQKNQOWtvT8V42H8MyMS8TWZwnAyjpW5IPL_qhajJeU_BXorg5eZZjOZHDwvRVG82nKlA1420O9krgJcnzj-XreVVacoVVHITBb",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Hector De Leon",
                "uri": "https://maps.google.com/maps/contrib/106490959666986002887",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIZJ0Hn6O7-flvqD2SZlzQYMRMG_DeKhwOYcWB_ozlzLzwsAg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOgk1N5_a-j1JhI2U9ZNM_f_q_m1S03KWBTjv5H&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOgk1N5_a-j1JhI2U9ZNM_f_q_m1S03KWBTjv5H!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          },
          {
            "name": "places/ChIJrbU2qDQtDogRVUpaeaoBctk/photos/AdDdOWowra6lp_ZMIYUqpiLtAYS00ttzxTreMUm0qX2-UpHOgVMjTjUhVegnzPG4TvDNVal6SpJdM8nB-aNT3ECyv4_T6Eda8Cv7yc0qliz8mO2QS2kt6WhP39IzF8N85404HDaiG1mpjwHx4BmW3QpQ-7j3o5F5KLlleJwv",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOYT0WT4HEcIkaREVUgmA9gkLXQCNwo3ops65pM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOYT0WT4HEcIkaREVUgmA9gkLXQCNwo3ops65pM!2e10!4m2!3m1!1s0x880e2d34a836b5ad:0xd97201aa795a4a55"
          }
        ],
        "goodForChildren": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJ8bMHJIQtDogRIJZYKHYmxDg",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "33 East Ida B. Wells Drive, Chicago, IL 60605, USA",
        "location": {
          "latitude": 41.8751749,
          "longitude": -87.626760699999991
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "On the Wings of Change: Chicago Suffrage Mural",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ8bMHJIQtDogRIJZYKHYmxDg/photos/AdDdOWoeLOWEceuFexjUVbEG_t6NUZ5Hxl2u9PhyVl0paMPmpqS58cg_MMMXMSxgMulfcTPGGTGvOzoQvotWiE-dj-irTImtNkEiieW0-DQJoYJfgm-h70zBsA2YJhi0rH0BeY7nlpdpB-gn6sTq41KgnEF1zS96-VHN7Wav",
            "widthPx": 3264,
            "heightPx": 2448,
            "authorAttributions": [
              {
                "displayName": "Michelle D",
                "uri": "https://maps.google.com/maps/contrib/105585809089856008751",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLkC0yF3p65jfNWN2aez6H2J34v05aDCiZOgse3talXfjBx5g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM5D9aDmzis0q0XkqhrHYP6WaKQDQBAMAk6M0KS&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM5D9aDmzis0q0XkqhrHYP6WaKQDQBAMAk6M0KS!2e10!4m2!3m1!1s0x880e2d842407b3f1:0x38c4267628589620"
          },
          {
            "name": "places/ChIJ8bMHJIQtDogRIJZYKHYmxDg/photos/AdDdOWry-Va_119PiF-MvJcDhQq-yUi_-UyyqiFJ90Y8aD2N5LaB7dPIpkMU1wOFLuwEpa_us-suOrLzDPQKxuAUtjMDTGdAxLv8-Zlurlp4HE7WO-sq6XHgUVm8qEbVnQ6q006Z_WhxF4MuWqv_VkTABs04MF149X-FWTwm",
            "widthPx": 3264,
            "heightPx": 2448,
            "authorAttributions": [
              {
                "displayName": "Michelle D",
                "uri": "https://maps.google.com/maps/contrib/105585809089856008751",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLkC0yF3p65jfNWN2aez6H2J34v05aDCiZOgse3talXfjBx5g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNlGTZNU3_gqn_LIn9qhUg4nyfGYpEOT2HZWjJk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNlGTZNU3_gqn_LIn9qhUg4nyfGYpEOT2HZWjJk!2e10!4m2!3m1!1s0x880e2d842407b3f1:0x38c4267628589620"
          },
          {
            "name": "places/ChIJ8bMHJIQtDogRIJZYKHYmxDg/photos/AdDdOWrSNPJWUdX24ao5kOULkhqLTQCkaOz_TQf7RfiLuIYlbOz5EY7M6dMIOt5mh1wBt9wt8bJ5hToR0oPvs2bBPmVbtcXXtVeZYkLe4bZ6aMMNBFgeMSHYuekwsTKS8mOUrxltSMglYVpCJyH77XlILyji007JrB2kCQ8h",
            "widthPx": 3264,
            "heightPx": 2448,
            "authorAttributions": [
              {
                "displayName": "Michelle D",
                "uri": "https://maps.google.com/maps/contrib/105585809089856008751",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLkC0yF3p65jfNWN2aez6H2J34v05aDCiZOgse3talXfjBx5g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNMym5fevCi0Q_1BauO_6C-BZmkJ5aWaRuOlnb6&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNMym5fevCi0Q_1BauO_6C-BZmkJ5aWaRuOlnb6!2e10!4m2!3m1!1s0x880e2d842407b3f1:0x38c4267628589620"
          },
          {
            "name": "places/ChIJ8bMHJIQtDogRIJZYKHYmxDg/photos/AdDdOWoqum2LFKCH4tGjvytCL3NZ8x-LM6DWs84HIDoocFbmxM0hbxBB2ATijxezIBVE1OJfC9hSE0a4jCfOhvtnNN73Fx26n74yvghju6zu6maNHEeqXERUrmRiEa5AHmBhZjzHOskvsANSoKFbO2uUYLaVXkbcmN1BVhh9",
            "widthPx": 3264,
            "heightPx": 2448,
            "authorAttributions": [
              {
                "displayName": "Michelle D",
                "uri": "https://maps.google.com/maps/contrib/105585809089856008751",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLkC0yF3p65jfNWN2aez6H2J34v05aDCiZOgse3talXfjBx5g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOnbGYimy4b3Nh1B_96qYdY4ZO6CUegIvJpovuG&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOnbGYimy4b3Nh1B_96qYdY4ZO6CUegIvJpovuG!2e10!4m2!3m1!1s0x880e2d842407b3f1:0x38c4267628589620"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJaTOyQN0tDogR7HlIpZFff3o",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "290 River Esplanade, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.888884999999995,
          "longitude": -87.6207348
        },
        "rating": 4.7,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 11,
        "displayName": {
          "text": "Chicago Rising from the Lake",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWqJHS_p4yefNvyL2-GzPIcSRijPFREd7F5EwYZBBqxsE9fmILuUToLkjsFai_Z7mr6YLIgxvIwOpdy6Di7UhXqB2yEKKReD5PpXpCgvR7sodjfSmLkzKm-Po3ERqOGwWZnt7OSsPwGhKO7Eqvzl0vGnHXubdLx32Xwn",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Maged Hossameldin",
                "uri": "https://maps.google.com/maps/contrib/117968475923147851704",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW7cLVChi2ozTmgk6OOtcy2y1j6ZOFsoA2uG0PvhL3h8jKFvSnI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOdGhCeEjfUZj31LS9UiEy-DPPUPH8NqlTVmPFs&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOdGhCeEjfUZj31LS9UiEy-DPPUPH8NqlTVmPFs!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          },
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWrwU3JqQLPYBsTvt9QzUQdyvTOBywixWl-jCLCdTjRddBn0NyFRSsDuZSHb_f4GeJJUBgCQbO7OOUyZXmE82iub4ySkSR0_qrRhXnWfcnjSNV9Ka0uw1EfbaRmwqR8pHUkCi3Sj4NUUl-FREw2glblg6aBQS4lpu1sf",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "carla",
                "uri": "https://maps.google.com/maps/contrib/108687626748129036334",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJFJRef90jp0ETp8obQlz75Qcun3T8D79L9AtTYGTYpFbNNmg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNjSS46AeCf6CjXmmoZzw9wy5Mp4cP7xo39GGDW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNjSS46AeCf6CjXmmoZzw9wy5Mp4cP7xo39GGDW!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          },
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWp7fobDzmNCLtUDKfPm5hRwA7NWWOuf9k91VzBb9Yn7EzCao1mt2D2vj4w5sFA6l63VatcFuWYZVTC2H9kCxfximOZrDix0Wy9m5OTRsfLf0cDM8B2qyyjlDbw_sXNM5HkQ08rqAr8mgYmqTDjna3YOMjpVVjIf475_",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "weichao liang",
                "uri": "https://maps.google.com/maps/contrib/105634024172928345098",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIiDV-UpiQZz1yIVdboOChjn-JkAVoZOFBICnJaAr9lm-FXiQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNV_Dlw3ECIZwScbSZ1-WAhLy3R7qsbr0z2bylW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNV_Dlw3ECIZwScbSZ1-WAhLy3R7qsbr0z2bylW!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          },
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWqJZBQ9639rMfm-6_SqJzaBIRTzNhu5P-m7R2e6Sm6o0NWsAad3sG8i9y1tiXHqJ8qxrqre2arBvAnsdSJt7nNfdlYDppwMZ1lyh9g1l-vDKp75O8HAlgwrexadzoj7XbQpfnht_hmqyEqIXXdJWDDy_Os4Gg_MO7WD",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Jay Aviana",
                "uri": "https://maps.google.com/maps/contrib/116364601228449896522",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUH9MJqQXsWGUc0vlsTGM0A6qzYIZ3mNonIH1Z7efql3tBSB7T9Cg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPZkEuYqOT7HWW6ib5LS2JMPvW5H3THw_U8Zsny&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPZkEuYqOT7HWW6ib5LS2JMPvW5H3THw_U8Zsny!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          },
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWp3wr0nQZz4WZH_Z6Pm8gUrsjw6ffBYp579vIsYOq-E2P0e7GX0dChVwqQfCOFqEwU_RTpAXXWMNUuod9l0Bu0MvL3EQltSmH4-7YOcn52JrIIErGKqIAiiIqAfuERmkx73YJvgxNpZNyaGvScE-DOuPh2a0BbY7cJV",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "carla",
                "uri": "https://maps.google.com/maps/contrib/108687626748129036334",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJFJRef90jp0ETp8obQlz75Qcun3T8D79L9AtTYGTYpFbNNmg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMTPYfM8k-DVH8ZtqGDFptaGMlmSQ7cUjyIoh_Q&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMTPYfM8k-DVH8ZtqGDFptaGMlmSQ7cUjyIoh_Q!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          },
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWp0UZRQQWJspq44C072WZmcDtAFkLefjkk3MQLklZn8itoFcHAiCUQ8VR9TwZ4EIgMv8qWfwDkg3r7eVgkiM_5q8iTjpRARVer20G32NV5x2HB8FDru1z1HDJTjHbWpqF4iDDeQTxhLW_8V0QQ3xfN6MjEDur_Rvl0d",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Jay Aviana",
                "uri": "https://maps.google.com/maps/contrib/116364601228449896522",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUH9MJqQXsWGUc0vlsTGM0A6qzYIZ3mNonIH1Z7efql3tBSB7T9Cg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNYWYSluB1i7OJAwwhhokbA5kXiBXcAlJAK6fYP&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNYWYSluB1i7OJAwwhhokbA5kXiBXcAlJAK6fYP!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          },
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWoQSJHyzc692YwdduO6oqprUzuqmCoLKVojr2wji7IHswWE-6MqeBTAaGiC7m2BXnax1laFxHE2Q3yELfbyYy9sl6yS1254RrzHPw_wI1xdtyADDVQwVSTmLNtQLhglN7AcDvqZbW8BjWwNPomotg7LWbrBAYtxmb5M",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Virgiliu Lesu",
                "uri": "https://maps.google.com/maps/contrib/114103802034049446049",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXR6mV-r2E4bo36ROkr9OW0Ul3A_M4sEutyNWARbJcfZuaPT1-3kQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPc2hDLsp8n4E5YxzDz3oVJtXlV0_1x9AF3qSyA&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPc2hDLsp8n4E5YxzDz3oVJtXlV0_1x9AF3qSyA!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          },
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWomyhi5Fx5PtBdB9nqnl9bsdmNzI6fO5vmlD8xW2FoADqMpp9tkefZAXrV38B_POh70iKSv05hiTb1d6iU-8ZrwpCaoBfJLTYXb6juGOG3d2pIwXJpAtGJihCuYjqMcyxKwczv77cirnvFm0i0T00kBAuYdv-Wjv9I",
            "widthPx": 1200,
            "heightPx": 1600,
            "authorAttributions": [
              {
                "displayName": "Oleksandr",
                "uri": "https://maps.google.com/maps/contrib/110738052506846867393",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVtaDBc1BMcreygCZSWpujGxLHDiyY85wFqDOnfZdZp3Bee_rQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO8iJM3QPGROe1GKEOHUtyCw5OAF-JS_uhxgPw&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO8iJM3QPGROe1GKEOHUtyCw5OAF-JS_uhxgPw!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          },
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWrD_PAvYF1h772BtVPbLOJeDYrG7JpPKn8V6jirXTp_mjadJiAuk7FJehUN0xIak3_yJqtQfHKI6rPPRezEN0uk6nAiy0d4_kJ8tBm0_xCRmHCyfusGVuFRVZ6cl4CSRN-Qcnn-ti67xpLzpA3wmbkUD3nQEcT0_nJg",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Virgiliu Lesu",
                "uri": "https://maps.google.com/maps/contrib/114103802034049446049",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXR6mV-r2E4bo36ROkr9OW0Ul3A_M4sEutyNWARbJcfZuaPT1-3kQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMMGXd1WzIEnGV-lV_CLJjxs_hsa3e-nGhde12_&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMMGXd1WzIEnGV-lV_CLJjxs_hsa3e-nGhde12_!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          },
          {
            "name": "places/ChIJaTOyQN0tDogR7HlIpZFff3o/photos/AdDdOWokWY96CuV7JS4VyUm_BYr8mTGaQAq_XU-lL61FI1kwOlXMZrAPm1pzCO7ssRfZFgIQRbl2rzVcOlEUMbdLFTl5OI9Qnmcar7rOeE80UEkas-1BBE2u0SR7w6L2chWgFlw_WtPaYDAUecJVWmFwmnJomB2M7GTtCfe1",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Virgiliu Lesu",
                "uri": "https://maps.google.com/maps/contrib/114103802034049446049",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXR6mV-r2E4bo36ROkr9OW0Ul3A_M4sEutyNWARbJcfZuaPT1-3kQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPFvmWANBcoz9tIzgE1AZkV77FzTf2N54a2qhqi&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPFvmWANBcoz9tIzgE1AZkV77FzTf2N54a2qhqi!2e10!4m2!3m1!1s0x880e2ddd40b23369:0x7a7f5f91a54879ec"
          }
        ]
      },
      {
        "id": "ChIJWepn510tDogRHaIfZ87atxQ",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "120 N La Salle St, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.883685799999995,
          "longitude": -87.6326729
        },
        "rating": 4,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 2,
        "displayName": {
          "text": "The Flight of Daedalus and Icarus",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJWepn510tDogRHaIfZ87atxQ/photos/AdDdOWq15dA0IvTKObZd7A0EX0DWgyq_pOVaJDpZvIiEd76JkEqUC4jwB04hvMhBdr-aOu2HIIsOXl3MzkWlHQD2nPN2tyb8u2E4LhuCEas5TRIB6KX8N7VeHW6zTVXJNUkjJxBKt3zrYNHGPXLCZbFyxBRmNwQXkuyWycXc",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOH5fvpn1AtUdr3I2nWoeMGLzsI9S7SjRIyp9ek&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOH5fvpn1AtUdr3I2nWoeMGLzsI9S7SjRIyp9ek!2e10!4m2!3m1!1s0x880e2d5de767ea59:0x14b7dace671fa21d"
          },
          {
            "name": "places/ChIJWepn510tDogRHaIfZ87atxQ/photos/AdDdOWqWODfOtmDSIfUH9N2j_uIMWM6fwEGiIOfVSKjREnTyJT1N_aAxpdt5wyeRg1OLl3ysJ-ANZBXFdU5S6Yh05BWiuP3Ug2Gp7VB7UNS1xIzVGlTbOEbGeYhzh1Yj0-Gud3OCkdszyc19vz3jum8JrUqTMK6TrJlGsEQS",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Jana McLaughlin",
                "uri": "https://maps.google.com/maps/contrib/100197819751459613880",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKOvpypRYX-rgrL-0iPjmzfg7xuIHGnkoR3MNneoHMlBZaNSQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOuXq5YYlDFeiVIhCh8nQHORR4mk2u1IP_wbi4h&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOuXq5YYlDFeiVIhCh8nQHORR4mk2u1IP_wbi4h!2e10!4m2!3m1!1s0x880e2d5de767ea59:0x14b7dace671fa21d"
          },
          {
            "name": "places/ChIJWepn510tDogRHaIfZ87atxQ/photos/AdDdOWq86l4GuyHXYwbAouRROu_axUVZkX6LeJUtGijrbWPAXFkowjn-S0C9IotzytN9R7d5ZM5iUH2yROirYuC5eVMMLiGPfAzyDmcQhKFS5gJdpXqUPuY3Yu4-_vNqZR7tKDDSMf-6svNj4SY7amZPPWOS72A7BY-1hzfi",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Pavan Rama",
                "uri": "https://maps.google.com/maps/contrib/112325643636948738666",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWZe8WuO5bBf_h1W4ef_5pfRpd7LHNcOfvsJM7TKvPU7_eXGDWQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNJHoSlBIQtDe-i93XDNghCBmil62haKxQjMLkZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNJHoSlBIQtDe-i93XDNghCBmil62haKxQjMLkZ!2e10!4m2!3m1!1s0x880e2d5de767ea59:0x14b7dace671fa21d"
          },
          {
            "name": "places/ChIJWepn510tDogRHaIfZ87atxQ/photos/AdDdOWq0zGqaTLcD-TXZbnhIgI5xsMMztlD84qN8hGPJOMP8ubEIN0JPO3JJ0xYO5EYEVWvRme3yT9xRs_fkHvHVLWpQj80OdlDv1Cx0LaLrVGg6M3U8biu3H2E5DI6iz5kduAZOzyKt14eBQjlI5VayIxnRsq2x4GFK7KjT",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Nick Storm",
                "uri": "https://maps.google.com/maps/contrib/105091578901420480046",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocILbS9uMx8Y5rkyUI9hKBZGMt2SJ1mkg4-54_kiMJHTAtgzUw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM7Ty4qF8AKYROrrkHjjUEnWNrcZ2Y6eel8noiX&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM7Ty4qF8AKYROrrkHjjUEnWNrcZ2Y6eel8noiX!2e10!4m2!3m1!1s0x880e2d5de767ea59:0x14b7dace671fa21d"
          },
          {
            "name": "places/ChIJWepn510tDogRHaIfZ87atxQ/photos/AdDdOWoAXGQfB7WSKxIhNVKbrcWeJtl-8nn-hkvnDwfDZ4ca9kVcHhoJdRfDoGAEa_XLZKyPlrlYb9vmkxeGP8LT4oeoswh3RIieXNsJTn4qEXF5tam9SWlMxf8YWVPI5PaO5maoBywlfEzv6FyrTBgoM_pRl1iA_PfJbc5L",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Pavan Rama",
                "uri": "https://maps.google.com/maps/contrib/112325643636948738666",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWZe8WuO5bBf_h1W4ef_5pfRpd7LHNcOfvsJM7TKvPU7_eXGDWQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOSl9tkq9wAZNMlivlVMQ74SxMaIqG0gCSdft18&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOSl9tkq9wAZNMlivlVMQ74SxMaIqG0gCSdft18!2e10!4m2!3m1!1s0x880e2d5de767ea59:0x14b7dace671fa21d"
          },
          {
            "name": "places/ChIJWepn510tDogRHaIfZ87atxQ/photos/AdDdOWpFZzVa6ohvgEd4nMhP7NpV_uGcAdQDF_3_1Oskrdi71UFNpBIbTb5MfbCqgRRnUFEt79N8A-BWGpnpIgGFd7ogeMdjQFgHvdy7y8hx_FueiuJ-NG7wj1_Wn-i3aK8Jgp_tf7NobCHH9Lu9Nt6FLERjZiR-KDHpQunT",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Angel Bucio",
                "uri": "https://maps.google.com/maps/contrib/116526394065375639511",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVf5pFyPLrhDddRJTE6NjjsHr-KgsW_XS9V4OHB9PJbb9BuvPcn=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMMENlNQo3WOBYTJbQ4cO1gza96pEWMTHp0xbIL&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMMENlNQo3WOBYTJbQ4cO1gza96pEWMTHp0xbIL!2e10!4m2!3m1!1s0x880e2d5de767ea59:0x14b7dace671fa21d"
          },
          {
            "name": "places/ChIJWepn510tDogRHaIfZ87atxQ/photos/AdDdOWqsmmOunfTkK0_dZc9O9R2jceQFEp71SVwHRhYmwo_-FO9Fw2x-VKAV3_cKSxCR2ekAhDUHXiXrkpzr65RrS_uFG6_of0yPDcufp9cP_O_4ebD2jBS2R-MELnEiYvuI1gJrbA9mimFkv-GoNwZhXdARvM-Rgjqzu0q8",
            "widthPx": 400,
            "heightPx": 267,
            "authorAttributions": [
              {
                "displayName": "Marco Fantin",
                "uri": "https://maps.google.com/maps/contrib/116323534747701880524",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX4Sk7_Rbk_la_NBZPBwE8IufVyIJhe8vYFH15cJvthVHIZlDUU=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM-5EhCoWWPq2WhTwxuhF70XJe2jZGUYOzdh4wn&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM-5EhCoWWPq2WhTwxuhF70XJe2jZGUYOzdh4wn!2e10!4m2!3m1!1s0x880e2d5de767ea59:0x14b7dace671fa21d"
          },
          {
            "name": "places/ChIJWepn510tDogRHaIfZ87atxQ/photos/AdDdOWqMTfXvbmONhxkrcQn9nh2El-f4mez62IoMLysLDC1TrT5sZMaFJU-_Lixds_-T9OHtDMkEYj0-xZnLIZ7-4NRnqBS6zqsCaXdXr93-FjWmfPnnQ7JWpJcQhVE4g-Jrczp-lnGWmYg9gSsRwuXsUB36jLCJ_AtMToXE",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOFoKNr0H5e1tleuFEdiLC_kvW8veqApxw2tMXG&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOFoKNr0H5e1tleuFEdiLC_kvW8veqApxw2tMXG!2e10!4m2!3m1!1s0x880e2d5de767ea59:0x14b7dace671fa21d"
          }
        ],
        "goodForChildren": true
      },
      {
        "id": "ChIJ-Rf5PAAtDogRwsO5XSP-aHY",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Gleacher Center, 450 N Cityfront Plaza Dr, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.8891651,
          "longitude": -87.6225607
        },
        "rating": 4.7,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 3,
        "displayName": {
          "text": "Shoreline more Chicago",
          "languageCode": "zh-TW"
        },
        "photos": [
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWoxP6-N18_Cju9ZRwt0qq5e2Sf2sA4gZpBrCMCVX6v-RfLNJzYGq9RiNzVohHWj7wr8fmjVNNnOLGJvdieSDoHUKI-aU4UskfI6Ko_CUa0-UhRGqMiFzgdwlSAfCn4EFaETG_Fa_TLfElLKxBboQWS5vXJgRmQpq_nm",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Robert Bloome",
                "uri": "https://maps.google.com/maps/contrib/117900323322694945934",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX7fOKAkFDiLM6JeJ6Jp-jT9Y7DMYlnQlSj5P9QoFnuKxIwm_c=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOYdtN84e1IpIsq0spm7a9nSaOtyXaJZAqCWdAN&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOYdtN84e1IpIsq0spm7a9nSaOtyXaJZAqCWdAN!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          },
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWrDzx70QtDouy5VX_Yy6yFkDOvkJDwWhW4J6_LayJblnOcaKcTLdzJBnonhnXQ1roSfKcOFVpqSLsZ9-vvvHybduUVykIsI-WOjEDUUlvqiLc1ipMxL5nF3wCWOo_7PzaRf0QKsCCudZ5UvgzSvUpGAlMQj8kLu2tT_",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Erick Hasbun",
                "uri": "https://maps.google.com/maps/contrib/112779466149239874964",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUg2O6RjBA8W4nWV_5Az2bJsCt0ZzNgN4Z_p6dLj94Z_rS1Deqrmw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPb1Ab5kA7An5tHZuEMBDy2I56Kkqgr1ny_Q3-M&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPb1Ab5kA7An5tHZuEMBDy2I56Kkqgr1ny_Q3-M!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          },
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWq0Qkq0o1KSXPCzOfPjyKpqb6-pMpub5HjxU_HEqgforqfkI6nN3s0MnnEIkhaTUQ2NmySEs4oOHNszb5EuXydt3kNlCSC8HYHdZ197e7KsQJbUGxExIw93gqG0hbMXyEhetDhM5U8ABmNV_e3rSgbvaorQYVApuGez",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Erick Hasbun",
                "uri": "https://maps.google.com/maps/contrib/112779466149239874964",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUg2O6RjBA8W4nWV_5Az2bJsCt0ZzNgN4Z_p6dLj94Z_rS1Deqrmw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOPIcA3Wb8zEvzKTAvJ0yfg9dKA0j0diULddI4N&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOPIcA3Wb8zEvzKTAvJ0yfg9dKA0j0diULddI4N!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          },
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWoL62kuGMPf97f5yUsIzwvwMAcXBitz31aeKli8nz3ZFHWsGR95GAzu_JYgnLVhL9a3T-ygWXkEgYF8JkHg1y3skO5Tf4YVNKVU5LlrjewaEmYZUhy8lhZbpB9hlgQwOXR03ZDRChefO7axC-oZ6fcbaDuubcfPh_w5",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Erick Hasbun",
                "uri": "https://maps.google.com/maps/contrib/112779466149239874964",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUg2O6RjBA8W4nWV_5Az2bJsCt0ZzNgN4Z_p6dLj94Z_rS1Deqrmw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPRfEY_Ii4BsDxkYQ9dAC_iPFixzISKJBVCVYrB&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPRfEY_Ii4BsDxkYQ9dAC_iPFixzISKJBVCVYrB!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          },
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWpgnzd0yNIZP4L1-gMC37Zrh_-JI4kbmU2_isQOCQSMaq_gOJtfKQgJrZSrtg4TzQaxTXZejdN0WEGbkjK4tOgJ44YiptOeJYeWccO0yLpb_a-2qmrl1a_9jpf5TPbQyvHnhOEl8pTcL81uVMF4Wibk5JBoGXQFyOw3",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Erick Hasbun",
                "uri": "https://maps.google.com/maps/contrib/112779466149239874964",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUg2O6RjBA8W4nWV_5Az2bJsCt0ZzNgN4Z_p6dLj94Z_rS1Deqrmw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOVJFuB9lOPtfyM45YKJQIrRL5WFsxBd2olUzlU&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOVJFuB9lOPtfyM45YKJQIrRL5WFsxBd2olUzlU!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          },
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWpT4gX5l8bk2205PU6GqoAoivyaWVWtN_YbbCc1Z-NsAQ02rhaqICqzYnfP-sL1Hd3Gq4oRR9TZIix_N2DRcS3YX6-yeT3N2L0zENltaIS4BqQHNbKio0AjkH7bIu6bdHrvlgV65_zjVBzgtW1yrfo6EZKKwwD3e0kI",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Erick Hasbun",
                "uri": "https://maps.google.com/maps/contrib/112779466149239874964",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUg2O6RjBA8W4nWV_5Az2bJsCt0ZzNgN4Z_p6dLj94Z_rS1Deqrmw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMRd0IS6MOsIY4-7LlwWm7pxUUGi6lMjYRUESdL&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMRd0IS6MOsIY4-7LlwWm7pxUUGi6lMjYRUESdL!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          },
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWpot8i1vrV4k-zgLQPaywNRkd73Swcb1aFgR9MJDY25bk1-vT-zfappLB-MW5qXBktB_q9nCr0W7uBHweAPHqj1GpoaidWC28Dx_u2liM3eQWvmdCeTdzDo7UPYzLl_vU_FY4iTFHl80TsPKiUdg-vcByBim2VcwqKG",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Erick Hasbun",
                "uri": "https://maps.google.com/maps/contrib/112779466149239874964",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUg2O6RjBA8W4nWV_5Az2bJsCt0ZzNgN4Z_p6dLj94Z_rS1Deqrmw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPJZ7U1ojv3KebMD0qeVxi9--BNMGLmO1esNDOD&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPJZ7U1ojv3KebMD0qeVxi9--BNMGLmO1esNDOD!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          },
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWou6qZBkWYESVQR22IFZAzLKwl_B31gLwY7Nn3ZojPJRZOzyeuyGkrxcg0X7ceANKndHwYeN5rUgU5tJ89VnPsf1OM5G9JXzNxdVGhtSvAKXasXfqW-3VLwuy-c2VArVTOIp0SsNnDLr7PPFdfXq4bo-sisR81Q46pk",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Erick Hasbun",
                "uri": "https://maps.google.com/maps/contrib/112779466149239874964",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUg2O6RjBA8W4nWV_5Az2bJsCt0ZzNgN4Z_p6dLj94Z_rS1Deqrmw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP54REEbcSrqBj6W6sVgNqyRWXZWYgPmqcbr_dn&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP54REEbcSrqBj6W6sVgNqyRWXZWYgPmqcbr_dn!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          },
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWrAa3xjosN5OFIH1aK4-VFELOZD5JFlOmbmByqoJnz1NO5I0wjoH7OKFTTHYDU-FU7JRPGvHW265kCzlxtXXPTEAwER0CslGCtvMe5CdAIMBxUMsNuoZCbakqtPz06M9eDL1hC777cwbhrrXj5luk36jHcoMGHZcLMN",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Erick Hasbun",
                "uri": "https://maps.google.com/maps/contrib/112779466149239874964",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUg2O6RjBA8W4nWV_5Az2bJsCt0ZzNgN4Z_p6dLj94Z_rS1Deqrmw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP8baORbrKRKOY65ZrAcI6ELBJHt34sqKHJAV0w&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP8baORbrKRKOY65ZrAcI6ELBJHt34sqKHJAV0w!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          },
          {
            "name": "places/ChIJ-Rf5PAAtDogRwsO5XSP-aHY/photos/AdDdOWrwfstlbBu8o0zlTykTD5cJkwjJSok8BwfIavzP9w98fXSbug_ABaTOPit30XAdn0ERzssCXg1KJmakunuDJQs_WwKqSQIoqoQABBGMFduhxrV15Yhd2t84SLVOjOcigXghOkec3gfcFtVyJQIZ4HTmAxYRnCqXUXYN",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Erick Hasbun",
                "uri": "https://maps.google.com/maps/contrib/112779466149239874964",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUg2O6RjBA8W4nWV_5Az2bJsCt0ZzNgN4Z_p6dLj94Z_rS1Deqrmw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN-9pmGUMWfKvVLRgI5wWD92jtZQFDPVCDYlwC1&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN-9pmGUMWfKvVLRgI5wWD92jtZQFDPVCDYlwC1!2e10!4m2!3m1!1s0x880e2d003cf917f9:0x7668fe235db9c3c2"
          }
        ],
        "goodForChildren": true
      },
      {
        "id": "ChIJ5T1oEwAtDogRyufDuX9Xskw",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Gleacher Center, 450 N Cityfront Plaza Dr, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.8891651,
          "longitude": -87.6225607
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "芝加哥河岸巡遊登船點（City pass) Shoreline River Tour",
          "languageCode": "zh-TW"
        },
        "goodForChildren": true
      },
      {
        "id": "ChIJjSGyi0QtDogR3M3Lgyur5SI",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "410 S Dearborn St, Chicago, IL 60605, USA",
        "location": {
          "latitude": 41.8758534,
          "longitude": -87.628962399999992
        },
        "rating": 5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 3,
        "displayName": {
          "text": "Loop Mural",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJjSGyi0QtDogR3M3Lgyur5SI/photos/AdDdOWrAa2y33C6Wb5sOcUas-8kqCkcN5ZotaYNtUAmC94MYcmQAhuCHdgoFdpoXA1D6SCBTX3OUF-FTF4IIGBCzP6ttW2VLFFc3AzH47SYvYaklJqE4ZyVSwBQyfs6Fa6_8vjZAz0hPW3tczy4MaDkv0-le9_zlNoU1ZGQ",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "A.S.M.",
                "uri": "https://maps.google.com/maps/contrib/101222577845999556832",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIQ8f8PvRaCdd7g7S2I5DY0Te3AN8cHXDvZ6Vbnd3s7Xa3M=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNrRP4NQEF3_hHLBJHWLhpFKyyoZw2MpSPt3Hk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNrRP4NQEF3_hHLBJHWLhpFKyyoZw2MpSPt3Hk!2e10!4m2!3m1!1s0x880e2d448bb2218d:0x22e5ab2b83cbcddc"
          },
          {
            "name": "places/ChIJjSGyi0QtDogR3M3Lgyur5SI/photos/AdDdOWqb41BXxJxNSMV7vWAPWCE44ivWa3U5MyqRUpEupcz_Izsju1zYN7uoq5TTo7sAGUaY_g0b8GwnLr9Bv3TFIwJnGtbvPBgjOTm2sb-gE_3OQHNShlQphvVa5gMmljffnF4gzlN7-UX2nLhxtMtxoCcThpICjzs2rqr2",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOJkBeTYZoO55_zyUz99zAP-R2hQsxfZwM7u_LZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOJkBeTYZoO55_zyUz99zAP-R2hQsxfZwM7u_LZ!2e10!4m2!3m1!1s0x880e2d448bb2218d:0x22e5ab2b83cbcddc"
          },
          {
            "name": "places/ChIJjSGyi0QtDogR3M3Lgyur5SI/photos/AdDdOWrslvpcdrygACxlU1_zvtCimu0vKWqcq_hbqSRVA_BNp0xDUmXsD6ISnn2IAnAKLkjANGLncaAZpRCeY06M4fxth3iEz_3139Eu0EsiidmR6E39Dp66JmEdjAIWI4m5ZcTG66DJJtQudB1lHItgpAgVTqepDcEVTIeI",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO6C_kQOncl4qDdM7FGvEz29FcHe-ORQ3FKNJWK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO6C_kQOncl4qDdM7FGvEz29FcHe-ORQ3FKNJWK!2e10!4m2!3m1!1s0x880e2d448bb2218d:0x22e5ab2b83cbcddc"
          },
          {
            "name": "places/ChIJjSGyi0QtDogR3M3Lgyur5SI/photos/AdDdOWqfd8SSQ9c-mMrIxd5ZMa3GoH34RUi8w9AKhKpTF5IcFHKesTW9_EKdbJhUT9R7tNRYIQd_khPOxvFpOqy-gnzQH4vvhOObjpfmUOGxQP-UwhQIrbWEhsewxagqFNlyk9UTf3n9TUdoin3oS7a3rke1yeI0fFN1a6P5",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMUuky8H0eP0MKqFc0ZpUJ3IFeplNQgscbGnySO&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMUuky8H0eP0MKqFc0ZpUJ3IFeplNQgscbGnySO!2e10!4m2!3m1!1s0x880e2d448bb2218d:0x22e5ab2b83cbcddc"
          },
          {
            "name": "places/ChIJjSGyi0QtDogR3M3Lgyur5SI/photos/AdDdOWrNCIYjvZITasG09oXlJ9crQMxT4xyiXtK4cyGUndlpBURu1Sjww73WUtU97VmZzSqL0k0u4bJGylNm7JbnY5rs-51J9HLSZuaCs-t9UG5K7RiK5x4vlTJZx0Y8kFH9Y49YGbNjYSDdRSnBUrYEyIlN7FpJCqJAY2yA",
            "widthPx": 3474,
            "heightPx": 2793,
            "authorAttributions": [
              {
                "displayName": "Mamunur Rahman",
                "uri": "https://maps.google.com/maps/contrib/103076330224437009930",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUKRZE1DeLk3PfaKPkJLe19fmTEAVizhyugaR4FCrfx-4hLASXk=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOFH8JQk2iqeb3kdbH4N-GBKvQZ6IiOgE45rbCG&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOFH8JQk2iqeb3kdbH4N-GBKvQZ6IiOgE45rbCG!2e10!4m2!3m1!1s0x880e2d448bb2218d:0x22e5ab2b83cbcddc"
          },
          {
            "name": "places/ChIJjSGyi0QtDogR3M3Lgyur5SI/photos/AdDdOWr9p-0LmzJwEkAYoKoWQsxYDm7YQrvfQVZB4AtlIFvF7w7GldaYCb9ZLk0B84ecmOqQa-FLPN1Mf5cnUSZIF1rHWEi3jfKM5lxEdYTlj0TjsP39qzxBHmPMlvOb1divBaDywT2yzExP0dBmnfbn_YemalyGoDkizU48",
            "widthPx": 715,
            "heightPx": 715,
            "authorAttributions": [
              {
                "displayName": "EARNEST KING",
                "uri": "https://maps.google.com/maps/contrib/109568179906575426608",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLMW7CADY9B3UmBu_u5puqFEjJB8UxysGh1oAJZ9s609-_qUg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPoNpsiZJZNQ0o7G-NNb2Jo8yrLyF25-fS5SvYP&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPoNpsiZJZNQ0o7G-NNb2Jo8yrLyF25-fS5SvYP!2e10!4m2!3m1!1s0x880e2d448bb2218d:0x22e5ab2b83cbcddc"
          },
          {
            "name": "places/ChIJjSGyi0QtDogR3M3Lgyur5SI/photos/AdDdOWobbUZt0QxoqHIKmnJMpHSIkoLRiGNmPk-3EL9LSfRvpQgrSCJ1rFsV0m5wLJ4Wr_GcerpOm420j1h0bZeVyCiEYjeOfMJUt7w9hh2oVwCiM5hlWyt--y_5gypVOIsvJ7uK5dzof6E5Dw-Zp7hAXwIEGtBcYvgAKkzn",
            "widthPx": 2440,
            "heightPx": 3253,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP7oDxTWJPnauwN0jgklJ3bw8EUFl9k6OrN6HFr&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP7oDxTWJPnauwN0jgklJ3bw8EUFl9k6OrN6HFr!2e10!4m2!3m1!1s0x880e2d448bb2218d:0x22e5ab2b83cbcddc"
          },
          {
            "name": "places/ChIJjSGyi0QtDogR3M3Lgyur5SI/photos/AdDdOWpyr9LZLFlUwRGGbu8_3IS18ecdEP33yNUEg3zJ2Aehbfw8mKqjInNLadn4SJYyOM3J9nC4vCO4EaC3IBeL1I9UPClNv5lymWCs1p6QRhB8ymNRFVtqLg5WMzEcfJ58vEKBc9NWVMR4g3F8WxdaRL6plMhRx8Q9385l",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMYO5RgB4ZrT8uelEL8uVXRDbhMnhpn12ttGcHt&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMYO5RgB4ZrT8uelEL8uVXRDbhMnhpn12ttGcHt!2e10!4m2!3m1!1s0x880e2d448bb2218d:0x22e5ab2b83cbcddc"
          }
        ],
        "goodForChildren": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJka7_dwAtDogRKdFdZVzXDSE",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "300 N State St, Chicago, IL 60654, USA",
        "location": {
          "latitude": 41.8879039,
          "longitude": -87.6289943
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "Chicago Boat Company",
          "languageCode": "en"
        }
      },
      {
        "id": "ChIJf1ugAQAtDogRgde6XRqV1B0",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Manupizarro Square, 302 E North Water St, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.8894464,
          "longitude": -87.6217563
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "Great View Point in Streeterville",
          "languageCode": "de"
        }
      },
      {
        "id": "ChIJ1a07FgAtDogRdsTD4Q9NgZE",
        "types": [
          "tourist_attraction",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "151 W Adams St, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.879312999999996,
          "longitude": -87.632999
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "Second City",
          "languageCode": "en"
        }
      },
      {
        "id": "ChIJDaRlAOEtDogRQEj4S6xKRMo",
        "types": [
          "mexican_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Michigan ave &, E Monroe St, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.882197999999995,
          "longitude": -87.622585199999989
        },
        "rating": 3.5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 43,
        "displayName": {
          "text": "Caseras sabor real food truck",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWrHelwW15blsIxu3QETGxwTI11HvcOuUkthrE2o1nyLOU1PqfcQQAA5D4hpiAATzDHvheRb-dZzyKGELcsfIciw6ZdXDkYZh-C4SBjsIZ051L0_rq9rsk0UDC2ygPgi1HfxLFfNCMEe1hWEZfQ0JNCl4hPFuLYG8pHh",
            "widthPx": 2048,
            "heightPx": 1463,
            "authorAttributions": [
              {
                "displayName": "Andrea Amezcua",
                "uri": "https://maps.google.com/maps/contrib/110934832584710638790",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLvyMw1RjxgBKNiKLb5tMbI17TJn3NokSSpdFXLMpRNXZUdqQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNezaI025dKlqiNtFraAwCx63rj0AmFGNFkavWn&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNezaI025dKlqiNtFraAwCx63rj0AmFGNFkavWn!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          },
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWp-L6hQ3joqVOAVfwhSyfpfb83TvqTD7-RPDX_3uruUTYQDu7KN6JaYPHX0Jwld-e-6v6MoL0eKiuM_r-Lihss3xYpjlwY7H8q8wA1S1CKATxOo8L46ayW9JCPkkdtyz0n5Uk7yA2HVRNZQ6UAYpxSOhEe0Yelr64Z7",
            "widthPx": 4160,
            "heightPx": 3120,
            "authorAttributions": [
              {
                "displayName": "John Wagner",
                "uri": "https://maps.google.com/maps/contrib/114187597593536032667",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW9QLxp3aaaAKztdknbKw3ZxWeIHzwCi50kE22Mlin857ZXoZ0=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPOq7MZvCKqTvu6DjIG9EVXJKqhmYWIn2325-91&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPOq7MZvCKqTvu6DjIG9EVXJKqhmYWIn2325-91!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          },
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWo1GVtye79pjvOlQ1sHwky8SvPluC4FLN7lxTg_Fk-4cMfzRo4c2a1Vw5XKRDg71Kw0rKjuYN4LALzjBMl_8LF9PyBtp8IKsfaokWBuGsqXmtwTu8JzMl56mX6LBunX2MGBEWeyT_J1GWu2iu9e00k_mgaK9jSeBv8_",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "Narendra Landge",
                "uri": "https://maps.google.com/maps/contrib/101886061033009951746",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXK-LipNV_j3vAU3Rks921bbuKFaO8FZgGirsoxZv_NP_XoI4Eo=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipORl42ifbX5cS1CdLgk4H-CojCLO5iJPmbqbP7N&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipORl42ifbX5cS1CdLgk4H-CojCLO5iJPmbqbP7N!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          },
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWoKdVCiCLLIK6jHB4GWdm3CfNwuzmw-tjzydDuQBCt5VZcjzhSUeC1Aj6sRukedPZErSNG1h7oKfPwyv81WlOlW9PiiFk4BWlsJOZ7Zk606bTSs_FVaL8HqdrCOgQ3eIgacecUE-OYSN8-PtkgmtmQojh80Ih8EGcg",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Abigail Ouankeo",
                "uri": "https://maps.google.com/maps/contrib/108645468812288368118",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXWP6AyWhMY5Vl285zfyMQHeluUhv-4tuk_pcvuVihst8lDDQE=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPk57cJqFjGxnWaLbwhDWmrGUbU62EqvXkEukY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPk57cJqFjGxnWaLbwhDWmrGUbU62EqvXkEukY!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          },
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWqsb6Xar9whYa21UiRGEWztk1IhXGUpMcFsr5Ab67oJb6HH1bglb7Y3z22sQReVHAozWFTDuUjbxzrue8dXvfFJ_CmhqDV8ykgpsdnIjWUKsclmA2GU6iFu-KNn31ViVmbg6cg-38IjhuJY5M4hkSu0G7DsH-p8tAOe",
            "widthPx": 4160,
            "heightPx": 3120,
            "authorAttributions": [
              {
                "displayName": "John Wagner",
                "uri": "https://maps.google.com/maps/contrib/114187597593536032667",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW9QLxp3aaaAKztdknbKw3ZxWeIHzwCi50kE22Mlin857ZXoZ0=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMRRjV3inypB66_zoPRpCe8qALRx4X2R9onc0pv&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMRRjV3inypB66_zoPRpCe8qALRx4X2R9onc0pv!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          },
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWrqV0mXSp8S8z_7mJ-XL0EX281cyP5qLLS_9w6tVBXcHg0njXJ2Vi15yYm2Xvn393XepUZv56FhXDIn84d-CYITPdFM2MaBWEbZEHL67ys01n46SyTZhnhKOML08KU6dhT2FZ93oixuKI17jd9Wf2nswmWHfMC27GcE",
            "widthPx": 1749,
            "heightPx": 1428,
            "authorAttributions": [
              {
                "displayName": "Andrea Amezcua",
                "uri": "https://maps.google.com/maps/contrib/110934832584710638790",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLvyMw1RjxgBKNiKLb5tMbI17TJn3NokSSpdFXLMpRNXZUdqQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPzZ3YfTkrml_bbsuXv1r8KzxemreuQqm4NilpK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPzZ3YfTkrml_bbsuXv1r8KzxemreuQqm4NilpK!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          },
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWrPhf468mGRRXrBbQkpSuP6qLHG7jIIrxL0MsON9lVJy211i2zeRmJpguXWjO7vXCQiwP9MbmjxDjRoDe5_sobFpRwIFEq19v4BBt_EOkq_DW6YRfPl4Glt20LosPQlnWvN68suMPDVAVyjZQ1d5p6gxaT94FQoqU0s",
            "widthPx": 1536,
            "heightPx": 2048,
            "authorAttributions": [
              {
                "displayName": "Andrea Amezcua",
                "uri": "https://maps.google.com/maps/contrib/110934832584710638790",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLvyMw1RjxgBKNiKLb5tMbI17TJn3NokSSpdFXLMpRNXZUdqQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOrDJ06PEZXwoj91sEJBD5aZf7pztIKXvwFvJcN&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOrDJ06PEZXwoj91sEJBD5aZf7pztIKXvwFvJcN!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          },
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWonGu8GNzgsudnx3AWi5W5aiBPZK4knuuMdUlS-NJWdg8hPgVEP7R6BLRDw4yrM83WyAPSha-u_KIdLeP7MF6QiSYkvTC5cF5kWX1Eh03jBwUAd_IxmQ4SO8JnibyojzhYHpFHqvESo35DSHIy3pVNM9qZAnvuUCNnC",
            "widthPx": 2268,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Narendra Landge",
                "uri": "https://maps.google.com/maps/contrib/101886061033009951746",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXK-LipNV_j3vAU3Rks921bbuKFaO8FZgGirsoxZv_NP_XoI4Eo=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP989Uyv_xNzZ01mubONeJLAIEjhsQGpXn6Epe6&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP989Uyv_xNzZ01mubONeJLAIEjhsQGpXn6Epe6!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          },
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWrVQ_lz4tvbNVGnBOOSyaIflQrAw-3UYwyq0-Pj2Dc3xZ-m7RB9094mRnYdUJ6-bgK-uqMOnXFkr5wPxq7pq8wwVnEP01VoeLz2uYnOI6o1xd5RG2bOBkd_7V-81mqEOFe7n5E3U44K8Alm0BkI1Er7attUQxyyinOp",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Prateek Singh",
                "uri": "https://maps.google.com/maps/contrib/112362067192819966887",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWPIit_plCoaBEZRr-xLywsbv-y1cM0hOlmKo1iIu9MITidIdiM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOt9zj7oh_a_QWNxuuk64K-462S6_o_ywhqwRem&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOt9zj7oh_a_QWNxuuk64K-462S6_o_ywhqwRem!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          },
          {
            "name": "places/ChIJDaRlAOEtDogRQEj4S6xKRMo/photos/AdDdOWoX1rD_Yio2PCeNMJ38jdfsc7KfUsz6rX0NCD3QKkSjnCk3ZW8WJCIytU-rWiqb_LOT_Bs0-Z0JtO3h0Wj87nMAJIE7jww86BqNXg5pORN-5FgFlwiIJMM63RfrF4azF0OEbslMpzl5JXWzwBrCVIhvcOMONVt4nFI",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Andrew",
                "uri": "https://maps.google.com/maps/contrib/105411715985959310355",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocINLObcHo08Uj455V_egHD9ToS8tdItAOe25E-tuxO_fGD8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOYDWoj0rI_QbucdpAta51MWbGu9EnHlQ_n5U8&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOYDWoj0rI_QbucdpAta51MWbGu9EnHlQ_n5U8!2e10!4m2!3m1!1s0x880e2de10065a40d:0xca444aac4bf84840"
          }
        ],
        "goodForChildren": true,
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "10"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "20"
          }
        }
      },
      {
        "id": "ChIJoyrLQAAtDogRrH4gSak6gCo",
        "types": [
          "pizza_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "17 N Michigan Ave, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.88266,
          "longitude": -87.623526400000017
        },
        "rating": 4.3,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 3,
        "displayName": {
          "text": "Napolita Pizzeria Wine Bar",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJoyrLQAAtDogRrH4gSak6gCo/photos/AdDdOWqCBbsyZumdFju5Rdw1MCnlSwcqtmI_xB7A8VM8TXl9hP7lHaNr0BD8NzMr019epdfHUFM3-eToICF5HmvbtlhvZTrMJ1Gmwcx9I5aQyh4_3npwCldBFpJ32DrM1OWVx0o_LO-ZhXr866TiKKD5_NBSvC2SdWMfeDaO",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "William Alvarado",
                "uri": "https://maps.google.com/maps/contrib/108608250551193385317",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX0H8DJg8DCrI_u3QIr5FahBArQIajmtWJxRUxYiJisODrPwLfKQQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNu625g3iNRSPox08TqIovNifzZm-auJg5I7tVh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNu625g3iNRSPox08TqIovNifzZm-auJg5I7tVh!2e10!4m2!3m1!1s0x880e2d0040cb2aa3:0x2a803aa949207eac"
          },
          {
            "name": "places/ChIJoyrLQAAtDogRrH4gSak6gCo/photos/AdDdOWqjBTAWyTyB88fxQ3NqEH67MrcAghfRhoQa0QLWVTLBT0IPEzQgzBVe6Vj0K99VUHRI1gBvjRwctYZTAygBxxk4pEAnsKZIcusygypR47aBry6Olhi9x8GWI1nh-mCE99LukaRtIjjN8tOPBlHApSR-Ia07QsUO-ipN",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Darren Braz",
                "uri": "https://maps.google.com/maps/contrib/118103478451269669529",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVJq7hWh9LxWuArbAXOHayLLOyFkl9FLTelJ1jhPpNrFaO713msJg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPB7j0V9Ef8mDTjnRyOa_poM-GPzxkBfiHg85mX&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPB7j0V9Ef8mDTjnRyOa_poM-GPzxkBfiHg85mX!2e10!4m2!3m1!1s0x880e2d0040cb2aa3:0x2a803aa949207eac"
          },
          {
            "name": "places/ChIJoyrLQAAtDogRrH4gSak6gCo/photos/AdDdOWp5rcKrWvkaIggAlZbEhKDD1r60OOE-7zl2soqspxIQz1zSDE9Dd1cxAdpN0Bpk-llKRbeIrTxOY80n445P2oSEShdOLlZCBKWg9mPIUYdwwxLtQyLKx9FqNyP3ClcvZaaNiDCSwhM1cbWOJ7p78zJNKkUVR7rMKeam",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Darren Braz",
                "uri": "https://maps.google.com/maps/contrib/118103478451269669529",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVJq7hWh9LxWuArbAXOHayLLOyFkl9FLTelJ1jhPpNrFaO713msJg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMheyX4kS5eaN90QvTQ7OaRa6GME19EEgKj0hOy&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMheyX4kS5eaN90QvTQ7OaRa6GME19EEgKj0hOy!2e10!4m2!3m1!1s0x880e2d0040cb2aa3:0x2a803aa949207eac"
          }
        ]
      },
      {
        "id": "ChIJAZ-filgtDogR-szdsqpDm4c",
        "types": [
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "11 N Michigan Ave, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.882678299999995,
          "longitude": -87.623482
        },
        "rating": 3.5,
        "businessStatus": "CLOSED_TEMPORARILY",
        "userRatingCount": 28,
        "displayName": {
          "text": "Double Clutch at Millennium Hall",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWrXrTKSWp0dRPrOuQifVGWYiAN55zjBrSwJp_jED67udPasJrC3fAf2mDMQXFKLfFUUiMh8aT-i75hrvTFoP6rqbKfjF2UViM7PY8mmPb4xI1ApWi8ERUZnHQ07Wb1c_SIopeQBOoukNKuXgOPy3zwWzOmi-Pn2VeZ6",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Jon L",
                "uri": "https://maps.google.com/maps/contrib/105877892124929952379",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKEPjRHzvb2mxeHkK7-yuBy0luxjM6f0wnP_3Wp3Tp3i9OZgRz0=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOy4RrN6JPESyR3OiCLEw2U089IDfiJ9ZMNMBNZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOy4RrN6JPESyR3OiCLEw2U089IDfiJ9ZMNMBNZ!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          },
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWoua_M83ObxkyDV-1Y9gM5XGuFTpLc4p3P07loachhSTBg6NNI-RWUnvfHBsrupQKqJLh7RZn1ckvMWvunfhHjrTBc_eH8sDfK-DQ0orEkTqiuCGxPodV42-qfiBI8NZjf8LoF0_tYy48v4T6yjuddaJw9a-x0J6D_9",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Luis Gomez",
                "uri": "https://maps.google.com/maps/contrib/100233376285528510520",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWH1bQ7MmIjK2RMjUo7514uF4lkOoqiHexXi_Cp8SesqmXfijhr=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO2Hkz8J54J4IPZIU2bJHWd6kssfyXCrPKPZfEt&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO2Hkz8J54J4IPZIU2bJHWd6kssfyXCrPKPZfEt!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          },
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWpkH_8GkKuQzlpr7j31qLtk7zj_Wge0ut50bPKOaua3stqp4uH2tAV1CkaIZr_7HLXaKJyeOlyUCWd2iIssbzlIJ3ATc6PwBVzSA3-rTZxFbPopt6v2l6DyBHj5A87IsXnVyHFZk1J8Wk6-a3QxKzcjcoZVf9IPVkpj",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Asbel Cedillo",
                "uri": "https://maps.google.com/maps/contrib/101539471767915831271",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVpHiw-_6jzpCkpI_RYYahZ4NFRW_PUKA1xqWdbt4_xJK7XyEwB=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN6RYPvuxsM4E3yr4vbbtPMKXxpskW7PrpZ6DKf&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN6RYPvuxsM4E3yr4vbbtPMKXxpskW7PrpZ6DKf!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          },
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWr_ko9g_-4idtAo_wGCpW9Ra2DqpIFwSp-ZM0VpYrWujwO1jwc88dy_tNffU5jI3aOF5R7z8svs1IYLIUiLWIsktMe3cgjlB0GF4Flbk1r69N2xXo_II5055p6R7osVnlfk2eG6a2KDipc8_plvm7S_fRaTmGrr58Ss",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Asbel Cedillo",
                "uri": "https://maps.google.com/maps/contrib/101539471767915831271",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVpHiw-_6jzpCkpI_RYYahZ4NFRW_PUKA1xqWdbt4_xJK7XyEwB=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO5AtgGlJP_bBgEWv1lMkP13lPny-OvXWS3l51V&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO5AtgGlJP_bBgEWv1lMkP13lPny-OvXWS3l51V!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          },
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWqwKhhS8dWXVCoZ5OCZABLDfmK-0ayn49wrD5Sjo3pBJLiRSxJPFtPOKvbZlX1OuYkfUIOWREL1YlU-zHNbqI0cgvTgy14WbO2QXlV23nzmNoXO12e71V4gtN3ePx5MVV8iUx9WT3Rm4yh3nA8Q6VtTcR_yNARajEUC",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Luis Gomez",
                "uri": "https://maps.google.com/maps/contrib/100233376285528510520",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWH1bQ7MmIjK2RMjUo7514uF4lkOoqiHexXi_Cp8SesqmXfijhr=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPTxBlZQNnafdFtWaWmvpKUeRD-dDaor9cgwlP1&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPTxBlZQNnafdFtWaWmvpKUeRD-dDaor9cgwlP1!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          },
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWpScyeuXyNSsLSaVriof8UBy6gG4AKkTMsHqqjmR-qkJ6MpB2ntuBh46RA4ai66NBVY_u0MU6AjudyGcwOBTm85Wy764oO6bucw9RqaCHiuKgKzVHrAjHPz2bp5YHoO0WahS2P90MDzEYMcRvHTxVHnkE1t9v7vuM0",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Renata Cayton",
                "uri": "https://maps.google.com/maps/contrib/111730938194876066435",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJIr3O4n2RWf8nFJwcEqNkVCf19cxtFVOa32UKLnN3LBaWMDZs=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMX0MAghwa3z0Uc60BtCszBwjIyUFsy59pB4WE&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMX0MAghwa3z0Uc60BtCszBwjIyUFsy59pB4WE!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          },
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWozo2brZyisEl71P2VEzmxGbtZRNyu5IpBrAHjG-WS-hrnSPBr835hvYQl1_P9L59PITM0YWsv57MsxhU4X8eb1GXpwNmcveL3nWW9Rw6T318CfHYA9G8-dhNyrmCS1HAjnyrJYU6sYHbTnjiBF33uLkn3SC3qs2TnR",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Asbel Cedillo",
                "uri": "https://maps.google.com/maps/contrib/101539471767915831271",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVpHiw-_6jzpCkpI_RYYahZ4NFRW_PUKA1xqWdbt4_xJK7XyEwB=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNb4CJc98TixFy5Z3jCriwRgwhkjlkP9RPkL0OC&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNb4CJc98TixFy5Z3jCriwRgwhkjlkP9RPkL0OC!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          },
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWrmj1VBIzDRkxbmyboel2r7nWV5kzffYxtddYwM9skrCj04nDfUVOTt6Xqk75mdPpIKtcSyn_-SNinWN62ki5JN0xwb2AjB6ewW9NVUIn0wWDi2wKub8gXJY6oISQ704UpvIRO41JgSO0xuO0j-NPMw0SyekbkWnHlR",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Valery G",
                "uri": "https://maps.google.com/maps/contrib/113391103601706780532",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJdb9102RmyKu5Ulx9PhVKvvoHTPQjrFb6SSMGzuFvS03eFwqEi=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMyiRjstv1wNuhECyBLc5GJcTZ4Tgr4RZQQLyr5&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMyiRjstv1wNuhECyBLc5GJcTZ4Tgr4RZQQLyr5!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          },
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWqv2bvLiKv62b8a0dgUtirFKbRojt9gvg2_eQ7QFYg2rnt90-_z0MRfzYFcndJGZq1X3yu0kX62H3gO3L-3IffcX1yvjszn9wbbTggwdTmMlbDr1mrpAZ12_MBtrkFyRJASAzF_pQuwJ5QZVWHWi227YaUwPGZLvaf_",
            "widthPx": 4624,
            "heightPx": 3468,
            "authorAttributions": [
              {
                "displayName": "Saj Popat",
                "uri": "https://maps.google.com/maps/contrib/102127687213932722925",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVex-N5BfTr-iRMRVHvKM25NBtW46_k5F588zSeFqh2plyV-ahx=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPw4oH4F_gl9QbYeASxGleNGEwmBdqYz3kiADgp&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPw4oH4F_gl9QbYeASxGleNGEwmBdqYz3kiADgp!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          },
          {
            "name": "places/ChIJAZ-filgtDogR-szdsqpDm4c/photos/AdDdOWphQASLPwkK2IfL48VFO3Puy51TqFfhFhdh1WJA7ODDZeZvY0tE7AX94sIigI9--Wlut9zny7lL6Bx8D-vT3v3SEkQ3svRUpVp0_u_de_-_aD-QEvVIS6v2xq2_XV8cu3DeNDYAwtyCQUl0RXleBAUxq3fLhDR1gt_f",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Jodi Graham",
                "uri": "https://maps.google.com/maps/contrib/112078691008147717394",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocI8ZkaH3WhT3MdvLeccojOviqgD8B5O1_Lypvn5dQodvnqrCg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN3OCfYP0i9zPISj_g1UvbnfbZ8wzoc4SuazaJZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN3OCfYP0i9zPISj_g1UvbnfbZ8wzoc4SuazaJZ!2e10!4m2!3m1!1s0x880e2d588a9f9f01:0x879b43aab2ddccfa"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "20"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "30"
          }
        }
      },
      {
        "id": "ChIJi11NAoUtDogRRcpe3-2WMI4",
        "types": [
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "11 N Michigan Ave, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.882678299999995,
          "longitude": -87.623482
        },
        "rating": 3.7,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 97,
        "displayName": {
          "text": "Millennium Hall",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWp8zygbMRLPFCDZKxbZpCziFZKV9qpRAUYLsxCrLXRnDFY4phWRlPwuh5LN8ujmVj9ZtCYxvawzge_bdTk_QltZsStFQtatx1skZjllJvl-V6oEFo_ibAzWnxYE8BqT9iQzeqKYEEskQEVXeHcnDUCh0YYSYmoUsOqw",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Scott Schraeder",
                "uri": "https://maps.google.com/maps/contrib/107576413113691628273",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW7ZSoLfB-HQwXJK50wfBpl93SkLwbmDW_KC5a3ZfmdXe9iKHLp=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOAUb-MA57KUYakRz0IdhJ6Gx76M32FIuEb_bfq&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOAUb-MA57KUYakRz0IdhJ6Gx76M32FIuEb_bfq!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          },
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWqpXBZfILjWs50jeBEmb6C80_doFatR6CREa0nyswzBUZqfW_7k7AyBCoJ72OEtfyvS764VVBgfBvWl5zV64zGekHPNkGURurcZ3-1apD8F3P9xSrWDZnXH1YMkkNtawKfGxdkyc5AP9GE1NncZFgNWW5XCDHw4yfaF",
            "widthPx": 2827,
            "heightPx": 1967,
            "authorAttributions": [
              {
                "displayName": "C Stoney",
                "uri": "https://maps.google.com/maps/contrib/114937184703262525479",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXEtx-ysuHc-X3cZiWxD_UwcWWd_k08ta3rcbw-oIrhctXQS_bY=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNLZXu40j2sJDpqTBU-u13zvSw0zAgIxxthlSJj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNLZXu40j2sJDpqTBU-u13zvSw0zAgIxxthlSJj!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          },
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWrgL6lm4wbcNy3a04iKfiFc4EedNRYoAci01M_Bw_nP5tGDGA3Oe3tN2ZbCSgd2UdpU_lmpp6L51HGk6pJIPCyW73hQmba62Khh0p6S0Kc7J7I0CwGFUijNoBwwZAQgBEVV3zpudSahoP8zmguaaV6XxEGRRh4lEa3V",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Batman Jawn",
                "uri": "https://maps.google.com/maps/contrib/114388183666570817246",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWZeYbarBLV8slVybMPbhbkdJA6HL1NDN8pIeq02jTit1wv4jKS=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOesDmqzUEq6_-muKTbLJFbX26xwJ9ZIwgsXwaK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOesDmqzUEq6_-muKTbLJFbX26xwJ9ZIwgsXwaK!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          },
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWoJ72TJdQt0p0HsKVYz1sVRhWjAtwFlf6lzjqrvirYLFch4CbIjW8Fqw-gxuQxYWDn0PEKL9TvoMgxaIhXMyML3Tm9CK25U4agkYHMgAndGtvu5evSf5lg7WoFUbSkudFWcDNcRaBTYPtaLhCWCshQDE_y0c_sdYKeQ",
            "widthPx": 3456,
            "heightPx": 3456,
            "authorAttributions": [
              {
                "displayName": "Blerdwords",
                "uri": "https://maps.google.com/maps/contrib/117226894249185016133",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUhvwP_gneC-08-SFlWs7L12HsC1Bty3A5WFX6HQTuIi24DIQ9R5w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMb0Z9x3JxBRC2NtsbGyZamBp4vB-YqmYZcI2mX&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMb0Z9x3JxBRC2NtsbGyZamBp4vB-YqmYZcI2mX!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          },
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWpRAWHJLXjJNWhguJMhsOd2YI5lzj92Qfn1Wv7ggQrl-siH34tPALLjXs91uHS5vhtJvuUnVz_q2W6jmFIlT_jcxqSmOuUv0F0C1VDGgprPhahVBMPoNdG41CjcDuxXk44L_u6IRMsZFTz9yQYqmWbfAQIVSegynsw0",
            "widthPx": 3456,
            "heightPx": 3456,
            "authorAttributions": [
              {
                "displayName": "Blerdwords",
                "uri": "https://maps.google.com/maps/contrib/117226894249185016133",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUhvwP_gneC-08-SFlWs7L12HsC1Bty3A5WFX6HQTuIi24DIQ9R5w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOhThVUUBbNcdvP4Ev9gzGm5lsy0JnnNIpfP9td&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOhThVUUBbNcdvP4Ev9gzGm5lsy0JnnNIpfP9td!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          },
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWrMsZH2FR_Jvq_9msYyyfNWyCF-Vcw0pS5yKrcQp1Qob_WofHuvQfZsWzSBmWNannD_k3UA8vXmU1ydni2iOw5gH6X1E4sgps7eyPk-bxfuKv2oeHP3L2_3x0umqqAhTd5kV4_2xir96R6brobbQeL2aivswwzWQu2r",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Batman Jawn",
                "uri": "https://maps.google.com/maps/contrib/114388183666570817246",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWZeYbarBLV8slVybMPbhbkdJA6HL1NDN8pIeq02jTit1wv4jKS=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMZ5Aol9T9vOd3xN5n9UjxfIRrfDyPSFVxhipG7&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMZ5Aol9T9vOd3xN5n9UjxfIRrfDyPSFVxhipG7!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          },
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWrSxvJNdVwoBjaqOegV_EzvrJArasS1F3G4KlGmkQo6W5cAVUdPlFC68yMiI-4a4a42C5PdAf1yVWdB9psbI93zCCQUO5qhFraczpQstHZax5crVTKgY22Qcun7IYmkvpuy3qvQJLWK_pt7dSAkUJVsRPXI4677wrJv",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Batman Jawn",
                "uri": "https://maps.google.com/maps/contrib/114388183666570817246",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWZeYbarBLV8slVybMPbhbkdJA6HL1NDN8pIeq02jTit1wv4jKS=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP6WZjHUrqR1Vrrp0HVshxLyRb2D07o7XZsLKbi&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP6WZjHUrqR1Vrrp0HVshxLyRb2D07o7XZsLKbi!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          },
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWotNXYzymYkEKohnCDW3wffjDF18-1399wdDNkrCtVfxKUuGN2Uon2OH4ZxVNDl9ynV6PhSAgG-bH5i0QZKVD73ciSy1672qmsezIuxIvIfzJsvkbtLkmT1ejytOz4j2y_4P6mXQ4wcIyU7W6-G3ri39X15R5kBpiTZ",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Greselle Ramos",
                "uri": "https://maps.google.com/maps/contrib/100735066399281085638",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUz00npsolfAajzRexWQVDZLixE6N7UE6XQjcCd57WMROiC7xjA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOMgCUgApLhwcy5LrJpRVX5rmfqu4ZPaiC6iW-A&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOMgCUgApLhwcy5LrJpRVX5rmfqu4ZPaiC6iW-A!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          },
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWrHkJHee9mYmugOiZ2XLqtGRx9oXn9Qsc0PC5KA5o0SdyDcIIwV-BaZMdWJahKUd9A__YpolyYlp0JxBPWZd0VtjNIRuyNdA-UJa1CkKzmzr5rNfWfvPh4tXt-sAwihdD3Tzwd6LtBMwhJ3jjmRIaL0x8q_ej17g6eP",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Dr. Mohammad Shamsuddoha",
                "uri": "https://maps.google.com/maps/contrib/117352289297743537255",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXDTIXNJNAEdLoNe4XytsU4fu7irAMyIrw9QN822jdvx6yWrIeu=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOATVjKjArYITIsMa5xlQr7bh6o1698ZkUPNmIM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOATVjKjArYITIsMa5xlQr7bh6o1698ZkUPNmIM!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          },
          {
            "name": "places/ChIJi11NAoUtDogRRcpe3-2WMI4/photos/AdDdOWoAEuJeHe88OwoPeDRjfSjJPAbME1OZ9J68135Ou6vDZh5XR4nD8__a7vwDTxA4mdIT7aE1jRj9iS5-bEFPYYr_dgGAAzmz0JiKJTQHp-2gsJ54tGqXPyGfzErMNG4eik9bmJ3pzEd0bU5aU3bYleoDYlifiC3vhKAc",
            "widthPx": 3456,
            "heightPx": 3456,
            "authorAttributions": [
              {
                "displayName": "Blerdwords",
                "uri": "https://maps.google.com/maps/contrib/117226894249185016133",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUhvwP_gneC-08-SFlWs7L12HsC1Bty3A5WFX6HQTuIi24DIQ9R5w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM8ScNrUTJ2_HCSXR5F3u_4_ttKSGYGvXo1Qtyb&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM8ScNrUTJ2_HCSXR5F3u_4_ttKSGYGvXo1Qtyb!2e10!4m2!3m1!1s0x880e2d85024d5d8b:0x8e3096eddf5eca45"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "10"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "20"
          }
        }
      },
      {
        "id": "ChIJPYvanlItDogRi-7ReWS74k0",
        "types": [
          "mexican_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "11 N Michigan Ave, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.882678299999995,
          "longitude": -87.623482
        },
        "rating": 3.8,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 37,
        "displayName": {
          "text": "Casa Bonita at Millenium Park",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWrfjvAwYTU2TyH4gDaHemLkGuu-kIpsMRnOSOvv-hyMqj7x3Yjm2EpQ5Z0-bAT4UFl3vCgWXlmuF36vt7uAKPKOWBxjBQtzgeHLkduhC5S_pSIpElG2DAfFo_Mwwj2Jau5TxIS5Rwm90R4-t0TW1BRK1_rE7vbZ7SUI",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "REAL REVIEW",
                "uri": "https://maps.google.com/maps/contrib/107251797285813750111",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXhqYugXVbE91yB-P_R_sk_KqajFMpk0mnD6SORw71z8Sm7DXBf=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipML970Symrb5VmFh3Eutf-StwSOwSASUVJXN8MY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipML970Symrb5VmFh3Eutf-StwSOwSASUVJXN8MY!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          },
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWrOEdjzMztxc8Mc3Xe3Gj8TDV66eAju3vpeng6Ea3WN37iWwUCatEt-IyilX2rFeggWcLo7_UkY8uMeo23kptdxBCRLEDMyQjooaOlNdPZ3DuGV4FLo1XD2I_dgs79_McPBmPJCcfXPeR3V0RngaDwLFsymCcoH5qXr",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Kathy Fowler",
                "uri": "https://maps.google.com/maps/contrib/101028854033706155841",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUgeRHFZLfI7oUREX6_53fEjK-ZEEcTKDntQzfAUYziGrXCL2EQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP09ArojMWY2WuMwtUyCcvye-GI5BXFeMQPZeJM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP09ArojMWY2WuMwtUyCcvye-GI5BXFeMQPZeJM!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          },
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWo3lskfmKvv67d5_3zLNv8mMh4o0HXhpqHG963b3lgb_UiDsBhfatbAJeeWwtqP7kXf4hBNC9Dw4bDD-Cb3HnZgDXvPnjHUQGcjTIYAEHyi4TdhvrC1PO6wno6kj44b5KF9oLEUoPgfsgBxGMr1RbdrESfMNwtaVNMG",
            "widthPx": 1284,
            "heightPx": 842,
            "authorAttributions": [
              {
                "displayName": "Casa Bonita at Millenium Park",
                "uri": "https://maps.google.com/maps/contrib/106374196574377357865",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocL3PZLUackRQsc2viPeV9YxRoC5BIPWQmnVL7HrKiias97jRw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM5Lh_R1Sep4kOTRlwq0DHmHBBfsIZODagPOj8D&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM5Lh_R1Sep4kOTRlwq0DHmHBBfsIZODagPOj8D!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          },
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWp3xC0I9Q4kYKWJfBRf-8--Oij9BWKn9V3-15_0WbMhfH_VPU8cAZbqm1hMOz4rBP5ialbIvi9TelVsX4q9iMh90o_6I6udbyORkfObDaTGxE6HqHrAiMzXbstRDwaow8XM0t1D24mEoQY7u4HhAnbKCtJSrETnIPKR",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "G PURNA SAI KIRAN",
                "uri": "https://maps.google.com/maps/contrib/114970826757370465028",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUDw4d1RyxSVLD4yl1c263E9kG-6fzP2UONZZCSvjo3fmEcHqQv=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMklchoSFenDBc2FE4fWv6hmL-d9dHUvqu0oGm_&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMklchoSFenDBc2FE4fWv6hmL-d9dHUvqu0oGm_!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          },
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWqLtUIKfFfAgN8pEWuNvUnaIO1_ol5ONRuaYF8zqkmH7cDRQienuIgFYIzjy0Occu8bKzSt_0YsP1UFhjvKdJ1weAw3PNjLV1mxEouzY4izev1ejWnIm8v9fcH4utteJg-1wTrycC1NbI3zqs8LmWjDdlZ2JZrUH68-",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Nim Ja",
                "uri": "https://maps.google.com/maps/contrib/102584875072436456503",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXOVUilUaqKOOtU9gLPACsfSuumEwS1tOAZRz96S9F9kmQTwwLU=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPYyrQRImn3U0ucJ-6TAaW_1aezmBvCvd2fPbx-&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPYyrQRImn3U0ucJ-6TAaW_1aezmBvCvd2fPbx-!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          },
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWrY_f-pKMX9MubCYDC4ZiJBVklU3h9jbeSVlxFEeZjc7NXhDXStnreP-TMB8IFYVisiW1--89inYokD-a7O4wUG-y1-FOkMxDtjIgN7qTGxBZm5XxPpSECG9NmO5q0-69RVMljvQp6e3dY3C1k0j-0NjujVoukiC02G",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Paridhi",
                "uri": "https://maps.google.com/maps/contrib/107264356889881927539",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXUtlz9M8l0RowUVHK8So7TnobOHojfHqGdtxbQLkxAk7Irfoa6=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMpcevyM6ftvFoojK054gLMywUHdgDKwGivXAz0&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMpcevyM6ftvFoojK054gLMywUHdgDKwGivXAz0!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          },
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWozDr1AS1CD6LXjQf__xrGwPKiL40S6EjqP3Q7OxP2EtdbHrJAykN5jxPUTMJDxAxM9omFhuGoTyGu6QZwlYz_I45uD48BKlphLxAU55NJeRMlOem-fK07tyckARMhYF6JxS8SQ8F62_d1pYPIMpK9VjgrQpqmLD6Tv",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Amanda Arzola",
                "uri": "https://maps.google.com/maps/contrib/102600030133730232933",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJ_GhtSoj0OolPGe_Du8TcjHG79Tzq1v6oTbgh6kuHkSChxzLq3=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNAkr2_VWYYbaRd7EY9MybMe8HzHV8XsfbQlltL&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNAkr2_VWYYbaRd7EY9MybMe8HzHV8XsfbQlltL!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          },
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWqEGhhTF8xA9bRinxuoXIJOY4DC8nB1GoHGQJmoheihO-lEBzLD6_H66B2Sa_wl33g9e7w62-owtc_Tx_oTmVKUBEOb0BFAy6aR-2SaHosO8kYsm28zyKGcRpTDWgJfJAkUQq_IqVJ7YVkHGzz5UQBjx3H0EGwR56h2",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "G PURNA SAI KIRAN",
                "uri": "https://maps.google.com/maps/contrib/114970826757370465028",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUDw4d1RyxSVLD4yl1c263E9kG-6fzP2UONZZCSvjo3fmEcHqQv=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMcZ6hG6AL6JWnOJHqEaksexSdsh8mRcEcGvTha&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMcZ6hG6AL6JWnOJHqEaksexSdsh8mRcEcGvTha!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          },
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWp5pLnYAqkrad7lZbRWAgzcjVz12fE2no9FK7ucZGSEJFrN7uJZnZK_VpaAy1btqYpjO79k39zBUK7Y3KaSky-F91QbBAIrR22uPk7o_L_zpI_yMvOpQ9hlB9mmt8yT12zFWNztLVTrVF7mLlk9eHwskHQsbD7Qn9TG",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Evan Guthrie",
                "uri": "https://maps.google.com/maps/contrib/108715078108737755494",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUwjfUaTbhM2FvN7HgW9qADZ2ryoFkEW6MdUibF0Uqk93_jMr3u=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMv-FCGhteznQZjfzc-b3mskRF0LuzSd1ZMSzpF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMv-FCGhteznQZjfzc-b3mskRF0LuzSd1ZMSzpF!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          },
          {
            "name": "places/ChIJPYvanlItDogRi-7ReWS74k0/photos/AdDdOWpb38i0dcYa2b42-udLRk-WYujglwTmETtGZu4GLKbQxDg3U6YwvcFoVhStstqYUmsLL7HrIjxzf1W2x4q136NE_TRdzoUAz4To4u3tlIJxLTheQD2TuSSZNB8S8-43c3CjO836zdlNDe96MjmmJao4AyDBy80sYtaW",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Paridhi",
                "uri": "https://maps.google.com/maps/contrib/107264356889881927539",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXUtlz9M8l0RowUVHK8So7TnobOHojfHqGdtxbQLkxAk7Irfoa6=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO5lPVau3rhLuo3OUYUq9-5fqIFcmnPTYfD7Jw3&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO5lPVau3rhLuo3OUYUq9-5fqIFcmnPTYfD7Jw3!2e10!4m2!3m1!1s0x880e2d529eda8b3d:0x4de2bb6479d1ee8b"
          }
        ],
        "goodForChildren": true,
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "10"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "20"
          }
        }
      },
      {
        "id": "ChIJKysZP6QsDogRAF-guhg55ws",
        "types": [
          "italian_restaurant",
          "wine_bar",
          "bar",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "18 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.8814741,
          "longitude": -87.6246755
        },
        "rating": 4.5,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_EXPENSIVE",
        "userRatingCount": 955,
        "displayName": {
          "text": "Acanto",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWrm6H-I9VdtdEdrCVuZICmZ8tMwtJ6k6t_B23YKct8xnU8RHWfkD3RwPoi8UhNJ_Fi0nsHyniA8891UYLSD1WVW7QFEHdteHNW-LvXfTXkw9awaDn81Pl2vcV7IzOaXubkXIrLv4RbubULBaIRJLoP0waNRDTIkOiVU",
            "widthPx": 575,
            "heightPx": 357,
            "authorAttributions": [
              {
                "displayName": "Abdullah",
                "uri": "https://maps.google.com/maps/contrib/102153862946180267307",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW4kUHYT-shxZnjlXtnLL-iSQ5oiHEP1chdcYShPbn1i2DN8k5XeQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMVE-zdgJY2K3p4gmiX66CNEdjTpdsFyY9SO_4U&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMVE-zdgJY2K3p4gmiX66CNEdjTpdsFyY9SO_4U!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          },
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWpXIfkvEm0xNFWyvwW0lu9sqL4Futja9ZEPGLCGPINCK_PHkXGhqjjXjIyRLWgcn4YNV-yuJQ8Kk9EYUFGHLYn6fkxgKYPUy4aEuKhraMgqDHUMr47tixq7HdOjZyQ0jyEwxQtozFCa93HpQBDgF7SwY36IOJRSmjWy",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Ryan San Gabriel",
                "uri": "https://maps.google.com/maps/contrib/100528195105738501017",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWhqS9QuScxvTyQV_HRo36Sm-CLo9KeYwlgpdD6__GvwlUfBefI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPonx8ICUXA6yiC5F4tVDZ5Rgob9VGfezzviCBp&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPonx8ICUXA6yiC5F4tVDZ5Rgob9VGfezzviCBp!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          },
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWqqR0hJll1CtjO_0OCsHRYOMTuAqaTkyvKtT0-39a6Ndww5LTyKr5hSAd36QgtLvWe5Nws_8gMEPzQRLpCfeEU8U2o6wRy8Z78wYg3dxoDh7ZnBBRT81jh_V7H9Qs9UeHZrV9B5aeBN-UQQnfH5XU9V-xpgndutmgyT",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Jennifer Ames",
                "uri": "https://maps.google.com/maps/contrib/111996751094641027828",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUJ4W5EmWKSkUAWkWKQ5PAjeb-af477a1TE_SFtO6kgep-pT2Q0=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPI8R95RXLQ4z_booM4mel5k_9Y5eWfEnZoJCik&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPI8R95RXLQ4z_booM4mel5k_9Y5eWfEnZoJCik!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          },
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWqiAw-LkANd-3Ixuf1ChhOMgNwpYSpamYjnyzwCCfUVSlKQpHTK9jtG9DrIt0Opgwu8uO435U5mKT5J5hcLakRIWcelA7kzf4bbNNSfM3HV_pkoyBFtzGa5YowTxrGqNdGcbR5c1bZOjBZ4a7GT6RQ4iSbi5ZkviZwm",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Amir Na",
                "uri": "https://maps.google.com/maps/contrib/116776269375990247740",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVdhqd2eijV0l4nSBbvIKzHbd5nm_MYh2DgFcDIzBIDv8XNaQE4=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOTWmpdKBTlShhpDOeJvy93-6GhU1lmGlR0lhQM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOTWmpdKBTlShhpDOeJvy93-6GhU1lmGlR0lhQM!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          },
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWrHZ9q2O7LH0owNuSVs7ysgIGz8S99NlQm-qQfqZygqKREKe52KIUvfe-8ulqf3qct2OoPWpWEBVFX6euqSdmYzUcJIyKHUzMkPpg8v_rXxUvLBb1ExtJyRSQP4ZYj5HjmXn5fes_97kS-qaVpAB9Auciuys1Nyq08u",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Kim Haesoo",
                "uri": "https://maps.google.com/maps/contrib/117665943473799532397",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIaAbLa2ajFmuj4YDYzwes2DCuvD5NJKxn9hrqWs2Jq5vTn0g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMuInRFHM7RwpmT8_Ku0ttdIhVL5rRpeEwKXkUm&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMuInRFHM7RwpmT8_Ku0ttdIhVL5rRpeEwKXkUm!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          },
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWrptvQ-x7z1ZUlCIwhyfXMV9lHnGH-HkvReATrFvbuLI7y46ZuS4qMW01SRxSbRrVnHAxrurUcXk-jgmQfCSELuT-uqnS8dLdmrQNHDBYRX9lFx9G90JK2DODJ-P3iN87qmWzKnmOp7lUES82lYh75zbteZ4p-m8EBS",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Táňa Rulková",
                "uri": "https://maps.google.com/maps/contrib/102519854796435474593",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWLzVZZfuZgVesb_Kr2cYNtoCYQEJtbUwXuJDSNAoM5KOp42gtf5w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipObpP8BPh3fqidkBMu3bsqc_sfh9K4yyjHJMpxT&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipObpP8BPh3fqidkBMu3bsqc_sfh9K4yyjHJMpxT!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          },
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWrF8U3AD1kNQYQSLUPoi2t2Cafetm1eTG1x92pRdyRGhGa28EAIVwfTU5b_u9v7ILGxkIAqKcM-pRMmZytkh7Vv6HxRRKAd3lqGLwuLbEE7ePTdZ2hh-hygbQnfCOfU4gMEHUPj1bAznpYWFuTsRRZ-FRx9FQjc8J-I",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Amir Na",
                "uri": "https://maps.google.com/maps/contrib/116776269375990247740",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVdhqd2eijV0l4nSBbvIKzHbd5nm_MYh2DgFcDIzBIDv8XNaQE4=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMvtG7Wni-85ksD8U5v_cq9wzU3n7kO6B1ociIq&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMvtG7Wni-85ksD8U5v_cq9wzU3n7kO6B1ociIq!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          },
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWqGCSF72Rv5Z2cYFHkXRuBD1UnALZYTiLfdcf6PwZeOXwlgYB0MkgaRDLUOdnSiqh-yjydDTvBuNFm5b_3OJs560Ht4iBtPx7HgwylH0nYU7pI5ubpSMmAQz3B_LQ2Pxny4UCudMFoEwJc-D43akpWjFtqDZzQtgT5o",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Táňa Rulková",
                "uri": "https://maps.google.com/maps/contrib/102519854796435474593",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWLzVZZfuZgVesb_Kr2cYNtoCYQEJtbUwXuJDSNAoM5KOp42gtf5w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMjx82a5WHE2f-K0aqK4ymvNDaV2DLGbI4fLHuT&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMjx82a5WHE2f-K0aqK4ymvNDaV2DLGbI4fLHuT!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          },
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWr1jL7WlUfjDrFwPSiwOejZRnKp_pT0dt-ntukyFhofQopG2Z2VUr_z7qhT8vNzZ3qno7cR9wItZd4p9_Jk-C2-JuLnQeWt5hcQ5CyMq98P3CUk-RQ6lCRq0qxykHfHX3sA-qKF-kGmnRBczoOvLXRN_0qwh11B8Wca",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Karim G",
                "uri": "https://maps.google.com/maps/contrib/113212868994811297568",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIw6GYLpQ4QdR85b9vgPPAc_Tr2fDf2P1eADFiJIS8hDfCHVQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPChd4pK9aBMxN0MJQFlcjZVCJPO-eUSozDjf1c&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPChd4pK9aBMxN0MJQFlcjZVCJPO-eUSozDjf1c!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          },
          {
            "name": "places/ChIJKysZP6QsDogRAF-guhg55ws/photos/AdDdOWrzEhsY93ZTYoYJMBe_fz8yueDbX_MkU_g6ul5SPMGSMFb_Vea4gBzQXHiq4cX_O55edsY-NqNfJ8Do0fvAFQIdP_XTaasdwKp2Rvx2_HAmLGhSkIMS0u83UQeL7NsallBpoBaaxZSSoanZKKizWke4BMfzj1BeKlpE",
            "widthPx": 2409,
            "heightPx": 2165,
            "authorAttributions": [
              {
                "displayName": "Mihai Stroe",
                "uri": "https://maps.google.com/maps/contrib/109738503194724251823",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWklg2hlVKJFjI1dyD_TmTEOiuwjboDC3YpPLuYtm6nlI7O9BBNjw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMADeq7p0mEklpoCsWiM_WtXKyhViucEC8faCoJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMADeq7p0mEklpoCsWiM_WtXKyhViucEC8faCoJ!2e10!4m2!3m1!1s0x880e2ca43f192b2b:0xbe73918baa05f00"
          }
        ],
        "goodForChildren": false,
        "restroom": true,
        "parkingOptions": {
          "paidStreetParking": true,
          "paidGarageParking": true
        },
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "50"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "100"
          }
        }
      },
      {
        "id": "ChIJ5a8ra6QsDogRENtJLAp40AE",
        "types": [
          "american_restaurant",
          "bar",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "24 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.8813268,
          "longitude": -87.6246925
        },
        "rating": 4.5,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_EXPENSIVE",
        "userRatingCount": 4293,
        "displayName": {
          "text": "The Gage",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWr8MeDEjLjRdiIbykJzyB7SUQAqqJdGlf2Db-kh20MElx9zdAi1c1C9GElF4hg-Ni8mQ_JAHSnPPJodlb4mCKZuLNwg0VuYovL4wkWOoJHDJVkoPF3JfQjaodOY4KoxchzPg1O7t2Q5tyYAj2anrPQo6mAQF8_9qlhg",
            "widthPx": 2048,
            "heightPx": 1365,
            "authorAttributions": [
              {
                "displayName": "The Gage",
                "uri": "https://maps.google.com/maps/contrib/114657261104442184885",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW4Gkvy8l0UgTjtkRk4vGwcDEecxYAfuDVhlwjgpK_8-U5UHLQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMs_yNqxqTAvcsGmW_yBbiDdGXWeWJZ5OzkLZ0m&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMs_yNqxqTAvcsGmW_yBbiDdGXWeWJZ5OzkLZ0m!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          },
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWrLPY_IMrfUYIjTye1rF9gN4BRBJlapNa5OUYZFxb3B8qJ50Kat9dbl0UMSZE1O2VAhWaVTjjCyb5RQ83rnyv_6hrN1NKCxGza06Hy-pi1_98sVU_650XdO-zI_pBnTWyt_V_TOa_F0s8IVUadAtprAy3eEfDfgJxQN",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "Kay Coleman",
                "uri": "https://maps.google.com/maps/contrib/111851938398568264121",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXgCZ3AVf_RaYfUQ7qsSt1slcu6IHTPErDeyxznQipGURpj4Th9=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN32Fo69ioUu-Tf6vONl8dhg4JbFQg7AwJyq-dW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN32Fo69ioUu-Tf6vONl8dhg4JbFQg7AwJyq-dW!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          },
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWo6WGzNw4iktN-hmIKcosmgsrWIPyN7dL_pvs-X7VR2MNsbv3uARdi7T8mfBOx7BwtQYL827OkN54a9uc6gcostSihBUhez68dkA3TT2myLyTWCOD4YU7e307QeCt_P1XscFu3_k85j1xt4h19lJxc7rEd6ITkdQwFC",
            "widthPx": 555,
            "heightPx": 370,
            "authorAttributions": [
              {
                "displayName": "The Gage",
                "uri": "https://maps.google.com/maps/contrib/114657261104442184885",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW4Gkvy8l0UgTjtkRk4vGwcDEecxYAfuDVhlwjgpK_8-U5UHLQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOWGr79sNMdJ3OoMzmkikZkX14eUvSDM0DOr4z8&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOWGr79sNMdJ3OoMzmkikZkX14eUvSDM0DOr4z8!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          },
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWo45w8Llfx17YJTJMb77Al_RF4-uyJM8eo31gDVGQCivPG6Qt2xzlQ98IUIMYDVQZzmklOhQJjq_oEkG6p-5xiV63s6anXAhg4MpG8HwplDgj25gVp7rvhz6S4SRiRQUPqjVYws4KrPwBbBEIWqty2zujWwBPwxl2gW",
            "widthPx": 2688,
            "heightPx": 1512,
            "authorAttributions": [
              {
                "displayName": "chad svastisalee",
                "uri": "https://maps.google.com/maps/contrib/105718329295698192540",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWeSnr_aSxwmv7hQ1UUhS_OAvzXlhMipOCV0Rcxsxtc4CK9910M=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOQqIONCKUfsTC3cFxgdtDn1YOgj_OBa1ka8raN&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOQqIONCKUfsTC3cFxgdtDn1YOgj_OBa1ka8raN!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          },
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWrY_TjFbsyMZBArQBx4EhRgocR1GXFhOw4kDDu2CosHcrBGj84L4FJTydcZBnvDzLwIH1dktX917sVCGrfKL4hVG0L2obT0GWcWmU9rdEmd5WJ4ZW3UgS0leZ2Aa06LzWmweKSq0vplIveTd0CThufXFELf7qqr3H4o",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Marcin Krieger",
                "uri": "https://maps.google.com/maps/contrib/118255818261564513245",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWoPWjMR1UhAd1pOiYoMbfjPb8lVyNSQqo1RoIrej2RSOHZpg5GqA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM-69m-9UYHbCrPBl3Fr6PAr6_8R8dSp7rGLtui&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM-69m-9UYHbCrPBl3Fr6PAr6_8R8dSp7rGLtui!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          },
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWoV7-B55bB2ddY4vlmopwvkSsvsCQBbZIrYOE5FFmAuOzk9PrHEBBp9ANSRBCm_ZbB4-YoZsVie9-2cQY1IvDOd_Vz-KGgrQTe7ALLcCR8lNEmAX3EQ_uqayrSBWDgOC-SdiyRO_F6r7Ab_C6Tm5OyCJwWXoj3uomH2",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Jeff Caldwell",
                "uri": "https://maps.google.com/maps/contrib/113147114984362175196",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKe0IpFq2nGICvlQCJoD_HekOzjHa3HGADQg0UTzbS7tYZUZA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOfr1MZh09tQcqYAeS5uBfuZS3n4MRx-BYqW5sT&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOfr1MZh09tQcqYAeS5uBfuZS3n4MRx-BYqW5sT!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          },
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWroiNrbWRczoXVm-rgf6StH_rdnE1IyszoHs3UMHFlSInkNVwxN-rw20Ao0y2EDehTUal1PczX7LzteANdxmiRR_aHsKrLeVqErL3M_ER_-BLAB-58Ex4FDWFiKuJsWbgpb8dtwLANy6SxwaUT4S7GGeQr2_CIfCm5G",
            "widthPx": 1000,
            "heightPx": 723,
            "authorAttributions": [
              {
                "displayName": "Bautista Martínez",
                "uri": "https://maps.google.com/maps/contrib/114170030688589989241",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXXz1lHNpdU2MsiNMkf3mMJ2MdfyCSrA4QZPu0eiEYGZFA8QqPE=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPCLbomYgO-hjEweNc3SjtgmdcmwKMY91H5FmlP&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPCLbomYgO-hjEweNc3SjtgmdcmwKMY91H5FmlP!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          },
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWoCdPRaoEYSN1i3iHkBaQZjP7s1pmCbsIIpvi-_c4Dnx4uMn58ioN9rQ9X60Ad834YEKhLSoqeXk4oHnvMX4UueCDDH_sCY_G5bp6gFiWG8Pm9sT4FmQ8vhBhqDdzct3qj6h94KEfz0FT98YU3vAFVqQlRS-Efn82HW",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Gary Platt",
                "uri": "https://maps.google.com/maps/contrib/114958447632193407577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWUwwHUJEYyM8ozOMOCuSzZz0Y3-VycY3ffzSE4bgOy3ouaGEklug=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPA-p6mJnqAz9UJ55LQFGtU2CnmJoBxJZ5CmaO9&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPA-p6mJnqAz9UJ55LQFGtU2CnmJoBxJZ5CmaO9!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          },
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWp3Lij5_KSaIBo09sCl_dXu0IDYdCMp35Q3Hra80sLnSNy5VQpHBr4jiA9ztai2xjmall88JJD0X0eLzUFaF7TBeN-fsZXmKtKGQN169YNY5SOUd5l8OGfowO6xyhIOz4mWLcOTWCBpc8KSE37SXAGwyORWrjX4BgTE",
            "widthPx": 3000,
            "heightPx": 2970,
            "authorAttributions": [
              {
                "displayName": "Clark Van Halsema",
                "uri": "https://maps.google.com/maps/contrib/109320443572546926648",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUzeNfQyF_pHMr6KOBuNeVo0BFlydtN2K53VdLHX2xC0UT-42RBew=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNd6vgp4uKDo-hxq77WhS7XLp2GezvVS8T0MzyE&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNd6vgp4uKDo-hxq77WhS7XLp2GezvVS8T0MzyE!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          },
          {
            "name": "places/ChIJ5a8ra6QsDogRENtJLAp40AE/photos/AdDdOWrvzgjlXv8bgYCJ1LQDDMzIE73HpgHIgIVsRqnUjfru6HJf3wH1sLhca7tyBoyKyvEPrXQ0zuUs3MiJ7hm9zdihJXuDKjhQrQ_6q0JXTRplhkK5fvwal6uLPQRjEeJO5PAnWMSOcpVhAsbRq4FdrpvNb1D5ThQfvW8P",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Michael Clark",
                "uri": "https://maps.google.com/maps/contrib/101762835100220907100",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXYmTt1-8L4iSSStNi3X9NHqu0ngTXWU6Y9S0u9SStsr6PsUUjMNQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMiKAQY4L3LtEBmpRttHpgUFJ2O3fzr3sNH048N&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMiKAQY4L3LtEBmpRttHpgUFJ2O3fzr3sNH048N!2e10!4m2!3m1!1s0x880e2ca46b2bafe5:0x1d0780a2c49db10"
          }
        ],
        "goodForChildren": false,
        "restroom": true,
        "parkingOptions": {
          "freeParkingLot": false,
          "paidParkingLot": true,
          "paidStreetParking": true,
          "valetParking": true,
          "paidGarageParking": true
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": false,
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        }
      },
      {
        "id": "ChIJja3R4OEtDogRrc5n8J9LTE0",
        "types": [
          "fast_food_restaurant",
          "american_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "2 N Michigan Ave, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.8822846,
          "longitude": -87.6247078
        },
        "rating": 4.2,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_INEXPENSIVE",
        "userRatingCount": 776,
        "displayName": {
          "text": "Raising Cane's Chicken Fingers",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWpBibpt0_9UznxxmExNA0pPHsINtEPDO4k4CUaw5ETB3VfaT8RvLT9szmAgQvyVjSiIlytFbK4EHLuysddsVyleNCy1hjwYggdCmrBR1HP5J6X4sm8beVP62RwKVzOu6765kr2YYOylQN36Tk0FZE9InS_NxLVpg_Lu",
            "widthPx": 720,
            "heightPx": 720,
            "authorAttributions": [
              {
                "displayName": "Raising Cane's Chicken Fingers",
                "uri": "https://maps.google.com/maps/contrib/117227141385705824762",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVKpCWryNWXLN1jmQaRu35hjdninMrsnr2TXPtcIfLZ_2Zq-JM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNA-j3BF7dboav1bZBGw_0AIYNO1mKdyJaDNfzu&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNA-j3BF7dboav1bZBGw_0AIYNO1mKdyJaDNfzu!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          },
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWp5-q5667ppbUP7cmxb4MvE7eE6gjT_KGfODOqnsUbYxk7LqkGDtc6HKlKtyMH6WwqCaspSbB-nOCUxJUeiQ3R3gHVJ-yHqfwPoIr4qdjf3Zit6EqLkCOpyLNBfb-2ce0lIsKlPQh2NrqF02GOusmpmA6dwPS061e8V",
            "widthPx": 3472,
            "heightPx": 4624,
            "authorAttributions": [
              {
                "displayName": "Sergio Ayala",
                "uri": "https://maps.google.com/maps/contrib/113064461364868890702",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV9uTFRe6cCqP472UaNChGFQ7KXfZqE9ip0jPKBRxpFGGnb5fpGHg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN7pvI0h5QIlozmzLPyTmP4j0gTgvD0_yj0us_K&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN7pvI0h5QIlozmzLPyTmP4j0gTgvD0_yj0us_K!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          },
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWpQyQPfoLPamkouGBBd9hMHoIrdz2qJ_eorf2N5bSKrjtPtfysR0DQsKwryqlJnCCwnIpINwpC3jsczhSTqM71e-XHycdYy2EJs5v5Wl9rj0v0hswzjvj0TBBbsmN1K4RMcpQJf6u9k64KMPgAsQt61M_KmApW4r7cd",
            "widthPx": 1500,
            "heightPx": 1500,
            "authorAttributions": [
              {
                "displayName": "Raising Cane's Chicken Fingers",
                "uri": "https://maps.google.com/maps/contrib/117227141385705824762",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVKpCWryNWXLN1jmQaRu35hjdninMrsnr2TXPtcIfLZ_2Zq-JM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOo7QVDgmR6XHRoNmcBBfdAalmOMsmdjhILVjgw&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOo7QVDgmR6XHRoNmcBBfdAalmOMsmdjhILVjgw!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          },
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWr5lhCjPM9UYKCOejA6yVcfllZq3PXFbv53IYRLRgsy37Bs2_oo61EGrUzUWKvfqNgSngy3LI7SRwvewdmzbiOpUdThuPbcXhk-Mse2uShF8kQqPThs-6A-vh4Wyw1RmaryRsJZDAfr6c1KYp6A6ydfriNQfjYOXZ3n",
            "widthPx": 720,
            "heightPx": 720,
            "authorAttributions": [
              {
                "displayName": "Raising Cane's Chicken Fingers",
                "uri": "https://maps.google.com/maps/contrib/117227141385705824762",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVKpCWryNWXLN1jmQaRu35hjdninMrsnr2TXPtcIfLZ_2Zq-JM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPI8YinfaMjqrYKouy-JCZqDJZU6ppUqYJr4FmT&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPI8YinfaMjqrYKouy-JCZqDJZU6ppUqYJr4FmT!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          },
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWp-YlkRgbiqvQnKpn3YvpKxZTnH1muJ2D40RN0fM9Sktbel3G8mfavgzmjIRi_FwVhQwhV4C8vk7jSJDUOZ0qnCGgr5nDVhZGaDasSU2xC03UYVpT19oivDwUogsd23qj6CQ7Q1_VuAS43N4Ygb4fmcxyO_2nlO3KvY",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Paul Cina",
                "uri": "https://maps.google.com/maps/contrib/112584709540465729755",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWtS5DSyr02JKxeOAITVyc4JSQMow-zE6flX0HiSyH-caOZcspD=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP_8Cb3-JE8gb1Xz3rRe_aSvdQwjmw31Sv6Hbb6&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP_8Cb3-JE8gb1Xz3rRe_aSvdQwjmw31Sv6Hbb6!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          },
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWpPEw5eYkbyi0EQMTSNlHl8p4MF05a3DPbqM1xGcc9vqrnet2Wij5MO4kf9_2pVCPhtmjBrFkWkWwhixIYD2E_txYTE2wtAmywe3IsCw67ctPt6b2p7RtobHBAkKbcta41VxzPbQpk75Iey5J18kv7nC7cZvKvuKPGw",
            "widthPx": 3852,
            "heightPx": 2892,
            "authorAttributions": [
              {
                "displayName": "Dhananjay Narayan",
                "uri": "https://maps.google.com/maps/contrib/105538657625919951876",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVMQofjSLvh-Bp_ThuwBp8Vo3xrS9M_I7mu1ot2JPn5YfZveY4p=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNBiIOav153PasILFUEgaavKO3eUghxJ7L0zvaY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNBiIOav153PasILFUEgaavKO3eUghxJ7L0zvaY!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          },
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWr8phGs6lv5DF0OmtA8XHgHIzuj-Hurpf5TD49YR8QFZf5xgLiL0rrl1cx14_UGvj8lgBciH9mEvKE-v1UO1-N5QskzasMqIJ2EcJC0-8HfKHQvHia-ZGYyAwaz8mPaw5pMihyAiXxyHPJyrLQc_-3U_tKPW_QYBM3J",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Alejandro Anotzin",
                "uri": "https://maps.google.com/maps/contrib/113157604256045248764",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXvzCgkZcNB8pUsBjW_oWDc02cTTMdzh2KxB4omjN3X0S5hYmIHQQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMyG6s3vP6-RCrqWO1aWi8nES7S33wbQTxloolz&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMyG6s3vP6-RCrqWO1aWi8nES7S33wbQTxloolz!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          },
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWrNXMSv-rSFJR_ThGyidEvXFdcMAVtSRDKnUdPYnQUXP00TZPOop-tLopxmaFjDQYLjuc0h7O6duKmG-LzULanm1swyNsqUf7DfybXs1cEX7q9eJJ43HSziwBMdZwkQG9PmTyDzTJBFyveSg6xRjqCZ3r2S2P_Bx_hL",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Jenni M",
                "uri": "https://maps.google.com/maps/contrib/103433723253709817748",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXukhin9CHWYv5eO2eU2tUcPbraihYjWpgfMVysCWMRHzAReXE9Fg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPsezLO6hb1nye4JeJiAkWwL1c-iyfurjOkT2iR&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPsezLO6hb1nye4JeJiAkWwL1c-iyfurjOkT2iR!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          },
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWotFOgkHH3f8SVnZGGXmk554H4ZHhtNynXh_u9Z5KUMKFyi5Bw3KmXc_wQ_YFeQNzjz6pVLgwRTxmVH8_6jK31SWh-WA0-EXPZnKndPD8HPke_ZkBmYS0KrtmvVK2eKjpQTzOPVaAyPTtc6Lkx3A1DIj1aN46EHjS6r",
            "widthPx": 2316,
            "heightPx": 3088,
            "authorAttributions": [
              {
                "displayName": "Laura Fauverte",
                "uri": "https://maps.google.com/maps/contrib/110947628657397358608",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW_JI248XnkEBs0Hg_Wnyb4YHhaYHscS9INRY2XxSorDGnM4gB65g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipML_polKswuGi7MTNEWw2FaiCWJpN5wPL5rjWL-&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipML_polKswuGi7MTNEWw2FaiCWJpN5wPL5rjWL-!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          },
          {
            "name": "places/ChIJja3R4OEtDogRrc5n8J9LTE0/photos/AdDdOWoz3ZHgHD8gZmdinAGbO9VRjqkhQkZMiwtG_ZlwqNpKOSiyGPXOTeiyjCQX19L2s1x0eLINLQt96sXptfn3k5C4T9J6Oz0vY8Zr3FJ8fYKqlgMlgIRZE0vMxC_cff-LWuRWcD-y6TQn9GM_Fe1gn5cuoIgdYDyvVo4w",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Rodrigo Poza",
                "uri": "https://maps.google.com/maps/contrib/103772538087308806086",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIx4KVhcn-w7ad5g7DfPFSJpVgBQ_xKlQeVjn_QKmEzG4Wj7w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNZOMmjRcefdg7bF1fRPhXiQqW6rmR88GuZTjO1&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNZOMmjRcefdg7bF1fRPhXiQqW6rmR88GuZTjO1!2e10!4m2!3m1!1s0x880e2de1e0d1ad8d:0x4d4c4b9ff067cead"
          }
        ],
        "goodForChildren": true,
        "restroom": true,
        "parkingOptions": {
          "freeParkingLot": true,
          "paidParkingLot": true,
          "paidStreetParking": true,
          "valetParking": false
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "10"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "20"
          }
        }
      },
      {
        "id": "ChIJg4i4E6QsDogRouakuQx6drU",
        "types": [
          "asian_restaurant",
          "thai_restaurant",
          "chinese_restaurant",
          "sushi_restaurant",
          "japanese_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "MILLENNIUM PARK, 30 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.8811159,
          "longitude": -87.6246469
        },
        "rating": 4.3,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 1832,
        "displayName": {
          "text": "Hot Woks Cool Sushi",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWoiaM5gD2LOWYOGDFoxQPiSBDKWgnnSOEBbTWPpEbw0wNJhyafj-M23zgROFF0ECyYMBL3RYBNVbPWTHrkqvmDuqhcjQOLhNWCe7R8TZjk44DlyZGeb_QSHgHjX1vM5iM3-hhn_3OVpWJCakbWcjzEQwI7nnx8oG1dV",
            "widthPx": 2048,
            "heightPx": 1369,
            "authorAttributions": [
              {
                "displayName": "Karen (華蓮)",
                "uri": "https://maps.google.com/maps/contrib/113572281712043295737",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUXgr281VS7Prnv67BCi41bH_5-ZtbWpCu8sodQ66VKAHQpAhk=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM8SYtxlVVDSs3jQo1zwFWYNFHPnW_8bFOptRta&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM8SYtxlVVDSs3jQo1zwFWYNFHPnW_8bFOptRta!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          },
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWrwmT1lzXCLuTIZiQ34oi3N0o5vgJ-1BoWz809aNeNC9x6HLqoJ152wYKfxpcKwAeqsVqbmWRLp7iX1Ggnk7gbcS4yg9xI5qawh2sNKg9vJH6ucCvBNjhbS7tbZeFl5D3P-8TYOS-BC_MdXPyxuueepluXIuz97gopg",
            "widthPx": 2743,
            "heightPx": 1544,
            "authorAttributions": [
              {
                "displayName": "Hot Woks Cool Sushi",
                "uri": "https://maps.google.com/maps/contrib/118047545310799532078",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXQ3GIuo5G9sOT2IIHIBYTy_PUmGMXh36HQiRtPDq3tq2US8sE=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNrKGNRP_mXMwcwW9a1SLs9FpMfn5HSUVDNxM_k&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNrKGNRP_mXMwcwW9a1SLs9FpMfn5HSUVDNxM_k!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          },
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWqzmmoNf73-RqVJBaZdSTrqVvlxfNQZ2AR77qUXrwe8TDhN1trbBdE_DLrqoc9oSyK_EgaDNtCEjK1qjbeli-kjJYAmJvPZYEu8ZzRRLMoX5sfKK8q0SLk5w0RhSPbosnaYEjLKKWb57HFO15Sd964Xs7IHFwLNOEs6",
            "widthPx": 3763,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Hot Woks Cool Sushi",
                "uri": "https://maps.google.com/maps/contrib/118047545310799532078",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXQ3GIuo5G9sOT2IIHIBYTy_PUmGMXh36HQiRtPDq3tq2US8sE=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOFgvjxxVk1V8x-fVJDu7_oPdW8-ZkksS-LRi88&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOFgvjxxVk1V8x-fVJDu7_oPdW8-ZkksS-LRi88!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          },
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWq6kukG7ZR5m_FdM-7y6cW87-DyK_8JS_bW-fcb7zT0aBwJ7Zx04qcZO_D2pd2FBINarwo8GeBrfn2Hr6UQvjmlFFTOTkeg1eeQoHTktacRXGEGR63HAuMBTddbFafkSnBzypR30mLgPt8G0ms5f2lFNq_N__5f7Ru-",
            "widthPx": 4080,
            "heightPx": 2296,
            "authorAttributions": [
              {
                "displayName": "beat shona",
                "uri": "https://maps.google.com/maps/contrib/102998719718210389808",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocI57tyB_GBrF60U2N-AA9b4ZjchsGp-K-4ysRGtMeaViJi_-kA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP0xFqz22N_RM8exqJwGEkqYsY99GfuoAy1BEAY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP0xFqz22N_RM8exqJwGEkqYsY99GfuoAy1BEAY!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          },
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWqZo5y58NT0ZMXdPjx6ehmfQkq3ePodkHD7FOx_gpSmZmxJYLcKrfiqldObZuGgsNNLzBZluvxZXbtg7V2gJKLAlA2qpzALJZlvd4qrQ37MmmcLj3ldZitd3G7MvyVeF18l2L7e7j5JKssVvsfphiBZ3gbouwAQYO6I",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "sai sushma",
                "uri": "https://maps.google.com/maps/contrib/104217544192702134750",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUxFhCOg0EGkE9i4EWa6R-_wyN7y7ZbBr5COHYbX31-UvQCviDq=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMGUU3sxKIEP_uckDIbV3BDdmd2Oi5_aT7uDh4N&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMGUU3sxKIEP_uckDIbV3BDdmd2Oi5_aT7uDh4N!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          },
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWrYBfj7SINe_42mUyNcegg4AorxXCoeKJ83h1gdnfRgnIuYNGCVh8Fpy4OSSG_5AFtq8DxOio3VyVP1PzZDcmrE-SMEIzo6-FGOdJkMG7TYqh6HXdU9umXDp5v_vvhzCGoxR0b_mKUDhno3mgvfMDzGaZjPo0FG6IMQ",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Dave Bowman",
                "uri": "https://maps.google.com/maps/contrib/110990315511495668251",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWoCTvxc4h4iTMrtDwLMTuqp56qEVMVLBkfAM4mrQ4p7KmkXLZn=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPBIhPX2XkPhQK0Yfsc7wVGwL2h7Nq7_VWSf_BZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPBIhPX2XkPhQK0Yfsc7wVGwL2h7Nq7_VWSf_BZ!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          },
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWpQTM-amhkmgkBjitOnUiGNK4Zid8HPblxPdXmLwl8-wH-0gDqJS5bnswzcPHWp9qOGVFGwHPTS6C-PN0TJiJVLWWyyXxbuzU3ajXiZkMIJ8qa3RnV-LX8OBDbMhNVHDGZpqBbai-qLB2URiZc8rfAPjjrNVsrT-2xU",
            "widthPx": 2562,
            "heightPx": 2691,
            "authorAttributions": [
              {
                "displayName": "Hot Woks Cool Sushi",
                "uri": "https://maps.google.com/maps/contrib/118047545310799532078",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXQ3GIuo5G9sOT2IIHIBYTy_PUmGMXh36HQiRtPDq3tq2US8sE=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPCqVO-zi44xUhi5xstn78J7-aTwUxQYuYizVJc&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPCqVO-zi44xUhi5xstn78J7-aTwUxQYuYizVJc!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          },
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWrOs4714UVSo5bo7fFfmdFVt3WQ7CjyBDV3Z7S9mY18v499JuU4JjeJHkpZFaTkN-cH2JWmOqeps75juZD6oCrd_s35hH6L86Z9AYTkkCyhn00UaXY8sy63ZfB-DECs1u_tf8IheFjx7qiiB-GQjEHujnIBCK8CiBIj",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Dave Bowman",
                "uri": "https://maps.google.com/maps/contrib/110990315511495668251",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWoCTvxc4h4iTMrtDwLMTuqp56qEVMVLBkfAM4mrQ4p7KmkXLZn=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOHt25kco41JoTxZMSeFlsj4d7IqKjmLB9btXiX&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOHt25kco41JoTxZMSeFlsj4d7IqKjmLB9btXiX!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          },
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWqlK5L7GIoi9LClHjCJt53hEKmMdaaMeovF5axaeNsdJk5WnscwaRVKyk9LqHxeuq6qmc0kfyFO3ITM4R7EQKAG519msDpqYVB_hsDF-HkVEixjd7qN58uyh8wv0lJYOrb4Spbjve_kACfIG8FOIKZ56GKfhW5Gjezz",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "오늘도맑음",
                "uri": "https://maps.google.com/maps/contrib/100406507176376055485",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU8kHop6ReUjKZu46fl4y-EPoP2TMjwsxqu1KrCaGbU0OzjG1J_=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOfAEXPU8JdgsO1tsnslcLrcPaJ-CXptOK9ZFsI&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOfAEXPU8JdgsO1tsnslcLrcPaJ-CXptOK9ZFsI!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          },
          {
            "name": "places/ChIJg4i4E6QsDogRouakuQx6drU/photos/AdDdOWq40YJqzcfhXs_eHCCgWP5I_aSp8YhRyCQYaHYMiKEtbyTQS8WKARY8TW_G9lndHtxd_IT5O8FWH2CjqxXDNP3ghh48Sh7ijxg-N07KEfjmMedNp_7KQ8XgDsOpwu_LuSn4iVXO14IgrJjsmL_oDDEU-Z_h_aT0P9zW",
            "widthPx": 2327,
            "heightPx": 2613,
            "authorAttributions": [
              {
                "displayName": "O. Douglas Jennings",
                "uri": "https://maps.google.com/maps/contrib/116659862868180177988",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU4mWCNgXpvEkzjwqFeV4F0SKAvNWXHqA-KlMVoBaaINHu_rfdRkg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN0lT3CLk-nGvlR9iIYb8ggipI8QeAnKqpswORe&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN0lT3CLk-nGvlR9iIYb8ggipI8QeAnKqpswORe!2e10!4m2!3m1!1s0x880e2ca413b88883:0xb5767a0cb9a4e6a2"
          }
        ],
        "goodForChildren": true,
        "restroom": true,
        "parkingOptions": {
          "paidStreetParking": true,
          "valetParking": false
        },
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "10"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "20"
          }
        }
      },
      {
        "id": "ChIJr-1DeDLTD4gRgaK2V-GhG1o",
        "types": [
          "fine_dining_restaurant",
          "french_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "18 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.881412499999996,
          "longitude": -87.6248474
        },
        "rating": 4.8,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 103,
        "displayName": {
          "text": "Dining Room At Kendall College",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWoZAVPZTKbv-7M1AuzzIp57NapmJbPfQUFsLiVP4d5rr1D0CZlUBBNd1IyPJo3izrqnCkMZZvJsanUZbTkZBtAA4chVF2YLSv08mzl5ap_jWE75nG66b9KQ1GuJGLPUh4EvBCrKeyBFvOJ5-dxZmtFjO0k5EU6ra2lo",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "Rhett Hildebrandt",
                "uri": "https://maps.google.com/maps/contrib/102910500721599087419",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXNBbiXUWnmmLr8HRwwnBPOqNLvd67FopWBN58KUcqJEbX32EI7qA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPcu8Lua4KD__EZNil-aP-AXbyS5jLW0bDWtSfx&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPcu8Lua4KD__EZNil-aP-AXbyS5jLW0bDWtSfx!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          },
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWohAaEH7XfLi24WTptumuRkcKo-zkThG3-4tGRv9bymBVMk-N7IA-8Sq_vxBTAUTrSLCs7oR4EU_pOF2ICfJ79WQrkNzNrfyx3phhEWW0W_VI-c175EOucdbQJMcwjpyNNx_uvKVzok-Wl0Ezu8BB3T_aFGphQS1QPp",
            "widthPx": 2992,
            "heightPx": 2992,
            "authorAttributions": [
              {
                "displayName": "Daniel Castorena Jr.",
                "uri": "https://maps.google.com/maps/contrib/113890495497470243196",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX1eFK547sVBNf-TReaBd4NlQVe8uBNlKepFghB_44p6j1N9AY8RA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMOZil8g4Y5S10PFDGq0FvmuSpsTeVpYErMoPu6&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMOZil8g4Y5S10PFDGq0FvmuSpsTeVpYErMoPu6!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          },
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWrj3rO4yOLBm2-t7d7DsraVuEd4s6ENpzemAjQMmxtNAYq41C1pPWeMPaYi_WEAvGSCzDfyYOZsk384bE_hFx8HUVjQlzALL7kwNOtR8pPu2roNSub2aDf_UWJ-h-v7TRAlHeCXtBWzAubilw1fzsKurtBJnPz7feZp",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Miranda Andrew",
                "uri": "https://maps.google.com/maps/contrib/115062613952022340100",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIE40CGk6Q9F84VWnE_4X9D452iy3aATGMwJmrYGye8Z6SedA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPJw7FAtr9N_7jwxTo54eOr6kGxvHsXNqgUyIl3&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPJw7FAtr9N_7jwxTo54eOr6kGxvHsXNqgUyIl3!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          },
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWrQBhzzIERHI4-Y5imfiWkBrlva6jVjQXBSg7VFMpleNFzJpwZxacW9B379JHejDVld33xjMtMwgaVSbFIZ2nBp807YHm33V9NZFi4SwC-73v-72tofBJ0fkeNsRkTocTNkPLDZN99bS96vtXzJKYGVu89bMoDo_iOF",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Claudia C",
                "uri": "https://maps.google.com/maps/contrib/107782990541114660660",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVSAhOLWFqRueJ0v9JzkyQrxsBBwektfjMohSC-GjMPKpIKozPrCQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMDmoxLaEMdlj2crlZp-6jMgzvU_sj5-wJwgJLs&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMDmoxLaEMdlj2crlZp-6jMgzvU_sj5-wJwgJLs!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          },
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWqEzbcMoh7OeqgJ6dY4Had2kmJyvFhNlDPXonVFQ2JcIeC64yHgBXDoD_s2wij8QW3T5NNKvB8vlltAIS6PZXsMIGiWikfTF-axJrWOgDldtDcKxzd-MTMnf-yCR_kbkXikf56w7otNSQ2AOVlLDnNFWVY2PebmLwkX",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Vincent Mañara",
                "uri": "https://maps.google.com/maps/contrib/116571587529772372341",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV3saMaJQ-VBtiG5N1VYEJKSy0WIcyDM25Efc7GH9SwJCCaGrHe=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMRSw-Y64BTpgpv6zuZP4COKghXZ23FbK5IVPc9&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMRSw-Y64BTpgpv6zuZP4COKghXZ23FbK5IVPc9!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          },
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWoi_-woizhHvDOG9f5AsmGV-8qRp5ITFbnPNBihNS3wzSoX_b4MGdTmfLqp0zjlHWbTXPsLwoE2TM-NMRyAsJ2jkTmQ8wmk4j8XZrbWBNw58WJgsUvag81ui2Ft4BHXCVNBW7OwDmMZBwWzSpkB5U4E8fB7-ggSWkCO",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Ethan Cohen",
                "uri": "https://maps.google.com/maps/contrib/106261593091090801545",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV5Z6wW04qQq-Wg_7xrtpzIXpVQ4EY-JHji2PaIWRe0ZVFBpiki=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN4lJDVrWz_or3kt3Cr767Zyy8pbP7kQbdEibDK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN4lJDVrWz_or3kt3Cr767Zyy8pbP7kQbdEibDK!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          },
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWr5yqdXJy_ke7ypTklApLiqrJPsIxr_RUd08Q4MWBzjX9m1qxpQXQRUc495rb5KleEekaXc_I-9e4ZH0gOO1Aul1-MF0_YPWlDpl24iAG3jKC-YjLd9Nn62nHPZNPOKtt5KD3TOGgcB54ePCeNBJ8qBRxIKYRu1JoS7",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Dave Citterman",
                "uri": "https://maps.google.com/maps/contrib/111707783460266873438",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVQeNvJLtj-iiBwbgWjeKPPgnwugIdmeQ8qgV0YXrY-Gdm0PDBk=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOLVuej4-6J0TmAtK0az3SLItWEClJEv4tTt8VA&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOLVuej4-6J0TmAtK0az3SLItWEClJEv4tTt8VA!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          },
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWoVf1rCLTM21eKtXy-PXehymOVyL5Lh5EnJFPtR7WOVRb2DrcHiVr08X8Shh5VunIZHQGBSuxXskAN3zD-AUw_AQWmc6Q4MlpbJbiPrd0W9hIRQDapB28a8PgTgpDvE7o7pLduepGQn6lqeumRq3V7K0VpSVomQPv8h",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Cheryl Miller",
                "uri": "https://maps.google.com/maps/contrib/100834208738304490669",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIX3Qy-RxOhIBmd89GqbNcBOQ5-WN7yq9t54KvuOFUsWgwjGA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPTX8CX4FXOyHIR4rMySwW_zctQmYohL3F-GbHq&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPTX8CX4FXOyHIR4rMySwW_zctQmYohL3F-GbHq!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          },
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWqpQ3EGUuIFM4XqZ56Ys3-QdZQIIOHk9DAqIgMaDhvEYwRtT3Szo5q6a3hlolizxC4a7m6amvdwiDEbFoqZwKY3YZUUTtE8ohAR9VbS0AgTfZ-tqmN_Lx81p-sVC0uIB1j-Db1_uAMn9vnOoNOW26yn0XZPL5huyL0J",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Dave Citterman",
                "uri": "https://maps.google.com/maps/contrib/111707783460266873438",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVQeNvJLtj-iiBwbgWjeKPPgnwugIdmeQ8qgV0YXrY-Gdm0PDBk=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO6Db6FvEv9qkMCYurFhpEfxGWHMfB8ZqSO-e7T&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO6Db6FvEv9qkMCYurFhpEfxGWHMfB8ZqSO-e7T!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          },
          {
            "name": "places/ChIJr-1DeDLTD4gRgaK2V-GhG1o/photos/AdDdOWrgl9wACMfxj4Snq_WUAKezNG0dZY971kiZ7ZJEz4gXRwLl1PuuuBV1vdNL4QSL3MlxGyOYiPB_ZJR0upRh1X6xiIa5SLPYcnvyjKUFCPSZQY6czCovAirC0xB0Rg0gMcAjC5VM54RptDaKzE8jLEqyuUS-5weLZwbq",
            "widthPx": 4096,
            "heightPx": 2304,
            "authorAttributions": [
              {
                "displayName": "Pinchen Chen",
                "uri": "https://maps.google.com/maps/contrib/114116958881364203276",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX6aQ7-yEmXu2xIJS4ZniqwXvcOvFUp9g4exvsl1FBeIKbPJEAMqQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPp1c_9fGPo8BRp3-oUy35--C0e9-qI3v2bDkzJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPp1c_9fGPo8BRp3-oUy35--C0e9-qI3v2bDkzJ!2e10!4m2!3m1!1s0x880fd3327843edaf:0x5a1ba1e157b6a281"
          }
        ],
        "goodForChildren": false,
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "50"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "100"
          }
        }
      },
      {
        "id": "ChIJ3aVOQKQsDogR7C6gmWwrVtY",
        "types": [
          "hamburger_restaurant",
          "sandwich_shop",
          "dessert_restaurant",
          "fast_food_restaurant",
          "meal_takeaway",
          "american_restaurant",
          "catering_service",
          "food_delivery",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "12 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.8816646,
          "longitude": -87.6249436
        },
        "rating": 4.3,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 4518,
        "displayName": {
          "text": "Shake Shack Chicago Athletic Association",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWqm_F1vWU8EBaGShC6JFhAsurmPhT7Co_cBd1qLcWMWb_0YrQqy8kO286ibtnW5yKt2fxhetImPIaH6QB_QvEB0undAmP6yofxqFGziarizA-tfWUnGds51Shb648b9OQk4hbEL2sg_o-jzmSVSkAR95R8tl--_CEiV",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Alison Cruz",
                "uri": "https://maps.google.com/maps/contrib/106579515791426096496",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWKztZ2V7heHzyVWJxwLQ48GqnI267SDck3TnD7lJDG2c7WvJqa=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMJ2d_Iw2HScRDxJsSOBxGPWnICcsANKd5pP-1J&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMJ2d_Iw2HScRDxJsSOBxGPWnICcsANKd5pP-1J!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          },
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWpZvQBLdhKdpN78KmljhcCgVmIYrUYCIPMm5-gYnu_AchxhKFkipqBYbzjTtTJ21i8IvJQeWGaytlAYLfGbOKhk4OC3E_hBqERknEmr1_PmiRHq8QMcy-yvUAfqgUw5v37gKeQNY_6Z-UvIdHC2McnsNokhuR0MpYlt",
            "widthPx": 1080,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Shake Shack Chicago Athletic Association",
                "uri": "https://maps.google.com/maps/contrib/117937050771907537861",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIRvjL04Hkou9ncDhdaFgD2rtb4BqZXBWFnI3qlxCTpEmci05w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOCtmxIFTLZpsL3nLxunoJkoNYAzeJAy6kNl0hR&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOCtmxIFTLZpsL3nLxunoJkoNYAzeJAy6kNl0hR!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          },
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWqi3Tx8LecZOfzUT6xUYXwHIVSuYTtLJnHFpu22twhdm5nGJ5rrxGaw2b41y4CmFkCYaNZDyB6y4hhOol4ymz_xScg_EkbIFaK4Wl-eC3Rp-fpugSr0Tylpuwe2EZO6FvnchCBnMK4o7hAUfmKw4vWhSG7XYGLBxZk7",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Alison Cruz",
                "uri": "https://maps.google.com/maps/contrib/106579515791426096496",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWKztZ2V7heHzyVWJxwLQ48GqnI267SDck3TnD7lJDG2c7WvJqa=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPhB-cMROjp_4m7V4IPbMhWa-iXstWwiBSgUz_4&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPhB-cMROjp_4m7V4IPbMhWa-iXstWwiBSgUz_4!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          },
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWqdN-uNE3Uz70Rl39mpC6L2yg0eQM7yMWxGetzoPLUdAOF9JTS0NaIFsIJ8kUtGCMW4FC0v4ir0HBXmTZAfjcAgEoTTOjP-GPg2Vz9Ko6qvoC_SOAiKRv15u7qdgR7G2krdbvCANKcuL9UKMKtOWR58m6D1vfvSzEvi",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Nadia",
                "uri": "https://maps.google.com/maps/contrib/110928551179263166703",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW13cbUIgTkVWGhmnyVz0HYOoKVwBoW7F3dCqkahIqaxU7DaINJ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNO163QKGuNrusm4Qz_fh8yTid3etEM4J7i5DSD&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNO163QKGuNrusm4Qz_fh8yTid3etEM4J7i5DSD!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          },
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWqsisU411otGduiEh5RzvMmGKPT8w5ng05yjbAgW0RyC179cQ1z-pVHFwnmjjBFlGzo1WZdT1dKHKPnaM2WjREztgCu_fvdUo5Yxj7FfHAtRtRLiUmoeOSv-YE07_gtOmgAYKcxBr03Psv3b1hcEg8Vgb6mNGJmt1fz",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Cheryl",
                "uri": "https://maps.google.com/maps/contrib/101750280304661852233",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW4Qj_QkosSYogTUJoG9vMF36Bc7T1x88fHUWh6kt3igGHSBzJFMg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNO7NP977T9wbpOUR8JiHbz1F6kCboJylROJT7d&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNO7NP977T9wbpOUR8JiHbz1F6kCboJylROJT7d!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          },
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWp-_M-3w0HITvjKSqamUNx7x5OgwI9sSFxJh1NlxfNwr3HYi13MUGRFZCXTWHOxB6bdpgYxeuR3Zn5GiHdFxCalM_JfWCQ7_pyrm6DmnFcauiMhAWr-JULnf6rhaLP2Rt4zwtyD_5EX0_cGcYBChDl2kmr4s8UTq3Du",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Néstor",
                "uri": "https://maps.google.com/maps/contrib/100871334591574297805",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXyzNwUx3Fa143ENWItIgUq-wV7ZYDb_wAOVFKUgaWSe2_T7l2-=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPPU8EOG9gYf_aF2zVb8vCaVM6hjXeNLRhJM2LB&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPPU8EOG9gYf_aF2zVb8vCaVM6hjXeNLRhJM2LB!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          },
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWrB0g7v2swt8FWr8iYYBkpT1IGNHxyX1sf7m6qx3cre_i3jw1UoENmM6-Kary6VPmFRnZYcWcprp3FvWNUiqCZIUZ99cAXI8QN15XL-pYmrc2-vJm2RVxe08D7_1G7PKbVg6lSOdGVbk1dWwayvYkuNzbX55TavMyfJ",
            "widthPx": 1200,
            "heightPx": 800,
            "authorAttributions": [
              {
                "displayName": "Shake Shack Chicago Athletic Association",
                "uri": "https://maps.google.com/maps/contrib/117937050771907537861",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIRvjL04Hkou9ncDhdaFgD2rtb4BqZXBWFnI3qlxCTpEmci05w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNXQVnzhmb68d4a0Zvuq9mpQ6js85vQkSgJpUYY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNXQVnzhmb68d4a0Zvuq9mpQ6js85vQkSgJpUYY!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          },
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWpcWWmsLETmEK_YVXIRvEjxOMhgRLMfTg9fsKL98MictTXHzhLC4rZfcPj9ffbTfa9NbzPi9btc7acl944_srJnWArLDF59U6Wu-ruK4qITa_CIQWPw4NlcD7tHdTTh5RjeM1_gu8I87h7hB5b4SvdsN7MFA8hj_7e3",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Ivan Corona",
                "uri": "https://maps.google.com/maps/contrib/103240619605388343648",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXIcSjiixMrAXgpUSrMPa_fRgxn0LtlASZB7FQWQenOoqkBa7Ge=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMef7G859t9ClqIzRn8APOFwfghKqizIO-oFLTr&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMef7G859t9ClqIzRn8APOFwfghKqizIO-oFLTr!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          },
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWr7LQ2ts0brijlcC1CWDHcfrZY9PNLrkjQ-Teoc-9o7hjN7y0zs2oUkZoSRIabXSNRj4TkELcMhR3hAiSs4O57LV1Ogu8D-8Wg7bfkIGZWuOlSdSMsx-Pu_iDlsiK5ieBsauigmwZ-fb4PnZqq21_GY7jVegaAy_NIE",
            "widthPx": 3072,
            "heightPx": 4096,
            "authorAttributions": [
              {
                "displayName": "carlos Hernandez",
                "uri": "https://maps.google.com/maps/contrib/110523896070784412076",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocI4gMlOcPPiuCER109L9x6bSHGyEoPYI3ECke4YaZIQGTHnig=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMKjKS-F3Zb1Zc5NWYhmy_LaL3KGeD9SLympRcs&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMKjKS-F3Zb1Zc5NWYhmy_LaL3KGeD9SLympRcs!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          },
          {
            "name": "places/ChIJ3aVOQKQsDogR7C6gmWwrVtY/photos/AdDdOWp7l-j3uNxcKwxaRSlJzFATPq6nMrhnE0zvuMmzRJQQDSda4RVsa6cSbujsVUbpsVXIqlwzrtAxH6SzzcukqLuZkyiXIF-Hjttv2jllX_87I6H5FaWbVWLADo5MdTgkuWmCR1RWV5UtOlpItyinpTRIq8r7nQAWK06l",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Alison Cruz",
                "uri": "https://maps.google.com/maps/contrib/106579515791426096496",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWKztZ2V7heHzyVWJxwLQ48GqnI267SDck3TnD7lJDG2c7WvJqa=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNYEqvl5GZ7Bq8eBQGftnvC7emJnqc-zUQZ-1z6&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNYEqvl5GZ7Bq8eBQGftnvC7emJnqc-zUQZ-1z6!2e10!4m2!3m1!1s0x880e2ca4404ea5dd:0xd6562b6c99a02eec"
          }
        ],
        "goodForChildren": true,
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "10"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "20"
          }
        }
      },
      {
        "id": "ChIJmaZOQKQsDogR3rQRpnycNg8",
        "types": [
          "american_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "12 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.881626,
          "longitude": -87.62494199999999
        },
        "rating": 4.6,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_EXPENSIVE",
        "userRatingCount": 938,
        "displayName": {
          "text": "Cherry Circle Room",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWrY7ZS17-5jBh4Zh0QzZkkcBljArlGKURiq8H9sg2NHRzY6syHMyGeJBmJNLZfmwwIhVetvQ8hU_TPv_GCq31Qsi3sk_9oP4TCvQEZgjqBB3DNe86VcyN-SEtp5YfO71U2_xI8toOh8CbAdChe6xShdT_G4lKNHp4ow",
            "widthPx": 1200,
            "heightPx": 800,
            "authorAttributions": [
              {
                "displayName": "Cherry Circle Room",
                "uri": "https://maps.google.com/maps/contrib/113963068176480067737",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWRzRg12kk_2tq8upKF57M26o0NIlbNIOWzF5TB2F7xtg8OAT8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOS6IzefLyxU2ZfecJW-0BngpKDRPCAt6lHoo10&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOS6IzefLyxU2ZfecJW-0BngpKDRPCAt6lHoo10!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          },
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWppc8LAnJNzoZfxpZJ5SQ49SeHz77V-6oepo1J-z19Jq2gNNP0HnkCQ9zaZZVR53wtRS9lj_U8MhnoswlDKLQ_MloV9l6hypogUu82253pRQfVZWnlImqazitrQjKqggekuB0E5lvw5NofV7NdRFCcOVgBd5BBdIxs5",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Bryan Halpin",
                "uri": "https://maps.google.com/maps/contrib/104212883167388613262",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXNpuGjlch8Vj_6zY9jB05VwWNGgXYE4VYSw4HSfN8ywqpFen7P=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNaPXB_0dD9PRWzt2upTSEFugqJER7u4tBW_KUF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNaPXB_0dD9PRWzt2upTSEFugqJER7u4tBW_KUF!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          },
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWq-v4KCkHtZWYotcG5D4mGObTvkq4YxO4C8CBz_ngudsJH9iR2UWPSQfGgO2whDDg0VCrmfn9T9A3FbfI64IJetJZ0G-Uw_4t8IORAEAExTbbZ0K4hnR6SG0HiJJxXiaUX72qFcwRbr0B9aBQLfqIzATqa37D0ABSUY",
            "widthPx": 800,
            "heightPx": 1200,
            "authorAttributions": [
              {
                "displayName": "Cherry Circle Room",
                "uri": "https://maps.google.com/maps/contrib/113963068176480067737",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWRzRg12kk_2tq8upKF57M26o0NIlbNIOWzF5TB2F7xtg8OAT8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPOcCZSBuSd_pTGeLiqiqwOu7xBW2yMo4O-PAPW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPOcCZSBuSd_pTGeLiqiqwOu7xBW2yMo4O-PAPW!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          },
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWrvg0FPDjw_LobPKCEj1Dl0nl-bCQHRxOMBBTFpcWGYgqbSyWj8NwxP6E4KwX42L4J3poO2hd4BNE8uu8XWlODdshZvbfoi7WDZiey6GVfdB-LX0yG9OSbxpwp3KS68xY4NSLA43RWoOssuzY3HKGS6NoEK7wd1Xheh",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "CHAU NGUYEN",
                "uri": "https://maps.google.com/maps/contrib/103739847136001884324",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJWK2xdoX9s7Kd_PDMF9yjcyRcChExXkR7431et_Xb1nOqm3DI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNFHSbYd1y7lhBf2sTpZx8aDXQ_KybD2OxxrLQZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNFHSbYd1y7lhBf2sTpZx8aDXQ_KybD2OxxrLQZ!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          },
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWrd_qMIzmrNQx4MdAIS00TcviitVTJSw6xHUeVgNC9V7cPRgDMjtwI_s0dEtSYSimflon1y_DgOH2fGbZWtWTn0fCdl9Y0_J49_01aJjgjSpcGE4TRN1zTgDSmbZZdSMm8IS0SJ86K76vzqBa1DsXdBJ78nDBVB-ce5",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Laura Vélez",
                "uri": "https://maps.google.com/maps/contrib/111474523622901261810",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXlOVr1G_WVokYtioHE_UOdrBNckfy1eoHGTzEfXdiCghvvcLap=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPOzXhfa0ybUlCFySA9ZxAAM63Z5H27WcCk5-fX&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPOzXhfa0ybUlCFySA9ZxAAM63Z5H27WcCk5-fX!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          },
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWp38CLUyooHXF1YZfMM_gWAgpByHe3ZHNQOGPSrqVW2qetrbZtdmz69hGxPhuM4UE3PIdhS_caPIeev1HaS_iqPT0JT_GI-rBY7rimNZVVoTAmCEL8t0nQyNSxSLtPpQ8DYwIO3zFSYM7U5Wm6U05E_Pdgu2alBA9qC",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Mike Oren",
                "uri": "https://maps.google.com/maps/contrib/113570831396096412529",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV_KeKEb2JbZ8mz15Sc3Ugjp6BwGfAuTrnLsJcca8tHd9eeCCsg2Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOf-HesAr-sdW3t9MvEDUFrK24XA0N91udL_wOt&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOf-HesAr-sdW3t9MvEDUFrK24XA0N91udL_wOt!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          },
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWo-axHOse8C5tvlz7f_bfgamWvz5r2iGFZ7o0ysrCIEPk-a4XOM0cV_sXj7w1TUAy4daUZrQIewaXtGmF6QYujHD3X9krVIn2T-E1wcJI8fbCs9mehJ4ZMjajzoTj3CbOw1mxQEJzH6kUVXcMuFc-3S08-MOvoBfcvl",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Katherine Ferris",
                "uri": "https://maps.google.com/maps/contrib/111590042287015671658",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKbsqCQHvGINLHGncmGCnnLqLHRhPOBczxR1NaX9nS1ebpDKw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPe_yLk2eiW80fnYu9ZSnj2Fb5KkPax4LQGoyXA&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPe_yLk2eiW80fnYu9ZSnj2Fb5KkPax4LQGoyXA!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          },
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWr1zAHSYW6R7EouA-QgNzpMZppzoGGCQO3B0rRZAbssitkolQvuhVEgpAdnahQ1A8xdBKg6blJOpl6-FlDL149n2KojVaaTtQQFZ9V5TDCNG3h4IxDt4Qe2tOWCODUysPkL4cuJZ2Xu7u4hZZzgSPFV5gCQZA9KfiEV",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Thomas",
                "uri": "https://maps.google.com/maps/contrib/101963919700806461725",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX6GkGKPM0abhupH0m4Md3i8yLrwRYnC3HWLGaOTTOxYxveKxWlKA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPg7KAZmRexWs6DqirPCAlMnMdzUgU-cD9YAltT&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPg7KAZmRexWs6DqirPCAlMnMdzUgU-cD9YAltT!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          },
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWryeH2KqgQqiCK--gJq-kdyvorVc5KtWVMzIuk1DvHBME1MJfgkvh52mw_BvPIv_QjFQpGzt4_VXWXqlRXyQdA4kugyYwzuSHlUmmq2xe_ZauDZyTrP_TBaVcluMGYaBFKwesUph3FyXqh9N3XP2TQwjcEWTYzH1iSn",
            "widthPx": 3372,
            "heightPx": 3372,
            "authorAttributions": [
              {
                "displayName": "Alexander Chen",
                "uri": "https://maps.google.com/maps/contrib/111745796980616513786",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIqXVUlYYIJbLL1V2dD9TY2DrCjIsiWenCZYZOCTufub2Q8Dw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNsrAv60ySOW6P7ceh3jbUoULrLMrh1seu-HeRu&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNsrAv60ySOW6P7ceh3jbUoULrLMrh1seu-HeRu!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          },
          {
            "name": "places/ChIJmaZOQKQsDogR3rQRpnycNg8/photos/AdDdOWp5av01BtrlqQ20arvDvwqZ1Vb215fVEao5eLQ1QQUQsmZbD8qVtXiVIuhV7hotRIFU_TfWoNn6OqYYvaWcyokS7vaRKnKZ3QkjM88JoKpxOm5UVvkEBP5vGri9UWX79l_HuhgHXEla-avXxjzQ-rgqFusIn_o_S2I",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "David Yang",
                "uri": "https://maps.google.com/maps/contrib/108758130672736402198",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX0pU74KVQcN-Y8jv6S2vfR923xfI7MpPnb-7-DUzMh5UWKM_8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMJFi1PWRljJtzBqXd4rg4A0dRvRIxZbsAxb2o&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMJFi1PWRljJtzBqXd4rg4A0dRvRIxZbsAxb2o!2e10!4m2!3m1!1s0x880e2ca4404ea699:0xf369c7ca611b4de"
          }
        ],
        "goodForChildren": false,
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "100"
          }
        }
      },
      {
        "id": "ChIJeYbaOKQsDogRfJrgIMgDNvE",
        "types": [
          "restaurant",
          "bar",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "12 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.881662,
          "longitude": -87.6249684
        },
        "rating": 4.5,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_EXPENSIVE",
        "userRatingCount": 4753,
        "displayName": {
          "text": "Cindy's Rooftop",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWpJOOb2ghpWPRdMMsXVLwMKKsE7kQ7XcnpCUwIT5RdgsBNdCxR-t5YvWOA_L4YeK_3gM9SJkd7AH1a4g0jlmP7hHXMX9Jn-HNobgHdQiv0TzlY2PpZs3EhcJ5Anhg5ZAB3HvHJhTskhDTn_HRecAZh4IshApGoxLG1M",
            "widthPx": 3600,
            "heightPx": 2403,
            "authorAttributions": [
              {
                "displayName": "Cindy's Rooftop",
                "uri": "https://maps.google.com/maps/contrib/104533726182427983838",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV40sYSRFSLi7td-j3OL8iZ9JsBf8buS6sznWl-iID4cPDaZbE=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOHuBKIbS4tBiDssp1YAiZxPQdJpq7aoBv179e9&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOHuBKIbS4tBiDssp1YAiZxPQdJpq7aoBv179e9!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          },
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWrhIWmHzXK0sA8SU_od82EWwmSZLA9GffdaSyOIQcqfkAKR7kl48LJh51KZozAZPDnlotMGriiMiVgst17oMW1mX8IOsMdGCmQFBJB1oiTdcpK0Pm9gFk5Ruwx9__RsYJbpzfydmmhjVKDJ0XLJZnf_wr0ZiW9S52TT",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "Kyle Lowman",
                "uri": "https://maps.google.com/maps/contrib/118173668664573637767",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXuQTWL_GT1NnLqpFK8ZPEiB2THbE7UecjIiYMKvIeEGyYpT-qw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNgcVgS6jnqtOVEKYJ2OvGb7CPZF5g2uCR6oQc0&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNgcVgS6jnqtOVEKYJ2OvGb7CPZF5g2uCR6oQc0!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          },
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWp0nMbQr7c3gQXdhNrhNx-IjVTt1Zh2yKAjTrpnbLissrXVBYsX8Q6xsquyz6JUM0z5EQ3_O9nY7kEjFW3G5_sg2ju6XQdAae2iA2wi_ut6hmpO2yAzvHnGL2v9J9uyImVS43Ji-QqIxw_CTrk6_30nf6aX76XuK2zu",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Zeynep K.",
                "uri": "https://maps.google.com/maps/contrib/111526335975778274900",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWHasfH8e-LncK4n6bol9SOl8onZ3pKwhY3Y4gdZHx6LcgZ1hxB=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMJbkrSqeuG5Te4x7I5uOV5KaEJZkKKDjgtwZPP&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMJbkrSqeuG5Te4x7I5uOV5KaEJZkKKDjgtwZPP!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          },
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWpCcFyWxudZ898QIOesxyH2LA0sfRdoWi20gWG9RjV0yPhm2v96bJ5ZwIxFpo0WlvIL-4t0Feutdocy-gGbDE47pd8DRvhQZ8LhhKqIM7R6SAMsr0jjeBE6AkI4ESdXSI67dIsqxc_Zsm03sjxdQU-QMNA_Me9s_Wwy",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "江映月",
                "uri": "https://maps.google.com/maps/contrib/102022102497553872096",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUYV5kg4HugPPLtZIBlvGW03qmPcnZRLvIp9_SpNa_H-1_ppLI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPaB5_3ZE8vxG5u1o2zGsZonoKnEfPjqRcicEgJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPaB5_3ZE8vxG5u1o2zGsZonoKnEfPjqRcicEgJ!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          },
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWpmjGZBbK9NVA0vghH5cVLLljJ-TG6EGoiUJBKh_QaGaX1enlwrVzliQcnCxYvpgBPy7HUSijofka7z_IsDuXsvyBY5BQCLI9M2ilklbxSUq3f5b5vs8vcMUbHiM3Fp4r5PTqnMZNczfLcUpfuy4GlWn6U3vQA2fvr9",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Lily A",
                "uri": "https://maps.google.com/maps/contrib/105094690984220514023",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUY-7LjPTNJCgiP6EdfdlNKGXgeuQvZzAW1nCfmcOMwoO7946ub=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNIkZsAT1KSYmNN4EfWgPr46whXP2EWak0WsqBM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNIkZsAT1KSYmNN4EfWgPr46whXP2EWak0WsqBM!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          },
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWruHdTV4HeneA-v5ndwWgSldw6-GpWZjq19Dtu1ypgF0Y3MJVtbCxZOXyLlzptMOd1I9GeiiNq_gj3_jmhmWCG4DbifoEr8I8if7shjuxD9DHYylaoo1wVsM8mmf26VG7SmEFBZHJw68u26Ai678itOTyeyzSyn01Bs",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Cheng-Chen Tsai (蔡承臻)",
                "uri": "https://maps.google.com/maps/contrib/110241317621643163597",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXzzAt8uR3YTzOaBpUNgc0d9qzy9PsdTgrPLiI27ePzD6MtmNzUKw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPbvfrMqTdQWY66um6hrH1msHqm-i4txq_hLRrF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPbvfrMqTdQWY66um6hrH1msHqm-i4txq_hLRrF!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          },
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWqwzD0fEbky7cFLe9FTE-SRE7uyl_gvGjVSUQzkzs5aPPBpcTdLa6pqxhA7PrMeaefCMgeGLOYfq92lda46HBSdFH9ulhHp_aaPSWUhg3iNccUK2w4-cghaS-xjB-g-mVtP_c-kmoZjWyoBXwOqZcY-JX4a0Hr1qp9c",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Arya Alizadeh",
                "uri": "https://maps.google.com/maps/contrib/118075444892434080628",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUKA6KLLllvn_mFjgtpDk2cPzd7JiAAXMAoORLAVAViNEaTuqmoHg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN5oIsQourk9WavHCx5N0C9klui-HVjmC1WX-xW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN5oIsQourk9WavHCx5N0C9klui-HVjmC1WX-xW!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          },
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWqi61URo7LzJkLcaFj0QsTJnG63Y0jGxjafUwtY258OccGaZ7G7n25m-BqXlhtlMH4TMrvJ4WXxGUigz1Rd_71N0zvtDgHF2uvd7djXJys5UjeB1Y9r7OLfaOFWIpbB9FivUQ6D6yY0DphxDpqdbIU2NKDeXMpOP6wF",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "christian madge",
                "uri": "https://maps.google.com/maps/contrib/113745723891676765287",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXFGXiHMjg_KO0ejjycJfR4ZMCcR5QFRH8choCRMQSIDVxRL80V=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPsL_xm4hoXfFUFAUea-M1AQmCfYXclvwmWvJvy&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPsL_xm4hoXfFUFAUea-M1AQmCfYXclvwmWvJvy!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          },
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWq3jhNhLDzMfgnC8n2AzRWm_3tVtVt-1aoXdgByYjxn4AGiKU7qMZQXs2nBglCJwZxafNUWG6tTDfkd0XnsRquxgEtv45dii6CnyZ-PbUTOD80sz_WzQ2bHXJhkFkY8Aykj144V_K2-j5LvWM-_5sdeYdH61aXuLZ3l",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Andrey Guzhevnikov",
                "uri": "https://maps.google.com/maps/contrib/118172750113953356989",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWvzP-4v2QhnxgGcpRuIZ1N2fOrMxKDeu6mheh7PpZMObfqmv0u=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN87s07z7qWNUp43QtUxaKqNd3x8176Pkheml_o&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN87s07z7qWNUp43QtUxaKqNd3x8176Pkheml_o!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          },
          {
            "name": "places/ChIJeYbaOKQsDogRfJrgIMgDNvE/photos/AdDdOWq6CjPpdGcwUeLoFSrMW_-IQ4b6nWnio9rq_vqnDO5Adj3hOJbVq0ovPbvTQBefw89B5zwnyact4xEa4ng7PVBkL1VklDseXqXiIuWpCf9qudyk2bGDNj9q7k07iiEAJOwQtqpZ4GIp5oD25KY18JvGBxgBkn32HarD",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "NUR ÖZTÜRK",
                "uri": "https://maps.google.com/maps/contrib/100533244831680111224",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVN57iEXN-H-NHgf_gY6yb-Gy91PN-5Lj-0uGaFsKc6dO1lZNE_=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNLbMwtHrGMx9bGen2yOTaDvsOlUEKpkk-rw9O_&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNLbMwtHrGMx9bGen2yOTaDvsOlUEKpkk-rw9O_!2e10!4m2!3m1!1s0x880e2ca438da8679:0xf13603c820e09a7c"
          }
        ],
        "goodForChildren": false,
        "restroom": true,
        "parkingOptions": {
          "freeParkingLot": false,
          "paidStreetParking": true,
          "paidGarageParking": true
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": false,
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        }
      },
      {
        "id": "ChIJ53IdSwAtDogRhMv9Usv7vYk",
        "types": [
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "12 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.8816433,
          "longitude": -87.625001
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "McCormick",
          "languageCode": "pt"
        }
      },
      {
        "id": "ChIJ__9vaqQsDogRFk-Kguc9-4o",
        "types": [
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "18 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.8814882,
          "longitude": -87.625001
        },
        "rating": 4.8,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 33,
        "displayName": {
          "text": "Gage Hospitality Group",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWprub8g0SwSB8_5v7Ix0kgY_TytavuOkObZfr6aG-08f8wEOEuc4ygCPbyQLGrqFdAuVVOUtEsp37J1wiV0p8X1JFNo-vr6w-ThTSRt1D80ZMXv5aB588ytzbs_jQcFTH6DZps55aaTSfypc8Fk8m5J_ASajJBbekeO",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Victor C",
                "uri": "https://maps.google.com/maps/contrib/111694588608807842086",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVAFZ1_q29ZB9A5V3F_z8a_1Lc1uW4pbrOMPHAYepG2_RrNV9i56w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOKMkF-6BqebINfksmZzGFwYJY8IXjcD_vreNJZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOKMkF-6BqebINfksmZzGFwYJY8IXjcD_vreNJZ!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          },
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWqwtd3n6BH5V692EKHnNCWV9htGoWe-GggcoxkaIfd4JkvlcDn_RBD2s90vvuXVW-Y5-yPYXiWu39psqSg1BUl64LCZEkfeK1N6WhJVCaqDSMpx6t54vnXMc6b0SPTTRSKptHBxNGvGrFVL8qdhyDi32K7yHsZZo5g6",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Samara Grossman",
                "uri": "https://maps.google.com/maps/contrib/103623902018494933450",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUu-6nGJwF8Ko5y2PVMPuUPP6Qaf7a0iTudFUGYKeO6slTiAm7U9A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPvyBVia2pTEfmrzNYlFgBlb5U7FSi-dB5Tv2V6&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPvyBVia2pTEfmrzNYlFgBlb5U7FSi-dB5Tv2V6!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          },
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWocho87QTP0I5Vt3efy6BVK82V-iZJqWYy-av6pYQ6pyipPaHO0gvtNqvZKGv9QkSnIotr6elqxT_ZqfbD2u4REEasKIBp3SuJrzWSLxT-JlGDNf2YYRuBVkO1sZizjAsuckyZMW86zO4QqEi4B2SzRs9tyURT6jKGW",
            "widthPx": 4640,
            "heightPx": 3480,
            "authorAttributions": [
              {
                "displayName": "Anthony Moore",
                "uri": "https://maps.google.com/maps/contrib/108051321420116681481",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW1aUmhdVZOPMK9B5CxbltAmsAPYZI-3Dhi2vWZhJ3ybfw_ouWs=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNoY9n7k3Lfj-pjUwYQG1rOJ9N5AL_AHiSv9TYl&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNoY9n7k3Lfj-pjUwYQG1rOJ9N5AL_AHiSv9TYl!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          },
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWoV6Ok300V_w2y2jPorX3CXwBy2eOpnSOQXAKyWK87k9ciqK7spkqH8D0Pk2P-hqMhUQHDVrjgfE4ej_fK5Fkg0vmQQQipwsvAglkodB4os7WUTJnAWI4hp33ACQZWlKUgxR1X367RA5t8tHZw769vaWSTOcbfiI3c8",
            "widthPx": 3060,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Gayle Ryan",
                "uri": "https://maps.google.com/maps/contrib/113772727734815538945",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWGK1z3ALR2OVn3fsMup3eB51Ur2YPDsEHLXnWV9rBoxxjMuMOI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNTCpyPkxpRwR3qoizam5no1D79XR4c6hYUFr6T&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNTCpyPkxpRwR3qoizam5no1D79XR4c6hYUFr6T!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          },
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWo1yTRCiXD3Pp94I1A-ixJiYgt9lpl6QExOfwSwVRJ-eB8wqJAkJ1YbAqN5eajFGSlC6zCaOCf94lzeurx3dC0daE1ZJteQqWjRK8pD0sh0tOstsbZCtQmmAb43RpRszdXh8RJ28bwlWQ6LmpVXjJqbwO_KSpANmaR5",
            "widthPx": 3060,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Gayle Ryan",
                "uri": "https://maps.google.com/maps/contrib/113772727734815538945",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWGK1z3ALR2OVn3fsMup3eB51Ur2YPDsEHLXnWV9rBoxxjMuMOI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNesOZXH71jWMrbrfSYlIyWRdEGF7a19XtGqUQR&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNesOZXH71jWMrbrfSYlIyWRdEGF7a19XtGqUQR!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          },
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWrLs-KotatGCRHyE3IxuPtQ4872osGViR-BuCkHCy6Zv7AChlVuIxeyAWV-lv-0gxJcjRcXWql9ly3LA0pF8XZwi2gGqxnF6q5Jdu_gIZ2iWm0iCkuZN0MrWnkv0ahKGkbOmTgyl1304yn1wqydCdn7Hsd9UaoJhspo",
            "widthPx": 3060,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Gayle Ryan",
                "uri": "https://maps.google.com/maps/contrib/113772727734815538945",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWGK1z3ALR2OVn3fsMup3eB51Ur2YPDsEHLXnWV9rBoxxjMuMOI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPSOh-3IxECen_uT4pjK1wKzKxlAdY_0S4TjEEg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPSOh-3IxECen_uT4pjK1wKzKxlAdY_0S4TjEEg!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          },
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWrU1eosBTbVy7ktGJQm1AxQD8i7DBIV1sT4vbE8drvim0oSexvE6W6SjAoZzV983QbfHCOPrA7KwOR8ZUoBmUrwGFCYyTqZM4LG3AWWoKNbaXMNNlHBoMiszU6nebYbzmTyMlHbGZcIJcE_4VhqdqdDxeOQOoY2qrKK",
            "widthPx": 3060,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Gayle Ryan",
                "uri": "https://maps.google.com/maps/contrib/113772727734815538945",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWGK1z3ALR2OVn3fsMup3eB51Ur2YPDsEHLXnWV9rBoxxjMuMOI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPmpyv__2RasEzYmN5OkRFvrcEeF8S_v_C9s9bE&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPmpyv__2RasEzYmN5OkRFvrcEeF8S_v_C9s9bE!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          },
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWribHayKUOZlVywMck9Dcq3WP9w5HpslU_H3tx07JwIdpTF0BRQUuUKw0ibBaZxkmTGueERALp82nob3TLuCc7NGyIocSNp6o3CQGj6nkHNTO6CkKSbEFYmwTeWXZqCALhKhTnENsoJkIOJvn-94VVviJvDE2Ge2FAR",
            "widthPx": 3060,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Gayle Ryan",
                "uri": "https://maps.google.com/maps/contrib/113772727734815538945",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWGK1z3ALR2OVn3fsMup3eB51Ur2YPDsEHLXnWV9rBoxxjMuMOI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMVKl1uH-Y_ct2XqBPt_1ZVpTwXf7xGFtf-pU-X&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMVKl1uH-Y_ct2XqBPt_1ZVpTwXf7xGFtf-pU-X!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          },
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWoTEgBU8t5ALvrAQn1fgxiKXh3OD-850V2PGeA-KIGLoGUY7cU93fJ6yXPAkPTk9g4Je2zB3WEcQlu1w_-dH0iaUGcDb3CXlL1U_rFHC_-ylMe0TvPwTFpf1oo-xWlK_PI4pgNW4HGd1hSJLkreuEh8l9KRpoSnOMmp",
            "widthPx": 360,
            "heightPx": 800,
            "authorAttributions": [
              {
                "displayName": "Miriam Hyson",
                "uri": "https://maps.google.com/maps/contrib/100527556930952102581",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocL2Yz6NSwb641mSLY0lark-MTkc9vkes-luNT46qE6ALWfzDQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPuj99tlsX814zuQdz9P508g71eyQwlOy4XEG5a&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPuj99tlsX814zuQdz9P508g71eyQwlOy4XEG5a!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          },
          {
            "name": "places/ChIJ__9vaqQsDogRFk-Kguc9-4o/photos/AdDdOWoGyjG4juBitsLXn0pP6CgTwMrVdCriGF4Cm3CeX9OAj6iGP5XcRWsx18U-BsloDtkos1oPFVf4yAKhXKlXz0snvUq5HWpjkPDOJmXL3lo7qKG6RqbeQ0xUM1CNRXmSh1cGbApFfBW5TR8WRg4OqkPI4GlLkhB-bAOH",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Matthew Ludwig",
                "uri": "https://maps.google.com/maps/contrib/114798837645153112411",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUZchEB3fDTw3_e1VG0RHzUJ2nTQuildFourEzL78rfCMU-gsD7Bw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMzkFI8a4ZaGtWoTh0AqVg78I9ccqQUk4ljBusC&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMzkFI8a4ZaGtWoTh0AqVg78I9ccqQUk4ljBusC!2e10!4m2!3m1!1s0x880e2ca46a6fffff:0x8afb3de7828a4f16"
          }
        ],
        "goodForChildren": false,
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "50"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "100"
          }
        }
      },
      {
        "id": "ChIJfecaS6QsDogRYoT-1zdAdJE",
        "types": [
          "american_restaurant",
          "brunch_restaurant",
          "bar_and_grill",
          "fine_dining_restaurant",
          "steak_house",
          "bar",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "20 N Michigan Ave, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.8826897,
          "longitude": -87.6246716
        },
        "rating": 4.5,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 2225,
        "displayName": {
          "text": "Remington's",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWqa2u29Pyj0PnakE4BOz_LLuK_N5UJjxR9B1rqSwpqdFJm_DAV-7jXbnj7vpGfy3Fk_sgyYTCMAI9i92vV0-dtdimmuYd0I592ERzz6RhTU-g9YeUG2_4cQFshhcZrE7YAtETsk8xHLx3uUCSyKzU7ot0yqioYdfReH",
            "widthPx": 1800,
            "heightPx": 1200,
            "authorAttributions": [
              {
                "displayName": "Remington's",
                "uri": "https://maps.google.com/maps/contrib/116745891576201228817",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU5624sNfBbsiqSMnw0QZJWyy6nNcVRmnC6DENuun-OiT087T1A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNCyZiciBSPTbznz-TMWCEq4W0mG6RFZMY8QE_D&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNCyZiciBSPTbznz-TMWCEq4W0mG6RFZMY8QE_D!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          },
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWpwIe5TsYCRxiQFNYC_2rJISgZnrXjeecjCbKejnmKUm-2NgvkclU6jrEqQtRkLjram0QspZMEKLv2gVVXHxZ-mWExS5Gz68ws8GrJz1zLhafXJvEGPRwXWAl-JKtgib515Qok8Iq__TdPtZwLLQxHuvhxXTJVPLGTu",
            "widthPx": 1078,
            "heightPx": 608,
            "authorAttributions": [
              {
                "displayName": "Remington's",
                "uri": "https://maps.google.com/maps/contrib/116745891576201228817",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU5624sNfBbsiqSMnw0QZJWyy6nNcVRmnC6DENuun-OiT087T1A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN5HimLwnYSAw2svvpvdBEvy2P91AMXD25Dnhl1&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN5HimLwnYSAw2svvpvdBEvy2P91AMXD25Dnhl1!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          },
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWrjYgSrndHjcA9HDBksj6C2gzWNgtqDdTWeShU7zjHbRBcRQx0C8KvrQywZruvgLrdDG42LNX0P7n6q5r_4LDwm1C4zmlRwF9VIO69DCv21BaLuOhT2S7ODTn_6sEJGTEYO4A1RcHLoJl0lLsde3rzWxE-qupX_vjYK",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Arturs A.",
                "uri": "https://maps.google.com/maps/contrib/108160784986561238229",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK42rb87n0cjqUpR4mpTt2iO0RX9_-hN0A1vBrqY7W_cVi7dA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOd3TtUJSrrAMtQ-6b62X6SbrHtB0XZN68BjAeo&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOd3TtUJSrrAMtQ-6b62X6SbrHtB0XZN68BjAeo!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          },
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWpPx3u1lc8gmTz4Fz1qi8dT0OH_s6oGTMxmzMS9nEXsXh1yXqUrlLTxbUaJ-xLReWMvkSh19gZvt3PYha-OLPb7X1madbehnIu0zcgRvrxAmKD-_fFytwvYuKhAe5CyRaLtLY_NvUSb65LqAoxcVrlKk6_WLonCnHJA",
            "widthPx": 2992,
            "heightPx": 2992,
            "authorAttributions": [
              {
                "displayName": "Thaddaios Enzeru",
                "uri": "https://maps.google.com/maps/contrib/101373549461157682377",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUlEOrzJz2vNZPdzEwCRe90D6mVpKV8I8D4yrSSy-7t00xRq64=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM9UIUkNPkLN-luYRjnM2i2TxgpYuQEWdeo0kif&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM9UIUkNPkLN-luYRjnM2i2TxgpYuQEWdeo0kif!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          },
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWqAxtsYbXedTsUhOOs6n_MJ3sbpdbVVpGzI1t5VzTMa1cn2NCbKsecGoeup_ZB5AEql749g_tBoKd_zLm9D8TReqwkrYwsXFBZC1lOY5E_T4yz3TjAv4zyzcI8K5lLNMV8RBeMizgwW09d0sV0vFJSCck1rysrsLOlG",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Deniz Kilicci",
                "uri": "https://maps.google.com/maps/contrib/118167344926384470342",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWr6aPtur-6b7VMWrZuPgPNbdAgCtiNVUqvG4RCuAyurYPP3LyfPA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNNUouUdlvTsrZUz15GcaHRTmWROd4yPinT8Qjo&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNNUouUdlvTsrZUz15GcaHRTmWROd4yPinT8Qjo!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          },
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWqNVqyKi4dUyYZWbj_8GCCEDiEtSJ7zFANUg3MyYex8cpYV3pLtsr44WF9GXIvWmQuy48l9GGqESPSZ5roWenOyGqFsH1fa0t8Z0-CR88YLPSCeVX_qkKiU8CUMM31iBLAuFG0v8J6HpGkzQnU10D6xgf8JXqpuFqrn",
            "widthPx": 3310,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Ellie Kang",
                "uri": "https://maps.google.com/maps/contrib/116844202728734595577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX7Bc6Sao7y45J74MIKvA7CGGkYkgIFZe0B0qIkRhH0NulzixE3=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMqCbU6KQexJfFbM16TyVbKzg89p4tnkokWLTrC&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMqCbU6KQexJfFbM16TyVbKzg89p4tnkokWLTrC!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          },
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWromdTFWWPSxEz1cX7S53WqczZiGy_6X33hJ2CMd1SOsYCSa5O56vfrGg6eLqTSYB5Ipg4RTwtZH6qa0k3u9nnExqJKUIMS1OpBDQ8-QlxRtKPkezP1IAdqeSaPXlBqZcO2VOGXvFiJ8Z1hKVXlvar-6liJnt2eX5B9",
            "widthPx": 2992,
            "heightPx": 2992,
            "authorAttributions": [
              {
                "displayName": "Thaddaios Enzeru",
                "uri": "https://maps.google.com/maps/contrib/101373549461157682377",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUlEOrzJz2vNZPdzEwCRe90D6mVpKV8I8D4yrSSy-7t00xRq64=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN6MvnyOINCzqoPbnAjZMfVPjmo0yFBicZBz-fy&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN6MvnyOINCzqoPbnAjZMfVPjmo0yFBicZBz-fy!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          },
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWq-SdMKBYf7yHmLUQybDuGE-4mgVSat6g29EMSI2ubS9eLFM9aWTK014IFxzX-u5PnQw2J7bRdDbZrJNgFqqegFBBtBqR0IV8tlymmQYXmpa6e81UucMYyNNJr9vm-XmKlxUD5mqjdiEFq0Rk5sIO-zV-YUGinU5Ckf",
            "widthPx": 2672,
            "heightPx": 2538,
            "authorAttributions": [
              {
                "displayName": "Lee Millerchip",
                "uri": "https://maps.google.com/maps/contrib/110277717107431430012",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVBoMRVntP3fcdVeFqK_40Axf4vILcFBhwKGeMxuJh_qsgpqn88ww=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNaPHuvjzsZ_xl4DiyXuu5z31AOTwo-dGKK_xqg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNaPHuvjzsZ_xl4DiyXuu5z31AOTwo-dGKK_xqg!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          },
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWqEIF1kXdcywaEKfVqkDqg84DLub2a3bwDfyM7oas0jbfrwoC5llUCAeuxTOOQCzmjQRhwXAQwtIkaLdDPI4x2fpEOFN6lqa34naDmg93AEyj0iqOwKgWRdEf4JpMcG8cXcdvPz7I4-xqkC2nqdUd89ldojlUdK_sGC",
            "widthPx": 4284,
            "heightPx": 3180,
            "authorAttributions": [
              {
                "displayName": "Tony Przybylek",
                "uri": "https://maps.google.com/maps/contrib/113894398780891834016",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXVhgEzqQoWFaMTwHm4thl10HBwbHMSXZ5ol0wXh-_AplsBQyo=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPuiQCHaTmWvTkuYmW6YvqlAQTj32NiIKVJmtMl&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPuiQCHaTmWvTkuYmW6YvqlAQTj32NiIKVJmtMl!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          },
          {
            "name": "places/ChIJfecaS6QsDogRYoT-1zdAdJE/photos/AdDdOWpuds2evya3abxR204H0clldjjIZgG864DYaDBdFvgPDbDx3BzcuAaGykp1TPbu9b6qBifsWPP4AoV8i8GSNN8txiIp2CwR3I2J48-G_Mui6fVJ4uKIlQGlaa38wPl0UF1-xavyNMID3nGlfCf6qtTE1PvAdsCS1c-P",
            "widthPx": 2400,
            "heightPx": 1600,
            "authorAttributions": [
              {
                "displayName": "Josh Kelly",
                "uri": "https://maps.google.com/maps/contrib/101310869777909258241",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU0zIcSehfUojqJx8cLPQofxl2f-g0221iZREfEt8wcwY7Ss7uVVg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOos368WBOgCNGVRuY5B8OzDYHLo3wBUSuXxlTW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOos368WBOgCNGVRuY5B8OzDYHLo3wBUSuXxlTW!2e10!4m2!3m1!1s0x880e2ca44b1ae77d:0x91744037d7fe8462"
          }
        ],
        "goodForChildren": false,
        "restroom": true,
        "parkingOptions": {
          "paidStreetParking": true,
          "paidGarageParking": true
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        }
      },
      {
        "id": "ChIJQbFh7WotDogRdTjeau5P1HI",
        "types": [
          "brunch_restaurant",
          "american_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "108 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.8805446,
          "longitude": -87.6246422
        },
        "rating": 3.3,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 185,
        "displayName": {
          "text": "Sugary Chicago",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWpgkBP0YfV-DiROM6amyFOSn14MtJkdiHjoKnXzS2Kg5z9DdTAs_FbZdKi_7ZafMVruUMAW1-JEna7XP_JixTJHy-p6UDkNVk2_vw3QLDkoNUMNxb4CXjha1nxbLGRLbDfQ1D4qa0eAgG79MDwrceM7lHfpYpD6SbuB",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Wolfram Misselwitz",
                "uri": "https://maps.google.com/maps/contrib/100887525199276995443",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXqtftxSPjm0JpbdaS6M04lgJ6n5F_MN0dgYPImAzYvxWu6tfw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPz14lNlhvcnCTpVhesclLkqnIlkkRdON9_tIRz&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPz14lNlhvcnCTpVhesclLkqnIlkkRdON9_tIRz!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          },
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWrz8C5We2LcwwE5v_jCtNEedTEw_acURGVmnOqtg9hwy75dfPZ3J0FdBoOfCSdjd6oDrH2C1p6tw2gx7brP8KycsTFoDt8mKKvee1g9JDIGOuqgP7BlfyfKizR8ZOemMfeLaLlGsCjJ_VNK8EDmCWwwB0eL0O1N2Or5",
            "widthPx": 1108,
            "heightPx": 1317,
            "authorAttributions": [
              {
                "displayName": "Sugary Chicago",
                "uri": "https://maps.google.com/maps/contrib/104738608032165251723",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK04Qum8hakt-V4JyPMGfO9zoGE639J6CocjRpPS_hC-b9LwQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO2z8K91RYS9cjR1dPCYrbl0IuTvih8OxzGa4t3&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO2z8K91RYS9cjR1dPCYrbl0IuTvih8OxzGa4t3!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          },
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWpE_9LUBe_wpS1DZFh4QZtT0J0bMQMAxI4xq3exwbh_osrE1uvLRe55XwHuayagz3_U981uKdM0Fym05lrb2RCSVPZgHx_2iDaSjjoVCOBsyMEpBS8_OsJRA6Kom8dAm3Aqj2sCn2HQo6X9iCtQiuGnpzP5dxoJBbEU",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Coral",
                "uri": "https://maps.google.com/maps/contrib/112863839211602779883",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW5znQI4KtCfRhmgNqx8VNr-GcabvYbKFl937mzDeKSRaqFTBHK=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM2t3iTtU7-0TjPUatFLAm0ezIOmgVfaULX8z9V&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM2t3iTtU7-0TjPUatFLAm0ezIOmgVfaULX8z9V!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          },
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWrgN8YM7TiYS0OD5co5koBi07vExu5sB33VAoNOqGnrfI5iAMS9cVdUAvjXeL19bh0TkkRkSFRCxo9IoYomMiBMR5dgcikCBcP8C7z69pejZ4wGuebRbJNx88Iy3jqla2VIs-KTokf5nzbqCyRHLHli-wnDrHZlM7RT",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Sugary Chicago",
                "uri": "https://maps.google.com/maps/contrib/104738608032165251723",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK04Qum8hakt-V4JyPMGfO9zoGE639J6CocjRpPS_hC-b9LwQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMIN1z4_ieWO_uQV2H-bpSmKudDfT_e4YZe-a8I&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMIN1z4_ieWO_uQV2H-bpSmKudDfT_e4YZe-a8I!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          },
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWoVjTcJdgD-Z7pq04Bct1FCs-a99LbzmKmXpdWv17t3nwZ9OhaDoskxE29hd2HjsbIGor_Ir4JXa-JfIEKgESyDgqBrbsdqq3qxqAom7LBhg4BL1lSVfoqpL3_rdD4KKo40GojgrNCXnRiiacP27hqMWvVLaZvUEl2T",
            "widthPx": 1512,
            "heightPx": 2688,
            "authorAttributions": [
              {
                "displayName": "Stephanie Maione",
                "uri": "https://maps.google.com/maps/contrib/115725086415646957524",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUxgcQCZUVx1XKHBxjHV1n0L4D0YsirZ7_rUQLIWsp3ZP9_75DK-A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPLZoqphjeWRQYrTNxeXqf_gW43QQFRxPj6KIJK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPLZoqphjeWRQYrTNxeXqf_gW43QQFRxPj6KIJK!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          },
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWo9ojSJEAN4Q1kbSwZZx-TtIDHi96_8C5T3amXSeHqS35P5GBW4bwebTdnjCL227O5Yo9yBYVE5S9dIhUKTsCz9zD4h9iAvJynbfl3N0fNBSzMvR_P1mvkD_UJl0qeYaXfN3UUAdRwazO_nltApXBuRbwxCqOp8PtM2",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Sherry Shen",
                "uri": "https://maps.google.com/maps/contrib/101115518074420051786",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW6mznNm5HNuqq9EzXVLoznJUmXmmGxvSwTKX2KnDQ9WRkqlGs=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM3h8DRm2j6XGZDnwYm9ZtZZ8Z0obr87LZI0hgD&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM3h8DRm2j6XGZDnwYm9ZtZZ8Z0obr87LZI0hgD!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          },
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWpeys2ycWsw73TWwfqnF7dqK8YNWHeCJWSJm54HBNYRuaWjli_UdfxgOEBWOLuuzvh3GI7p4tXYFihUSZKcRLVhg9tEiV6DxhD36uMNw8d75vgRkVYjiO2kiPr5Y8jh3RslkfsvyGbzO8IF7BEXh1aymnXuUotqy1mV",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Sugary Chicago",
                "uri": "https://maps.google.com/maps/contrib/104738608032165251723",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK04Qum8hakt-V4JyPMGfO9zoGE639J6CocjRpPS_hC-b9LwQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMTWUGOj-AaDp2S2VugUuSwujbYEb6UBcrp_SKN&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMTWUGOj-AaDp2S2VugUuSwujbYEb6UBcrp_SKN!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          },
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWqB07PrR4IqZeb5T-SW7acqoskDcvIwSjooHPLQH-FeYMA-h5ZDYQi7zdE7YmkUhhDudzrceWXHA7EHffAK2o-z6RKQayh_qhecibRlc0-ZG_IET4sVWPSWlxnaBk2Wp8mVyS7iMA43l0mPMsLkVu8s9YML6qEQGIvG",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "ARI K PRODUCTION (Arian Khoroushi)",
                "uri": "https://maps.google.com/maps/contrib/102109750279703477059",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWoCWTd0T6UiE0tnV4tw5v9eOYHPCT60JRTF-_Pj616g4q3YQLc=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPqXdgNmQ-7y_UH5rOx9e_zC0a_ZceEhX9yvzS7&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPqXdgNmQ-7y_UH5rOx9e_zC0a_ZceEhX9yvzS7!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          },
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWpYajotK_NeUMuLCuFZ38aveQyGwFLnuCFG5wKz_oooe2oty7U_2foY78nK6Kr117BZ_cSz_1W7iO3wDZ1YUvdn-TgmjgHMwEsJo23fI3sXu0P7x5DvAq9vHOID-ePFPrS3qn-ThN-ne8zjpp_BzwaBRQCXIB_28X-c",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Nuha R",
                "uri": "https://maps.google.com/maps/contrib/101278640199244895064",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXbx6EQWEw0BYGM2fSdWe-6WTHFVDBSsg9JAwXBzhtmSYX8Rno8gA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOjc2z_zWrT0bdhuvlAwUVmyT88ND9zIu1tqu2Q&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOjc2z_zWrT0bdhuvlAwUVmyT88ND9zIu1tqu2Q!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          },
          {
            "name": "places/ChIJQbFh7WotDogRdTjeau5P1HI/photos/AdDdOWrXFw3rUa7wix-kD0xmg2pafEYiyB_1je5khWZBq2348TXhtdX9EZGt1yIGMykdqbSua315xmCF4Se6jOwa4SvOOGzRxO9vYG-3WPveyeU07-FPW0tjtVmG4hh5xQuhg2pnAmMGtoSNuD1jNyvjAJCO1lFF3yNlxqOf",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "ARI K PRODUCTION (Arian Khoroushi)",
                "uri": "https://maps.google.com/maps/contrib/102109750279703477059",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWoCWTd0T6UiE0tnV4tw5v9eOYHPCT60JRTF-_Pj616g4q3YQLc=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM9SlLzYgywM0cendreVWNG1NiS6jXtNuYXsI81&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM9SlLzYgywM0cendreVWNG1NiS6jXtNuYXsI81!2e10!4m2!3m1!1s0x880e2d6aed61b141:0x72d44fee6ade3875"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleSeating": true
        }
      },
      {
        "id": "ChIJRVBIZd8tDogRe30TCsnVE6k",
        "types": [
          "mexican_restaurant",
          "bar_and_grill",
          "meal_delivery",
          "tourist_attraction",
          "food_delivery",
          "bar",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "69 E Madison St, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.8819564,
          "longitude": -87.6254324
        },
        "rating": 3.7,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_INEXPENSIVE",
        "userRatingCount": 185,
        "displayName": {
          "text": "Cantina on Madison, Casual Mexican Restaurant & Bar, Voted #1 Tacos",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWpy3oxhPvfBahNXA_8Funzlh6-1BDjgV4t_qv5wR-4gjbEfxEGdlAT8NVXElv5ToW_koj83kqI3nKdC9NGs6qAu1CIpJyp7cOzUDffYtkUwZbW7z41fsHzTgFzob13oE8bNnhyHQ9o9l6EcJm943mJg33kQq-Zr-dwN",
            "widthPx": 589,
            "heightPx": 1278,
            "authorAttributions": [
              {
                "displayName": "Cantina on Madison, Casual Mexican Restaurant & Bar, Voted #1 Tacos",
                "uri": "https://maps.google.com/maps/contrib/114228943067415884747",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWbIc3XvMignfd6d8HMFM__3Z3jQUuKwdub_NtFGAPy_1dyr_k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNNLhdk5CDE4F8OA69sDpq2NiEGpPG3tOilaxRN&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNNLhdk5CDE4F8OA69sDpq2NiEGpPG3tOilaxRN!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          },
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWq96U5nl9Hx0eoUSmB1Mzjm6FuRtZjsQTprVyIWzfludIMLAdpBIpmnNVAg0DhANsH7q0Siol-Wygh8I3aLSsu1QzQerSyGsYGoasiyeWEgiXlRfoQ55qbyJJzPgQrWyHCE9ToXj_2_enqt35j_bmkYalH4J83Q8lv2",
            "widthPx": 1103,
            "heightPx": 621,
            "authorAttributions": [
              {
                "displayName": "Cantina on Madison, Casual Mexican Restaurant & Bar, Voted #1 Tacos",
                "uri": "https://maps.google.com/maps/contrib/114228943067415884747",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWbIc3XvMignfd6d8HMFM__3Z3jQUuKwdub_NtFGAPy_1dyr_k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMMqY4qbvHLPFjZYbI0cgkL-MjNXrKa8yXPhrxm&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMMqY4qbvHLPFjZYbI0cgkL-MjNXrKa8yXPhrxm!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          },
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWqj4VKnONZsDJjqGIyiu7CynKpLVdne-brsxeMEY4RezlUgIErN47dTeLsKzaru0Be-XQcjD2kGjhXjQ-w_gHyzwHo2C0xcieZH832w4xQuqPF72xSGKeDmzAPGjzvY5xoBwd5yTTRz2nJWBgXjYvtQQdRLzBo5V5R9",
            "widthPx": 2048,
            "heightPx": 1536,
            "authorAttributions": [
              {
                "displayName": "Martha Garcia",
                "uri": "https://maps.google.com/maps/contrib/103466248368368091032",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXDEefdPC4PPkdYIVFV5LWBfXxhyOT5dnw6qSKcdaLtcj6rR19D=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOWoX9k0m2B7wEWkCrW6SONZT69sxP5eIlyqChG&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOWoX9k0m2B7wEWkCrW6SONZT69sxP5eIlyqChG!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          },
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWplwX8y61c0RQ8rYnFzCATsG8r7ZsJfcSLN_62PwnE76-FrXXUPbOwq5X3Vvpc1JH4nn9Ukv3gp6MjjE7PjQOeD45OFNItDHQ5Kmmc5Kd-MVccZTRyh3dxtvz_PqN0HVhO97h8tXP4m3CtbmCn6nnNP8fOK9ImkD5Jq",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Cantina on Madison, Casual Mexican Restaurant & Bar, Voted #1 Tacos",
                "uri": "https://maps.google.com/maps/contrib/114228943067415884747",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWbIc3XvMignfd6d8HMFM__3Z3jQUuKwdub_NtFGAPy_1dyr_k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOktxsBGIBWRZf42L1NT5bazKfbJjzSpO7ATZxC&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOktxsBGIBWRZf42L1NT5bazKfbJjzSpO7ATZxC!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          },
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWoOCo51riCxzzAZah0MyB-kDsk-ynUcPUH651mM9sQ_pj9ulXY21DeM4Ydh7bB0TEdDYdGoa-483_fqgLLu_vwo2nA14fOOsH71nVbSWrW-oZ1in4zwwkI5arrvqhNiyxT_Cgz1NMfyrJEErxRMkuU1nIgcM2jJf4Hy",
            "widthPx": 1103,
            "heightPx": 1175,
            "authorAttributions": [
              {
                "displayName": "Cantina on Madison, Casual Mexican Restaurant & Bar, Voted #1 Tacos",
                "uri": "https://maps.google.com/maps/contrib/114228943067415884747",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWbIc3XvMignfd6d8HMFM__3Z3jQUuKwdub_NtFGAPy_1dyr_k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMV1wbxmSgzOOEiP_N80pJ-5JBBzb5T7lKu4Cid&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMV1wbxmSgzOOEiP_N80pJ-5JBBzb5T7lKu4Cid!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          },
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWqYaToJadPkqh4mSr1hTITUQse3DH-7VIfh84aWUDxeqPiWDqLXB2u1n-U2oWUC-4sq1KzFxTKRIvSWp0l7GtfUO_2dH5k0J4J3qeNW1uSX6qfE5TAJFVIQEgxtUrSKoa-cw1x83slx2rRMRHJTps6q4faeuNitMNwY",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Terri Turner",
                "uri": "https://maps.google.com/maps/contrib/103119473263157284379",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXbqIEE0xPZekkIz-a7u8DAsT8-9NEqy-NGcCj--LIDq1qGEG-m1A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOUZtoJERR16MGk9WW4uAZSJnJ8WYAGP0iiwwKP&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOUZtoJERR16MGk9WW4uAZSJnJ8WYAGP0iiwwKP!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          },
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWq97aXqq1ESQZ_CpTVJrCQ8sp-zxhutwXNjkHO6rU3LbXCW2YsEwxDU9nCjYWzoqxrvjDgTYOKtdqzkzOK8V6m2r9WFIa91wiuLRBPRsWNMxBJncdEJ0IhyNbdpGAxZMR_qzH3DZqtYJnjW7ZfTWI3uOy7FXp9rqQWG",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Giedre Jonyte",
                "uri": "https://maps.google.com/maps/contrib/117758097980985179208",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIaGVHKQoyq6Y3pY_Zocn9S4JVckMqCZ6X2S5SPFSvqG_Xs5w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPoZwOnR1j8u2m15uDmc2mLWUes5FqO1L4U4V-2&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPoZwOnR1j8u2m15uDmc2mLWUes5FqO1L4U4V-2!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          },
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWq3Xa64nsU5mvHMcd9PoSZ4VsBliFIomSWt5ukJIIT6M9v2JopFLrFQvfDDVBh5PWtH5WdHYbjZNd0HDKUQA0EhCTljLZMFpax2G4qfEbafX3GZyBeSXBA9refOonC36YxmmuNG_yh_NwB_-xleFXf8efb4N6FnB72Y",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Evan Guthrie",
                "uri": "https://maps.google.com/maps/contrib/108715078108737755494",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUwjfUaTbhM2FvN7HgW9qADZ2ryoFkEW6MdUibF0Uqk93_jMr3u=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMVf2s1LycYrYdQfpCumAGjRl34u-yXZWJQC2lt&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMVf2s1LycYrYdQfpCumAGjRl34u-yXZWJQC2lt!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          },
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWrJxNXn2iRX__UGdEK2IWoP1BTpfQXUQjKOpuHcvR7qYVZ9-Ic2xeBCRA_dWS-0q777lKGVaQLXyQnnXq5hxPnh1aDKw2MObEzd1MRFNROjd0m9wdNDo7v7V3KhlDg4e1pDHPSRaMD2ujibt1iZpEFd22M6Wut_Nf8y",
            "widthPx": 1284,
            "heightPx": 1579,
            "authorAttributions": [
              {
                "displayName": "Cantina on Madison, Casual Mexican Restaurant & Bar, Voted #1 Tacos",
                "uri": "https://maps.google.com/maps/contrib/114228943067415884747",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWbIc3XvMignfd6d8HMFM__3Z3jQUuKwdub_NtFGAPy_1dyr_k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNObmDcKanF9UqCpZuJU3bKmYi7YFwmUfhvow-9&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNObmDcKanF9UqCpZuJU3bKmYi7YFwmUfhvow-9!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          },
          {
            "name": "places/ChIJRVBIZd8tDogRe30TCsnVE6k/photos/AdDdOWo49SXXexI6T_ba3ET_Mn4rOgN11647DVdEgiFYNcZFnpdOwW__I4Zaf4QQABm5mV8sWr7zsVeXkxA_t54JSuPFKE9ScJwGvvuYy3zPSKFDgQqA6LygexwzB9ew4J69Vc0MC-aeYH7mCGqNFmZDz9Gzvk54zT_DENKo",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Giedre Jonyte",
                "uri": "https://maps.google.com/maps/contrib/117758097980985179208",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIaGVHKQoyq6Y3pY_Zocn9S4JVckMqCZ6X2S5SPFSvqG_Xs5w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMY0mAnOAJWTM7Z0Y0-OwogC9soZSLED9yN3Vyv&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMY0mAnOAJWTM7Z0Y0-OwogC9soZSLED9yN3Vyv!2e10!4m2!3m1!1s0x880e2ddf65485045:0xa913d5c90a137d7b"
          }
        ],
        "goodForChildren": true,
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "20"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "30"
          }
        }
      },
      {
        "id": "ChIJo4gMJKktDogRHaUJ2_O1bHw",
        "types": [
          "cafeteria",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "30 N Michigan Ave, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.8830903,
          "longitude": -87.624734699999991
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "Farmer's Fridge",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWp7NaVLcDYIeuO1unCgyjy1r22OJpQHh1N5YW3JCwxM4naLiWABMjcc8iYFzqIAzr74aFS8z41LkTUSUbIE7-UMsV5JJaZsXXxQCPd1NtB0KLTsoSOC1G-dLNAxXNiO7GoMaC_q4wdqht8KJSjYvdio_RZFRjsHtp7B",
            "widthPx": 1080,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPJZwvZ2kX-bpR0B5YelciA8MRQLl0TkFrVZVOm&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPJZwvZ2kX-bpR0B5YelciA8MRQLl0TkFrVZVOm!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          },
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWrLEcDsKsnyH8Ze5vMo09W_zuAsls_b-H62pwWDn5WTSgoOFtHv_d5sDLAfzEKSoRyAkk6KsBVOCltfKD06n5q5cImldPSN9JB_YjtYocpmbLPghSaGjGOcQkwJsvqm3gVs6GnwnwTSjoZKwQgeupnPpTv7kz6SgUeR",
            "widthPx": 480,
            "heightPx": 270,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOPVCt0i_ZOLrWx1mcJIWSZmSUAMcpQhQGXaAP4&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOPVCt0i_ZOLrWx1mcJIWSZmSUAMcpQhQGXaAP4!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          },
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWrCCV5uHo0tGQx7-ybVRcqgTH_d0TP-LuR9dTqFbTCBfTs0jGwnORO7aHPdIpJGC3xet1wZz8hH_deBtyouLF_he01PhrBdumysejKUhtvmci4PhfPfRWpnQF0eluv-3l_UlPu_yvj_ckY9gcx8ygnbuG1riZyPNzJq",
            "widthPx": 1080,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNRKOhDc1LnJrSMV3OgKsTpTMs-2CmldeUR_AOM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNRKOhDc1LnJrSMV3OgKsTpTMs-2CmldeUR_AOM!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          },
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWoxitMigYyRrBGyWxfmTx_6ctjUpRUYOlJsKZkZSRqXtwdSvO4FPAeC0n0Hv48orPt0nQ12qbw8d2ErEywENhJLduv0xnt94jXGLwXX4JXNITtaaHt_za0n3Ey1IKmlHFYuP_HPfCArpQDZSzat8TKMqnT_v2oGx_H5",
            "widthPx": 1080,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN0DUvAfSs3FCV77DJkKq11bjcIpvu8I6Z1_Ixq&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN0DUvAfSs3FCV77DJkKq11bjcIpvu8I6Z1_Ixq!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          },
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWrh1RFye-zjr91zQE7-WylM1NDTV6EQVztQmAYWT2gsJnHCWMI5QnhyFfQukXCUxs1TYAprOtCoxyGKQ6GjM-mFURX8xAkIfyqWCess9GrDJ0DWZ1dBLU-1nojc8TnXjpv37DJZ_9a7hayT_AWV-fuz2ThCdL-uqPz-",
            "widthPx": 1080,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP6BNPPNJ-m9g2kwsCDUnvtqObibGWIFCwVB-lf&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP6BNPPNJ-m9g2kwsCDUnvtqObibGWIFCwVB-lf!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          },
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWoEITCywCkqi40drKeeNAnr78sGGhezTKarXEhdjjbIxUEmSwWkM82Kz_7Z31EymINcvkwEU6nlquRDsEEM6t09repooqFBQsCLrd8alvsObf8oO0R6Hv09nszcrw3v8P_BKzszGkWl4XuIvxxsDUcfmW1l7M6epaLs",
            "widthPx": 1080,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN3VpwlH1Peuj2XrVnjOJ4mRN860m8Yh2kAoowJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN3VpwlH1Peuj2XrVnjOJ4mRN860m8Yh2kAoowJ!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          },
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWpgM6_x6Mw20lAqigEdIQkkgyzKNu-LclT06BXYWK5Ojwv04hDJ4TmERva9O62saEoXrqUiy8i_bgJm_0rrt6ETtWBNPr64iG1vuq4deRAgkOdYjhFsICX9DcWoQ1qSAL35AfeoqQ7ofomRrkVhCcXHoc0SzXmaCzOX",
            "widthPx": 1500,
            "heightPx": 1500,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNR_gCuknSJ6RJFsM7fa5j-k0b-1sHhv8rQ_4kD&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNR_gCuknSJ6RJFsM7fa5j-k0b-1sHhv8rQ_4kD!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          },
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWome9nCiynER6hj5e5h3Hr9j0LViopP-41FUm9eT-wowds_4K_r6_24_nm_5QHjxgv_ve5-8nGlK6I87ypPhdjw2sVC0KR29dWzfS1BkbqAcOa1Jcdbo1mzO4kkd6_ocbjTEngd6mIag-fL8aIlcUgUSyyHtqs9_33h",
            "widthPx": 1080,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNL_flTZcGVk2syEqEVr4BCK2MdNCUpJMVhrjb5&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNL_flTZcGVk2syEqEVr4BCK2MdNCUpJMVhrjb5!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          },
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWrCOh8ndEmg4-0SeqyHcF4BQBmTQ2n5erpxu3hHv2GoWU8ucNXh_PzQgCIvt-TKqCty9vFHlFoBsMJ9_v5IliCOizf0s__wlQSYFNGs8qZPKGBLaOf-kRvPHAgzRzlnUbn2Y7GNlEs2eApKxKRAlRfCTR8M9Ummok2m",
            "widthPx": 1080,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipORWmPS1x4kmgTNPIttVnHm8elfCw72CDbqLPEk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipORWmPS1x4kmgTNPIttVnHm8elfCw72CDbqLPEk!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          },
          {
            "name": "places/ChIJo4gMJKktDogRHaUJ2_O1bHw/photos/AdDdOWrZ1dOCv8nlvFtSR7gFWkklhkf3enfaYOIQXRUJclfw_bzXIr3hO2siKl_dLMR6CG4cXqdUBiBNcoYxl0C1nfdlBBzQqy4DFTeSYTkOwBKmlf3ZNWk8LQTtDBKxUmhfjifp3PrH__bkomWoMjc2kFgECIw_CaF6ZuHM",
            "widthPx": 1200,
            "heightPx": 1200,
            "authorAttributions": [
              {
                "displayName": "Farmer's Fridge",
                "uri": "https://maps.google.com/maps/contrib/109348189479425812577",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-j6hIiQwh7uFvCO05p1HaKBME8Q13pEJzs_CerBRw-qrIjX8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO-UURVzQd4pnm7LTaJFEXpBDaAGO21wxRHHjUS&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO-UURVzQd4pnm7LTaJFEXpBDaAGO21wxRHHjUS!2e10!4m2!3m1!1s0x880e2da9240c88a3:0x7c6cb5f3db09a51d"
          }
        ],
        "goodForChildren": true,
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        }
      },
      {
        "id": "ChIJ0WOwWqQsDogR15rEDd2YmmM",
        "types": [
          "japanese_restaurant",
          "sushi_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "62 E Madison St, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.882317199999996,
          "longitude": -87.6254739
        },
        "rating": 4.4,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 894,
        "displayName": {
          "text": "Ryo Sushi",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWoyXMXzAaWQiH0ttbFFRDZmu5cCB4Cq0A1-tTgbcX_uicJj4iQ5T0AOqZaSrqtqYyloC_h2vdsTT6kj5mjNqEknkj5bdHqqSdNdDbdyNPJ4NXxHwvDua0uwTnGWjVFaavxUXKpGCtDQZN9lO2fgY9tX0DFsIemvNgBJ",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "Arnold Cap",
                "uri": "https://maps.google.com/maps/contrib/106704350709357548086",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWhp1ysjHnKbpIO-Z4iVEHSlS15we6MKbwARzrwBEeJ04P0PuFnIA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM5K20l3aG9OlPiYDTcrmLbrj5teyi1Hu_sIR4l&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM5K20l3aG9OlPiYDTcrmLbrj5teyi1Hu_sIR4l!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          },
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWp3O7unvEl0fqp6aYcFjk-2D6p6EX4L8gzN7FZBfDBljbqHej9bb1--AM6urFpKnPwCY2Wv87J-9R04fCenF_F3KiBr8agu8Vx32Sl_w6PxZImYJIuy5HABEgJ5ZI2iEH8zRc4zuLUgQJwvfXv04ORZHzDE0t3OenGm",
            "widthPx": 1223,
            "heightPx": 874,
            "authorAttributions": [
              {
                "displayName": "Ryo Sushi",
                "uri": "https://maps.google.com/maps/contrib/116447156970969516489",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVs1No5t9JFzgUg0YEkPW4Fh0ah12Zni8lm6NK5tzIHKKrh2iw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO9NphTvAL4ZcFVhDn0_hdvIcfc0HdeNlJM78-W&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO9NphTvAL4ZcFVhDn0_hdvIcfc0HdeNlJM78-W!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          },
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWq_r04SEs0WFjtzp0PwWMnsew2l-TFWPvCgas40I3kkv1iYcINzyRwno4N9js7Fc7nTmiD4tac5hJmyxoOWISxe4TSD3UYr8iCyKzi-yu8K1CN5NDm1ffaogEJgtRPD8UdFXB3oDytaZzC4u6Wse9b--Ibi3revl3HX",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Daniele Michelotti",
                "uri": "https://maps.google.com/maps/contrib/100250950011067085794",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJl6Z7cU2BzN5kN6MafT2HKmFcKmKUyAi_VBA4PNIk6cn9mNQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMnJI6GO-cA5Xyj9kVRX67rn4hne_6BO1yRXFJo&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMnJI6GO-cA5Xyj9kVRX67rn4hne_6BO1yRXFJo!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          },
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWqxVMHHQT7h75dxXpRe_LjJLE7mVrrWJUmXdCUL_gncGv35dLTpsmP1kJr7OgV9dAn6sh6Fni1jsB7cYjDTWDAqdRZmkwIDqZlgx2SDosGPZehCpyTPipwbM0vTJ7NFgyfWy67ykQOkbjuS9JqhsG1APhSVsi6PRUrc",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "karina k",
                "uri": "https://maps.google.com/maps/contrib/117684880291477667435",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUoNhZIhd-au7J0HtEfzLTcPCWt6DwJq4jVzaraLDgQ7GYY8PPh=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNajQomGzVbHvGZL6LHrwk_lR9Enk-zuyPJocuA&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNajQomGzVbHvGZL6LHrwk_lR9Enk-zuyPJocuA!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          },
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWraPNLTj1ZpPqu_eMlQs6ufLy6LtvxAUU1x_ef6H27sXuY1HXX7K_581fIxwVhwUuiuP4mhCEftaanLg8gwUr7_TvZBTiOZZ3PdEbOTiEyu1ewROC6qyVX4eqOJoksT0RIT6aylq7wFVU0hjN92rpDjtE-UaUhpZXv6",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "zhao zhen",
                "uri": "https://maps.google.com/maps/contrib/104406573344934542197",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKvuWfmWLJkPoI4X12ZdOL9UTpX8lugqXI2Ml--XdKedviMXg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPuU9-qeHaZc7VpZfvHlHEx6pcFy2JCzRy6ik0b&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPuU9-qeHaZc7VpZfvHlHEx6pcFy2JCzRy6ik0b!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          },
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWpxkuFfvv9s5p8P0WMoT1KfDs8sOTRP3QvLqjLqXo-edtY8dBW3T3pY0T_Nvjs2djrgIwZKkbSJBe7wKi53N9b178Jct_1Hz-tVOeqYKJ8x5aXiTac3ykeo-lnEcQ4cWPKX1tNu8nZrRktrr9AKRZKv4fyX88NdZJrm",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "James Amin",
                "uri": "https://maps.google.com/maps/contrib/112172453537512059033",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUsEjp2gJpEIHzsZTX9BXVWy81rs2_LBczW3W7Ne2Y2ev5ACGT25w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOjYAbLMPTcCyGOB1vr-42bR2B2EwG7su7mTMOf&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOjYAbLMPTcCyGOB1vr-42bR2B2EwG7su7mTMOf!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          },
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWo8sVKOOAdDz5g-gZZbd_IqqcmQqgi28KxAlzttwMEnH1um9HlRiWdsWNcx1eK_XF08UIG58_SZM7Evm9ogv6zYkznv0xoepq9Vek3izbzUfFVWOxw4xaiGwFr2BEcmIV5b5MF8Bd0CJ7is2_qtjvRZgqZBm3KF4FGs",
            "widthPx": 550,
            "heightPx": 413,
            "authorAttributions": [
              {
                "displayName": "Adrien Crust",
                "uri": "https://maps.google.com/maps/contrib/105595871016762779005",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIbb-dJR5QBWB8-TbSsE1exiKMZNjNSeVsdBuPjFkRi7d279Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMCl8Ok9ed_Zoaf3RqcXx6wbDX8Wnzss8pWhOJ9&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMCl8Ok9ed_Zoaf3RqcXx6wbDX8Wnzss8pWhOJ9!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          },
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWqMI7ByrBHeModyPM7BP010zN3djS6PIiKQBOlQEG6r21yr1S7v3C-aj8spGKrEzThjGhq2xCA11hLJ9FxdlYMsI_6M8cQIqbjabU3TVPDPgTBAs5ZkMBQG0PAAkVX4prGnn_-h0xyEXgSK8qYIXUn-SpPrZU1atpwS",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "V Lopez",
                "uri": "https://maps.google.com/maps/contrib/109783776453386650464",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocL0WE3X-HcggB5Rf4D0KMb5Xk_VeemUOY1wt7f8tgU8W1fLPA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMm1Aq042ZXUx6OhDmq0aL9Xn2tD85rXCoD75qW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMm1Aq042ZXUx6OhDmq0aL9Xn2tD85rXCoD75qW!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          },
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWofD8Y_iG1jUuRKkJs_-3DXo_Iy_tgmv-fWbwaIPpRRAS_PS-ITc_KQm0wvY0TnZy4flJ3ZtGyJC2hvoyU3c8pIA3j4ixl5AR4lr29lol30B1TmgBp6CcQcU_wFMrm3KQfq89HyrLJ0x3tOgyEASXAf8muvQvVyt7G9",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "jenn yoo",
                "uri": "https://maps.google.com/maps/contrib/115030839775259364112",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWOu5D7PbV4evo3c8Ym0VcNV_ZwJaPVXvEjgWUrnYPjMAAlHMmwNw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPQqf3C5mzgIY2QZ3LJOre8l-uu76TnTzzouFGU&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPQqf3C5mzgIY2QZ3LJOre8l-uu76TnTzzouFGU!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          },
          {
            "name": "places/ChIJ0WOwWqQsDogR15rEDd2YmmM/photos/AdDdOWpD2lP8rBEHPoazTCJcDX_fvVGLUJ7Pmg96tA0K0prqnn7Q3yCR0CpX0ao1RgdeQkGFXqTS2cDtjjt9FOqVgzfCo9hqAvm6FKD6Zfr5q0wdavhVsVDlD8GdBYJXG3U_jkmbAyqeBwr-Vp3UmxoV8Ee0NZN5XO3pfQw7",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Yulia N",
                "uri": "https://maps.google.com/maps/contrib/115999655801270917105",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWxx2L50p-ZVCHirVEA701HV_1XxzuPsFFk4UNh0Bm5MYNtBNeZ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN0Ld_zWbsoiZf_mlcySTgXAzrDmVFDGfl1UKOl&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN0Ld_zWbsoiZf_mlcySTgXAzrDmVFDGfl1UKOl!2e10!4m2!3m1!1s0x880e2ca45ab063d1:0x639a98dd0dc49ad7"
          }
        ],
        "goodForChildren": false,
        "restroom": true,
        "parkingOptions": {
          "paidStreetParking": true,
          "valetParking": false
        },
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "20"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "30"
          }
        }
      },
      {
        "id": "ChIJDQZMMqUsDogRu9WvEkLpNDY",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "108 N State St, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.8834734,
          "longitude": -87.6282109
        },
        "rating": 4.3,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 5793,
        "displayName": {
          "text": "Block 37",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWoIkZ9uOtu_UE_wO3_OHhR02ZG5kP4_8TwuJw57VcVTMdbvmiNT5KMdzsPeu7h6qRaBtC-G5x50gZl07Za0lL4lGydvkDqpVaZdn0qca12Rq00wqX9sYkilNrDutW7Y_4fCqZ5QxJDWfvJfYppsCRxW_mH2kM8mDD4K",
            "widthPx": 800,
            "heightPx": 450,
            "authorAttributions": [
              {
                "displayName": "Porter Harrington",
                "uri": "https://maps.google.com/maps/contrib/105251669679762813834",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVwUI4EfRXOi0X6OQhDu8NgJ2TI-VYDZVxtJ5CKws09UeMBH80=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOnLmEkJpro_RFIi_bNyMcu6_Acd8I4BgMxuwim&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOnLmEkJpro_RFIi_bNyMcu6_Acd8I4BgMxuwim!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          },
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWoQinYhXLOgLglA-05jxhQy2DqRaSNMKwHObNfRhJAW3T5iNgqqViY-YhjH_E6wgGSHyUapEJ4tLGG4Sy4JpOZCnCpSzAoxgnQYujYZzLNVAVMeF6mD_h1ezRlnii9uUQUIm0RSvpx9UJiGFiMEyha0G_eYRu4kcYOK",
            "widthPx": 1060,
            "heightPx": 596,
            "authorAttributions": [
              {
                "displayName": "Block 37",
                "uri": "https://maps.google.com/maps/contrib/113658993552502326000",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUoS4YBjUSZEod1vDPUYA3LMeLHCfy6Vdm0kKakb_8XtTwRroA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOle2gKXop4ob9mU_DEAB_f073rohbPur7GoRrJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOle2gKXop4ob9mU_DEAB_f073rohbPur7GoRrJ!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          },
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWpDXujGogD9M704q6RHF90UrG_jgPPuy_HwGvsvy10oQL_j4b6TPofmXBX26XsUVKUvB3AxaH56mfeBGGXptkg1LMzrlroFjcnuPaBJ4yyyh7OELDgSkrP-N2wGNnVawoQE9MDxApYvIXNwIBwcdxHijjR1Vuzc28Xy",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Steve Farr",
                "uri": "https://maps.google.com/maps/contrib/106105921054138284608",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVcCdaY3R4exLlufLCnxWoMGRBpakmKM02IFuAjEiMO-qjSfBG0VQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPxey4VUAGGaK_l7IJZNXftxasmdbJeoDxcU94U&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPxey4VUAGGaK_l7IJZNXftxasmdbJeoDxcU94U!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          },
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWqQuQEJCKaWWOGXJFfqN-boXIk-kcWhhXWL91M-aMrhotKI2f5iluwFJxoFa7_V2O9CaXRJ7eABcRRbO-uaXmlYDPUFh0latj9sRiOKUt_FdnjFCbg-4RoktEbeZpEF_6QODVALchRpxPF6YWmcl79qlbUhAG0fx-k7",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Darian J",
                "uri": "https://maps.google.com/maps/contrib/115225124462394094477",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXvK3cSu7k3qWj_xj5AvE2zlJuHiYvMtEZHVyT0S8zi1QZr-YL8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMBbd6ILzoU-w1DLcuK7e31Mmock-CBi-QnZcEm&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMBbd6ILzoU-w1DLcuK7e31Mmock-CBi-QnZcEm!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          },
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWp8r7o7bLpfSn-CvCFTDpyVr3y6cytwHowLz17mJrSvCTuvAcofiEoEH2OpSVbot62hrsbRoip_z71b2rYAp-79jt5hNOxzD2tEdfKJw_NlJVphDKM-dgLXwmAT02UVMb4Qo9m0wWPVv-znDhZxb5vI7Q2Y0UHLZeXy",
            "widthPx": 1836,
            "heightPx": 3264,
            "authorAttributions": [
              {
                "displayName": "Nelson Grihalde",
                "uri": "https://maps.google.com/maps/contrib/107235907700452498215",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKFIQwLweUrdlAXjQhOq8poiJQr3NdanQ3CH8Amqb8IWfdXAw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNf0dDLxUqZTOdBIrS7V4z-DQo6DITCRyJATiCu&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNf0dDLxUqZTOdBIrS7V4z-DQo6DITCRyJATiCu!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          },
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWqQfznYrCFXA5Pv_tiwzwLHYfe9dOM5DuU40avwsyjzar08vYkBemfsVV4i3TsjoPEop3P9i5iMBdSlDmygMSc1ZwLz1CI0l6JlHymVaTm7k6cqM6GtY6WdoShByleHu5KEC2ds4KpnshdUvqJ_mpUpcalSwxOXpbtH",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Walker",
                "uri": "https://maps.google.com/maps/contrib/111803661507980390587",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWuhOtppjFp9L__eoDk_yvhrHBj4p7bmmrI6QMGGXaKZ4W8Qgr9Tw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPl8pCYuOOoWSil-GWmtyfZlKvupnMW8KlScZyw&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPl8pCYuOOoWSil-GWmtyfZlKvupnMW8KlScZyw!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          },
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWqE0OvYR_84lhWZkCacAuMJxtM1aMGEXPVpyd6BM-QKGz7zJrX0uZCX9a8Wku6mWEC-ueKH_xWJELFOhxW9pHfZfWU7gpv9z1R4N-5McwyRxCgJ6974srKGV6aASWbFAbRVSXSKvwNY_OVEdgiuVzpA2pAYFV1n6iVI",
            "widthPx": 3648,
            "heightPx": 2736,
            "authorAttributions": [
              {
                "displayName": "matias Bustamante",
                "uri": "https://maps.google.com/maps/contrib/103514137759602242864",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVsoI71bHsk3qPGiu2wautmbEykKMpuLNdBGrO2iWPFrErDOVm7=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO-4Wrl4g63T5S2SjTFDndOlMaTYpYtxBfVT625&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO-4Wrl4g63T5S2SjTFDndOlMaTYpYtxBfVT625!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          },
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWrf0d0ryc56OGSDnh0woIOvh8b5o6_jFGB5RG7ITCtmNjRoD5Meb8fFOAewmEfn40k748mPnQV0yGBMgKtPryengFfDlQ4I6aemwn_sWhqLzKUh6q7Gn9eewI7P49pGi_AqNgHp3uiDIzBdJ7VTxYpZECIjbZ_OCnoE",
            "widthPx": 4608,
            "heightPx": 3456,
            "authorAttributions": [
              {
                "displayName": "Sara Arevalos",
                "uri": "https://maps.google.com/maps/contrib/114073954407998872063",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVPXb7kxsh7a4sE3RkKnUFW_v0ypng654MUrNOSzyM4r_BQIL0eUg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP2lW8RsU-uchYukTDul5tySx7xn1ftdcMl-jcO&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP2lW8RsU-uchYukTDul5tySx7xn1ftdcMl-jcO!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          },
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWrkOJ1cp68ZHPebxc3PD3mcSGPR9dNuq8LFhZqc2VV1sMnLpfKVvml9sqDV5v7kIObEBf38jB_n3ZdgOE6UICuMtWlvAa2w-lp8gZCa8Wp6f2-xUSOB51GPOCJiE04gWw54wLqEAF6z_99ir3fyNcUb5MZhw1VTlLSQ",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Bernadette Markley",
                "uri": "https://maps.google.com/maps/contrib/115408364456609710988",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKnt2YyxvAW3bb-RyxLlq4pLL3yQZSaNLsgRtB2BDyoFreSK6vS=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMmwGHVzTOr0VZz4x93gCcHdG4DGJVTMzauhVkr&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMmwGHVzTOr0VZz4x93gCcHdG4DGJVTMzauhVkr!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          },
          {
            "name": "places/ChIJDQZMMqUsDogRu9WvEkLpNDY/photos/AdDdOWpSLOQZvDVeDk6llgxfCNtogh97c6eohHZrZdwxWelMkVmS5aDVzOeWR1pxuElP7OdQ9F_iPA_eaBkvvTA9o-9io_OIF6qT5tsh1mup6DAJZq3hDOFbJaaZ5dkRchJ1Zvo4pubxbiTgTZWgesUHel3MPsz0x4wBCEZl",
            "widthPx": 2992,
            "heightPx": 2992,
            "authorAttributions": [
              {
                "displayName": "Isabella Polidoro",
                "uri": "https://maps.google.com/maps/contrib/102757020370851021804",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWepFjCLtgbR4via1Wh7q3hZHoki1J9lZSy33HiwbAUA5rnK4FRbg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN92vqfDy2mlN0MBjU_QyFm41anht7m8KhLj-Nj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN92vqfDy2mlN0MBjU_QyFm41anht7m8KhLj-Nj!2e10!4m2!3m1!1s0x880e2ca5324c060d:0x3634e94212afd5bb"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJwaK47KstDogRe-Up0gY2tEc",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "332 S Michigan Ave, Chicago, IL 60604, USA",
        "location": {
          "latitude": 41.8772942,
          "longitude": -87.624614
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "Freedom Digital Marketing",
          "languageCode": "en"
        }
      },
      {
        "id": "ChIJq6rqKq8sDogRBnCux2OqSMQ",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "111 E Wacker Dr, Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.8876241,
          "longitude": -87.623651299999992
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "Galleria and Tower",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJq6rqKq8sDogRBnCux2OqSMQ/photos/AdDdOWpWV_qEee7_qosTnTb1CjsL8_oFieTBM9vVECIQAW4NOZ94Lu4XKNcSq9IihXNx6uyqo3lxt91JLIPHs9Z79x0rb5cygWHioGo1PNMR5UvBf2muepcNz_PMStZL4S28q7cdcwm6iBEBIPUbyFhqHSxAg_onL2UdfrNz",
            "widthPx": 3036,
            "heightPx": 4048,
            "authorAttributions": [
              {
                "displayName": "Gaurav Borgaonkar",
                "uri": "https://maps.google.com/maps/contrib/107496685530152879452",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVlIlqQGRD8mKP__GZP5ESe1z5ze-m4Eogt4u8WgtghvMR2EX1m=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNB0xY_sBL_hdg3O2wIO2yLi4h41FR9cQPDjHcV&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNB0xY_sBL_hdg3O2wIO2yLi4h41FR9cQPDjHcV!2e10!4m2!3m1!1s0x880e2caf2aeaaaab:0xc448aa63c7ae7006"
          },
          {
            "name": "places/ChIJq6rqKq8sDogRBnCux2OqSMQ/photos/AdDdOWrQ1X-DYRqZxOlhOaEKsayMU0QzlP0l5tXBWsgq6_Y6qAlFzeGyt-MmiOt75XcpVIn8AijYnOa_PgyuKUgurvwQ2DEQxpN_z3DRovhZKaweFIOvRxBJgC6Wu9Tcuf8i1vBCJ__azD37j2tNHIkooq2WKdVjSVCKDZvD",
            "widthPx": 4048,
            "heightPx": 3036,
            "authorAttributions": [
              {
                "displayName": "Gaurav Borgaonkar",
                "uri": "https://maps.google.com/maps/contrib/107496685530152879452",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVlIlqQGRD8mKP__GZP5ESe1z5ze-m4Eogt4u8WgtghvMR2EX1m=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN64cfUu3n4muUZtcr2218JFWeMqUXDayQ0apu1&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN64cfUu3n4muUZtcr2218JFWeMqUXDayQ0apu1!2e10!4m2!3m1!1s0x880e2caf2aeaaaab:0xc448aa63c7ae7006"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJn5StfLAsDogRj9KiuwHRSdk",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "201 N Clark St, Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.8858866,
          "longitude": -87.630740899999992
        },
        "rating": 4,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 3,
        "displayName": {
          "text": "North Loop Terrace",
          "languageCode": "en"
        },
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJH3aD0rssDogRmLGy5BjCeaY",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "30 N La Salle St, Chicago, IL 60602, USA",
        "location": {
          "latitude": 41.882894199999996,
          "longitude": -87.632693199999991
        },
        "rating": 4.2,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 74,
        "displayName": {
          "text": "North LaSalle",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWq620c0XcXrLDhCLG5M8Ft9Shi2Fu1yzGYFGeh8XcYSqYaUl9AtbD9He9FalWO1RKEDext6RllGJILPkRcmxbMS_nT8JJrhQLFwu26cD-gSw2cFDz3qrCZsHiRddNiY1aWBTZKtSQuhYpFEdtEQrglAPWNRqnssge8j",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Ron Balmediano",
                "uri": "https://maps.google.com/maps/contrib/102593705576635230009",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWCwc6d6UenrjAmXcy9EICmqJvWJdQ50sNgutC6r0ewi0sjrWtL=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOu0CFHZnOuBvYSW77dZ22u-XRHengbRYu9lx5l&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOu0CFHZnOuBvYSW77dZ22u-XRHengbRYu9lx5l!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          },
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWqATQ1OiOMDWXjE9eXODy9fppdG_Kf05nxzmSM65hOe3cCmkMhftOil2Jb_JNlQ3EtbskJY-5_DeqmVXRW1q0JZHySy44IdHdg9X6SWE_SyjXyJfKIZDzeZLHLzMsNNV3jra1korDYdKpX3TwsM7qF7o8ef4ENvdM6S",
            "widthPx": 4800,
            "heightPx": 2700,
            "authorAttributions": [
              {
                "displayName": "Loretta Northcutt",
                "uri": "https://maps.google.com/maps/contrib/115240253222711789610",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUNHwhVgPCalFyg2rKcLP0hWE_DUDD4_KHfT8XpqR4JwrmKduXL0A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOSi4NxxorBX2oychxNOEbwb5VE1L_7OfiKceUj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOSi4NxxorBX2oychxNOEbwb5VE1L_7OfiKceUj!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          },
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWpXmoAdRuhKCcG4hV1c52St_MQ_VNt3WnLoPsbr3UT1E18bTC3aoiSH9YQzIiaUKKBg94NFMGq5Ac4EtvC_Its9F9ft8O2s-n3GaEYvs4bovDR4Tt6xarRZwkOdLFEOaSBW_isDV6cADLEpacp3jLXiWNK0G73E8laW",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Mrityunjay Singh",
                "uri": "https://maps.google.com/maps/contrib/101435911933748370873",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXxZr1lGHWm5JaHcfIGhVVrDX3uZsGI_P3KUNk83dfop_31kvQc=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN7HGw0lu4LGryn4yENx4eHd4zEYdFAuZRr8UuA&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN7HGw0lu4LGryn4yENx4eHd4zEYdFAuZRr8UuA!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          },
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWrjcOPqYsnkYToqSIpFi4iq_qr9k58-SfEi7XKssKB3rtLZpjPZvdLSc0oB_8dvepxX8pA9K4nmoGwKVCYNvdOeDr9gMALmnvH6_ame0Vzc3BlBGw04It2O_xz6-BNzvstHzGQVuNGjVdKKcdKFKn4SFJEJdr-QEnEH",
            "widthPx": 2252,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Pamela Zell",
                "uri": "https://maps.google.com/maps/contrib/111931460370327457665",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVVJGPtWTrrMh5Mnv5B_jMAa3O7a-VHaV73fAoWahlBHnXvnG_zsQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMBy9spmyDwF8iY1XCccpbByAlc03WOcLSlNzv8&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMBy9spmyDwF8iY1XCccpbByAlc03WOcLSlNzv8!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          },
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWrRkBWDvrpJwVejgYzuGN0wCeEwo_Pkj_jNFh8ITWYmejsffBoOvZcOFYwyfYxlHa8je0bhG2k4qObDpuSs5yRfveascTGdgnG6H_JLKmcrN7Bpchzg5TOnedHm9IAcyhs1X_THGZ7L5SKoCagMlcXUxzZKT22PDhFv",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Marios Soteriou",
                "uri": "https://maps.google.com/maps/contrib/106063595917619889157",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJDHPBe7NN1CpcCEulXzFK1fHljp7lWQKwOSjtnQaHPZd3QnXg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOruMbijvSxHztCpVgr1wmwGkp7rfiXu6J29L5r&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOruMbijvSxHztCpVgr1wmwGkp7rfiXu6J29L5r!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          },
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWqY2JYakjJ4Gg6cdobkVUGQHdz5KTJTr4_kMMAHf57nAcqtZ6dKRGgnJYal4DbPBX1b2izlLZ7m6o-Fzdm9k9QNYYLKxpRXkK_0zJgQ4uxcZL9PvLywqfPAyR3K6EUJlojNb_sNo0k66FHYI6xpRklraM3qXF9lveDF",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Mrityunjay Singh",
                "uri": "https://maps.google.com/maps/contrib/101435911933748370873",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXxZr1lGHWm5JaHcfIGhVVrDX3uZsGI_P3KUNk83dfop_31kvQc=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPeHa3KYUsYIcK8adaRR3a_5UxvoBu2Queqjyo-&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPeHa3KYUsYIcK8adaRR3a_5UxvoBu2Queqjyo-!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          },
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWogLD145hc2s_lJYdTFCZxSYYj4324kbhlKAU7OR4ySV4jocpr_czpmjPlw_sIWhJ6XRIlX_I6xXAG5zgv99B4L7ddLDauRBH5tCF2R8bdnUZGHnjl9K3v5A3uOk6Jja0DSKSPDZUYnpBzJcV1e1sFWyo3ItO14E4er",
            "widthPx": 1908,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Elisa Bolanos",
                "uri": "https://maps.google.com/maps/contrib/102931771643257439763",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocITnZywYcbzYgu8GE6eOdIRMT5nPMnJ4F2MuOslJGSWRG39Iw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPUjrarv2Y2OJW53tx7DRhdpOlhutwdHo763e5Y&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPUjrarv2Y2OJW53tx7DRhdpOlhutwdHo763e5Y!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          },
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWqSBmAVGl1KQBNdwXpagF3kXAQ7WVs0s_Fgd65dsBubNqRh8e0E3D_-bU9NSUTNfXkC5AtHFjol_y6qtbv5RR9txNVPVTQCJs4KXEXJjCRgC0Gh4lMZrNRtF6far-_TLBa7izBmRWQ4FLAHKlLObR5hij84_5P9XKal",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Marios Soteriou",
                "uri": "https://maps.google.com/maps/contrib/106063595917619889157",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJDHPBe7NN1CpcCEulXzFK1fHljp7lWQKwOSjtnQaHPZd3QnXg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOnK2dlxqH3w2_U2G6gi3hPmGLMSdNRJt6zCyhZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOnK2dlxqH3w2_U2G6gi3hPmGLMSdNRJt6zCyhZ!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          },
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWookU-yesmqZv0EqQhIjymrnJSX4XBv6NlO-2k5g5zzNclYrgHM8vFGX8kDSED8hrP7VEAGaVdJSeGde4jC8x0WIvuzIvl_SP4m17BXA6wXm2pfnBzHklBVhjQgu3DhzQKmr0RPpCuQZAfCa_7MBSOUjTRjfgx7C6L9",
            "widthPx": 2976,
            "heightPx": 3968,
            "authorAttributions": [
              {
                "displayName": "Vilmos Levente Kovacs",
                "uri": "https://maps.google.com/maps/contrib/100971629439400104974",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocI40UWzjdNPtfyHB7-iLJugo_fclgtDF86atmsOHKBSNqymqg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNpd8R1reaNH9MaXbbhIyv5_EiG4JHV-r7FAP0J&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNpd8R1reaNH9MaXbbhIyv5_EiG4JHV-r7FAP0J!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          },
          {
            "name": "places/ChIJH3aD0rssDogRmLGy5BjCeaY/photos/AdDdOWpRenT1YUb_Nw2thva_VmFSw6V84JQgFw8T4OXGi4vgCjLwyXyK86kBpcWinduIMWx106r7nLbFPdw29mEj5adyotiMFTvPPg1ylIvYk7COQgdADRQFlqpFQELmuHZeGlJbK_2L8AXQCXmYBzxpOIiKbXC0FmZd12wf",
            "widthPx": 3200,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "30 North LaSalle",
                "uri": "https://maps.google.com/maps/contrib/105012964545170459999",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKIiyvRLTZeLBfkBenxp25ZzD0hGkIp5rN9xgCWR4Dfzr6gig=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMlkh3Xn4B3cd5Yec9jLscxpzgXmNraRVD56dEk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMlkh3Xn4B3cd5Yec9jLscxpzgXmNraRVD56dEk!2e10!4m2!3m1!1s0x880e2cbbd283761f:0xa679c218e4b2b198"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJ1e8DbqwsDogRNv-31VC3KaM",
        "types": [
          "shopping_mall",
          "shoe_store",
          "department_store",
          "hair_salon",
          "hair_care",
          "clothing_store",
          "store",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "520 N Michigan Ave, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.891476499999996,
          "longitude": -87.62491829999999
        },
        "rating": 4.4,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 10387,
        "displayName": {
          "text": "The Shops at North Bridge",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWqZCU7VLT4GCiLu8vR7tMX923d6JpmwBkpEKqtY6D4gUvnqy2Z_BQdzp7sUZLjMwTOCnOgrM2GU2zgwElWWFN2CaI4Nnij52bBl5JHylMUGfiI8D5w0v_k0NdOZGH6aYltPU4JrraEdG40seESxY4U7HNx0btZmqr9b",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Ian Cox",
                "uri": "https://maps.google.com/maps/contrib/109507706918402513920",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUWdtUe8j7kJGOLK16IklwS9QiQEJWJBlCa11yRCB1vFKZnI0BN=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO87GNPLtTfn9mFyRyVxazhX7wxD0Zq9Qr1tAum&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO87GNPLtTfn9mFyRyVxazhX7wxD0Zq9Qr1tAum!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          },
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWrZSQShF2A3PBnpZfsJefMeT0CXaSRSdO0u4sQ32WI-7yJwdVBFyUJwKgBU_IhieSJF2Sx6orY3ez4ecM47nMiW3a8-t2a23yffWJJAXrhq9xPW6KNaYBtjuQSr4CnuJ8614S04alRHxtjNlU1nPcUuBlAuGs0NSvmk",
            "widthPx": 960,
            "heightPx": 540,
            "authorAttributions": [
              {
                "displayName": "The Shops at North Bridge",
                "uri": "https://maps.google.com/maps/contrib/112717411260737145569",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVP9rYOa9r-U-cq1HuRuyV45QGKnHpXoG3TQ7erRFp3HXL3bow=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN5T4vY0xmXdENNomV6rPjxFDc0N258xAVhhDCg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN5T4vY0xmXdENNomV6rPjxFDc0N258xAVhhDCg!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          },
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWpdGfc-0R5xYDFU6RC_EtLO1XK-wliKRTdfDBcJ0V7Rv8lmfNKypfgILduaMk1NJR418cf07MvuwEThDYjO31RamCSbo5JlFM_fC-C-G5nfv51m24WbXIGgKvbgr-7dEHTnwKxJmT0QQGbTGr3MwEABKzx8c9QcUSaP",
            "widthPx": 3500,
            "heightPx": 2333,
            "authorAttributions": [
              {
                "displayName": "The Shops at North Bridge",
                "uri": "https://maps.google.com/maps/contrib/112717411260737145569",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVP9rYOa9r-U-cq1HuRuyV45QGKnHpXoG3TQ7erRFp3HXL3bow=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPVrbzZ-KqKFluawZVcYyqE3kW3fmRovksjJfiH&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPVrbzZ-KqKFluawZVcYyqE3kW3fmRovksjJfiH!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          },
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWqJfx82eR9w6r2wIay6UIhsv5JXagfp_ZQ6LqGfQDjRTYyOHt7Y_af-jWSxz8wrJicBy_qsMrrurCGdW_0OMPpvDXxNaPYb3bYO8ePetKKteCqrvpZ5e4P724ru1IvtD6peIQc8_pmzXTb_sPU2CCiw07mMgvjLkHAG",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "A",
                "uri": "https://maps.google.com/maps/contrib/115546527540126890096",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXhBeUt7vYaFOb1igy--oYO5JtJZBGq3GpWr4lSe6KIch8VPiY32g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPq6-eRg_7hbL6zbwTJoJFuv002kgtqRtvneKpE&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPq6-eRg_7hbL6zbwTJoJFuv002kgtqRtvneKpE!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          },
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWq7WhdoDXyVjI3cAUK26zHBxipmmXRg3qPyIAJeP42Llsy-ynJvmyjoXe_bZ_pPZEmVDtBz6RIQKC7DWMzayTZpUzU6bMFHN91vXrD6gYlEyCIYRZrKpv9mxXWB6P52WArX6_tcIB4kTN9CtRPlo_KmDUQXxUaLN7np",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Swetha Varadharajan",
                "uri": "https://maps.google.com/maps/contrib/112758837270515729254",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX6z_ghXtcjg9GNexLPRg8kAjBg2_VTsDHOoLry02nSfdMj7N91KQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOD3RByUCzt8xGQE-DdIP4RgHDby_6XkwkWNUxg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOD3RByUCzt8xGQE-DdIP4RgHDby_6XkwkWNUxg!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          },
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWpBkZrKr7KwAIZqjUzObD05iOCkSgoRJqecFeD3zkuvQycMKj3MmQUJ9d3wHpnSJZ2SMc_bvDRBhbSWIS6uuL46NCb0XxcLI61QNY6A3fGG7zgdenX--iGKGZvMImlePl7bfuudDXYot7Z2cRTKM5FKRkTayUDU1sQ",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Jiri Konvicka",
                "uri": "https://maps.google.com/maps/contrib/110052613032010211721",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIUfTcE2JQ7OeOydaBKxUrNpAgps5esr_MU16t7vdvvRE6H=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOVxJY7hnRL9Zlcja15wPQgVS8OOrZ9ej-3vug&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOVxJY7hnRL9Zlcja15wPQgVS8OOrZ9ej-3vug!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          },
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWq3vDfyouT4FMZ2U-02SHc4T1adaWVqcFaq8sjLb9Q5wTwMtC-hUBrIzSsoO4RySEK7oXgoEjcpvUsZItVb2ICbUdUj21un2ZlnpXdiya_hWgc3nfsneURQa1oa6AzhJAluVQ0dPykSvXyv_oC93smTGgeptKdgt1Px",
            "widthPx": 2094,
            "heightPx": 1571,
            "authorAttributions": [
              {
                "displayName": "Ronald Thoman",
                "uri": "https://maps.google.com/maps/contrib/101060633699539685621",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUhCm4RUbfuU8alzXCh9-8sqFA7O9mEf2tryG5QKT154GiMypBsyg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMR4kJMZDT_Af8gu7xMlb4ULcRTxoniaewuYtAL&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMR4kJMZDT_Af8gu7xMlb4ULcRTxoniaewuYtAL!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          },
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWodfXoNNnusLkYLTBVFtlZdm47taZmGje8p1qNXbJIeIHo3GLRN9yArzvi3rCnjnxjzlKoBB_SqZ9LAIVAf15jODYKL5TEEspWfHIDTBaReM3a4beM83RScJRbt2NH05uajoaEY8H6Iij3futqgH5fA9g2tw255EmU7",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Matt Cervay",
                "uri": "https://maps.google.com/maps/contrib/115800103943199409189",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJmYa_3EPkQxOEiqNVtkPNWTARUupVpPSYBxPqTABtDps1E7Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMRHEzaSutWjWGADi4B6eC2CoVU6CzAZzR0VqAR&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMRHEzaSutWjWGADi4B6eC2CoVU6CzAZzR0VqAR!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          },
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWoOrFST0Q5dXDj3rOfG8YOmjIabT_a341RJ4Vd1y1ENHJmaHe_OR5e4esqdBMB83t0MkXfELUb_arGjX0nk2isgyIn9N-NZ1MVRx5fM-LeUscyUfiaHrWZC8yEjYaSc29s7Rj_dzs_p1qa266gXV1a53EYkHhgaqUb-",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Dominic Di Domenico",
                "uri": "https://maps.google.com/maps/contrib/101654821429008194070",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXOzzshw7UmNLvX6iiuXx18pi4Su3kjeu8v8ykq3l0WOMEn_APz=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN488ysmk57RvHEfQB1zFVb8IuDlGPpdoV8Fcyc&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN488ysmk57RvHEfQB1zFVb8IuDlGPpdoV8Fcyc!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          },
          {
            "name": "places/ChIJ1e8DbqwsDogRNv-31VC3KaM/photos/AdDdOWr8vJAiXY9OXJkXhiUtDvuic4c6tYoyZbQ-HHbewgMzSFEpkZgSNwRQcW4yNj2jI1Mw5Hx86peYTtHSDZTao9sBzuCoYOIteMIzUwM8VsmtdwxeGWI8wRQ37K4lB8HbHIV92T3sWVprYDNV-oRm5O7pD6y-vJJ11l-c",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "Michael Umhoefer",
                "uri": "https://maps.google.com/maps/contrib/104255385663016013345",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVBxbf9k7uQEim_Av9tgLHmu590BvxHrmgM3Oz8hLil0vyYnvYH5w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNV82Ntq2dXJY8UZPWAC33tCPKZCeoLa8JE_l6D&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNV82Ntq2dXJY8UZPWAC33tCPKZCeoLa8JE_l6D!2e10!4m2!3m1!1s0x880e2cac6e03efd5:0xa329b750d5b7ff36"
          }
        ],
        "restroom": true,
        "parkingOptions": {
          "paidStreetParking": true
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJP_RXonwtDogRHT-uqQk7E-4",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "320 W Jackson Blvd, Chicago, IL 60606, USA",
        "location": {
          "latitude": 41.8782437,
          "longitude": -87.6359016
        },
        "rating": 4.8,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 9,
        "displayName": {
          "text": "Catalog at Willis Tower",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWp_ZbQnNC-lWh8ZOgKzYe_Y7cb_sdzBDKi_ueLXsWaegTmR_gPn2apHPSxbOyJcvQcarCRs-FPHnYfkzO0xjm-8oQob2r5fYpAMoHSGK_DJkrYSKiSvD4eIPzpdZNo6-OlTp_HgMUrhn5QwDg0da55LYaAVaSigHrWb",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Kevin S.",
                "uri": "https://maps.google.com/maps/contrib/105697486295897700926",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK-SKrwX6-YTEE9sXp06Cql3y5uCY922EcC2rCpzdrqOXrnGI3c=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMZCSvwlbRwbpgFaESLbvVHxZAps9-jXDLYaLv8&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMZCSvwlbRwbpgFaESLbvVHxZAps9-jXDLYaLv8!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          },
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWoDJ-51tGRCKZ9Df60C7qE8BOVdRmxWuE-GS8rNN7YcALUAjOHpyzReO5JlGIZvLhV9ntPfIdq_CTGyPT3gx4f45JHJeeHnGgMOGPXV7DLCkXjFBGDoel2MkwuLfaXb-R4Md3iGQcKd5cPnNnqqlaDRhCC_HoGUyOVR",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Venkatraman M",
                "uri": "https://maps.google.com/maps/contrib/110324280803461219167",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVUWGvG65HS-F8cUErfxSP7xohZ2MxnK4y-ld-5d43ZjKwLmAOL=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO8p8oMcgw0Mz17CU9RWmeZ_XOcXt7OWXAgxdAF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO8p8oMcgw0Mz17CU9RWmeZ_XOcXt7OWXAgxdAF!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          },
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWoyr96BEI5xCgtuXyhdH7tBuoSG1vVmG6BHBrMFHNDwKxfYFIO7kzaPHzK2KorKc6CFx-xAn91vXJIvMnpCxmewy5jWbX6tg9Rj1_7kNqZaKnWPoqS6otcTyMkUyM0SzeH86IRh54YKdM13ey_1GQs9goyDVC8fW--9",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Andrew Foley",
                "uri": "https://maps.google.com/maps/contrib/100414227162458046709",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUMjFMOMvr6BeM4KEY2Gx1AZYws17JTFrN_Pe5_h8C29vx52h8AyQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPwicATpfjL0rBAX8dCaIcNrp8gu8QgczzuvVoB&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPwicATpfjL0rBAX8dCaIcNrp8gu8QgczzuvVoB!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          },
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWqcgzKr3Uc9oVfN1DwnKXGY6OEbwsaP5RS5lT1LcdZyv_v6IxVYT29OWc-3gqz_Fd-iaG4NfNoX48M8jYMEbIpT5W7Cp62qRpdhSNu4BijRRt_vZsD8SqVKDCwav-PaEfFczE6a-EPGFN-UH5PBgyRPjQchG5Ww-O59",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Delia Todd",
                "uri": "https://maps.google.com/maps/contrib/115816183356035814230",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVk8jTL7qrRoLOb1yYJTaP13QEeJv-8MpeH4jgKJKbitiJ-9kOq1w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPQFSGXbZZe1cMPZQLnw1LiKsUqsBo1pGg1TCu9&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPQFSGXbZZe1cMPZQLnw1LiKsUqsBo1pGg1TCu9!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          },
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWqkuNd3rwgFPhPIs0zkQOeK-l7dhmWt0snQYyMtfT4WmlOpwpURFqgwiWMuZ1B_NT9o-3PSgYls0wYKAW-UchYjJ37CkSNVbmbPtNS2xC0DpKiLP7ndSUoA42E5jy61Eolti_jxZUlnd41PsYu0_N4gkSRvTq4ExtS6",
            "widthPx": 4032,
            "heightPx": 1816,
            "authorAttributions": [
              {
                "displayName": "Md. Afzalul Karim",
                "uri": "https://maps.google.com/maps/contrib/103824045039692123243",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXXOFoxdX2Qw8Ciw1hCIFmgELpxJLoUw9pg-gyR13E7rded7j_09w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM7nIXZI9DP-Zk2TiJlztXJ8XkHpZ1uiJPFUnRM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM7nIXZI9DP-Zk2TiJlztXJ8XkHpZ1uiJPFUnRM!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          },
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWpm4cuaTFLj8irTHDnWptcIoe3X0a8ZfAlp_f8xL7b2YLs5_JD3S1wIr8jrQPr-puC6mukb3C3g3KuB9ileYx85DoDAIKHkzFcnEtDpqkhMkeAtycTS7UsyYYowW5b0y6Itvogqq_4ygE8ji0sJ-XXKLLWiy8ija5H9",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "James O'Shea",
                "uri": "https://maps.google.com/maps/contrib/111744033087665337324",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLk1UR2uCAsEz_Stmyq0v6rQDtw5KM3QiM6PcaYyjgjBvKcHg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM9AS6XX_2-DyRcqzZlweHjZWKgqe0BQ-e4almJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM9AS6XX_2-DyRcqzZlweHjZWKgqe0BQ-e4almJ!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          },
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWoCUGqlCYysTmZg0qIU5FgR-NNNxuqxQptqGX6ptIOSfwnNYTPnIjtMCcGuqrFe5IGMhov80iJFXF0XRWQV-oDCGQjlyUZubdspUjfjpw3wwL7u3gNzWZ6WFqQGJHet-aG-Pr22CP9c1E-U7s_VJR9YlY287dANZuBp",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Delia Todd",
                "uri": "https://maps.google.com/maps/contrib/115816183356035814230",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVk8jTL7qrRoLOb1yYJTaP13QEeJv-8MpeH4jgKJKbitiJ-9kOq1w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNc1Bt57lYAdxUeDn_kjFlGpzHEg7hBffbmSr41&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNc1Bt57lYAdxUeDn_kjFlGpzHEg7hBffbmSr41!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          },
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWo9ZJ2oqrJYs-E6hwAbTA5XOIuHVoBbdYTKA0dbJlr7AbO85DpVh2iyo-4074qZvFoG6q0ji8HUhoC8SW4yGdDGqUBPaJ9tgJVaMOENFjk5T2wBc6N0SDdHLFnf0KS2NpqIyQk3zlMzEMCwsTbePWve45KF6UJ0V-_j",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Melinda",
                "uri": "https://maps.google.com/maps/contrib/112980999224108406292",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVJJv3zC-4mblbBpLcNbcXt6YLRjycFFWVQiJkKyp3kKry80v1SKw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMh_HwA6TfFZl6GPhtrOg3vvxqkprxCD_aFBDMt&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMh_HwA6TfFZl6GPhtrOg3vvxqkprxCD_aFBDMt!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          },
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWomQkL4X_0HGQfqAl8zHHQW5NvtYXHR0FuSs6LzLsdFNy4J_5t2PiyM2CmpZXsDUNzxLae4ZOdmnyzO86N2CBIXsr8Vmg5OkqPjOByhFhWd59QdR6pmh9JIxFcNiO-U87MJ-DCpqSsxpAqdV58D9ZvOG_CHCnrSvy-n",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "최재혁",
                "uri": "https://maps.google.com/maps/contrib/103398486367862125605",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX1YQSgohBksqkn0qghC7casx3WrbzpLWzsHIkFoHI12f3A2sEfEg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMIiGxdR4SeSrJ7bUid34y2HZRvbi2mWjFkr3Ig&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMIiGxdR4SeSrJ7bUid34y2HZRvbi2mWjFkr3Ig!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          },
          {
            "name": "places/ChIJP_RXonwtDogRHT-uqQk7E-4/photos/AdDdOWqY5rHEuv2o96-CkgluDFFL5D8_hXAjzGMOFC5PrbsSiefVQJtiAMD4bdL8B0pVKE-1lQLJO15DXaNb-bDYMqANZGDHThf54gMjtaN4hVohWsopeI-P9P-cFQrPziwq1RWdyiPMein1t3l_NRhCSl7rJAQaKZ0ID6ZN",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Delia Todd",
                "uri": "https://maps.google.com/maps/contrib/115816183356035814230",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVk8jTL7qrRoLOb1yYJTaP13QEeJv-8MpeH4jgKJKbitiJ-9kOq1w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOZAI7g-SK0wnT-YYH9mOfLfqZctpUBjzkegG_X&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOZAI7g-SK0wnT-YYH9mOfLfqZctpUBjzkegG_X!2e10!4m2!3m1!1s0x880e2d7ca257f43f:0xee133b09a9ae3f1d"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJlVI001UrDogRGFRqOf-N13g",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "River East Art Center Promenade, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.8905896,
          "longitude": -87.6159658
        },
        "rating": 4.7,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 6,
        "displayName": {
          "text": "Ogden Slip",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWov1CIbQuOA_bMkI0fJZbQ8N5XeiTtoWy2Lw2KjNhUE_zTeZIwEe_EbcJBy6fLwlwmWTFsQk9z-RqaLNDH823HvVrS3eyOJs3PWGNu-VSd1WZOtrD9tsU9hTkwAVg5wGAsaL5FCxflRoV9pS2Mb3HPUvccFTJhFLamS",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Sandy (electricbungalows)",
                "uri": "https://maps.google.com/maps/contrib/104612016394063908111",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUtPdiqYQ5UJjsnJuek5PnexorQ2rTzz0nw09QuoMAfKKg0SSqdvw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOgXvsvbPZJ46rKwJ0_EmMUKT9ppkhHYX34PHKy&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOgXvsvbPZJ46rKwJ0_EmMUKT9ppkhHYX34PHKy!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          },
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWrkXIf-beIaFTpSDt6GLaoRmv1S7_SdML4iFnkJRLZNvITAjjy1Y4-lWZ1wtB3-KhpfiEXN8AXP4_wGuqnYMZsONUqNJZVwlm0p24_CQ-MzrZZ1IkDFg2KaQDCEVGGVJf6MwytKhTYZEsxSAvhGjtMeiw1vvhlt2dSW",
            "widthPx": 2848,
            "heightPx": 4288,
            "authorAttributions": [
              {
                "displayName": "Rich",
                "uri": "https://maps.google.com/maps/contrib/116274304678682015710",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXydixdf180inxkl7-_Pa8IaQ4l4PgFjAj6xugO6IfTJhwlS5ur-A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPMPqvnCRWLtbLubJEq856gpYd09SNBTKCFd_Ks&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPMPqvnCRWLtbLubJEq856gpYd09SNBTKCFd_Ks!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          },
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWqLaLE7Yr5YnBj-D7OYoBxl_NfTSO72XqOy58jCXaJU8JU5Z8p72m9UkkQ1J6JZYrT567XgrswHZB_NvBMMvI-KyTZZ_HerNQrVY_tAFs9c5zIQIzlb6uo8ED_3Yqj8W6MOW8EI10yzhl8kWF3Q8cORy3YFTLcWrieV",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Sandy (electricbungalows)",
                "uri": "https://maps.google.com/maps/contrib/104612016394063908111",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUtPdiqYQ5UJjsnJuek5PnexorQ2rTzz0nw09QuoMAfKKg0SSqdvw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM1Py6gsGnPi71-2kzOGXgnv9TKONk6Rk4zgOoT&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM1Py6gsGnPi71-2kzOGXgnv9TKONk6Rk4zgOoT!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          },
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWqQWui6ExMLDInUS0k-oxEMnoRSHByYk_Zj2LMM0r0tHSYy2xZlppe089jHxSfMQvBH7Uj5vHv-eQ4tNZOGOmwUcIw3g-Nb8au8w66OTWR4Km-p8_tNjd8o9Ej-DC2JKm3ZSp9PvUWzucVDn1t6haidfeF0wt5UYkaE",
            "widthPx": 2268,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Davi Lyra Leite",
                "uri": "https://maps.google.com/maps/contrib/115221367342053959978",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXsIPBqpPW87uH5pRS3MmSM5t6c-B2GoLX0-kBbBkiARkqdO5jH=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipODKIx-_COsIv6FPMra43AUDkvvtuxK81TLPUeO&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipODKIx-_COsIv6FPMra43AUDkvvtuxK81TLPUeO!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          },
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWpO3Z_Deiv_YZt87dsCL_4xesLyiZs_Dt5fqIVsUoHTc5zuAoB89kJwOhKYzocVBL03H1xKOl05FmQawmEE9I-WMSCadFK5H2rOuWFdMXbbGfCPWoe5tfCT-oy1hxPWdrPYkZMAP3e21GbQHxMugf15J8vfO9qQoC4U",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "Davi Lyra Leite",
                "uri": "https://maps.google.com/maps/contrib/115221367342053959978",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXsIPBqpPW87uH5pRS3MmSM5t6c-B2GoLX0-kBbBkiARkqdO5jH=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPNZZT3sLdkvvfqq1OYUHSHLq5OW_BDXFp6b1vh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPNZZT3sLdkvvfqq1OYUHSHLq5OW_BDXFp6b1vh!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          },
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWqK6RDAX-oXk6dNPET7GjXN1z7JkbFSHHS8zBy7OtMDfw6UGX3U3AXrUKxnk913uxOZayfh3pTGeEBW8egMLwnZxfEyLNcobZfhb0kzagl8_0Ean0o8Fqa5n9CSQS2zW1Vc0STNIf_f8iphH1NNI4i-NwRO--b-hstW",
            "widthPx": 4288,
            "heightPx": 2848,
            "authorAttributions": [
              {
                "displayName": "Rich",
                "uri": "https://maps.google.com/maps/contrib/116274304678682015710",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXydixdf180inxkl7-_Pa8IaQ4l4PgFjAj6xugO6IfTJhwlS5ur-A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPFA11nOcKZ1Iyg_V_GGogv7YlS7a2pIVkHpfgA&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPFA11nOcKZ1Iyg_V_GGogv7YlS7a2pIVkHpfgA!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          },
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWr2Nn4pkZGSw_VxRg74tYvrddUFrvS5m78mrWQmlIonB4IXYPnNVDP7j6MgkXLqQE_78d3i3HbagG23WtENDlWsoBfn9UmGSoVqJloFooIc7zrg8mAxub3_XySsWsdqEgFesPzFLd7QZv73I2-Eo_lumnXpwkteEXK0",
            "widthPx": 4288,
            "heightPx": 2848,
            "authorAttributions": [
              {
                "displayName": "Rich",
                "uri": "https://maps.google.com/maps/contrib/116274304678682015710",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXydixdf180inxkl7-_Pa8IaQ4l4PgFjAj6xugO6IfTJhwlS5ur-A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMrG5GKAgCQqyFDBheGbztFT_0gF9Hcf5ljDPX8&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMrG5GKAgCQqyFDBheGbztFT_0gF9Hcf5ljDPX8!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          },
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWprSB_q7IoCO52W5ERwwzjzvJGPhrjy_obrkgQ1b9nTUU6whzJjNhElrauFejUQPoL69MMYBkDKTJze2cgtyqRUyxot7Fz82_e4lBoUnOvJl8w9bafdU8l9NTOPyq7LsA0MRt5A7F6FU_aAsu7LC4yYOe6m_foaM-ec",
            "widthPx": 4288,
            "heightPx": 2848,
            "authorAttributions": [
              {
                "displayName": "Rich",
                "uri": "https://maps.google.com/maps/contrib/116274304678682015710",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXydixdf180inxkl7-_Pa8IaQ4l4PgFjAj6xugO6IfTJhwlS5ur-A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMbtyfuRvrL7G5_dbLbRDz2ZCQpT3uYORYqIlBq&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMbtyfuRvrL7G5_dbLbRDz2ZCQpT3uYORYqIlBq!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          },
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWpt_a2VqfK5Kizv0g5lIQ_l5jaxiW11aXIGl2O03FCW45BR5dGnaQD7qFofUwoqfD7GnyXhDsAZ9xuQ6uVLGdaZ7wOuGmy831Cq96wcridD_23jrAv-zjwaqeYR-jdAZgClNNaMF9_yCOLMF_8q7CzTo4FRF1BIincW",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Roberto R Aguilo",
                "uri": "https://maps.google.com/maps/contrib/102112834991460559390",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKdGkR_KQDa3tbFosIirm9f5FGEqcgn58Lks3yOu1OIfCEFEw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOGBZ5YvJ7dF7KUNY12gHbmKb9kg2q1T-awnqRl&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOGBZ5YvJ7dF7KUNY12gHbmKb9kg2q1T-awnqRl!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          },
          {
            "name": "places/ChIJlVI001UrDogRGFRqOf-N13g/photos/AdDdOWq20qLtU2D0EoU4W8k2erSeJfie53apYvkU1jvXq81v03ml-kFlhmHM1DTccX9l4B8SOw5S-ziMjUed0Yfbzum64V45Z2j5LrqTRXUcbbBPadDm2sOJGuuXA9HMhByLpeW2M7qYtHGxa_zz3chSzshjvbpG8vWnOgFO",
            "widthPx": 2848,
            "heightPx": 4288,
            "authorAttributions": [
              {
                "displayName": "Rich",
                "uri": "https://maps.google.com/maps/contrib/116274304678682015710",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXydixdf180inxkl7-_Pa8IaQ4l4PgFjAj6xugO6IfTJhwlS5ur-A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO0X0HRRfnZMPvWh3X5qx-Wto2iJTbU-0vjxyE-&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO0X0HRRfnZMPvWh3X5qx-Wto2iJTbU-0vjxyE-!2e10!4m2!3m1!1s0x880e2b55d3345295:0x78d78dff396a5418"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJ90QMdqosDogRtsJxTiwKtb8",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "302 E Illinois St, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.891656499999996,
          "longitude": -87.618702399999989
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "The Retail At River East",
          "languageCode": "en"
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJJzayWPAtDogRVIUmp7ydqVE",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "2 N Riverside Plaza, Chicago, IL 60606, USA",
        "location": {
          "latitude": 41.882188200000009,
          "longitude": -87.6387607
        },
        "rating": 1,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 1,
        "displayName": {
          "text": "Riverside Plaza Skybridge (Ogilvie Transportation Center)",
          "languageCode": "en"
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJ49-PDJEsDogRMrnzwXHY7PM",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "150 W Roosevelt Rd, Chicago, IL 60605, USA",
        "location": {
          "latitude": 41.8678745,
          "longitude": -87.632564
        },
        "rating": 4.5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 3196,
        "displayName": {
          "text": "Roosevelt Collection Shops",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWqa0SJ-KOU02x07AZX_jCfyU0xl6z-9FdSO4UEz9husFUw2tkoHCHAd2duaU9Q148rXx50nLNhBSjyvK54epFvCelgU3rdhDilTJHx0paVyf0E_BC91KfIztfPkUNvxV29cHNiQN9mLNOYCLtYfcqY39bTRZDKlBzMO",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Kevin Winstead",
                "uri": "https://maps.google.com/maps/contrib/108047517672686611154",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLPu08yqwcc4bnQln-nFIkVPUWmkmB5nzaRNcFdppsBsPhz-Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNHzF3rBBTw8CE_sRGOUvDB1nFacuPnUrOgawVs&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNHzF3rBBTw8CE_sRGOUvDB1nFacuPnUrOgawVs!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          },
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWog7pUSCbUicrAi4TcoAsWaV59zALnGGPc_syoiv5uwqO3UzBz5BWZ4SlYjE1KlCYJIitdNIXWmwm5jMS4_dS0nXRfVsDdltDHp0LhxvLy3Hep1vuWD9RhIJPeHjG-A6j6gu7VerUukAHOe8EAM5QLuCxYPZ8fKQhyK",
            "widthPx": 1125,
            "heightPx": 750,
            "authorAttributions": [
              {
                "displayName": "Roosevelt Collection Shops",
                "uri": "https://maps.google.com/maps/contrib/101764178672749322295",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWi0sNtXF9m4XmXCQ3NL8Q8qYgKa861hR-kiVGxfeAlwhTtrJaX=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPuvZIeB6hWV6s5Gl4yrFlwgW9bGaNApGWfIfzy&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPuvZIeB6hWV6s5Gl4yrFlwgW9bGaNApGWfIfzy!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          },
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWqzyejR-CGS-DG9VVzl4Fwf8_CxMBsp8NV4qPjd9Z9uAlYemsl7WCrEiCS8H_geTUbhP-hIuF1iN6rGcJ7gezUZPfrlPVOgYK4IO9vSbY7Xe74o5eHM97zkC7tgfyMBy2VnAHNO9oE-CrV4OyJbI7UJqD2zO1de-kq5",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "David Schwartz",
                "uri": "https://maps.google.com/maps/contrib/109062645224511469514",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK3hJl9Gf3fPDHhcPa1TSaA36El5mwnUM4iSyMTrilwlJvB8A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNJ8ootCjIjYeBkNvAjl38VqxnLAl_l_yVX0kZl&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNJ8ootCjIjYeBkNvAjl38VqxnLAl_l_yVX0kZl!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          },
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWrzij5de6Is0lT9zmNYs9rZFdJznFdT_-gMaycgmpndhPEKMB_dQehpXCCWIcxsOP_ySHEHuCraBbnWG90ZFwptQIlMoF_SzzlEA11z92f75Mgd4NzRD9LqxQgeb7oNByvyWgzDyP_e-nIaTUhUPCJHUMzKSnS5FE1_",
            "widthPx": 2340,
            "heightPx": 4160,
            "authorAttributions": [
              {
                "displayName": "Tiffany Taylor",
                "uri": "https://maps.google.com/maps/contrib/103186043794925553052",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLMssnTFrirry0ybv4hBJPR5dEUiKxL3b4R-gu1JvEGJqeLag=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOMbwiH8Fx8JcRjLRwJGD7XuJmy-EoLiQTl7NUh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOMbwiH8Fx8JcRjLRwJGD7XuJmy-EoLiQTl7NUh!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          },
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWp4Yx0ZdtG9dQLPPaoA0FCtowOpFlQNLv9UJH4RzX-Wt3rEztF8-qbPSbGfFlzW7fvkGgaDJVrrYKs2V2YWf4YT1N39TPddokOVhPjZJ7rpY7B50DwSGw_GIZ0tM-K3bCBAvGXRzEROqeSJ2Q55yE5WhMAGxnPY594S",
            "widthPx": 2560,
            "heightPx": 1440,
            "authorAttributions": [
              {
                "displayName": "Maria Prado",
                "uri": "https://maps.google.com/maps/contrib/106377622690905275322",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWgV8SXAYE1dnvHbyAlVfT4OKkdR53kYKOFTJZwkUSAFqM2N_1E=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO3JYJgnFMgeXt2BYWABf6zoZnoKQnsp-xjbQXj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO3JYJgnFMgeXt2BYWABf6zoZnoKQnsp-xjbQXj!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          },
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWqUUReKseH4jpjWgKP0apA--FDCyTgIJh8fgnOG5WspfYQ-GFigN0qw98xvOiutCx5zJDHaegJiywv4dFJ1bVP1moeWUlZAkIMV3z1qcoiNxePlO2oF0Hir0LUSh5KW0puwbm23jSPPk4WkvofEzDpzBtZ3CSdazb-2",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Eddie G",
                "uri": "https://maps.google.com/maps/contrib/113635686341188720362",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJdFsD64RrJNnQ-QjFWdsIuW0nra1UOVRGLRcoZdNSzuvEfyg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPOhGZxoMNEImm7XXgKKXy8ZaltyBFPEtRpDD0O&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPOhGZxoMNEImm7XXgKKXy8ZaltyBFPEtRpDD0O!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          },
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWq98sFMluZo3MKjEVU4Dz9Pzsd_xykAwt0InG43atbbQc3X-Fz7qmSRCMGVCGqoatEjqgyvlBJ6p_gLjahfWBTSvtTQF9NYlsKCRbJcb9Pi17roPIFQD09mwgs7R3nrQ71KFMG82TzkIE8eKpFW7lQFLzjMHqb7s69a",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Washington Guillenea",
                "uri": "https://maps.google.com/maps/contrib/100439373384886115308",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUbDZJeda0QTVT_uIQuukL2GSbsZcWM3Tp6jCWhFi6tjWWTbR7Pew=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMsvnYim-aJ58NJZZK2zXmviPkafT_-5e3Fe_LF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMsvnYim-aJ58NJZZK2zXmviPkafT_-5e3Fe_LF!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          },
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWpB3JnUO0o3CMvx5UgW7t8mOKOkDrW09jCi7aK5mBk_aG7Qcf9T7K_qls3UcnzTY7k8EXfZEwdncF4R03dKni3WJ3qcCpHUmrC-qHBT8LoD3Gct_dL-139KTKzroKkntwnOzh-EHhIGYg8JdQSAVUBnJ4Pqi3GWgRCl",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Maria Valtierra",
                "uri": "https://maps.google.com/maps/contrib/101719089898273864481",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK8-4uQkJq3JxmLZU0XYtYjs2JA__WgughUybBXCVCOdXz3xg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM40aKkQxGOSuKUUE6Mo5fextlZjrHddTx6oO-N&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM40aKkQxGOSuKUUE6Mo5fextlZjrHddTx6oO-N!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          },
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWo9pLniuEVkT0LX6yQY9MOAth3v1rGyAkSR_TPXppQ-vdA44FmyPV8-3vdenBDr23XJh7t8cMy7zlz7vemuLcTROnL0AYtv-xnEH7CaGnUnz8pMShuzdjkWJMWZ2z-ojCfYStLYA9CnttWJuN7pCZBONeVFO1MAmk2-",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Carla Pereyra",
                "uri": "https://maps.google.com/maps/contrib/107533503879342540593",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIQsPRHtUcQTykh3Fuo61JhitjhTbvROJmUM9v54yN0znkAzo3P=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPIjxRs4K58thF9AKSGzNL7V5BDAgaYsuMF5IAL&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPIjxRs4K58thF9AKSGzNL7V5BDAgaYsuMF5IAL!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          },
          {
            "name": "places/ChIJ49-PDJEsDogRMrnzwXHY7PM/photos/AdDdOWp9LmLpyu5Vejr02A09zz0hcg40Wtv4posq6IH96Yf9wcwd4_a1YKfpIeaFWVn9xac5NgBJADFaIPQxqgjneLeTbUJU41DfUJKfoqTLtBc-zkWlU6NruSHL2wl2HGr0-aDAZEQCzNwQnlWoZZJVNV9Vt_m4xcv1bnC7",
            "widthPx": 1080,
            "heightPx": 1920,
            "authorAttributions": [
              {
                "displayName": "Thepanther 007",
                "uri": "https://maps.google.com/maps/contrib/100904731405597477732",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVgYkr-BnFlkT9pRw9B2Fq6tmLbJauAz3PqoydKmgt2GQ5yjgfA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPP99R0lrcdmGP8WVbUFC1XV6p1NudrSAkUYWX0&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPP99R0lrcdmGP8WVbUFC1XV6p1NudrSAkUYWX0!2e10!4m2!3m1!1s0x880e2c910c8fdfe3:0xf3ecd871c1f3b932"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJeQOqg1PTD4gRFLiIyAncMuE",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "835 Michigan Ave, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.8979303,
          "longitude": -87.6228927
        },
        "rating": 4.5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 13803,
        "displayName": {
          "text": "Water Tower Place",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWobYobyTNnYv-pUyG6LX5Vggj_IJ6hOqtL4-cdET2IB8w2Zn7Dy7I6pznw7VCB4JHSC-viygeGRmJWA9qUjpUXOWGxsoMFkW6shsl5z0l3EghUVcWQe4sq90aK0r-O8OUf5a031Vs89ayoOHUDczSs8FPVKa69ZYpN3",
            "widthPx": 1365,
            "heightPx": 2048,
            "authorAttributions": [
              {
                "displayName": "Water Tower Place",
                "uri": "https://maps.google.com/maps/contrib/101854856165210552904",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocJThii7W_-v-8OKVmdyxeR4qe3K9kaHpH8JD3cPKFdFu0JdSw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNHhehyAK1Z0c_RxspTSVSXaHmjBnelOJ7i9Aye&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNHhehyAK1Z0c_RxspTSVSXaHmjBnelOJ7i9Aye!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          },
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWpEsbTfYnYR7uQhnkupqlTZCSZf6YDMdcjZ6VH7B8m12ShCC63-omoPKyMBA9fYGNITAlxl9-F1Zao6aUyflxDAUSOOx8rFqhSIFeMeLA_1k9GM8FEppAdtEsXeNykUyBnL4tB4Rgvrud3oeIq5mKqaRdVDAM7wc367",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "J",
                "uri": "https://maps.google.com/maps/contrib/105385722158155445411",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXIoElGWt8Sfn0I6TOLl9K8TuFuue5vw7s_IiEi2NCJrf56vtYY=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOD9NdySNLS-PZY1EgiygRlUMai0Li7P80H93eb&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOD9NdySNLS-PZY1EgiygRlUMai0Li7P80H93eb!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          },
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWp3f2CrPYJ-Pihjj8WkvXZqeLYIKSnev8g3EHEwX9v4UlB-p1hUIi6H_C1eeI5cuLjtK0JbozbFS48R1o_LLCX5syErqr88CJqoiXmrsr0XwCUPyZjLf53ajc9j1-jhMMgCoke5OL-TfWDOOrTHjL2X1t_eHjpD5crl",
            "widthPx": 2992,
            "heightPx": 2992,
            "authorAttributions": [
              {
                "displayName": "Adam Dunn",
                "uri": "https://maps.google.com/maps/contrib/110503383522586300504",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIcF2pfm9XcC4lj_EYt-aQtoD881vHYM7m_RW6KwT21KN1tkg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNs0xTHMB72zZouDNa6f_2L09QU3aXUscYXPRvJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNs0xTHMB72zZouDNa6f_2L09QU3aXUscYXPRvJ!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          },
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWqPQojkH1BIhUA7ZY_jOghps9Wv7pAN-WqOJCHRUq5PQL5_VwUFdAAmiMOEmNAEfi0m-jK4oalVjcjgNY1Am85wP1t4Nl8BkR2lIjrvreSFgCrrRavYfcw8LVk09RR5YtGpb_NU7COFr_XrYS_XsuhawzKVF7gdiMKR",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Danine Harvell",
                "uri": "https://maps.google.com/maps/contrib/101446505300758216078",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU5f6lLeXA3qSL4bWyFr5jP4gLO4FWVuWKHWWxqqkKi8dNVsJpXrA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMYM-coGZ6vC27SQ0QLiz_60BMgiFjPsNkxFftH&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMYM-coGZ6vC27SQ0QLiz_60BMgiFjPsNkxFftH!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          },
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWotjccgy7lEyb_hmr3Icif__Zxv2I2qqlVKZ0pjS1L7HUq6iOIwpQqr8fW5I59uohj-zEpnidGK0IxlTsT21-RZADxibzOHA6YUpU8qRU_k1-osMu822-SZXG0aAtYCjgYRrtPSy-4eHeP0JKUkofNQJ1SEIPNcBijM",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Marcus Certa",
                "uri": "https://maps.google.com/maps/contrib/111503804064426868347",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUOXri1fG_MhswGVmdtwhg-SrcGPpCJIZpJFgygAUMfOmf55UH0VQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPGalXRGnrjM3zz-ucgm712-oJwF-Z9kQr7KaXa&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPGalXRGnrjM3zz-ucgm712-oJwF-Z9kQr7KaXa!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          },
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWpBIz1Mx0fvxOjNT2TZU9A6rmyLzdFcoooypNtj_jsyz0YCosod9tgcIql04sSjsk29zQxbmeSBxz_zUJF6EldlbE_3VEN3pp1Sj_62CNnCA15Er1OpNaKSZJevySfXZ1FIm5RKgJT-RCjAHZ4hvikYYf8eLXoEQmHF",
            "widthPx": 4032,
            "heightPx": 1960,
            "authorAttributions": [
              {
                "displayName": "Mr.O Viengmany",
                "uri": "https://maps.google.com/maps/contrib/101852784262561863707",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWEwDgqBFQUtHbyCTGHYQKreS8vfsOKQVxObWXyPGodOIhiCrX8WQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPyi_om_SU-0P7TkOBrjiIStGNq31w5iHkgrvMb&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPyi_om_SU-0P7TkOBrjiIStGNq31w5iHkgrvMb!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          },
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWo9SYsyLP0lSplGLBKHc_nYgVYi9h7bSU2GSVlHH3Ci7U_j3bG0OZhGGjeaTwNs0o_VNWtKyRDmfBsQ6aFI2DIdqYSmO_WLuATP4qsMtm1r1_xFgvMI7zNpv1XbbPN03_HIoJ0A3z2JK0nBGrfHgRGA8ZvFNj_9MEcF",
            "widthPx": 4160,
            "heightPx": 2340,
            "authorAttributions": [
              {
                "displayName": "Thomas Boyd",
                "uri": "https://maps.google.com/maps/contrib/112879232559261807884",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXIxuN7MoV_JOTrmGVg4oyqe3mNsBgzFqM5CH2X1vvAwwfzMUR9eg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPZIYQm86onybukcpmFzesYqQmD5QkhRn2UEHli&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPZIYQm86onybukcpmFzesYqQmD5QkhRn2UEHli!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          },
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWp0URwFjsONQ685MueWK9ABnyZsKKGSW8YjW7d05d_yE4excNQOD_ey72CsAHKe5SgX_Byz8fSrx9iGzIxLdcR6ql8-XNcxwBZS1T0AuVEWRnLey8QbdKWKPTUR8lE2p3ILxge9zVJGeKpViaiP1taQcV1vzTHkWYWA",
            "widthPx": 660,
            "heightPx": 440,
            "authorAttributions": [
              {
                "displayName": "Liam Marsay",
                "uri": "https://maps.google.com/maps/contrib/107791635422736252655",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocL3XwUkwnKnHdctr4F_zmu20u58XfAWdanleNjTYvtWziRknA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMzQMYrtoFx6IA1VYChPox7gh6NiJqaZkejpoJQ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMzQMYrtoFx6IA1VYChPox7gh6NiJqaZkejpoJQ!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          },
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWrdZX5kurxGnQkxTGD6WmSR0ZNbgRWSGsAP9BPV5DKhJrpvRmuguxhsHvNl3kkMDcxgf-IcQiV1RfXrUfETK9YSOnjGhRkX-7zodln1I1oXb1t96GzL_-j70Xq-8YV4tcOUiMYXtcJbBx8ySHrvJATevJN-uA2au8hm",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "The Law",
                "uri": "https://maps.google.com/maps/contrib/111275727114657539919",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXJTX8t7LwedHMMPnpzy9iQcy9DNeYPStst3p-XPgpz8i1u_a2d5w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNbsOCBu_udQdNGN10hYDDQ7Y_pISF66_jRM40N&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNbsOCBu_udQdNGN10hYDDQ7Y_pISF66_jRM40N!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          },
          {
            "name": "places/ChIJeQOqg1PTD4gRFLiIyAncMuE/photos/AdDdOWoVpOYdnBDNY4gw5paJUDKNPQcImGjDDyZ8fnbNFyrR2K_pbL4Xc-QjmyYiPXijPmMB0vYJ0BsmJgNHiDkwAApObEU4jP7ATAQcKKFQMg9JqoTpeH2NIbSyiKPRThbJ4c1HR2K1VAezt0pkE-7Leyr7TegJknHdaUt3",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Ashish Kumar",
                "uri": "https://maps.google.com/maps/contrib/114370992774317896604",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVIIyTGRXJvmaUtZcHT2obCoa8Jju1jxWMz6sG9UIUABvAwA32f=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMOVsGXMz-aUrlbDFsqsqa7Ue-ElxojgAym4p0M&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMOVsGXMz-aUrlbDFsqsqa7Ue-ElxojgAym4p0M!2e10!4m2!3m1!1s0x880fd35383aa0379:0xe132dc09c888b814"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJBYaL0QHTD4gRWWUubClWzig",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "835 Michigan Ave, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.8980716,
          "longitude": -87.6228029
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "Tonight We Party",
          "languageCode": "en"
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJ0YWjbBItDogRb9hxOZf7-HY",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "1101 S Canal St, Chicago, IL 60607, USA",
        "location": {
          "latitude": 41.868528,
          "longitude": -87.6380884
        },
        "rating": 4.4,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 1643,
        "displayName": {
          "text": "Southgate Market",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWpU4sDxtmusljp_HyAXeppvYW-ZYiaTr7EYvLtAfzdJk27WtzHJCA0eF_M1ryZZCQvoGb66W_Wavn6aONmEeKWDtL8yYSzphzN3rzkIip-6OUrLpjSLylh0pn28SWCn6tKmGZbysvxHEkGPiJHG9s4h5a_HOitWcw-x",
            "widthPx": 1080,
            "heightPx": 515,
            "authorAttributions": [
              {
                "displayName": "Southgate Market",
                "uri": "https://maps.google.com/maps/contrib/105535889306407931420",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUge9Na93xaPeVOIQJT72dkZhORXM90z5HS86SOjQYlOQ_L5PM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOpD8P0stLET_Myw1ZRkrL1wCQrVzYEilkPC77S&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOpD8P0stLET_Myw1ZRkrL1wCQrVzYEilkPC77S!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          },
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWoEBdNy4_GF09tg_bmj1yYCQtNfwQK0TfR4oqbvsS2mfp-66LtwHT0RTAq41kfY0L9Qb9uvjPPDXYwomiSUVLRngkHtTrPIIOfE3Opr-yy7H1kPeiVdXgiMjvRHgkWNqs1_96p8FJ4aRo9i5kLG91ykrwoGB8VTNv5n",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "陳榮泰",
                "uri": "https://maps.google.com/maps/contrib/104644510768578579005",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLz6u8jVg-22iv2_-uFHGw3SnH7mXJghfODcWiTE7w8h9pYs3gC=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPt9oluVhK1XLdAoklzFzhF1lUHAGJQYqsFMHqK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPt9oluVhK1XLdAoklzFzhF1lUHAGJQYqsFMHqK!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          },
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWpjWfT8FZ7_08zIVN-as2geNnhu82-47tFX4Yy97-kawijN56Xh_lqNkByKO-GnKCtiI4VPcsDuk6RS7hmh8WT0mMest3SQwGCT0npC_PFaSQMis7P5bWnAzpB_BblGuYTcR1J20VxxJC5t6XhRoF4oz8zGj65GAzhA",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Rapha",
                "uri": "https://maps.google.com/maps/contrib/105197447580735126689",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUX-I8qyzQ3tu5jr4miwZNLqeCtzeK5Muo5zVC0QRiBBzp6hDoNEg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOr4AD4glQ4OY6uUciCbDJP9UKi2iSBRNo9I1EJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOr4AD4glQ4OY6uUciCbDJP9UKi2iSBRNo9I1EJ!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          },
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWqPvMxPiVz6E8XDwPaqANQCf5Os_z9vnGEXDV1R_qc3rYdzHeB92FiqxQOt1aeA3WA09_Czp-zKhxInmQERnIzZ3vQzTZcBP2bCg4zbNNJLMQ0GaqQY_6JBlxVMdNsIigfGJJ8_y1lb4fPCmcYa6MjRKZ0I_doVnkmV",
            "widthPx": 3984,
            "heightPx": 1840,
            "authorAttributions": [
              {
                "displayName": "Julio Perez",
                "uri": "https://maps.google.com/maps/contrib/106980575568619706772",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWNpVdh2VQzePmDL2DFUXKyIIQ61ULDiGOkaEB9wiqnJZL7z_c=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMlEhm0Zc_anxHehYWUMdEthcqnlKMWedfx7HQZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMlEhm0Zc_anxHehYWUMdEthcqnlKMWedfx7HQZ!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          },
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWr33igjY_XH2dI86x6U-7UzNyv2yE4HnqTw391ewbb1V4EPUxtx_-9aB21BJ_msbtAMmElcqzty9Dpb7jfb9QqFgxCPJijJdcL3kxaejUH5J5uY98-9j1yoziSagi0A4Ua8oQa4l2JBibpmRN51SY9hhIBzDx5napP4",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Darcia Marie",
                "uri": "https://maps.google.com/maps/contrib/105706199030798744718",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXyhLPNK9aq2RbBtWVgCFz_fGCHBIeoeFoDMXtqUubNkPRy4I2u=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMIy7QL3Z5C1Tj2VSPD_Fr-z1c6uqvM0zO7zIU0&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMIy7QL3Z5C1Tj2VSPD_Fr-z1c6uqvM0zO7zIU0!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          },
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWq5e2OqTU4jbxo5xmAiO5AvJmmLnDEjAUSD4_tQb8EN25V3pblwDUIj1eoFtv543qwqIm_0JpMtVpOnHRFLrP6vBJsbOSaTI4M-pczVEeOM3tQLzynhG_1UqGnlvHonQ6rI8ZnV5YAXM1XhSTOqKgD7rrb3kEColsvM",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Miko Jiawen Tan",
                "uri": "https://maps.google.com/maps/contrib/110308422839866657447",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUJsrgxPrW6bY-QllchRqw-Wpbszj3Zx7MLX_6pEnbQDkLuLzyDMA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOjqR8f9kcQ-lGNysrj2Mn1QKQZ8I07UMSX0CYg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOjqR8f9kcQ-lGNysrj2Mn1QKQZ8I07UMSX0CYg!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          },
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWp-VlW9bfBmYjR2mPBMaDDOH0QsRwJtfpU2HA0T4xqEKDWNaRrZ1EB3opLKL4i1Tg0dDUSMQAUrwNwXOKys6DKhf5nqFUowKt8aDCByZ9GvWaTpSsKpGETfaxbCkvXaMYCtFsOam0Shb6HTknnnfZsSTsQSTAOpBNK3",
            "widthPx": 3264,
            "heightPx": 2448,
            "authorAttributions": [
              {
                "displayName": "TIANWEI CHEN",
                "uri": "https://maps.google.com/maps/contrib/112257901895366101608",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVc8VFEL0zahqq6Gwa0ANkgyIPjwAGCMnWPeOE3nJqDR7k5Ip8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO3XAVF240ip4BVwPWCu22Z5UNRv9KjtkIhA7PE&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO3XAVF240ip4BVwPWCu22Z5UNRv9KjtkIhA7PE!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          },
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWoaqOHyRWnNGHN9Tk-mqtnlTuLDl8S6QtCXJ3U-caAquCxfye3eodArQ6amTg6Q05lSxbzrdN3sjIXxSKwMwYWXB_OA-1BffGWB-m47BRKmKvVwj8xeVYLhiYk39UqD8DysIKM59Ef0XZHwe_ltaH7p8U4iSzBRt-t5",
            "widthPx": 800,
            "heightPx": 600,
            "authorAttributions": [
              {
                "displayName": "Southgate Market",
                "uri": "https://maps.google.com/maps/contrib/105535889306407931420",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUge9Na93xaPeVOIQJT72dkZhORXM90z5HS86SOjQYlOQ_L5PM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPxMndW9T4usSJh6V2oDB9cVlevHlLoXb-cSJiJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPxMndW9T4usSJh6V2oDB9cVlevHlLoXb-cSJiJ!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          },
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWr0AQduk320UWOUrv_lrAQL72WmAH3qz5Uma9Iw2EziQK84cy-vm5_JWRVp6FJTgY2iXDg4a_BsoHmTXBIaEJgHjo9DqjQ8ShAJKptJStrh5LRWv09YoL18TgJ55YhfcLdTAtTDP7XAv4XvZSyd7RCZ0CRAwYRY1LGi",
            "widthPx": 4000,
            "heightPx": 1800,
            "authorAttributions": [
              {
                "displayName": "Brandon Barton",
                "uri": "https://maps.google.com/maps/contrib/103282480190420365635",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX0RYRvymiSgDIWcfZ7X3ygkYOia-riDAqSFEphe7OyJb6W1VSv=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMT0nUTW8uRPf78qgAH0sLOIIi6N6-YClb-iPVV&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMT0nUTW8uRPf78qgAH0sLOIIi6N6-YClb-iPVV!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          },
          {
            "name": "places/ChIJ0YWjbBItDogRb9hxOZf7-HY/photos/AdDdOWprs9U4turT-_6_-18856UkSk1gtXYwmWTehreVLyZLNjf_Mh1VKz49S-fiCdtGx88SdfPJwR-oqoTBK4iqxmJL7RcPjIweUGk6Ejh6ymxljgiebqdHblNQ0ms_NqEHAopXiv0P2s8EBXP_6t9ddyPcBTYrtZ8kCuQc",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Darcia Marie",
                "uri": "https://maps.google.com/maps/contrib/105706199030798744718",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXyhLPNK9aq2RbBtWVgCFz_fGCHBIeoeFoDMXtqUubNkPRy4I2u=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOWek7uzxfFBH7YBSeDH32D6hrwdTaxyvGLDCGv&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOWek7uzxfFBH7YBSeDH32D6hrwdTaxyvGLDCGv!2e10!4m2!3m1!1s0x880e2d126ca385d1:0x76f8fb973971d86f"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJDQ8-FEUtDogR7zbOMXUnLDA",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "1012 S Canal St, Chicago, IL 60607, USA",
        "location": {
          "latitude": 41.869407599999995,
          "longitude": -87.6394846
        },
        "rating": 4.6,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 8,
        "displayName": {
          "text": "Shopping Mall Center",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJDQ8-FEUtDogR7zbOMXUnLDA/photos/AdDdOWoUepoRpYBaIZDrb3rrAo2e7o1e7q7UEODwklZvXw_lijP5irTHNOSD5GCUSDfku1ZWQGV2TgD4DLMJ0pX0MJ3kIrml1YWIVWURvj70C5bw-bHH74BTnlqHUbfi3guxxdxJgAjj4T2SCYYNyi4NxbFefoN84ALuPGTe",
            "widthPx": 2268,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "hjar_ Mansur",
                "uri": "https://maps.google.com/maps/contrib/112310646739478126217",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVU7UxHUWwGsw5Y2VE1AR_7BsK99iaGP8JsmbN4_ELEp5TjhsvLpQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO-yh-3lrPCs2_czpp1EFTjUuNHe4ThDatbMx-D&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO-yh-3lrPCs2_czpp1EFTjUuNHe4ThDatbMx-D!2e10!4m2!3m1!1s0x880e2d45143e0f0d:0x302c277531ce36ef"
          },
          {
            "name": "places/ChIJDQ8-FEUtDogR7zbOMXUnLDA/photos/AdDdOWoEUSuCu4O3-gql2eFjnq0Kxe8KBxYqJWMZ9s2I5fcoJZRjggtnVOBbdVeeIHmlDCtfAPlM1nKzXWELgYQp-cV4lVKMkRCrWIVSg2KvDitwMPT1DnX_Buv9jhUfpSOOpyTibd1axa9QH8SNee_2kjH-GH7oc7rvynpK",
            "widthPx": 4032,
            "heightPx": 1960,
            "authorAttributions": [
              {
                "displayName": "Jesus Maldonado Gonzalez",
                "uri": "https://maps.google.com/maps/contrib/100732560050780292462",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVLtdO5MdUQvtdBDDf_kHzmiDRztwnwgmeHGiStyZMBG-L7y28U=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP4Cve51Mgphguel3s09loM3eDcUW355QOBRxZf&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP4Cve51Mgphguel3s09loM3eDcUW355QOBRxZf!2e10!4m2!3m1!1s0x880e2d45143e0f0d:0x302c277531ce36ef"
          },
          {
            "name": "places/ChIJDQ8-FEUtDogR7zbOMXUnLDA/photos/AdDdOWq9Cyqe_YHXGJc9CZbOMKFM7h59Bw7k7SALi__YvS5XpJJMsZXSFDZtIsumSqtcjK29x8jRrQzBTcxBoZfj3x1pBtQ9VNSUTsaN9v2V8treKi-T_dV1u-sOBVIcUk-3jYvKu5ofNeAIl6lviEVoHq3UaymCjoazG9uz",
            "widthPx": 1960,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Jesus Maldonado Gonzalez",
                "uri": "https://maps.google.com/maps/contrib/100732560050780292462",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVLtdO5MdUQvtdBDDf_kHzmiDRztwnwgmeHGiStyZMBG-L7y28U=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOrkjY-oQDlkBOLk4fO18ZRe064hHc9cCL32O6t&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOrkjY-oQDlkBOLk4fO18ZRe064hHc9cCL32O6t!2e10!4m2!3m1!1s0x880e2d45143e0f0d:0x302c277531ce36ef"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJtVu_5VPTD4gR6gogw1DhmJ4",
        "types": [
          "shopping_mall",
          "food_court",
          "tailor",
          "hair_salon",
          "hair_care",
          "sports_coaching",
          "clothing_store",
          "store",
          "health",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "900 Michigan Ave, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.899611,
          "longitude": -87.6251964
        },
        "rating": 4.5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 2260,
        "displayName": {
          "text": "900 North Michigan Shops",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWp8uuZPiwy62D867WutNhG8tbb3Mr_KF04whPr9mrcwAsAMsMrUwCiU9DnTxqCc1f64L9KOVQ2FctvlQFCkbzZmFdgnCENYCV9Pydyr9i7_pyLI6QYdvt4aSepuCrgME2usvn-m0h7bC44wJNDOn01SvQR7lJWsrXAA",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Skylar Lay",
                "uri": "https://maps.google.com/maps/contrib/107071358191666301223",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX1judpwRNoawUPtS3SeOsoJoI7WOFdqsw1WglWRH3zdAK_-MJZHA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNZaFNx9108iT50ftEwkgl6Qki040vOI-c2S2LJ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNZaFNx9108iT50ftEwkgl6Qki040vOI-c2S2LJ!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          },
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWqp2DMZKwzCDVapHqoc9rANGzQeKlprFJRjgY3SxogqgNREYXIBbz7jDz2MHOnvEAmfjWv-xQHALjcbksNHf224xDWB17eRIkwK4SWsqVUwLfF1nXL1w7vmuQ7iZaRth6ywkduadJjjEx6zzWZb9r_nEthT12-n9nMW",
            "widthPx": 4800,
            "heightPx": 3201,
            "authorAttributions": [
              {
                "displayName": "900 North Michigan Shops",
                "uri": "https://maps.google.com/maps/contrib/105736755539710445463",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWGScepWVfdwjTMcuOwyVatACAPmGuUKjsvtfponmYpahhLHM9z=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP0Mx20wtMLpoP9q7vipTjPUfjqiSl6byhGO9xk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP0Mx20wtMLpoP9q7vipTjPUfjqiSl6byhGO9xk!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          },
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWqNjhN5i_huBAOF_YZN_LVi4WsBAyeK0cI3nQ6W215byzzekBYbV-UtGlJUzrP4m7vdHnW2W2D1BBfDrL-7g1eYzEavCWta0Ofu1N1BliNJHgtu33CGuGysQd7NaLG9O2e_fnjBqlDwyAEjxIUQW5scc3X6lGeqUwI8",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "Z S",
                "uri": "https://maps.google.com/maps/contrib/116501803574168314693",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVrDW-MgoRPKky4hLc4_500EgyHPXJLSnkTeSJPfcMZNXz30TaB=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNHCNmsvzZeUKcBCfPellTzZfuGz54u65MhZK6e&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNHCNmsvzZeUKcBCfPellTzZfuGz54u65MhZK6e!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          },
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWqr2YFJSh8_lEeDLPuo2gqlQwDHw6u9jUL6g_3iCbmwCk0897opLJpmN4NuTEhxiJN0t5B9tsgDYXngpArrdjTC_YinEHBBfxXjNfvYG8pUc1XxFiQ8T6xfw26itCq0oE9OmDUqelPYvypyPrU2Hpp7ZGFwrO99Wt7U",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Xyz Xyzz",
                "uri": "https://maps.google.com/maps/contrib/100610174759931583935",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVJ1wqDTp33x4EHiyhawT6pcJFy-2F3J6Dtu1vJNBiZU2ojn6s14Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPi05ZMMiMBOrET9JOHn4rJnvb18VoXnX8Gmtrr&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPi05ZMMiMBOrET9JOHn4rJnvb18VoXnX8Gmtrr!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          },
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWoz6f2HFsvM5TFdFZVzj7LPqy6Q0vLXPa9OVVVCPs_4EshLwHwD6D-g55_5mVglmsYABwN9MZkFyzogeqlavt4j-NHXWxnvw7Ba0tD4ziT5_buFFXqRqLmx9zI1bnzafZ-ByFVo9fBxfOJ00z1G2utcbHh8MjwCHd_n",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Hyun-joo Kim",
                "uri": "https://maps.google.com/maps/contrib/110208219987975610692",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIxn_kpjdtLRO8kU_-9Uv_v9LKOJteO81NOc7oez0yE2MluEw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN2NbYt_IU6ksv5kA51NMWQBNeyh3ovAoNy6RQi&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN2NbYt_IU6ksv5kA51NMWQBNeyh3ovAoNy6RQi!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          },
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWpaNqA7Y6MM8n09HqAVK6E_Dv1v_J3VCOsCtbkgQ3S33O8jwKs1dfWWaundIlBYP9ODXqMvxNN9t0DqJcUO9tiNgjEBqKC6YvWyqH4G58yB4lzYoyPMRvAzrb19kawSu3d-07uHSP87o7gIWgMlX2xjFM4g1Ejhc-_7",
            "widthPx": 4000,
            "heightPx": 2250,
            "authorAttributions": [
              {
                "displayName": "András Metz",
                "uri": "https://maps.google.com/maps/contrib/110881040673063635595",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIAmbmjaxA3PqIhK-E6fST67AtFr-OlpG_uDV5t0VjTmP0VlA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN0PoeHR8UNz15N2RI2T8eTokof4HvNfS1lswJI&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN0PoeHR8UNz15N2RI2T8eTokof4HvNfS1lswJI!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          },
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWrsLaMqju919Ww7Dbs-4jKSVGgra1SbCm02lk-8MDYqydH-UC1_mPuFpwtbbCsiRdvAeEc59XGlgtXNdHh4oDIKT_x9hJ8XVsuUn6WfI6h1Ii_n6Dasi8J5X2m8lfbU4yaHbI1m0u4FqfNTRIt3kGU-D8eU74d7LV1W",
            "widthPx": 3036,
            "heightPx": 4048,
            "authorAttributions": [
              {
                "displayName": "Kosuke Koshijima",
                "uri": "https://maps.google.com/maps/contrib/107411673477327323045",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUJmKYUBFZvW1n6zxLMlFor2JYB3EP99kpH78s0QpdPO8NtUGexSg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNfQZ9wkUSxUkSznWcEBTU5ZbrAZ_MmhXcEgLvk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNfQZ9wkUSxUkSznWcEBTU5ZbrAZ_MmhXcEgLvk!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          },
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWq0ZO2Td_Dr0G5a4Ne4RPpHzdbrq0-QmdjcTSVvhNwU0U4e71STcUe9i7t47UqgR_4ICxeAqzOJeSssgzQzgt_iOiH1MTncjZZP0ttHgUhTPi4p3gj_W4oXRBk6JUg3HlSsx__m6YCyHU8oRyWKJ_WR605taU-oYGLZ",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Ian Cox",
                "uri": "https://maps.google.com/maps/contrib/109507706918402513920",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUWdtUe8j7kJGOLK16IklwS9QiQEJWJBlCa11yRCB1vFKZnI0BN=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipONcUgQyoOl_OIX4nlPDbhJnZy8V2SaLRy1BCDC&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipONcUgQyoOl_OIX4nlPDbhJnZy8V2SaLRy1BCDC!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          },
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWrqbIyGshGaLTt52ZntPzG_GpPXYQId5WyP5gcueINEwqKX20yLQjRO1vNxg6E6Nfu3LjZbCi_mj4LhqXKgIqVNADy_9eVQe9sVGhtLUXZLoC7im7zbnHMmGzRBmQJ8m8aBTsSupjFbSVHVX5vofNtlmBj2ty6NkNBL",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Dan Logan",
                "uri": "https://maps.google.com/maps/contrib/106897412781711275244",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXnwxGh9ZWcFr2EnyhQRdPnRInPTPDX7DDWyd7DLoGEmrBZHzjz=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPSqYRwUFTsD3y5viS3tVGwUaNaGNJHOI6WgLou&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPSqYRwUFTsD3y5viS3tVGwUaNaGNJHOI6WgLou!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          },
          {
            "name": "places/ChIJtVu_5VPTD4gR6gogw1DhmJ4/photos/AdDdOWqR8GtTmDbcCBASbt3ar49LMeFdUO8AoQz_r-4ekhuYCAlDbTNo47gzVw3ctKGflHhRjd9xlT-Co_9ndXcP8GPfH_-HPBeu5Z3rzx2iahUyfxKGwcXubWbl9J-CvOHWicUCS9V0Seg-VlRG1Y7jBkaqSC4IFErKuIOu",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Ankit Saini",
                "uri": "https://maps.google.com/maps/contrib/113612175866358443433",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWfCtsFf2Gry2xT7jnxDYoJFo_w9ik8SAyKO9Ch_Ao88Lx5g6Ti=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNwDmfFyIzb4Vll1S0gtlERWc2uF8RdWGUKwb_Z&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNwDmfFyIzb4Vll1S0gtlERWc2uF8RdWGUKwb_Z!2e10!4m2!3m1!1s0x880fd353e5bf5bb5:0x9e98e150c3200aea"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJF-F49YAtDogRp3EKsSDSm1I",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "800 S Desplaines St, Chicago, IL 60607, USA",
        "location": {
          "latitude": 41.8717233,
          "longitude": -87.644045699999992
        },
        "rating": 4.3,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 3,
        "displayName": {
          "text": "Mercado Chicago",
          "languageCode": "es"
        },
        "photos": [
          {
            "name": "places/ChIJF-F49YAtDogRp3EKsSDSm1I/photos/AdDdOWpXCKR7hen2Gbn5lEK3V87wecHDZvdrDpgFYoFfbVGvhLCQAAO3iRryJ7JplzUXZtkBdPwr3wli_nxD8RSJMuEP8Mvb-eLeBTdibsOpUFu87B4V5SIieFh9h0Q2DxfwF-3tr_KiceTm9Avr-tNyhb6eHou8jI2-36nU",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNtL4ILDui2gKxxKxvDgo8PqCfwZbRlS1OFwKdp&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNtL4ILDui2gKxxKxvDgo8PqCfwZbRlS1OFwKdp!2e10!4m2!3m1!1s0x880e2d80f578e117:0x529bd220b10a71a7"
          },
          {
            "name": "places/ChIJF-F49YAtDogRp3EKsSDSm1I/photos/AdDdOWpV1tWO_nTj-jq78rTF21znbGwpbyXIAHeXvSzrgE8_7n0GCi_IFqUtPwkaCqSHZZ3MKhpsG0MOdD2RnX_T1KIjOZtxkNJwqU3xRiYHxV8fiq7GR8UA7kyUsG_fkbD_5CE4iD4xAqqJy5qxM1NTSlxEAOq2E5_k6RYI",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNmUxGo0TFI7mjQ0rFGpwguwRU3NtkisJC-cTqp&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNmUxGo0TFI7mjQ0rFGpwguwRU3NtkisJC-cTqp!2e10!4m2!3m1!1s0x880e2d80f578e117:0x529bd220b10a71a7"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJ0f8Mmu0sDogR0CHup6YS-Uw",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Chicago, IL 60607, USA",
        "location": {
          "latitude": 41.866686099999995,
          "longitude": -87.6417214
        },
        "rating": 4.2,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 1813,
        "displayName": {
          "text": "Joffco Square",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWq_pXo5QQUPNtpi9t8PeN98aGNdkS2pF6YsUiGgJm4_3WiTBFLN9Q5C1Q3V9Zg_l4sNSnwxQlKaKP3PkvjjLqM-Z43gIySMPRpebuHAWD3i4eJ9im2D2XNmQTjoQmCRe7AcQiHc2S-2X3wkQATDWpZdrfz4CfDO2Liq",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Amiete dotme",
                "uri": "https://maps.google.com/maps/contrib/115155564169675103716",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVHWgv8VrSCA13ql28mtRvjt5uiQu00wiBBoupLifS3rRsiCWmDPg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMTgT6HZij-4DuF_lf9Spgu077c_jhL94Afy-yj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMTgT6HZij-4DuF_lf9Spgu077c_jhL94Afy-yj!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          },
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWpY6RSHs56_BsSygNC2iGB0ZqnpljBhgGkuqcFnHAMYvdtiRdYWGdPEB3KUdHH9Iil44brD09R4SJeWTc-68PQWM93bCfo8Beqw_6OcsT6sKPFpaEC02xXanRqugIW2TsXcuARXtaSqa7jRo7CR39cb0Vw54x24DAhK",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "Amin Abbasi",
                "uri": "https://maps.google.com/maps/contrib/106337532385741497926",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUkNhTazlfmVbQf1fRjEHkJIyCEVUrWtZyPtAjLGKLORO4ZpEoeFA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPF7tSw9VDgSmkIHt5o0w6P0sO41hSeKJKtaA-R&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPF7tSw9VDgSmkIHt5o0w6P0sO41hSeKJKtaA-R!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          },
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWoh9TuWQPOmhewrVCCZmREl7B3EhSqdUF6CIssxzqrIoimu8hC_QHMPT5Y0neCuImMksYqkg8nQCVMxfs5Q2yGiefYFHdKTEebuIuFfm44f4qB5BQJ8xXXv9a8pzR0BER-ZyOujLfNdZ-dr9a-hzY17tIIrcKWIrSRY",
            "widthPx": 3312,
            "heightPx": 3344,
            "authorAttributions": [
              {
                "displayName": "Stuart Docherty",
                "uri": "https://maps.google.com/maps/contrib/118296787836279653979",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXpSJSMVdiE-ZvTHNNbFeZDKI6c8SunBTV5yezD2damGE0gm4Jfeg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOTIVB8iscdaHql4oEDcVNUGF_ozbboSqAF3oWN&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOTIVB8iscdaHql4oEDcVNUGF_ozbboSqAF3oWN!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          },
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWpITrp_plSqa36a0l8UiiJOfTi-YGn3gPq3Mxw7pQzyp_mt28xothbuYGscCxp5uztw7aGRAh-Jmf_V3YjwrEzcKZ-PEqwYdwbAxXLH6cWvktn0_JoO8eSrfl7OdT9ssjfe7RtaVoynyz0-LW3_v1B-qZe-ApdeBLq-",
            "widthPx": 4096,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "James Melton",
                "uri": "https://maps.google.com/maps/contrib/111151794063364494223",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU22VuEM2IzHS_eBwsOb8g-pquxu2RPF_eMUoDtSATtcihekySW8Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMsg3Gyn3NavvHK3A9cLOaPO_WhnMIBmJEAbn-x&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMsg3Gyn3NavvHK3A9cLOaPO_WhnMIBmJEAbn-x!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          },
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWqEA3ELY-0m8wTevihWcv3kyf9B_tWinIH_nGDX7w-xZYC2NHVjfy5pmzJdji7qwKnoo5kt2D5U8MfDdyEZKRZkXO9DYq_NG3gQqBFQ6YcautoR9HSzjxWKAxhPMZ_v4rvRQRz9Xw-ip996SZHrs5EcSE0Oc64LIf9g",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "Amin Abbasi",
                "uri": "https://maps.google.com/maps/contrib/106337532385741497926",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUkNhTazlfmVbQf1fRjEHkJIyCEVUrWtZyPtAjLGKLORO4ZpEoeFA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPCxOi2HF0L-zG__In1WCMGKSJWgDONnyOR7-aZ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPCxOi2HF0L-zG__In1WCMGKSJWgDONnyOR7-aZ!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          },
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWq48hvRySUXDPAShdJlWKM1ycUeFxUV424BoTThQoaOb6MiQ6lfFzPnyI6VF-03h-BP6waBTtMXmzKkZeR9BP3R--0U4lmWCGwL2bxNJj7FcfEdXU27tph8ziRG9U-q0Bp_RsvKuiL7FRgu92cO_gTMGsIi6iqQq_QP",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Rajan G",
                "uri": "https://maps.google.com/maps/contrib/116792816527085964725",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWSMTyOXBe4FayZnXEbKz1bvCd7F5HLqOOP2EdID1nrdcauF8zAjg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNJtJOr9Dd_74JkZflEh1092kqeoeDBAU3Wby32&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNJtJOr9Dd_74JkZflEh1092kqeoeDBAU3Wby32!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          },
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWoM3CXil_mRXwA7EiIuePcsJs-0QZ2uSr2kFgH2RJ5MuAoiWgRmWKqMC9kDab6MfG6mXqOksIYYyOzWNcR1UibxCLDS-UfizwAQu7hPNHmPMEUOBNWW-X8wlYJnPo3qX9g0ksw61gDnB1ilO_8eC-drFuGfUlUT5gKY",
            "widthPx": 3840,
            "heightPx": 2160,
            "authorAttributions": [
              {
                "displayName": "La Escuelita de Martin",
                "uri": "https://maps.google.com/maps/contrib/116489562603861286353",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWJajbmHMmxdRYDjpm5973ZKbEjqPZd4TvdYgluzAjUsuWPiGljWQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP2aggW9nXU9S6UYTazK4fAscQYhIeU7A--Ldtk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP2aggW9nXU9S6UYTazK4fAscQYhIeU7A--Ldtk!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          },
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWqsfvQB9ErN5iZ4cipLwxD5IvLLHCHIRn5_mP8K5IMBTvqHTMjEYh-u3NQlgIlZINHYvoZSOLityGS9qbLcjQajt_bFoPU4PAbtatjUO3ni3XFY93LeQOQlrBp-RVRWFY2H5w0XBkftDCW3k_smtwcy35w5Vc7kcUnf",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "Amin Abbasi",
                "uri": "https://maps.google.com/maps/contrib/106337532385741497926",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUkNhTazlfmVbQf1fRjEHkJIyCEVUrWtZyPtAjLGKLORO4ZpEoeFA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM1n5b62Ne93OAM0ZYkb_5jXF2gziWV5lUOSjki&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM1n5b62Ne93OAM0ZYkb_5jXF2gziWV5lUOSjki!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          },
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWoPiUpA-IY5fJgAzwu0XHs6dpyEmqD17fnaycaH4lAs_Pdm6MWiTWG3ibZ0LJ66SV-p7gOgRiCrfdcZuQFfEYFXReXv7z47kpnzmtR3WQ0eZLN3DGGpwRd7cLzq296VAWqlKxN2i-9iUYavfGB0cMjFPWe2Eq3cLb17",
            "widthPx": 4640,
            "heightPx": 3472,
            "authorAttributions": [
              {
                "displayName": "David Diego Rodriguez",
                "uri": "https://maps.google.com/maps/contrib/109418560035476426012",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUOjs-hMPx63ECw9uUPe1_TvtTakw13HM7-OltqMq_0gS6E_0CP7w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM1aP4Q1RucFj1To-W62v_bWeSbz4yKtuKDM6Wl&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM1aP4Q1RucFj1To-W62v_bWeSbz4yKtuKDM6Wl!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          },
          {
            "name": "places/ChIJ0f8Mmu0sDogR0CHup6YS-Uw/photos/AdDdOWomoZXQM1DbuoMoFy95kCg2nRypKgXhH4X2LfrM9Jo5n82sl7ZNYKQjEehNZZbmRSbg0SY7Kwah4GZ_6cUBfFL1RIxiQhCLFYCBcJaP8VsD5hSWv6hGH0o8i3EAn3V2qjs0cV-PKRbOJfTztDM-Qd4GT7zljB6G8UEZ",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Rajan G",
                "uri": "https://maps.google.com/maps/contrib/116792816527085964725",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWSMTyOXBe4FayZnXEbKz1bvCd7F5HLqOOP2EdID1nrdcauF8zAjg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNnYbUtJDdfp9IT5UGRJ_wip61kYwfMBYy5BK1c&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNnYbUtJDdfp9IT5UGRJ_wip61kYwfMBYy5BK1c!2e10!4m2!3m1!1s0x880e2ced9a0cffd1:0x4cf912a6a7ee21d0"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJ9wkKLAQtDogRDHDE0ePzUSk",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "601 - 627 Roosevelt Rd, Chicago, IL 60607, USA",
        "location": {
          "latitude": 41.8669315,
          "longitude": -87.6434043
        },
        "rating": 4.8,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 15,
        "displayName": {
          "text": "Roosevelt Galleria",
          "languageCode": "en"
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": true,
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJO-73RCwtDogRtJnO2Y4tOgg",
        "types": [
          "shopping_mall",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "W Maxwell St, Chicago, IL 60607, USA",
        "location": {
          "latitude": 41.8648798,
          "longitude": -87.6467224
        },
        "rating": 5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 1,
        "displayName": {
          "text": "University Village Maxwell Street",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJO-73RCwtDogRtJnO2Y4tOgg/photos/AdDdOWrjQRL765UL5LXDpHwK-8MDM8JiYksgNZxop3X6h_VcyoGz35lWVj2D9J-O10BoNHXfH7eX0c6DT6SMVcJH95A7SE6V3xyaffE8jD4HkPLgK6LtqYLiHNvxWDEc0tJWCqQqhc50eqZlAFWreY8tCGj224fTUaEZFORu",
            "widthPx": 4000,
            "heightPx": 1868,
            "authorAttributions": [
              {
                "displayName": "Sev Nd",
                "uri": "https://maps.google.com/maps/contrib/110078407867592006392",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLgKrIQzITvsbDY8Z8SXQpmjMhAUaaEZxXfanvzaT618nlL6Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOlhraxTSMCF1dZzII26sAkUxbAW0CfvYhMy_EI&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOlhraxTSMCF1dZzII26sAkUxbAW0CfvYhMy_EI!2e10!4m2!3m1!1s0x880e2d2c44f7ee3b:0x83a2d8ed9ce99b4"
          }
        ],
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        }
      },
      {
        "id": "ChIJ-Z2sQaQsDogRoANuN-Pkyuo",
        "types": [
          "night_club",
          "bar",
          "american_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "12 S Michigan Ave, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.881662,
          "longitude": -87.6249685
        },
        "rating": 4.7,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 314,
        "displayName": {
          "text": "Drawing Room",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWozbQiSiC-keP31shew6emo1K9ZtV-8dXLkdzNpZRFI_hYN46WyoyP9kOM7HDOnE9SVC1YFLOZb0C99L2d3VH9ufUrdZCqs_0l-uXceDHZwPupQG3eMbzRoudh8UcW1D-IPBv3-q8PCU-L0Hvw6fuuKC-r6MLumFnj-",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Nick",
                "uri": "https://maps.google.com/maps/contrib/104809443152081557062",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVlfmjwHYrmwGDSLSDIH6NKXDPfb_LdB1GsxuRu-4jNLi2VsL9U=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNKCm7HKmLHVb4yhVSdMj53-1Shh2tVgihPzim4&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNKCm7HKmLHVb4yhVSdMj53-1Shh2tVgihPzim4!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          },
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWrorCm-zVnNIhOJVrMWEJIWHC_GSEyRhispK4EKLY_A9tOe42mMMMyW630eIgXI4HxXxFCJXGY5RK4t1vge7voobwdz9Azdm1sfQCws5h_uwP3_Vj5Lrjwoz70LESs9F6zBV1vX7aaQygB1Zl0H01RM0_3hWH88VI1D",
            "widthPx": 3072,
            "heightPx": 4080,
            "authorAttributions": [
              {
                "displayName": "Neha Singh",
                "uri": "https://maps.google.com/maps/contrib/116539641600322938092",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUbTd-_fYAOfjGW9VJ1LRKhMcNSOIxXaj1EythPGMHi7H5kppoBQQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPX2iWOFx7IUdeElc8TFANEgNf1p-ilAwsb6t0_&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPX2iWOFx7IUdeElc8TFANEgNf1p-ilAwsb6t0_!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          },
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWrKzBkZJakGREZ5BQ2fqXcKUvn9rDfGobV2SKgcyxcHtyguYENREGyVJw0u-WnZdGZMiCTyOh7TTmWiTdbFlqybt2CVkcq-w9LErLdawTRZX-wMY-QwxQd4niEYYtQLIkv5x11oIZI_pWCi3d-sCy1p-od0zlhEAOaL",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Shannon Hawkins",
                "uri": "https://maps.google.com/maps/contrib/104560786571493675941",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXUYWVgDjYTYISf9RJAxdvPaDNQDplaFxeBWlIXlcpvqTToDbngrw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMCbKcGQILnt7VsZHKmQDUeODR0I8n_eo58mxFM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMCbKcGQILnt7VsZHKmQDUeODR0I8n_eo58mxFM!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          },
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWqyCdhRyMfTuJkxIcAr4QIfgz_AYdP2CP4gjP-YMd5IrszGvD7z9qiujk-pHa_LhxhHQk0Dj7c6QuW-iJ2vIy66xro370mNhFxkvu6Tg_gRkGLYvev9VdOtvbdbcCG4HXmarbvbKpkIXVwOcjtxuVXOwBpfbDls54F0",
            "widthPx": 2992,
            "heightPx": 2992,
            "authorAttributions": [
              {
                "displayName": "Joanne Philpott",
                "uri": "https://maps.google.com/maps/contrib/110958575895531012764",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUk8inhzb3Jyugo5989ULqPbR12Ogyb4TUo-yVdLjPaWfEMMjw1VA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP8Pvh824Qtw3ERUDhQbCnAETQsWeeW_oVCZUhF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP8Pvh824Qtw3ERUDhQbCnAETQsWeeW_oVCZUhF!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          },
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWovYhoctyeORrZsdkMeUk7tRXrBIyVU2n4RmY54b6EAN7chxnYHjw-9WMzhI9XQXZY7B1iqCI18-mr2d9fFeCHKqp4wAy01S4OSNR0fh6-mkLWVjWkBhXKA24qqvo2uxQF9Bm4C3g2WZ71WVCnpyt9N1kRqO7aO-qg",
            "widthPx": 1167,
            "heightPx": 1471,
            "authorAttributions": [
              {
                "displayName": "H.H.H",
                "uri": "https://maps.google.com/maps/contrib/104413336382587549649",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXBCzHUhuF9KTCyIr8TxgvN-UYhBNNYDHusCCToV3cd5lZ1gCg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP-KxoxndHuuwkgZhiuUVv6aH0Z2k1vQ6Kq_kc&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP-KxoxndHuuwkgZhiuUVv6aH0Z2k1vQ6Kq_kc!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          },
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWoGXunDKt4EQbYy_JPop1foIGB5stFcIQXDx93_FpIGA6qbyj6eW8vyWXIcm44Y8ELbGV0MMIOEgPG_KzKg6NsFRFQlUj6YdfRSVwrHt-HwtBstnaBsKprLJ4BueFM27Pj-4Vgc_pGIlssaX_Kj6U-iN6xIc7OezUm0",
            "widthPx": 3609,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Olivia the cat",
                "uri": "https://maps.google.com/maps/contrib/112119136180969116240",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWdXQWmj2xFFP1ZXDlc8ZV1iNa4KGUqB72u-W0DyH0Iq5mzAA-3Ow=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNnOdPIA2Zii8e6qfIZFGKtVLfJZRAwsfyLG0sj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNnOdPIA2Zii8e6qfIZFGKtVLfJZRAwsfyLG0sj!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          },
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWo1rAJFLaTVvYQtlnpcALv-mTLFa5XiDvquqfhF_PsTmP64LKsbh087rlLpoaZIi9sNIE2yaKSyMZ0LcEioh8xQ7DkwQe1zmZkTqvAiZTPE7PS-sPZDOQEMUj78Bpm8yipY4YeT-ATxL9aRfSy2A8O1qmY5jebNxTsu",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Fernaldy Sutandyo",
                "uri": "https://maps.google.com/maps/contrib/111511884045681466077",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLB14mPn_kiRzSeHbiBn3uI0Sk9ET0ORqWEA2l1Vw_Qa49rVQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO9jyCN2hFNd9m3RsgYS4C4Xljy7FMCLJXatp3V&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO9jyCN2hFNd9m3RsgYS4C4Xljy7FMCLJXatp3V!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          },
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWoZONoEG55tDa1BIjNvAw9fuL3gJ88OVgKUT1EWmH6wrCMW5eCyKaQBpGRZ8yLKB3USmFKmIXhVy2zFqinmklwrrXu4MrYLeJ922C5aYPEvoSACztsAeDScGfDraEfHSMNuoof7eDNlbnT7yQwZIl9SgYY-bx6-oIw",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "Zuul the destroyer",
                "uri": "https://maps.google.com/maps/contrib/116053784568718562332",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWiN27UccyVIAzW3ZqsQKYQm_cO_y_2Il2rLluGQeUR33VL0E8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP0_hXwB-G09gqaC5u16BoWEVf3UORhlgjCNvM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP0_hXwB-G09gqaC5u16BoWEVf3UORhlgjCNvM!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          },
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWpDcPniTqjawOu0hG0vxjFcIMRC1_cdz1cfqUsI4orMVbUpm9OxXxMKfbN0fm4fMJ-mVo8B6GEksM9p_5gFjx35ft4Ke051I9TI3XsSIbGXEDJxPodD_M9TY4sRqye9OJ-HKitSRHinH2Kgy0C4oLdzTPfOQV93azk",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Ann Louise Tisdale-Ramos",
                "uri": "https://maps.google.com/maps/contrib/100713817876087446082",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocL007HXSOOMKt3OjXKtBfSBySYmxWDcvdg06ODQxIoDu0gkEig=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP4XqFMvWZitl6vBM7DRKA84UBv61uIqk5w3lM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP4XqFMvWZitl6vBM7DRKA84UBv61uIqk5w3lM!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          },
          {
            "name": "places/ChIJ-Z2sQaQsDogRoANuN-Pkyuo/photos/AdDdOWoB_YJsI-Jh3koe4FIho6QQrsbGTC0U0idJg3zFjEkYEsCA7qQTV7GC2aIDSH41KKMKRjfMfBRL-QJXtQiAEV15wk-MTnm5rwRu_oEnVQVCXfR97NZ6WBvpN1KqUUtq3ZTkJbd1NH7ibPt-6SGmlKwu--lOBhOpTJW6",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Luke Chitwood",
                "uri": "https://maps.google.com/maps/contrib/101839846888030512028",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUHiE3f6JI8087CPCMzn6QQ_3a5HSo-YRr1hOdX7QLtyk6ClsQT=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNlIIHdMClqHj2_ksbms2LP-XTdBwqiDhZz7TKP&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNlIIHdMClqHj2_ksbms2LP-XTdBwqiDhZz7TKP!2e10!4m2!3m1!1s0x880e2ca441ac9df9:0xeacae4e3376e03a0"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleParking": false,
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "10"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "20"
          }
        }
      },
      {
        "id": "ChIJa7JMLqctDogRaastmSK83fc",
        "types": [
          "night_club",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "Aon Center, Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.8852516,
          "longitude": -87.6214919
        },
        "rating": 5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 2,
        "displayName": {
          "text": "Braceria Se nni mondo esistesse un po' di bene",
          "languageCode": "it"
        },
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleRestroom": true
        }
      },
      {
        "id": "ChIJHULHWu8tDogRs7tOspUzcEk",
        "types": [
          "night_club",
          "bar",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "1-11 E Lake St, Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.885631599999996,
          "longitude": -87.6276253
        },
        "rating": 4.2,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 6,
        "displayName": {
          "text": "Chase Lounge - Chicago Theatre",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWo6EME5M1cIbOelC9Zt9_uso-xoBuijub28_AcXId5NgJ-m8L0HfAnzAkLgHJuplIgSNIogJAdloksE1KuReSdIPuildPCT4yWxA5uaWpNAiRjpmLaXAE-JqP7GNYAWWfRnmtTPCr7OgLoPRzFBWwo8XMc9OK3CX90N",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Perry Knotts",
                "uri": "https://maps.google.com/maps/contrib/115183812511941616504",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVicIcPjVReZyIMZ8otwOlMO8a-K2bNHJg4rqKb4ioEDL82SMgB=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN4Y6pwbCw9GGnfA-_1UHUIBW_mQZx49QFCb4fq&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN4Y6pwbCw9GGnfA-_1UHUIBW_mQZx49QFCb4fq!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          },
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWpvbm2xTI2npq323eYfviUfJDbm-r1PBsYEUEcLk0Y8oBJZsoMAEM3G8tNoQxEs2QLV2OlkyS_eyVZiz7PYFLoBOlYHVYoqmytRU8k3EfYZDlQ8YnqFXAGu1srZNeMYHOrZsVkDMDZYrTNnFnkv68QuEfhdRnGyrY_S",
            "widthPx": 4032,
            "heightPx": 1908,
            "authorAttributions": [
              {
                "displayName": "Ralph H",
                "uri": "https://maps.google.com/maps/contrib/115080162451903876898",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW7ee7oa0scCDFb_9z_rbgMUVdkk5-lRRZhFOvQAifc8JWqjcUBUg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNTo0Bb0fUthb-ai_bief0gkISD4Dkn6sbfVhuj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNTo0Bb0fUthb-ai_bief0gkISD4Dkn6sbfVhuj!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          },
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWqYf2JM-9IzYnx5DE6ED8UoChDIPpqxGwiN6-UWzqnf-iqfI9KiWiEWCvk1JPu5QI-rRLaWcucIIk5nMha8u6L_-lnd8fw36046xPb3xYy03kQUjuy6tHZaxV2AICBUEJtc91bsFl3tCVtQKUrrfuuLMnFR0Q-1usHZ",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "David Sazama",
                "uri": "https://maps.google.com/maps/contrib/109110219130678358349",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUT3u3c3Qeh_jBeaLUfUOoKPPCWg0Gvl3a0h7-okFZwxaVBDHM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOt6gjAvJT162bQmHiVyX4pAroPIMKhGac-YWgQ&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOt6gjAvJT162bQmHiVyX4pAroPIMKhGac-YWgQ!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          },
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWpL_NSgNzWzyfhp8P1IKDV3N4toBM0-ruHQqkOm9eaN7tdhn3SkHQJOYEpH2KRFb4ZgnM7Pk_lJWYUWbubkjAZsiwl35NWfNbqIwM2185jDHedl1c4txMNh2si010ea3k0eTU5lZT2pHQS9aiVXMK64goEDmSUn7411",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "David Sazama",
                "uri": "https://maps.google.com/maps/contrib/109110219130678358349",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUT3u3c3Qeh_jBeaLUfUOoKPPCWg0Gvl3a0h7-okFZwxaVBDHM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM7ra_k8z5fVPFgqlnCXeWN3XALJBxIfTxkMm4P&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM7ra_k8z5fVPFgqlnCXeWN3XALJBxIfTxkMm4P!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          },
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWqDTyBFrVblhMhri5QCO3h3N7AY3hR6NhHWNVtq4_rWbJ_jXd4yXPoYtmbS8RV3wzi-fpZ0iGuAUX5y58DVMZloDPxMfPXzddxhC5UtwMjWvUxcxIhj9xWUiVQ03w23weDEB_xc_eL4IsvjyveaZkBolDJlXV-i2TT1",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "David Sazama",
                "uri": "https://maps.google.com/maps/contrib/109110219130678358349",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUT3u3c3Qeh_jBeaLUfUOoKPPCWg0Gvl3a0h7-okFZwxaVBDHM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMinaLqhDtajagpFQcvXKyWASbDygqU1GQLZNcK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMinaLqhDtajagpFQcvXKyWASbDygqU1GQLZNcK!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          },
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWpX5u6GcyxFzX0NpnsUaKpwWuOb2ZBHExhHffLRwjZcOrgWVR9s8fCJ__JYPFyvp8RCSj85WQosSBzEd9NhZklp1bWti49NSwlhLwcbZCPKgIb5UahPPVUHFzHQiX2yxakZYdKkA-Y1C4GxBbVwhBaJD0A3xA9u8psf",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "David Sazama",
                "uri": "https://maps.google.com/maps/contrib/109110219130678358349",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUT3u3c3Qeh_jBeaLUfUOoKPPCWg0Gvl3a0h7-okFZwxaVBDHM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNAbztjnJsi6kEl1uxUVh1v7aMXo2ml6eQaZFwR&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNAbztjnJsi6kEl1uxUVh1v7aMXo2ml6eQaZFwR!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          },
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWoJ4kIE73FdCTPUTi3UzxYy9gIqDpyEu2xcRxq24vBSMp4bQqviRtqZ0NLr_8BDU_1SEODZsvOtk3k2Ti-DRS25EQrHgIb9lSSgxL0egKLv-hHeNdjfkcYL2cFFsXMCcV4DQd1WBvU4Z9rtV1IlMoY7DoBekuXDF-fN",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "JOHN HENAO SANJUAN",
                "uri": "https://maps.google.com/maps/contrib/116260332179655885992",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWWWFePiW99K613SMLROH9Pq8hRo1iqkrIsWUGyh7p7Vt44Mx5a=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOquAk7uv87OXUD_SCQeesNC6hsYNt0_azpNNLs&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOquAk7uv87OXUD_SCQeesNC6hsYNt0_azpNNLs!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          },
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWqU1dfJ5nLdqtAPywTVl4iu2AQYPG6YpdZJDaQhUUJ84o3ie8F9N757TT0fl0m_1qHeNxsozQKBhJ4IQ44-WjTCTFcH0ea52ltf6caYftADzGW-KqfR_IwZ-9lQ1aBMLWpTSX1JmlyGEDuOiGlhEOiJ6CZa_T0fxLPf",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "David Sazama",
                "uri": "https://maps.google.com/maps/contrib/109110219130678358349",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUT3u3c3Qeh_jBeaLUfUOoKPPCWg0Gvl3a0h7-okFZwxaVBDHM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOZiGE52k4tC3Vz9Ct70lHFEJMss_V0IR3tON7d&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOZiGE52k4tC3Vz9Ct70lHFEJMss_V0IR3tON7d!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          },
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWoWeIiKcdEicYdFt3RhSAPW07etA9IphaQLAlrzBuZq9a9drvcLEH3sXwIVvQxdOwiQGHNOMh6m3zSadU8xKvODmJYxdrosdvuVNykZQOjXXH_vr-W7ITJ_vUpdJuhajPD2aIqzaGdU9rxUznPSRyFF8qn6NmSrqefX",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "David Sazama",
                "uri": "https://maps.google.com/maps/contrib/109110219130678358349",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUT3u3c3Qeh_jBeaLUfUOoKPPCWg0Gvl3a0h7-okFZwxaVBDHM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNExk1vO-ybDHbBQ7P86N1YPi84I5icHCdnvBI7&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNExk1vO-ybDHbBQ7P86N1YPi84I5icHCdnvBI7!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          },
          {
            "name": "places/ChIJHULHWu8tDogRs7tOspUzcEk/photos/AdDdOWp7R8HPooACCtNPzTt7zti11W0hFaOe3bxkzKihEdyTfNFPjIgkAEH0OhZPlEGu1aEnA_VWB2D7-EjlJGPOPChavFeLA2V3r0hMdR5MsRk2PmUbZeNIQ3arrR85TfJ0zuOgWNskF_GmVNBUofdcGzy-ztoYZl3BU461",
            "widthPx": 2048,
            "heightPx": 1150,
            "authorAttributions": [
              {
                "displayName": "Vani Epelbaum",
                "uri": "https://maps.google.com/maps/contrib/116301959124140854923",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVKkoZxrPVPJ9AQvWbepnfcTEuut5D8KyjkV97G-qmriPMJo55D4w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMJEkjdOkPLxJA0NCQIzi4gT7zOrmmpJjyD3E81&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMJEkjdOkPLxJA0NCQIzi4gT7zOrmmpJjyD3E81!2e10!4m2!3m1!1s0x880e2def5ac7421d:0x49703395b24ebbb3"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        }
      },
      {
        "id": "ChIJuVjsyqksDogRqaQAtVw4KhQ",
        "types": [
          "night_club",
          "bar",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "E. Wacker Drive 323, Swissotel Chicago, Chicago, IL 60601, USA",
        "location": {
          "latitude": 41.887254999999996,
          "longitude": -87.619508599999989
        },
        "rating": 4.2,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 9,
        "displayName": {
          "text": "The Lobby Lounge",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJuVjsyqksDogRqaQAtVw4KhQ/photos/AdDdOWrcG9KtsvfzQ3G_D_TydZXwbyb6d2kUmSmbpNLzA7Y-QwStkx8M41wdaMuycAQpVu7TGaRRGnrH-vZA43sIzT8MAdi_Wyn2xLY3TpPum95b8gjcEQO8IgbKZVT6oh4byeloRfi6PxdLGi2lWHbWd-fjWBnlyxxYRWXB",
            "widthPx": 4032,
            "heightPx": 1960,
            "authorAttributions": [
              {
                "displayName": "Diego Raijel",
                "uri": "https://maps.google.com/maps/contrib/112250168912456641655",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLL9D0R-opX1JrMg6KMmSjJo3j4Gqv-yMS31TBOhOldWzuaHg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOjed403d611VBKmVfyoQgiHdcDM7J9tWv5cynA&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOjed403d611VBKmVfyoQgiHdcDM7J9tWv5cynA!2e10!4m2!3m1!1s0x880e2ca9caec58b9:0x142a385cb500a4a9"
          },
          {
            "name": "places/ChIJuVjsyqksDogRqaQAtVw4KhQ/photos/AdDdOWq2gD7KMzg6z6hMqXC2A4G9BCLTrJtQ4dH2cqidO-70h9aVjStWvk7mgUHa_xrbSOunsHXzEZeqbNwHEn2bdzsSXgshrQ9WCx31s7yC7qAHUI2k6MVzat6_YThNTPyRSzyBOzMfF4fFrrJHAlZPwYwn03aUhVPKzKen",
            "widthPx": 2048,
            "heightPx": 1536,
            "authorAttributions": [
              {
                "displayName": "Nida K",
                "uri": "https://maps.google.com/maps/contrib/112416474096653420487",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLIArCaG3MU2XkgrEgLvMp7erp0tnHg7D4D2gOfs5HlOSZBw7k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO2JSFPvKnQszFYYBS38qN98PkP9UKpLf05fm27&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO2JSFPvKnQszFYYBS38qN98PkP9UKpLf05fm27!2e10!4m2!3m1!1s0x880e2ca9caec58b9:0x142a385cb500a4a9"
          },
          {
            "name": "places/ChIJuVjsyqksDogRqaQAtVw4KhQ/photos/AdDdOWqqnZdUDwD0Hs8mxImwjqcwis9INON2HibfjIpZQzTdL3dcC2MOi7agZWfJzgpSnrTCBZFDuH4aMIB80s2V_hjfcuyh9vtdpqPd7KxVnUZVyJU4n-7sDsHDJHeWQ_PBXquU2qAgssaRZhpDuOYSUFEtRm54Up1Md7L5",
            "widthPx": 1536,
            "heightPx": 2048,
            "authorAttributions": [
              {
                "displayName": "Nida K",
                "uri": "https://maps.google.com/maps/contrib/112416474096653420487",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLIArCaG3MU2XkgrEgLvMp7erp0tnHg7D4D2gOfs5HlOSZBw7k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOmHxuGWaAtWw88k8I2QswSRIsjkOQ2hFIE8Z5n&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOmHxuGWaAtWw88k8I2QswSRIsjkOQ2hFIE8Z5n!2e10!4m2!3m1!1s0x880e2ca9caec58b9:0x142a385cb500a4a9"
          },
          {
            "name": "places/ChIJuVjsyqksDogRqaQAtVw4KhQ/photos/AdDdOWq6aMHzBXqF-6zCKkSTAJp3mTB0lMtQxsj7_1O0us_5EbkFaeEGYT-kx2Nv4TlMCJ7aQ-vynWQSDZcHSiwDv1gf4NhwKSKDmHncj7OOTLmHeut5kNPTPBj-3yl_zjC39tJGxZDLOJ0CB5jUzZEhCIWBtMGQrLe6eky6",
            "widthPx": 1536,
            "heightPx": 2048,
            "authorAttributions": [
              {
                "displayName": "Nida K",
                "uri": "https://maps.google.com/maps/contrib/112416474096653420487",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLIArCaG3MU2XkgrEgLvMp7erp0tnHg7D4D2gOfs5HlOSZBw7k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPBGpUqLTd1U0hUmZ6zCD-ow_WBHdprRh-yCU2F&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPBGpUqLTd1U0hUmZ6zCD-ow_WBHdprRh-yCU2F!2e10!4m2!3m1!1s0x880e2ca9caec58b9:0x142a385cb500a4a9"
          },
          {
            "name": "places/ChIJuVjsyqksDogRqaQAtVw4KhQ/photos/AdDdOWosTRF1a9uGl_a2yXZZSlwiGmdEGoAyvcNEF_UZeMxq6pVcbbNuuJQu1cO04an_GMqGyLgLARHafQoG-APvElvpuqbEMH194QDPqUHfWtCogLW1reVeJMKV6rFtXu_BVZlmxp-Fbmdk4qBRkT4EEfTG6Y_nS71n9KPN",
            "widthPx": 1536,
            "heightPx": 2048,
            "authorAttributions": [
              {
                "displayName": "Nida K",
                "uri": "https://maps.google.com/maps/contrib/112416474096653420487",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLIArCaG3MU2XkgrEgLvMp7erp0tnHg7D4D2gOfs5HlOSZBw7k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMwCcEOZo10k4bWvy76STvRFabD8PYrXR1b7O8a&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMwCcEOZo10k4bWvy76STvRFabD8PYrXR1b7O8a!2e10!4m2!3m1!1s0x880e2ca9caec58b9:0x142a385cb500a4a9"
          },
          {
            "name": "places/ChIJuVjsyqksDogRqaQAtVw4KhQ/photos/AdDdOWoyWB6CyJwTQqH04dFTcRecNeGQ_WFB1Z3hnl0EsLVK5oeDRkwBl_TyQlW2Ue2J9Nvx44kSDfadUqUothvnaDXfrSSlKLp8b2prIxQDljdv8tBP-Z-P_aG39dcuyPHUN3fDAaMlnUPL65d1e383M7cUE5R-mfluJHzd",
            "widthPx": 4032,
            "heightPx": 1960,
            "authorAttributions": [
              {
                "displayName": "Diego Raijel",
                "uri": "https://maps.google.com/maps/contrib/112250168912456641655",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLL9D0R-opX1JrMg6KMmSjJo3j4Gqv-yMS31TBOhOldWzuaHg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPmz82Aj_xyeeRLtxNsR0B8aMlflkPKpfSKY3Q-&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPmz82Aj_xyeeRLtxNsR0B8aMlflkPKpfSKY3Q-!2e10!4m2!3m1!1s0x880e2ca9caec58b9:0x142a385cb500a4a9"
          },
          {
            "name": "places/ChIJuVjsyqksDogRqaQAtVw4KhQ/photos/AdDdOWqq7OIS3c5APldCt4LABG-soW7XWntvsICTETdnYI7O8-epA6_KyvS_HM1sgbxYAor5UlxIJs6iybcKxcdepgXp27CYFlMX-mhmEJ7FHWsuLXMKJnx6QTsCRu8rz2EtPLNafrYAOt5Z-YILlRJvzZ70NXY7jNJ1p_fK",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Jimmy ZoomCar",
                "uri": "https://maps.google.com/maps/contrib/113895108634733144790",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUAKaIAS8nwATP8Zhjp5HES3fcWPfSXg0lzrpqtJUUUYX8sky0q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPoAiIUNzDrGHbsyYh8xMbWveQmZ0_ztQRfM2fu&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPoAiIUNzDrGHbsyYh8xMbWveQmZ0_ztQRfM2fu!2e10!4m2!3m1!1s0x880e2ca9caec58b9:0x142a385cb500a4a9"
          },
          {
            "name": "places/ChIJuVjsyqksDogRqaQAtVw4KhQ/photos/AdDdOWoNIGXnIHgL_OuBDA3ZJ5V4wlOFMX_DVF7e0J383Fq1QEIApaThg0aD8tOvmjt7Vohrb9R6jDxpWhJFd7XgseMJYCBvDw7vTwlDjbnW7oNf_f-Ep_SmVWUPT8RvHJB9U3LWIZWEth_mMRWOrrsMDWaf2Y_VPOpkrTfm",
            "widthPx": 4032,
            "heightPx": 1960,
            "authorAttributions": [
              {
                "displayName": "Diego Raijel",
                "uri": "https://maps.google.com/maps/contrib/112250168912456641655",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLL9D0R-opX1JrMg6KMmSjJo3j4Gqv-yMS31TBOhOldWzuaHg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN8aL4jjAu_pNsyaBUMXgCxqQUrPIJkYCP0Hh0M&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN8aL4jjAu_pNsyaBUMXgCxqQUrPIJkYCP0Hh0M!2e10!4m2!3m1!1s0x880e2ca9caec58b9:0x142a385cb500a4a9"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        }
      },
      {
        "id": "ChIJI0RHOr0sDogRLAa8Yfyy9a4",
        "types": [
          "karaoke",
          "night_club",
          "bar",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "343 S Dearborn St, Chicago, IL 60604, USA",
        "location": {
          "latitude": 41.8772786,
          "longitude": -87.6290105
        },
        "rating": 4.3,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 1891,
        "displayName": {
          "text": "Brando's Speakeasy",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWrGJXuH5XPqRCdXgCiWOHFn1NOz7ANOjn2CF4oPwDR2LeZmUY1LppBwTvd2ANlgpcz-McKI10kfL5jH36_zaoHBCRLgxQZ-CS0nx7h6TAYvhC8ZEhobpaAk8yz5UqjifgfneTErjMrJpq0VX_FH-ETEvMUoCvSQVG99",
            "widthPx": 2048,
            "heightPx": 1367,
            "authorAttributions": [
              {
                "displayName": "Brando's Speakeasy",
                "uri": "https://maps.google.com/maps/contrib/109525261385455434639",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWdAxnRI9dwaB5F9QxX5pHtvl3O9VXBjN2mCrQ8a5sikmKpbRn8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO4ZVj46DfgHAjQkTVinj2WZYkYAMMZROoV8zXY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO4ZVj46DfgHAjQkTVinj2WZYkYAMMZROoV8zXY!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          },
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWoBmQFJLqjA_u4vag1brdC3aH-Pu-Dr-f3rXE8ACgkyGTUi0Y43iOqF9z_jVfpi2Hmlsvz5q0mAOhErvE5JeqmzGvpyHXXxqfcZHHpeVmQ4Nlf-_4Gs9dkrA94TVzAOKuTOIGwdHpe-tKRgGWcge4Ixhei9PhiaWXLm",
            "widthPx": 3075,
            "heightPx": 2518,
            "authorAttributions": [
              {
                "displayName": "Preetha Saha",
                "uri": "https://maps.google.com/maps/contrib/106140785717937814638",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUF0en3D_tMN_7ss4aPxELThX4OrCRtUTRVeQXP9rAARuqpFgL-=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMJNZCY4PgKez2QbnlZ7Rvr53ZiO9hDLTno9BHo&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMJNZCY4PgKez2QbnlZ7Rvr53ZiO9hDLTno9BHo!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          },
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWoubP96eK7sYsBa4416gL0KK7Hu7I950s5G7hlaqwiJHL-l9sxy3wXQfJJTbUXXw45vk96b21BQYLt2V5d4gbmY3MlCAfyAAnj1tg1C1Xc0ft66qIJXYLNwleVR1aN5Tp65ybbjvEj30088Fo77fYViI1EqBch-NT8c",
            "widthPx": 2048,
            "heightPx": 1367,
            "authorAttributions": [
              {
                "displayName": "Brando's Speakeasy",
                "uri": "https://maps.google.com/maps/contrib/109525261385455434639",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWdAxnRI9dwaB5F9QxX5pHtvl3O9VXBjN2mCrQ8a5sikmKpbRn8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOAU3_NQXtxrEhX8TcLwi57A7K8rOgeGaq17STU&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOAU3_NQXtxrEhX8TcLwi57A7K8rOgeGaq17STU!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          },
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWrUj_jn7HqA8C2TLERVZGa6Daoq4ydPh7v-sTO1AJaQlOc9NyA8BK2ScMzHuMqA1JOEC9PAWTO9TvOEFvJY7B854zfc-1oeSYvOjfThy1azjpvKkQxrv_IEggF6LlV857h2FtjBcBLg_4WTTL6_fas04tBPC035GF35",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Sara",
                "uri": "https://maps.google.com/maps/contrib/113213249907591031330",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXRu8dTHptvL6mTE2YsWqDinu495HWMbktAgmznNw3LttWjFqxE=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNCqtWK7-w7WDKI_CYqslAE4BppijzjKO9Efxon&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNCqtWK7-w7WDKI_CYqslAE4BppijzjKO9Efxon!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          },
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWoeogDLChX7IpOXuH8_a-jAN_8MIEAFkKrzxyq8vNBGtNO3_CUhoNEmq-LZHc87FsM0IiGKgGF0fLF3qTeGifcGsP4jartprvPQbnqOtydBRViFaZ8G9U3mDGsccKGd2nx_d64l1LwM33-haJdOhrCXENuOsrfJBXLT",
            "widthPx": 2400,
            "heightPx": 2400,
            "authorAttributions": [
              {
                "displayName": "Brando's Speakeasy",
                "uri": "https://maps.google.com/maps/contrib/109525261385455434639",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWdAxnRI9dwaB5F9QxX5pHtvl3O9VXBjN2mCrQ8a5sikmKpbRn8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPrc6job8ThHtfafITxc9gTCJLG8fB-vp35-VbM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPrc6job8ThHtfafITxc9gTCJLG8fB-vp35-VbM!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          },
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWojWBiJSIjxSGchpj92cu64wgkbJJ5e3eutcCN4IGYElpw90Tej8f-yvU91LSEFh9IqJ4c9GixAOnkjwzt4wOyNppr1SrPFFgR67oGmQePUKHDe6B3ReyFf3BVDG5pIa76GK1aRDIJScTiuyx-aA6a90X6PmYfm3ayJ",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Junpyo Hong",
                "uri": "https://maps.google.com/maps/contrib/113504159391756951690",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLM76DSAdE0gV7u41uY8pT7g5A5OZbHbNBEQ1L8eqfMPc2nUw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMUKR0J_UmR-JyxlOwtR806vQw4-NXYb9ckOpy4&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMUKR0J_UmR-JyxlOwtR806vQw4-NXYb9ckOpy4!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          },
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWp7nmuNZA7oPNa4SiXzAKUKrEVk3fp2ZnYQzNBXuH8DsNcHpbldIw7Mj8YpI_MBcK2R8EiL17e5HKvnDZ0nJsVtU3K_zFgfq2KOphvQj6WwdXlc0I0Ig-I-IRAKyJ-GsgtJKYtgnucCrRY8Qrpc8-PX7fRgOBnVi_xe",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Christina Huynh",
                "uri": "https://maps.google.com/maps/contrib/113879273757694512511",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWyL-RLdaIOjA5hbaPZqnL2N9vfnHXKObk3ArCw0rHsjIJ-_v1DeQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMBxRPzBIwvdtH80klrdI_AP0zzZ6Fe3UWbvgBM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMBxRPzBIwvdtH80klrdI_AP0zzZ6Fe3UWbvgBM!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          },
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWrNYVMGw5NYVYvi2agdsgHP5JyLanF4v2HMeWjvyC5iFAoIlBoz5uXRdhzkPndqyrE4JSTbyUmKZg1Uj0v30IoxygFYMw673HXDI6HIPQQEf8Dyc1N2OXVgX5FJehiPXiS5FVOtfGxIFy8yOyFOY4nBgZwZyAM7zyFj",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOi1IlT742-pvPNJj56ekUnjQMZ0Tap8r350zxW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOi1IlT742-pvPNJj56ekUnjQMZ0Tap8r350zxW!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          },
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWqS132bRDEycRxxvn-ovZ1e-CLSEU3G-CDSd6RBKhEOdhBozOmcPKYxBbtMAjNJH-us3RIddoChTkngxuuiu4k3XQ27da9FtKs5ShxNJGomtl8b0tgF0ootHCqPXegG0BA1GTf4w-_DRYalydaYZ2XgAkjK1CvOuymq",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Blue B",
                "uri": "https://maps.google.com/maps/contrib/117932507028254512486",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU3vJFH8VSduqjxTqePckxqQWJT1bvklE1CElBHNfNH86FTQek=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipORvV7xONE_zd6O-bdChuFNI7aX_021bd_1xx0T&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipORvV7xONE_zd6O-bdChuFNI7aX_021bd_1xx0T!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          },
          {
            "name": "places/ChIJI0RHOr0sDogRLAa8Yfyy9a4/photos/AdDdOWrXMKdYyU6sOy20w1e6vsTUJ0uECi-GLFR5kuMinZ0kjEw2RXVeCzX2EE1ysu7S6vLbTm1-N2nqcz4teqAffeK4QWRiWcvEZ4SYUtzL3iZPkraa5P5fanD-0rnKRSvTj59coAywG4GyJVnER0EYGPuNcNDZn1ZK6Cks",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "David Vega (Tridence)",
                "uri": "https://maps.google.com/maps/contrib/108671578383049741960",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUTOJXRrzxTmsd-d5u6dMjEqLFwylAvpKQ8ta2sdumWLcvqzSU7EA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOXFDTAZiPXKEZ2k-xG5-hZxvyHXTE39br-J5v2&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOXFDTAZiPXKEZ2k-xG5-hZxvyHXTE39br-J5v2!2e10!4m2!3m1!1s0x880e2cbd3a474423:0xaef5b2fc61bc062c"
          }
        ],
        "restroom": true,
        "parkingOptions": {
          "paidStreetParking": true,
          "valetParking": false
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": false,
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "10"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "20"
          }
        }
      },
      {
        "id": "ChIJ624Gj7ssDogRGt9wLvHrf-Y",
        "types": [
          "wine_bar",
          "night_club",
          "bar",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "39 S La Salle St #200, Chicago, IL 60603, USA",
        "location": {
          "latitude": 41.880824499999996,
          "longitude": -87.632132
        },
        "rating": 4.7,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_EXPENSIVE",
        "userRatingCount": 321,
        "displayName": {
          "text": "Vol. 39",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWoehagl1qQYLZDwACcCeDW69GDvNVZNpmWi-TtVJruHPEqVyQ3C2RLenkIyWN6IW5l2STFGpwJY0u04ZJko-We-eJ2nRH1gLPQG7wBkROk-sB45nySjg2rhu7TdPDRkRriZbUHHYZBtonmZUcpF4BtLWpcZkQtLSqPw",
            "widthPx": 800,
            "heightPx": 421,
            "authorAttributions": [
              {
                "displayName": "Vol. 39",
                "uri": "https://maps.google.com/maps/contrib/117909742585911034711",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVo2tyfhLN78uYzbM1HeR98R8loYvxMNpRIamPkSVYHs2wUWEQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNRzgssxm-ouoDinHhZaVQqKxFESL8l5I1GO6Jj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNRzgssxm-ouoDinHhZaVQqKxFESL8l5I1GO6Jj!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          },
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWofkalUrxAEoS5BWij1KnCt252Ctj6Y8BIN9nQgzEl1FXbegezY8ZqYy1V4mhp4ElKE2_faynZIL5dcXzNZXRUcdmw1IbZPF3VF8gkiA_YOWJF_picNtgMgiVZ9y2uiiuzWEm4vA7zdf7Elv3ULJpLGNVzlZYltPMOv",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Kevin Wang",
                "uri": "https://maps.google.com/maps/contrib/110632059050808836154",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLu3o0ff4DWyiE9ShhoBBTLsfn5nNvrxIcaObk3eIwnxHTFZw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM6KsZlDsxORah1P8hFqPn4ZIs7sprOsV1B8Xoj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM6KsZlDsxORah1P8hFqPn4ZIs7sprOsV1B8Xoj!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          },
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWoNkuPBlnGed0pMBMS_0ZQnVRZow34IsnoupQOk1iIiD7U-W_Gju2fdyBbgB_6YRUgqeqXHphXAB-qHwtlxcxOrf9RDCrML6o5OYhwKU37MlHRsBjh_cJwlqmAnirADCK4M7kOybp_RtFRknw6uISfqf2u-nEzzDYNi",
            "widthPx": 2600,
            "heightPx": 3467,
            "authorAttributions": [
              {
                "displayName": "Alex Watters",
                "uri": "https://maps.google.com/maps/contrib/115035520564731649372",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU6AUWEwOQvSBcvtLbVEGSVjaaHuwVeYvKmeuBjZkQi2brXKOiJ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNybTtK3HLPUNE3zs1Whgeq4pRENMrPtcMaFyJK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNybTtK3HLPUNE3zs1Whgeq4pRENMrPtcMaFyJK!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          },
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWrmj89PKr-vi3Jf1SlF_LEsCwICzTOj6ZpvsG1_3XLlvfl94qdHa_kmkMKVooTgvPVqB_5yVRhcCd8k_JSRv1OGNOCFuwiSc99fqfs_Jw1iQawPbU1oxDd190uVbhGy99NaajLbAnhPMLjjueHSc10tfs1KNrIcA0qJ",
            "widthPx": 750,
            "heightPx": 1000,
            "authorAttributions": [
              {
                "displayName": "Eden Cook",
                "uri": "https://maps.google.com/maps/contrib/115500413302476839606",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLFij0wkK-RqreWj7bG-vpfavf11udWkbtjkSNR2MRtZ0GLLQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPFi1fENXomaDM85I5G6-zfTCFT0gvbNDqbxTTG&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPFi1fENXomaDM85I5G6-zfTCFT0gvbNDqbxTTG!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          },
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWrR9mRnbXaMSSNu7gJm0YUhKigW-wxQtfWLUMArU-Gj5d9lP0DjbJrMLB37SDyS2Z0QNMOiwmZvguFZbH2NVQqI-RrSoYupwlORvVXGavEGgDvjrjP5zN0RvrATy6hUAMfH6cJn1auRfq8UrKNZNwaYm16SXy3NpyR7",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Nicklas Ulvnäs",
                "uri": "https://maps.google.com/maps/contrib/115487680776092925895",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUrF3bPdg4beS82uzhhNC2lR2EvAxsASN5XmeybCqK0ZtfSeIX_6A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNXXnMJ0N3RjS7KzEdn68TnZC_thYCb2iwBB5ul&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNXXnMJ0N3RjS7KzEdn68TnZC_thYCb2iwBB5ul!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          },
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWrzFwewUuU5hMkDK9McEapu9zm04cqVhPMwEu14-xIDMj9PerILreOKKsNIcGg1g7LFbNqtGSfeqw2AbJKECgrCRNNBLJdMJSH-j1qrAxX0cirSLQeRfhoZzDltdllyS-HwnQGAKvdct7Bi0qPBYLfqssP8ddeqQuSx",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Dmitri Molchanov",
                "uri": "https://maps.google.com/maps/contrib/104910417903462971346",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVLiuc_S2G5PlFBn9tKukr3meQT2oyQE-KFXzMSvRPAe4S80w1f=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPO38K2iRfC0vuvOO-wWNFAkqnH9WHB20mj1mbO&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPO38K2iRfC0vuvOO-wWNFAkqnH9WHB20mj1mbO!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          },
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWok0PZ7vD_GFX_ao2hsL95YbakoApbkafckpaxc60cbEC6DaVA9tQjKlO6qUg-kv1qQvAkzDRwpB6cviG14ewlpXIN7L7SJOoko2SKrtRBoUa5VzNN-_JZrq4XSrcX6Js1WGn6wKakNFMj9V_34yetoK4KY1CB1SWZM",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Brian Kramer",
                "uri": "https://maps.google.com/maps/contrib/111117160629936959983",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV1Vxvv239bTmj_LA38tDVX4alaOj09AP0BZlvntRqxKsG-vjFabw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO23OsppzInhVDxGQe34h-hn2OZQEF2nALZspOr&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO23OsppzInhVDxGQe34h-hn2OZQEF2nALZspOr!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          },
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWqAUrVHIFyxVqfPTEmzcesfmnCGnwvuaLZHuSCIGUhJRUo_nIzXqo7JRK0aWLnfMfzdnydsjClL15cEAszNGK3krEMYQc-0rzgJVTAm7josyONDd-q29cSllpLve0rGZhUJghF9fw7oUvr0JqfMSifP9DvEIPypHtdS",
            "widthPx": 2268,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "PG P (thequeenmab)",
                "uri": "https://maps.google.com/maps/contrib/114659470886134758033",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWtpi98RVLJ57TYg53bEQa7Xv2cawrVWW7A9NAA-ahytaRoKt32=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOykoVSLNSxd9W58bV_A-_llySMbTnZVR9Pj256&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOykoVSLNSxd9W58bV_A-_llySMbTnZVR9Pj256!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          },
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWo4Sa0_X9JCAVMK0fYNVq8xD8hk1HWaN6GlYaKIRojqgYftPaFqZL0vIZz6CAZ_v116cx0U76FUxQaFi0QnwjIrnHoGugfux9o1GODs3Ss7lBe3pZsrnPHjox2yqAVwlyNv65NHkqks2EvojO_cqstba69LoXmALGGH",
            "widthPx": 3468,
            "heightPx": 4624,
            "authorAttributions": [
              {
                "displayName": "Marc-André Ravary",
                "uri": "https://maps.google.com/maps/contrib/108314444666453718024",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW6dPfJDCNj8FD-wisrNFu63fyepwkr4ThCoF9jgpuZGv82M17QFQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOLsiLHw9eY4seQOHKo_r5pvjHv9mlRyMBdC5tI&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOLsiLHw9eY4seQOHKo_r5pvjHv9mlRyMBdC5tI!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          },
          {
            "name": "places/ChIJ624Gj7ssDogRGt9wLvHrf-Y/photos/AdDdOWoNJruW6JJiuX3qyAAl8IEOok_KsDmh2HzGXLp-v8El9O9SGH7Gex209dHgXkAzdZ5srwFQb3gF3O40Er2H_PkrWFwbxVSdBOl6rYr70lTOn9N40OSTOp9BkWh6w8MACEYNUig4R4oi9XyPrVF8bEwLjiHlVNxUj6LP",
            "widthPx": 800,
            "heightPx": 421,
            "authorAttributions": [
              {
                "displayName": "Vol. 39",
                "uri": "https://maps.google.com/maps/contrib/117909742585911034711",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVo2tyfhLN78uYzbM1HeR98R8loYvxMNpRIamPkSVYHs2wUWEQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOCuqnkC2rnP--8uqzwvs9rsxqEA2yJTsUORjLN&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOCuqnkC2rnP--8uqzwvs9rsxqEA2yJTsUORjLN!2e10!4m2!3m1!1s0x880e2cbb8f066eeb:0xe67febf12e70df1a"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "30"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "50"
          }
        }
      },
      {
        "id": "ChIJH2tMGwAtDogRYKAz-fE8p9E",
        "types": [
          "night_club",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "520 S State St, Chicago, IL 60605, USA",
        "location": {
          "latitude": 41.8750728,
          "longitude": -87.6279636
        },
        "businessStatus": "OPERATIONAL",
        "displayName": {
          "text": "Eluza QOS",
          "languageCode": "ru"
        }
      },
      {
        "id": "ChIJc_cMoL0sDogRRYFpXuZTqW4",
        "types": [
          "night_club",
          "bar",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "105 W Van Buren St, Chicago, IL 60605, USA",
        "location": {
          "latitude": 41.8767808,
          "longitude": -87.6310577
        },
        "rating": 4.7,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_INEXPENSIVE",
        "userRatingCount": 173,
        "displayName": {
          "text": "Sky Ride Tap",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWrJtHCQjnlOoNwps4POvEJnkf7RSwx4LAB2rv3aGr9c9tSJluDb9EIsMQOc2RWxdTq4eHPf5496l1Q3WpKk4w_NEC2_E2Wvt5shwk8A16WjugaPLrM5TVsomgvMXtqutUVIYA_JoxVopOWnsNAYkLg4okpxKLhhIG6Z",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "gnome",
                "uri": "https://maps.google.com/maps/contrib/111154972910493287224",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUGd6TSvstjwrYf_aKbwTPwT_QkKCKqfs6Fe85eQa3n9ljO8hkY=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP9CR6_Iv-Ln-aQdqgXTr4LbWPav4htDH0OLZOY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP9CR6_Iv-Ln-aQdqgXTr4LbWPav4htDH0OLZOY!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          },
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWrx9l784R4vCRN3aQep--dJ4X-edqE1noY0V9D17RL6pqdkkfvvEyMMwMxAQOj6neblZIbvbn06LvvEiwuAn-ZbOX19-zq8TgmbjkJxvUKtIvSWqKLlxiJi0JH1w8PmvFbdzgYsZcEVrvsSioTDrQ4_rJciZ1w7rH2w",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Christian Montoya",
                "uri": "https://maps.google.com/maps/contrib/105708898504693368285",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU_Fe4RwLzRZW0p3Bs6LK0kRRa3IfH2ltSk92kqoz5hUx3Ny_Zt=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN472h8BwYfRD3K3_TM9YcuoVnRFedjT6JKGjbF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN472h8BwYfRD3K3_TM9YcuoVnRFedjT6JKGjbF!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          },
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWpL_CVmuvvs0IlzLpvz9NX998UsDyelFTOp2M2-39u-zcEGZifH1s-mkcI4rnhLTAs_CiLjAAYSFQ0R7P1y3jcV6RjeQyxc3HbTj7UDCYNCTY8xT_8E7qEHx2BmuUMyG5qC5CXdNWAO6VIMTe3ucKYngCYK2jdCdBy_",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Laura Melendez",
                "uri": "https://maps.google.com/maps/contrib/114411025422943962800",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUj9pqANnOgiZrfAfTHrXwZFhn6sEMou8I7-X9C4J4ZETf6hg0wlg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM7uVBcJqHTZPsq5_rGryXQOhCVkh01EwssmAiv&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM7uVBcJqHTZPsq5_rGryXQOhCVkh01EwssmAiv!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          },
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWojiwfzpB3398Tj1LIVtiwj1WBdcjXWAXTf9KMFUV4BHMkLMnnKuwkbaW1M6OnHa6FIrlu006M2ddfJ4tK_lt96b-a1EMK_CzfQ73uzIWww24VuGR7ISxxcdpjkUHMK6cKLQWxajBtxICrJcF4oOI6SFzePsZM1-RCA",
            "widthPx": 4208,
            "heightPx": 3120,
            "authorAttributions": [
              {
                "displayName": "Alice Venessa Bever",
                "uri": "https://maps.google.com/maps/contrib/109574541247865204286",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV25sK6S0wP3ZbldU8bCaTVBR0iEB-Sih_Zy8_ktB_QuMW2vWAXtQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOyucuEGxhMddIE7O5GuDluV38yEl_Xn4KOkyxu&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOyucuEGxhMddIE7O5GuDluV38yEl_Xn4KOkyxu!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          },
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWr6-6Ua8XKvsrA0WbAd9MgwsVGDEa1yXjdITq6k2Lp7ivCNmQsV0vR85D9iVLup-ulk2ifuUyj6d3rtfGdPBOeAZJZSBVvbvvHzemMRkmpkH-536iR86DW0icopTl9qTCOAMxrsN-NE4DrZycGHfhO5-LaT7CTX6erw",
            "widthPx": 2048,
            "heightPx": 1536,
            "authorAttributions": [
              {
                "displayName": "Tom Whatley",
                "uri": "https://maps.google.com/maps/contrib/115969612475865139451",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUJxT3-7w_4QCBjO92GTSzNUXL696fij4HeRCSWS3k40EDyHnlm=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN9TKWFJnnosrhpUHskfPlVPbJzSTipkUcgR4Qg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN9TKWFJnnosrhpUHskfPlVPbJzSTipkUcgR4Qg!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          },
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWownNZNqJBIaCS0zcMRMg2pVLuiSiBxB-oOuF9ad68846T4d2R97sdXDMPL5pG7J1py_8AcQLWdwR7QaETRgYGaGV6TfAxAU87EAogaQrsoBQBkHntyrtRCxclLU5WkaSrTu_-J01WTV_pnCLBsQKsQJEVs1mWopd7_",
            "widthPx": 2268,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Jim Mayne",
                "uri": "https://maps.google.com/maps/contrib/114921722434197106618",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWcfGaoSoBqfgeTb3nBl7qbRrJ_r0T9gBkR8qnrn6Wb9ZHSbCq31A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPjkkPVh9MTQhTfsNjT15ZJ-gWYVDV74IjbCPuT&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPjkkPVh9MTQhTfsNjT15ZJ-gWYVDV74IjbCPuT!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          },
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWrz7CrGoFeyy6Cyzb1fM-mTzoUa8YxoD-KhzqZGG8Sd_ppetaUU3H_7yN0F9LZghdiGWTIkSpoTfc-HuOlieCUEdXLkfPhRNGyjhQmePi3PXd8jAn1hidEJSiDYgkGBqKQNXXr2RvXkIWDN3nIT49VSACyXXzdWX9-z",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Laura Melendez",
                "uri": "https://maps.google.com/maps/contrib/114411025422943962800",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUj9pqANnOgiZrfAfTHrXwZFhn6sEMou8I7-X9C4J4ZETf6hg0wlg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPeKunPBvPVTh9-ECBQ5fVLFp9UTh9G9zG3TEve&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPeKunPBvPVTh9-ECBQ5fVLFp9UTh9G9zG3TEve!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          },
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWry6npwLnhYIzLWCV8OdGjpqBIrsH2C7Vqf0RIuzvslBY15iDORcGSkFX2YHNiN1ouNih-QGy3PRHOwHhDgra4dcszmm8C0dzRXHMPKekzO4OEE7p6rrv9o04yiyDlZts2npQKJusr-cOmZD0szDmOrGrBRif1G4cEC",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Tony D'Antonio",
                "uri": "https://maps.google.com/maps/contrib/106416248199999190893",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUFxMztzNQg_LBf3jx7sdxNOT8SmutAS9O31zy0fbSgD4MYpl1QjQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPQoNHZo_n2TfjfWjqKWlxWsfsr4cEkAY0vmlTu&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPQoNHZo_n2TfjfWjqKWlxWsfsr4cEkAY0vmlTu!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          },
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWoFVf11PepmcTC1hzxHyr1IUr0G6nSp68SZSBXgOuEsH-qaEQ06PMTDCBU5CMjGo9oP1zk7qcQH4BIIevAVAQmae1PTbFUuC52kPRNcPPVm0iaBaRfnOXEFvZZQ-p90Q2x1BoN2lUiHX0GNcrRzfoRphNMQXkXhgJJq",
            "widthPx": 604,
            "heightPx": 453,
            "authorAttributions": [
              {
                "displayName": "Margaret Larkin",
                "uri": "https://maps.google.com/maps/contrib/101963779612205608076",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjV-lsI-KhRukDrftmZGFGTJJMBpTEQiNTW68B1w0GepQFt1wzpb=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNzZ9uQeYN1USf929oFHn2EHHJnd0mA12zW2m6y&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNzZ9uQeYN1USf929oFHn2EHHJnd0mA12zW2m6y!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          },
          {
            "name": "places/ChIJc_cMoL0sDogRRYFpXuZTqW4/photos/AdDdOWo4-4s02nzmbPW9Nalr6aIG8qH-zdJUFV3aW2z9dS9y2_JzU4OBLf7untg42aPlu9uVcI9ZQGoD1VwtWXLJ3yoppChThAPaWs2DEYQi0A4fMZKxKi89Y7b7EJcXKPaSQfLkdwIcIv28mP-SmeDyLwHorS2F7_pYyhQv",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Santana Adame",
                "uri": "https://maps.google.com/maps/contrib/100858427099401833575",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWU0Webp8Pv0W9OD1t4FgRsR4_x2RqNxRS9hrjHXKr84kvoz7k=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNYza2AIFrYTXz_c5DuYFnsY7519T8ghPr9Xe9M&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNYza2AIFrYTXz_c5DuYFnsY7519T8ghPr9Xe9M!2e10!4m2!3m1!1s0x880e2cbda00cf773:0x6ea953e65e698145"
          }
        ],
        "restroom": true,
        "parkingOptions": {
          "valetParking": false
        },
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "10"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "20"
          }
        }
      },
      {
        "id": "ChIJuxzb0bEsDogRY0_Z--o0pLU",
        "types": [
          "fine_dining_restaurant",
          "night_club",
          "wedding_venue",
          "bar",
          "american_restaurant",
          "event_venue",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "329 N Dearborn St, Chicago, IL 60655, USA",
        "location": {
          "latitude": 41.8882037,
          "longitude": -87.6292039
        },
        "rating": 4.6,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 191,
        "displayName": {
          "text": "Foundation Room Chicago",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWqf4IzpvrrnFjc_4GD3Nny57-NYf_7ZnovqEkABVEKvshGop4E6Q2cSxHOksZVGqXcGaPTu7Sb4wbaVhVlzq7sJXrappjzHCGIC0xkWE79dbiNaALgxPDF4RKYF1kasP1zY3j5dZwR_hC2ycZEmAS1tH0NakWO8FETA",
            "widthPx": 2048,
            "heightPx": 1365,
            "authorAttributions": [
              {
                "displayName": "Foundation Room Chicago",
                "uri": "https://maps.google.com/maps/contrib/102973000018822079829",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW_yqxvYCgKIQ_7UaljV_9q-6AIsxSnzYbOrvBOvFbnmR_87gI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPVi5UBSqzPRSIYApYKFFfmmzT9fYp5macMzkKK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPVi5UBSqzPRSIYApYKFFfmmzT9fYp5macMzkKK!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          },
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWqBuitRwnZYSbCvry7vL_H5ekfwUDECCiDolHsuiCq9DgyUHokZmpiyZYAouVJ0sCaLm2vSvAcWVM_i-oWxTWnkUjrVtg0_7HkM-3Lh0RdPZ3zZXUw1BM3lhaliuWAeMTuBYg5WcMr13ECcEqYPAnqzt9FnvFnYmqf8",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Yvonne Barna",
                "uri": "https://maps.google.com/maps/contrib/115546864842988900479",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUH_rO06Hv8UNDSVPKOropBsEpLnlV0qBYQDR_cJEVmKnooigiGjw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMk4xOp9zqiIreTpyWBhEHBzZV-C9Hzju2uLhw0&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMk4xOp9zqiIreTpyWBhEHBzZV-C9Hzju2uLhw0!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          },
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWq9sIUTU_dhXIkIUET_RCLX9n8aWuNxZdKpg7T-4p2_KP-weD6wxGo6-fKNVYuka6iD065R-SrhBTxNWKiIFBF0GbpqD6DOatBk7o_eqyzraEY6sImkN1fOH6qmv2T4nsGonu1aqnjuH-ylHrMZr4DvhLEyL3KjDy4K",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "S",
                "uri": "https://maps.google.com/maps/contrib/111773361717729709515",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU5XGeq34AhYV6cmRQRMzB0_LflGnLKACJcMCGUubsMKJLiIM6N-A=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNzzGZatQmLgkb17GtILnuWfqh9bP7wQN6OjMJX&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNzzGZatQmLgkb17GtILnuWfqh9bP7wQN6OjMJX!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          },
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWouM1ek-h_lFkRtvOvXG5DuEp31QEQdxypsqKpOs1e9zQXUQJ0-ADdUTSpKqfCPA8WOcEDjCL6Wgtxhd-LO5zk1z8TNjeG5KZ8j7XZ1QyEo48Ht_k0iJ7H8VHLDXzQ34VMbke0SOEgHfeRD6M2-zUzySEKTY3VQenhs",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Belle Lopez",
                "uri": "https://maps.google.com/maps/contrib/104731732886039479725",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXJaXXCmJKT3A0h-pVZ5EtckuDukCB_PBRi4MZGRcmKMufnAMyd7w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNIHHsS8xBabgegpCRc9Au9jA4-tYRuRu-s58_6&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNIHHsS8xBabgegpCRc9Au9jA4-tYRuRu-s58_6!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          },
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWplsqn4QLEa9ylge_b1vqNfCwGfkc3WEvQWbnhHe0qiG7vDH7sFxZg2OHIXwMjAT_NosXIDDPUQG8gg3aoicSWURcUOAxQ9ycYG9DDrGgPQk3HmzZYfjS4KyI0UBiy8cXPlkrdPHbLb0omumO95GE6MH6yAq6_1XxEA",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "KEN",
                "uri": "https://maps.google.com/maps/contrib/103362631904794840405",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVfx8p6xVD33-DCgNATBQbfAQu-YRcLXS65yeNWiP3TQn-6iezDaQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMeUsM68FN67HjmwCg0KO7MibTnRjZJJr8Vvg8p&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMeUsM68FN67HjmwCg0KO7MibTnRjZJJr8Vvg8p!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          },
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWrVvSSUQDALAEW2aJlBOdweSqWNBKEqmzEX4QnpFo86We58zM1XH15hecbYGZjN6uJTwa-ETCfSRMo6liCxGVACHNpbrWTR-IaehECmFMvUkpzbcJLmjgYHU5ZgZoeZDXKaviKhgoEj2mLHbA8yfcqTfK_LJIgEFFZI",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Daniel Lindgren",
                "uri": "https://maps.google.com/maps/contrib/115449562438424052351",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUGAcdNuCKxFpOdnhD8tC-KVUciNZSaUaMlrd3iXitcM46e7TBk=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMw0v5SZyREI-nyAETVMSFajd2jtg8zV5Z_V4pm&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMw0v5SZyREI-nyAETVMSFajd2jtg8zV5Z_V4pm!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          },
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWqtc-Gsjl-PdyyUvdWq8796T7wXU60k7x0t4gZeiGKbAfp7Psiik8ti6St9i_5M6hjtTgm8lXyPnrw5PZh6s9BPZubcJ-iGpDTkWXjFsfG4HdGHtuJ3IsNHY_mbmxeWNQX3nmcj4OAsSGWSu9bOpPFe1I1WOedsxFWX",
            "widthPx": 4800,
            "heightPx": 3200,
            "authorAttributions": [
              {
                "displayName": "Foundation Room Chicago",
                "uri": "https://maps.google.com/maps/contrib/102973000018822079829",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW_yqxvYCgKIQ_7UaljV_9q-6AIsxSnzYbOrvBOvFbnmR_87gI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNovQOg_64Y_hQQ405s_z9GoSo6Yap9GQhrhJcF&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNovQOg_64Y_hQQ405s_z9GoSo6Yap9GQhrhJcF!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          },
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWpe6Sg0ihQkP344EeynZyvkK6vukPQazM_tPDmuWNEKTgVZNU3xa7DpeHQGwT44c8w22vq23w-MqjFP7YsS-mHG9Wg1oeZyjSpxmFM4l3yWccXi5ypGI0VQIudxW1DZEfU7RRlUvpHKDtpZQRnptViuqJRlEbyxU45p",
            "widthPx": 4800,
            "heightPx": 3200,
            "authorAttributions": [
              {
                "displayName": "Foundation Room Chicago",
                "uri": "https://maps.google.com/maps/contrib/102973000018822079829",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW_yqxvYCgKIQ_7UaljV_9q-6AIsxSnzYbOrvBOvFbnmR_87gI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNdR6yF8Z9-6lhDObvs_kxOtLrUGa7fWFpsldFw&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNdR6yF8Z9-6lhDObvs_kxOtLrUGa7fWFpsldFw!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          },
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWrflyESYYuk_rxmYX4NCbIaCQCRsB_EfO5b20TYUi7N8TtFdr7_w_Qw-ONZ-_y6otEpno5sk5ENTHpuyY6E51sBudInBx_lLZNPbtOhZ4HWbdavZ0E82bU_wq2s0wogJd7kwqgGLm4xos00hMFO3c7AvdE-gj_gXgAh",
            "widthPx": 4800,
            "heightPx": 3200,
            "authorAttributions": [
              {
                "displayName": "Foundation Room Chicago",
                "uri": "https://maps.google.com/maps/contrib/102973000018822079829",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW_yqxvYCgKIQ_7UaljV_9q-6AIsxSnzYbOrvBOvFbnmR_87gI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPMXPy7V3EKr_Q6JbOyFGyi5EsXw6RIKEBFbKRt&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPMXPy7V3EKr_Q6JbOyFGyi5EsXw6RIKEBFbKRt!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          },
          {
            "name": "places/ChIJuxzb0bEsDogRY0_Z--o0pLU/photos/AdDdOWpFo6b0Pn1VrCjAn5hZ48sxuARKcR1Mj7A2dIMzsBE38SquhQ1FNtkLDOoolKCGUtZmMqp7gRMHv4Ze-ID_GrxqjB6F-NFoj4lmzZP0x9GWdFn1GS8fKhie193hLVT-1KjFBty-hHnKZv6XAu4yisiSJ2SmJheMiHZZ",
            "widthPx": 1083,
            "heightPx": 1080,
            "authorAttributions": [
              {
                "displayName": "Foundation Room Chicago",
                "uri": "https://maps.google.com/maps/contrib/102973000018822079829",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW_yqxvYCgKIQ_7UaljV_9q-6AIsxSnzYbOrvBOvFbnmR_87gI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMfsgKxLe9NRM3Ti4sY0X7E1GPguH8SvDg6W0CB&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMfsgKxLe9NRM3Ti4sY0X7E1GPguH8SvDg6W0CB!2e10!4m2!3m1!1s0x880e2cb1d1db1cbb:0xb5a434eafbd94f63"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        }
      },
      {
        "id": "ChIJbXuHZqksDogRHFYb9GbgkFs",
        "types": [
          "night_club",
          "bar",
          "american_restaurant",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "450 N Cityfront Plaza Dr, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.8896295,
          "longitude": -87.6221158
        },
        "rating": 4.6,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 18,
        "displayName": {
          "text": "The PIMCO Midway Club",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJbXuHZqksDogRHFYb9GbgkFs/photos/AdDdOWquM-Y9hwadH1TdR6Ahphh045r68Zqe7RSVgCYkXu6_vrYnqE0Aog2vODNQ_UniD9i5QzPrkd9HWA856Mwh8SXRveWsx_gl8eMc3eVebuaCcje4Wc2rrbsdxrCef4jJ4Y7_I6H5_tuvH9YpLN8Rcz0jkEWY5lysCqE",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Sean OKeefe",
                "uri": "https://maps.google.com/maps/contrib/113181517160954422849",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVYVUJJ1Y-YxFXy0HJkl608XxPq0l7VuI2NyUi00V_8TQF7QA8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMKdp_NVhEHfxY8-9iVrk27JjXQdNCeAfdEMmU&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMKdp_NVhEHfxY8-9iVrk27JjXQdNCeAfdEMmU!2e10!4m2!3m1!1s0x880e2ca966877b6d:0x5b90e066f41b561c"
          },
          {
            "name": "places/ChIJbXuHZqksDogRHFYb9GbgkFs/photos/AdDdOWoT25kcudD4dwXGbgmOJAARJG8ffRQPzlJaSL2sAwS45K1-5hRHTLfea63C0oU4LEE7wEcQpWppQ8zbGx4CI3691_Ey6XaEmr2LzEWXCf766aiicg0arVyBWnX-JH7kbQ5rMxQw02vvruvPFQ8NUFvrjCtqA_KRVWH3",
            "widthPx": 4096,
            "heightPx": 1840,
            "authorAttributions": [
              {
                "displayName": "Ramon Seoane Gomez",
                "uri": "https://maps.google.com/maps/contrib/116414278540300819109",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocImce-XmR1giZKS9JkLAz22xEbw4irEG2ec5iw9xpGEPo52-w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMpR2JlfNK73Ox6wpwIjMNckECGhJWgPFF4Ix0G&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMpR2JlfNK73Ox6wpwIjMNckECGhJWgPFF4Ix0G!2e10!4m2!3m1!1s0x880e2ca966877b6d:0x5b90e066f41b561c"
          },
          {
            "name": "places/ChIJbXuHZqksDogRHFYb9GbgkFs/photos/AdDdOWr7z4mKmz7d6KcXV_a9tWFsYoB-qoJMpgWDstxY-9o4N5PGXQWLlVxjlzwIXUBlROoR1rFInWiHnzQbPT6nMA1YyC2GONa6zP8dkhF1E-nFFKYxO5LTDkJQeo0UZ_VcfmVNnuRRfMgEa2tfbvuiY06ObUnvcSYVh2hY",
            "widthPx": 1840,
            "heightPx": 4096,
            "authorAttributions": [
              {
                "displayName": "Ramon Seoane Gomez",
                "uri": "https://maps.google.com/maps/contrib/116414278540300819109",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocImce-XmR1giZKS9JkLAz22xEbw4irEG2ec5iw9xpGEPo52-w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNFcsi_6PShIEZW1bAR_BOHDsa-JymdRd3rO8JG&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNFcsi_6PShIEZW1bAR_BOHDsa-JymdRd3rO8JG!2e10!4m2!3m1!1s0x880e2ca966877b6d:0x5b90e066f41b561c"
          },
          {
            "name": "places/ChIJbXuHZqksDogRHFYb9GbgkFs/photos/AdDdOWrMGK6TvjP19VkY_FBypup8dI5O5gTISIcVImADD-WYjtJcocRG6OzubsJCXYMrko_fMMheSDUN8VbKLIguoo-AnSNnDuwFR-hXF0_MstDPWBBuYxBi15aEdUOFsuykgx16XpHyk_UJNIDekxhWisMzF2qLcUPaScA1",
            "widthPx": 4096,
            "heightPx": 1840,
            "authorAttributions": [
              {
                "displayName": "Ramon Seoane Gomez",
                "uri": "https://maps.google.com/maps/contrib/116414278540300819109",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocImce-XmR1giZKS9JkLAz22xEbw4irEG2ec5iw9xpGEPo52-w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMRvp8Ss6vqWhv2AcnWjY_tSQ_VGS1vc18qx1ZM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMRvp8Ss6vqWhv2AcnWjY_tSQ_VGS1vc18qx1ZM!2e10!4m2!3m1!1s0x880e2ca966877b6d:0x5b90e066f41b561c"
          },
          {
            "name": "places/ChIJbXuHZqksDogRHFYb9GbgkFs/photos/AdDdOWpOsHQoB7wotkD_95C29bjCX7CMgssJA7uDCeXyImRVaMCtdrVyScy6tht4QIfNLP0vO7GPSXPZkFzEhpbP5Dbj0XMMe7wWS9OIDTP2I05At4nmvSDA2BFAKuf1vVEGB1uVGcSulNYT53F-8UL-6GE-4UGrvfJROeZT",
            "widthPx": 4096,
            "heightPx": 1840,
            "authorAttributions": [
              {
                "displayName": "Ramon Seoane Gomez",
                "uri": "https://maps.google.com/maps/contrib/116414278540300819109",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocImce-XmR1giZKS9JkLAz22xEbw4irEG2ec5iw9xpGEPo52-w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMHmrGKYIIun_AXlRRjXqdu6RNlP4mZYbnIxAlr&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMHmrGKYIIun_AXlRRjXqdu6RNlP4mZYbnIxAlr!2e10!4m2!3m1!1s0x880e2ca966877b6d:0x5b90e066f41b561c"
          },
          {
            "name": "places/ChIJbXuHZqksDogRHFYb9GbgkFs/photos/AdDdOWrHs7lWAZBbJmXFwPp-LEqI02sGq3_lUY3vQ2gQLWZP5lAZRizTTDUCMNyXkA3GBXxUxPIU6uRkvXGZW55TK7NecEaq6itVJ5ylJgZyXFZQE_vWY862f6Y1FSe9MiSIxXp5bmpUoI7umdLyg8KEsztVC6XZGduk3Ak",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Sean OKeefe",
                "uri": "https://maps.google.com/maps/contrib/113181517160954422849",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVYVUJJ1Y-YxFXy0HJkl608XxPq0l7VuI2NyUi00V_8TQF7QA8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP6bhdkg21dNA3N-x0T3am745pfIGB76-BTaDk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP6bhdkg21dNA3N-x0T3am745pfIGB76-BTaDk!2e10!4m2!3m1!1s0x880e2ca966877b6d:0x5b90e066f41b561c"
          },
          {
            "name": "places/ChIJbXuHZqksDogRHFYb9GbgkFs/photos/AdDdOWrswcVgIRRMmJJ5SDwjui52MNVRwsFYTEDYmarvlBHdVsF9bWssUOu88whtOQaVcEaFcmqo0-f8dDulRoU_Mm1BcQeZRaK038ydxnvsvkfodPQtWdB6MnJokaekJ6mF56a8CBCv0Do9S9JG-QYuzGkcNPfZAypx2rs",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Sean OKeefe",
                "uri": "https://maps.google.com/maps/contrib/113181517160954422849",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVYVUJJ1Y-YxFXy0HJkl608XxPq0l7VuI2NyUi00V_8TQF7QA8=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMRP0e2Lc5YuLhxc9nsuSVRWb7KJ5XpPfeqJX0&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMRP0e2Lc5YuLhxc9nsuSVRWb7KJ5XpPfeqJX0!2e10!4m2!3m1!1s0x880e2ca966877b6d:0x5b90e066f41b561c"
          },
          {
            "name": "places/ChIJbXuHZqksDogRHFYb9GbgkFs/photos/AdDdOWovFwgScTn4X7PqGI8rSkcMvjsuwqy_qrA1yCmViLtUsuKb3zH0OWYj7Vq0J281GtGblMTLOXYVbSk6nldH8LbauRUrDjfFfdHsblF9fsZ3QM4x_JHZMuSG8vCWVf99j-BFiVR42VfAdOcC9CE6l2yCFd8TW8jZJ50y",
            "widthPx": 4096,
            "heightPx": 1840,
            "authorAttributions": [
              {
                "displayName": "Ramon Seoane Gomez",
                "uri": "https://maps.google.com/maps/contrib/116414278540300819109",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocImce-XmR1giZKS9JkLAz22xEbw4irEG2ec5iw9xpGEPo52-w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPEWl4azDPc1o6tito3vTo3hOzQxaE1mSiSy-BT&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPEWl4azDPc1o6tito3vTo3hOzQxaE1mSiSy-BT!2e10!4m2!3m1!1s0x880e2ca966877b6d:0x5b90e066f41b561c"
          },
          {
            "name": "places/ChIJbXuHZqksDogRHFYb9GbgkFs/photos/AdDdOWrVVX3_yawPAuCUB-4kxRikrjQFDzfdtgRc1682doBVq0mXUMFc_YGYTrY_LsrfDQvOkkvVFV7pfNzxOXkK0Opzzj3zDW7lM-RM_zpvJPk6fVeeaKN_QKZNKJQ_gw5Xs9Fpk_N7mDVNI_Tf9COHQFhQk-mI3T8Rn_lt",
            "widthPx": 1840,
            "heightPx": 4096,
            "authorAttributions": [
              {
                "displayName": "Ramon Seoane Gomez",
                "uri": "https://maps.google.com/maps/contrib/116414278540300819109",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocImce-XmR1giZKS9JkLAz22xEbw4irEG2ec5iw9xpGEPo52-w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP02TTXUeT1siazn7HxnepNi7OZhdq6mW-pjrFM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP02TTXUeT1siazn7HxnepNi7OZhdq6mW-pjrFM!2e10!4m2!3m1!1s0x880e2ca966877b6d:0x5b90e066f41b561c"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        }
      },
      {
        "id": "ChIJB605fVAtDogRNFAEhTqfgSI",
        "types": [
          "night_club",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "416 S Clark St, Chicago, IL 60605, USA",
        "location": {
          "latitude": 41.876404199999996,
          "longitude": -87.631087499999992
        },
        "rating": 4.2,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 74,
        "displayName": {
          "text": "Era Social Club",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWpi7fvbwdM4fcCIwLM2H9eKgpYCil5asSDoc3N9f8YIrfQSp5vdyTKyjMn9VV0q4TO9haON-JjaYTj1iIQnUUYQPqTP1UqxIknP7NBauV21_33iuFdOE4U6sBgCVOmYfl2SJyrOvMN4EAAXOgBfvfNwgL0ZuKKMjVFv",
            "widthPx": 1285,
            "heightPx": 1001,
            "authorAttributions": [
              {
                "displayName": "Kyle P.",
                "uri": "https://maps.google.com/maps/contrib/116447806832808824328",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocK1d7Fr0-sRlZZL7IWv6b8bZxy9QRdQHBeKjMMzFbywDYWJFw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPfiB6E5_QM81xaU-X6c8Ty5k-rJog7ymHdugVu&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPfiB6E5_QM81xaU-X6c8Ty5k-rJog7ymHdugVu!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          },
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWpnDZdcXDxj4zMS4QDcvhO5w1aGOcwTZTFzJhTmRlls2vIf1mMNAVIdTB7X8Mva1VaAeJTweESyaU9VEeG9ZRb8MXPdU-bRiL84y627SHnxFR1mth1GOMN8bWtUpCOP4IkY76ZTYBesJzW57zsFhk0Pltc1DUQ7f5aa",
            "widthPx": 4800,
            "heightPx": 3203,
            "authorAttributions": [
              {
                "displayName": "Albert Therese",
                "uri": "https://maps.google.com/maps/contrib/111299585826474122424",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUlJ6oy_KGef8zwO9-YOCaOi1r-HAe6VGmuHH1CnpE-xvltMejV=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMxkW5EsICdqv8a9EJ_VneQvv2nRxTNMgVJqGJE&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMxkW5EsICdqv8a9EJ_VneQvv2nRxTNMgVJqGJE!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          },
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWo_41wYC_eyYXZx5RbZyiZ9XCfJpOUh2HIOFOmKVd9-SCHHxU32IRHqQvN54eS0RNjjwLPHHxc9iTWa7lim5SJt02wUpsnTVQ_TzhdwlEJux5l0GDoEz8474HOP1UWEnt1TVvGaQ6yRP3afBGfeUWjucwPyJkyW8_M",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Agathe M",
                "uri": "https://maps.google.com/maps/contrib/110314228640736433611",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUCE3_5OTpSJJd5-2dPuYrRCV33zi2IgVpK263vZszLtmMFXq5G=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMnP15FENUvRJInUUmO7TKRiDppl3166wXcMhM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMnP15FENUvRJInUUmO7TKRiDppl3166wXcMhM!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          },
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWrbS5aXpmFAYHyVgytP3jZrv-SL7BgbGDx4G5wGMN0rSYAS9jtSMAkiEfuoQT7PWYSSv3kAgpe_uiOq3apzmsNl2ojUyKY-IgavOYTfA7TzXi2AaWchvcbkKytEbKB-ih4nqYJDbENWba-BR-DKTQbMDWpxB2pQ4N0u",
            "widthPx": 3680,
            "heightPx": 2456,
            "authorAttributions": [
              {
                "displayName": "Albert Therese",
                "uri": "https://maps.google.com/maps/contrib/111299585826474122424",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUlJ6oy_KGef8zwO9-YOCaOi1r-HAe6VGmuHH1CnpE-xvltMejV=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPbqH18mzyEn_97oCTP1FA1rskBpChGhpNdlMly&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPbqH18mzyEn_97oCTP1FA1rskBpChGhpNdlMly!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          },
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWqVX9sWEHd7e33LsP_5ap-twWUfrN6TddzdP_OqrbF1QR-gnpgAmzQOnuOTR3Nw4Xh1mu525z4wZbaCr25T3mpianmZvpqdU3ZRspnzQWFCtxpad3JbHEbkQw_JfUtJP4y-8yNyKUJlBYCjWuIxCuvrDdTiXCk10u4J",
            "widthPx": 3200,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Cas Ford",
                "uri": "https://maps.google.com/maps/contrib/102410471126841486002",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW2YkUUhj-CPJap_gNSJrj26Sre_o5FO24cAZp9NSkD8WcBw8Yr=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPBFjXASzTMjY7u2fGixxJsaOx6irVxHvCVV7Xz&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPBFjXASzTMjY7u2fGixxJsaOx6irVxHvCVV7Xz!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          },
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWrZ-CeQD-ShUcHsOBx1Kl-3StQRbLUytfk0ED3LPHfOuFT09PnW9AhFSzvgP-64G4d4dhK6il6FpwZ4mm05QXDnByMTBuvR9GAoyDxAsl6cEDyJ6CqoENx8RT1amGZoGDY_PrE-5lUAs0xXnT-Dp4KCVOp8hlKu33QJ",
            "widthPx": 4800,
            "heightPx": 3203,
            "authorAttributions": [
              {
                "displayName": "Albert Therese",
                "uri": "https://maps.google.com/maps/contrib/111299585826474122424",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUlJ6oy_KGef8zwO9-YOCaOi1r-HAe6VGmuHH1CnpE-xvltMejV=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPgm8CjnCsAlR8JtNTaryvfFA5T-8jUrT56EKOD&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPgm8CjnCsAlR8JtNTaryvfFA5T-8jUrT56EKOD!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          },
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWr2yl4vTMnBQlOs9a0Ko7pzZ8_b8QaDqgcSt3TOA5Egl-r_IHMz8RzejS0YsTjIY-mTpHwiHsW1nJpPQzaq9-FbkZv9vf56-gmHfYgNsKbTI9m2Dhc8d5fzKztHA6x8fhewZXEx1eM3ycRKVEMNhAL8nXQ_Rz6R0SQ",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Angelique Jacskon",
                "uri": "https://maps.google.com/maps/contrib/116715611655151211620",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXY9BE8a9ABeyMJXT8NcpMU-xFcGaEQmVUBxkEaL-E15Ghl9rg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNb8-JBTkgL3nMe06XqkvUMHflhEIVY0WCyvvM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNb8-JBTkgL3nMe06XqkvUMHflhEIVY0WCyvvM!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          },
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWpXFpAo0SwvoyLOGQGwY8ZAr7NQaqYvu1j0_BbKSMGvX0t7qsiznGMSjY4F3KI9-FetU2a2vUzwjcvQqF86pzYHyMsL1IaNlA8HhBGSDyn2w5_JcQuIz3xxWRJziGcUEWjAf2kYKiJQj8UZlx5PXwZUkOm5vsWAb7XN",
            "widthPx": 4800,
            "heightPx": 3200,
            "authorAttributions": [
              {
                "displayName": "Tatum Butler-Hill",
                "uri": "https://maps.google.com/maps/contrib/101896095616007847628",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVyhgOw58OtwksCG5C5Gq7RLwHviyKCemUIvuo66VPTxFSy-k_0=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPUUkDfj8CnCG3L94h_iQgnb1MfFaNcWinHThYh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPUUkDfj8CnCG3L94h_iQgnb1MfFaNcWinHThYh!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          },
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWrp32PKXwGBExRE7BQoLHkGeiBxl_yIi7lqaCDDfsyKThITB8cRwB4eusZV5_L76sWYBLKdD9vYXKzQOVHlkbibcG7zxOIy3Eik3T8_Mt0swOJzyKwxNh9PRhBTZ7qQmdkrjCJLUSU17SPXNp_iduy_2cpre1uS7ldG",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "SAMBA",
                "uri": "https://maps.google.com/maps/contrib/110795256372466737789",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVhSOndPzAKydhYBI3UNzIvMscRHHc51BCjYYubQ_dwhVlh7lpL=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPV0WHNVUFl7ZpbsWbLHNC79omKy0Bia-AeXT7t&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPV0WHNVUFl7ZpbsWbLHNC79omKy0Bia-AeXT7t!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          },
          {
            "name": "places/ChIJB605fVAtDogRNFAEhTqfgSI/photos/AdDdOWrYQte_LxiV_uUOiJ4YMa2qJBKB_2PLH4vYQxil0AwnuTqc4pYDMjpAFnfBd14Z5plgykkFT8WUR_EXOHobNyqPQwLXHmxoBIxC3pOKzVzm3cyW4bj08-8wQjTtYeoEw1n6YQ3MROztdD_DZI311uMj0_Di867vQxhy",
            "widthPx": 3680,
            "heightPx": 2456,
            "authorAttributions": [
              {
                "displayName": "Albert Therese",
                "uri": "https://maps.google.com/maps/contrib/111299585826474122424",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUlJ6oy_KGef8zwO9-YOCaOi1r-HAe6VGmuHH1CnpE-xvltMejV=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOXva19JIbSnPhr169CDZuvIX188eZhIxk6taZg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOXva19JIbSnPhr169CDZuvIX188eZhIxk6taZg!2e10!4m2!3m1!1s0x880e2d507d39ad07:0x22819f3a85045034"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "50"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "100"
          }
        }
      },
      {
        "id": "ChIJzXFf76ksDogRCHsX1LdyWa8",
        "types": [
          "night_club",
          "bar",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "455 N Park Dr, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.8900009,
          "longitude": -87.6192567
        },
        "rating": 4.2,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 9,
        "displayName": {
          "text": "The Lobby Lounge - Loews Chicago Hotel",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJzXFf76ksDogRCHsX1LdyWa8/photos/AdDdOWpmKcEMIGjiGjbfXvMrwWM3SYH3sbvS5A5xsX5h23FdIEHHon2zOpmtygR75jlkqQ_vtkoXxepIBmf_WcKUtlhzGU_p6VbXfsZbe1ahe8DKtivmVyAA8aNarIBMPQm_xsMQNMubu1HVDpGAfvSUKovhNNuw07Aca9h2",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "toni cucala",
                "uri": "https://maps.google.com/maps/contrib/105105910382453310187",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVoQTGzG26beOaJnOLns5FP6RgosWhbNk-jpnayhjDXtXjFALZYyA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipN9fJh_MdOHubkgsMpdnncS5kVgm8gzOI3mGShK&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipN9fJh_MdOHubkgsMpdnncS5kVgm8gzOI3mGShK!2e10!4m2!3m1!1s0x880e2ca9ef5f71cd:0xaf5972b7d4177b08"
          },
          {
            "name": "places/ChIJzXFf76ksDogRCHsX1LdyWa8/photos/AdDdOWq6CE7BA9YC-HJTXgWuqnVA9J318249zz8QClf4Ii3_BESgnHXwX-6I1obOdw3kRAdIsj47sJDfBUA4uPLLZBEQsVXNiUalBhQ_zQtW3D_vMdH-3O4rle1c7Lbauj7Xfwg8KzYzeL1nyRyzbheOepKmul6536bj4Wt-",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "toni cucala",
                "uri": "https://maps.google.com/maps/contrib/105105910382453310187",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVoQTGzG26beOaJnOLns5FP6RgosWhbNk-jpnayhjDXtXjFALZYyA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNc0-5CSVRxVxYPrdAlPNevNO3JtAqxp-siQPYL&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNc0-5CSVRxVxYPrdAlPNevNO3JtAqxp-siQPYL!2e10!4m2!3m1!1s0x880e2ca9ef5f71cd:0xaf5972b7d4177b08"
          },
          {
            "name": "places/ChIJzXFf76ksDogRCHsX1LdyWa8/photos/AdDdOWoxTh1_poUmSF7rTn_8H4XchsN2F5cNJTKsZ_IBrAfp-sliLiBy3SYLttJHtJf7-B5HvbPYvxEPbN5y02JbjAJ3VbydXtHOao0hN_wPrHtUh1C6eUNms1_QoKdFVN8VEKFaleW1LGgtTlqq8sQiHvARWBZBtR0vY90_",
            "widthPx": 2448,
            "heightPx": 3264,
            "authorAttributions": [
              {
                "displayName": "Belle Lopez",
                "uri": "https://maps.google.com/maps/contrib/104731732886039479725",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXJaXXCmJKT3A0h-pVZ5EtckuDukCB_PBRi4MZGRcmKMufnAMyd7w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipORrVfvmn_YGZKut7vuSXtek0kfLH5Fk-Oq1POd&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipORrVfvmn_YGZKut7vuSXtek0kfLH5Fk-Oq1POd!2e10!4m2!3m1!1s0x880e2ca9ef5f71cd:0xaf5972b7d4177b08"
          },
          {
            "name": "places/ChIJzXFf76ksDogRCHsX1LdyWa8/photos/AdDdOWqdPK-LB52-qImvxQVSUKYZFTNT_DxwSIjzF_jDgEYT4QeUgcm7VxB88jEkPduD9FL9A_6ANGnQWHNP9-SeOZwkXc4aw_x0Nh5op1R4yykvFYbbZbZkSG_s3pH40HYgU1JTtk8pdU-K-kixaLhILzT_Hwd-Kcesjno",
            "widthPx": 3600,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Reem Alsankari",
                "uri": "https://maps.google.com/maps/contrib/105419420815823339712",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXYM4QrqS-U0ZFD1XwMgbKQUNMSJepy3b6sbwd7f5veAw9X8SM=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO1JVi9GoOJZHmkC3il2bdeZIT7ss21c5Nl4NU&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO1JVi9GoOJZHmkC3il2bdeZIT7ss21c5Nl4NU!2e10!4m2!3m1!1s0x880e2ca9ef5f71cd:0xaf5972b7d4177b08"
          },
          {
            "name": "places/ChIJzXFf76ksDogRCHsX1LdyWa8/photos/AdDdOWppJMZXL3FgZgGamDLYrOBMAYk7DxJtLMkTFEzHjO-3sWbkk1ENaaFBRUe5WHzXAsXeia1bABdJiMKae78ksZodSn9XkcrX-qYQNg4WNb-vw0-G4Hny0OxMfEjlEA3PbVoRIxvyZmIlvQTHNGC27oYgTTod2LH9UsbS",
            "widthPx": 2448,
            "heightPx": 3264,
            "authorAttributions": [
              {
                "displayName": "Belle Lopez",
                "uri": "https://maps.google.com/maps/contrib/104731732886039479725",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXJaXXCmJKT3A0h-pVZ5EtckuDukCB_PBRi4MZGRcmKMufnAMyd7w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOJcboKUY44STm3521IlO6a674xblN--cMgQ0XY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOJcboKUY44STm3521IlO6a674xblN--cMgQ0XY!2e10!4m2!3m1!1s0x880e2ca9ef5f71cd:0xaf5972b7d4177b08"
          },
          {
            "name": "places/ChIJzXFf76ksDogRCHsX1LdyWa8/photos/AdDdOWqXXdvYG19Wp0D3n_zZ8DnIg19tkMbBddnJz1G_gc2ZTNxNGsYt7GOXCQ1Gir2NaekYbROdUiIFgwkUo7p04wsqtLfb19NHOR5_7EmyB_7u4By_mETtLUaAVUs-2lUvT_EeXfWZOJLB5wb9scMR3YNGLhu63DoniN1r",
            "widthPx": 4000,
            "heightPx": 2252,
            "authorAttributions": [
              {
                "displayName": "toni cucala",
                "uri": "https://maps.google.com/maps/contrib/105105910382453310187",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVoQTGzG26beOaJnOLns5FP6RgosWhbNk-jpnayhjDXtXjFALZYyA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOIjfohZNREn8e4Rco76ADLBDQPrPs1aANk3Z8Q&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOIjfohZNREn8e4Rco76ADLBDQPrPs1aANk3Z8Q!2e10!4m2!3m1!1s0x880e2ca9ef5f71cd:0xaf5972b7d4177b08"
          },
          {
            "name": "places/ChIJzXFf76ksDogRCHsX1LdyWa8/photos/AdDdOWoRPqsqV5cbszi5od6jo_IzZ9E6p8LEFe0qhvuA-bym1hRbNAkcF68ZAeh2T5DzXY2MnnsDR-JBPibYLJGkZDa80nE-9UWODww3fz6MFcTliIYg3KferTMOreNNvMumt_117pAFtxRh-pPqRm_ujXCT_6nSUXGb2FjI",
            "widthPx": 2448,
            "heightPx": 3264,
            "authorAttributions": [
              {
                "displayName": "Belle Lopez",
                "uri": "https://maps.google.com/maps/contrib/104731732886039479725",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXJaXXCmJKT3A0h-pVZ5EtckuDukCB_PBRi4MZGRcmKMufnAMyd7w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMPRRrrWCGvoQx1lctiryx_XTHhFFfOd2lSw8kU&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMPRRrrWCGvoQx1lctiryx_XTHhFFfOd2lSw8kU!2e10!4m2!3m1!1s0x880e2ca9ef5f71cd:0xaf5972b7d4177b08"
          },
          {
            "name": "places/ChIJzXFf76ksDogRCHsX1LdyWa8/photos/AdDdOWrZwX-M2wiPbucI6Ni5oORhvagBrm_j00fj1AXLNKWoAMMqlT2my7fCReD9g5e5dEV9Qli2nqW19D1qfUSwJ375ZFTuNexUGT8SeGH4SmeLWjSmUtXtcBqm40azj9d88eAXe5nWLflBgfTofsCy7V3NC7EmEczMcIiK",
            "widthPx": 4800,
            "heightPx": 1594,
            "authorAttributions": [
              {
                "displayName": "Belle Lopez",
                "uri": "https://maps.google.com/maps/contrib/104731732886039479725",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXJaXXCmJKT3A0h-pVZ5EtckuDukCB_PBRi4MZGRcmKMufnAMyd7w=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOFf-p4HV-ANeIwy1IvRwu6zdbnzlpUCzexkLIv&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOFf-p4HV-ANeIwy1IvRwu6zdbnzlpUCzexkLIv!2e10!4m2!3m1!1s0x880e2ca9ef5f71cd:0xaf5972b7d4177b08"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        }
      },
      {
        "id": "ChIJp77lDq4sDogRpoHbNJEoye8",
        "types": [
          "night_club",
          "bar",
          "event_venue",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "11 E Hubbard St, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.8899495,
          "longitude": -87.6274762
        },
        "rating": 4.5,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 3312,
        "displayName": {
          "text": "Andy's Jazz Club & Restaurant",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWrJ_Cxhbx2EHvpfobttINz-Wzg542NG9WkzdTupf9gVT-X-_Va_K1bp_xwLj2RMaRNBZOqSx4Xyu7zJpFjTc8BBTLrTaD-3_PQVgzJ-f-z1W3e-TGV9KD0JRLfprAkyS4EywEShK7pHVTFnJzDsiO4qOCqhgflItvi6",
            "widthPx": 4800,
            "heightPx": 3200,
            "authorAttributions": [
              {
                "displayName": "Tae Kim (coffeecup)",
                "uri": "https://maps.google.com/maps/contrib/115456773589950316807",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVVUEhNJZEYGtMl2CcgZzkn48ImpKeeKIurChOL-v5zxL1L6G1j6Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPG6fT4VJVllvqszPBsImeYykK-R7q3YQaBrl6k&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPG6fT4VJVllvqszPBsImeYykK-R7q3YQaBrl6k!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          },
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWprcxPgF9TATyqqpazIU0U5QYIs_aB76tGyzV529u1f9q11R1kXY8rpEe-RnwBT4jmFGMocTTvwAdWkB4jDsIzbB_pKw7XpG-NBa0287VMjioXmPRGGpd1GTHwdWYPQ6dczcL3pNVqsu_Lx1AbxfbL-fJ8AHgrILgJp",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Medic03",
                "uri": "https://maps.google.com/maps/contrib/106995109313539524986",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVd6py9CuuVJwUrHNb1-Ft3n2bnMW1Xkqns4tam24gftnuo6UUU=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNCuZPvlwopTJc4d_VMwrf4vx3DZ6HcIXtovwim&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNCuZPvlwopTJc4d_VMwrf4vx3DZ6HcIXtovwim!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          },
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWo3lGjNJ5wfzTbZ8345Q5RmwRwUK2CH_ziDYrC0PNxZ3j43QqD0TiR59WHKYrTdVlo3fMvp17UbVcByHvYXMKa6_zZNNO0fTx5xDj-w1Lt9TQWZE7Dt1WZP4rUKRj37ec9ADr1RJSgPfAngmQHteeoIQBSt-Z62RKk",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Blake Huang",
                "uri": "https://maps.google.com/maps/contrib/110896938340812179502",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW9nxQNWoliXyDM3UCqBQpLwX5_VyRa3h3-ylEBKh9g2aYgJ2E=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNLVItwz8LwVDQMHEiy9nt7inaTmObjYPmXyjY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNLVItwz8LwVDQMHEiy9nt7inaTmObjYPmXyjY!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          },
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWpqRFNTT9lPrZ0riHZZg9ixEYzagPQbUZ-r04HNxuv_QvVTIc4qRM6MpMrDLuKRTyNrS9r0Yk7JWayu1Qhoe6zGIOGkpaAP_XG8lsR1SU7D5aGHaGaRBwk_gKT83hLqr1tGJXH9x8-MrH7M-kx1rzVYQN6VkQlxjIvO",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Gilberto Mendoza",
                "uri": "https://maps.google.com/maps/contrib/103577703178312350494",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVyHZqKtMPdb5RYgduJoeN2dxEo54ZaqeFa3J-FYLPETu7TDH91=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO7zVkcV1X8tqLYl9EEJLWL_XjI_-qAXEDri3WM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO7zVkcV1X8tqLYl9EEJLWL_XjI_-qAXEDri3WM!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          },
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWpmUjxN_n4U1zlFZbJti8nYwEv4sRNV-EisLN_5EEgipjraWMfEibSLctbRPQtIm-EIFzQs6yiXF7SIewH2c77aIZJlpQv9928T9UJQNDMO18GtsHgEr1336rTP-nAU_xaUwmBJbdogq7NvNPe1mbMn8vxCfNaPZmNG",
            "widthPx": 3631,
            "heightPx": 2724,
            "authorAttributions": [
              {
                "displayName": "Jon Kline",
                "uri": "https://maps.google.com/maps/contrib/116183684734047586794",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjW_J2bF5xvSgxrpxNek4cEgya1GQwc3CsNc0RYamEglEddghbQEqg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOQ-jrVCfjwxDZ1q3rDrB3i4eRTfTetAL2TkzOY&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOQ-jrVCfjwxDZ1q3rDrB3i4eRTfTetAL2TkzOY!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          },
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWqyzYLepgM3kSplTRVD9Db6hEc1HeZ9V3ZHRKx4hZ5TXPu4KNHboNE9LVKuATZKme-_JgibDdclxkzU7YIdkY0J17TvRGfXoIfOd5nl0_1Nu8CjP838qqxqiJekOv8sAT4LqFSL0cbDQD8O96oSX0SqVgcx6bhQYXDl",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Yujin Julia Jung",
                "uri": "https://maps.google.com/maps/contrib/102178265010885852028",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVNLeXuTQ28_jyjs7wRgo13gPOCxQRckxOxNaPG_v3lPySbec6hCw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO4BcoKY4hZHfVD61iTuyOYcyjbeEIeXGF3j2Zi&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO4BcoKY4hZHfVD61iTuyOYcyjbeEIeXGF3j2Zi!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          },
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWrue2Kj9G1vlb-REjo5n2qbBm4bsKY2CmLdam8paBRkre5X0OcsQyoLe1rvx4gnFxrQmrmrENcdUOYoq6UuSGeMkh4OepvWgXurLE7FVkIsOHrecgMf2I8_qNfg4fcGd_5V1B_hLsujqh4Pe_kuTBZcg_DDvK7XaYT-",
            "widthPx": 4800,
            "heightPx": 3600,
            "authorAttributions": [
              {
                "displayName": "Ben Park",
                "uri": "https://maps.google.com/maps/contrib/108204302788283647618",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIkIbKJ8KbEOP2xghcDOyWwAfpCJHOOqB1gVqza_CIQXlceDA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM8CohILQ7TGR8V6ZJmtllBwPzFcPqlnFisYo8a&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM8CohILQ7TGR8V6ZJmtllBwPzFcPqlnFisYo8a!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          },
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWoX0-cqKYFFEPNfiA7TZ9hdG9bempQBM6f-PuWH1JbSV6_WYdZkRDFuIgLVOGiE798-_qP6jxLH4Iph_NF6MBsfJ2CAyEyUCQS6C8bfoJBG102HUIZB7YHd5zm126Np_3_8Lz5wvxw2UZtLMpOmSZDhYgE2KSJjIdSZ",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Sabrina",
                "uri": "https://maps.google.com/maps/contrib/117612319440361715580",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX7uB1PkCjrTNby_MBg2d5ejtcC-tcnmlTxDjW7sVb9zXyD5DQxig=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNdhQ6ymeLAbzGLLnCo0tN6KkHjlrnniUPHI6Kc&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNdhQ6ymeLAbzGLLnCo0tN6KkHjlrnniUPHI6Kc!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          },
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWpcI666PfGzyPyyGCxgusXOwOYECVY79JIhAwBlrD0fhN5vwZzS4p9OeKz5X53JSkajwX2ubfgntMhyoKbpZOOxcAtHzOMjvQVHZYIDQ8C6alGxt3MKDyAvzRx-bZ1EWbcAh2LmZ3U5N4BvalsZ0h1Hg3eiPrrh8uYv",
            "widthPx": 4096,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Michele Fagnani",
                "uri": "https://maps.google.com/maps/contrib/114255584449215213190",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIskySTvtrivtJNYucYzScrU6OZezzHaMakHe2qeEsRoVeroA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMJmXeorwUFjU654bGiWq_jumYs5FzGLeDs89B8&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMJmXeorwUFjU654bGiWq_jumYs5FzGLeDs89B8!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          },
          {
            "name": "places/ChIJp77lDq4sDogRpoHbNJEoye8/photos/AdDdOWrhFCozXaptGjcUmbAJ2Y22EFIxq4cfk4am8rLvsJ7eTS6jppNHqnse20HqNNKJuc7kAh1EyOZ8H5i7PQMY6LlLzGuDgLMNnsmopkEN3KEab9CtL4yVAwA0QmMtgiXB2AR0ocxdMwbx9be5MtSdGzFbaVMMdJ9KXi4O",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Patricia",
                "uri": "https://maps.google.com/maps/contrib/101870549330981781213",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU-Lziu-Qbq9SJZ1QIs9FeuJaQac5dZoZbLxJFIuuMIovz3inFXwQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOaK_9vR41v7Fg2aooxOwwC1erB9_oM9cmQ7_pG&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOaK_9vR41v7Fg2aooxOwwC1erB9_oM9cmQ7_pG!2e10!4m2!3m1!1s0x880e2cae0ee5bea7:0xefc9289134db81a6"
          }
        ],
        "restroom": true,
        "parkingOptions": {
          "freeParkingLot": false,
          "paidStreetParking": true
        },
        "accessibilityOptions": {
          "wheelchairAccessibleParking": false,
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "30"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "50"
          }
        }
      },
      {
        "id": "ChIJhyiIuBAtDogRx8hP5bP7zEs",
        "types": [
          "night_club",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "353 North Clark, 65 W Kinzie St, Chicago, IL 60654, USA",
        "location": {
          "latitude": 41.8889898,
          "longitude": -87.63075289999999
        },
        "rating": 3.5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 75,
        "displayName": {
          "text": "Bodega Nightclub",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJhyiIuBAtDogRx8hP5bP7zEs/photos/AdDdOWoBWPzDbgNTk8dMWIP8JwlvDrknJMXaV1dWvyPO7Nuw83EX3SmojqypAxjXW5sj9e4XGGgq-8t2YeEz5iNgje0uUnoq-5Q02pnq45qwELAJ-KTmbDsgi3S5G5Shz0uOZ7wxGADaDwXp88DSjRbbMd9S1EMGfO8GW9xa",
            "widthPx": 2268,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Sadaf Sharfaei",
                "uri": "https://maps.google.com/maps/contrib/109485037872597854423",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWRDqgoxl10TX5DoOR6Q5EXEdikUP3wq5biff77roAH_BlcbnJa=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMkofgPBK69SEA7V0Se_YfIJcnnIjZnM0X88nrU&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMkofgPBK69SEA7V0Se_YfIJcnnIjZnM0X88nrU!2e10!4m2!3m1!1s0x880e2d10b8882887:0x4bccfbb3e54fc8c7"
          },
          {
            "name": "places/ChIJhyiIuBAtDogRx8hP5bP7zEs/photos/AdDdOWoz4pPivVDn99EVhafTg1SOj18QLTfhUCWyxJaRL9u9wDEKfwWhKonEqzIQuPMbhVEZ-khyrB1JkE1Wwc3r0cyYLFMmHrUKR31k-t70gXapHohstq7-Z7bsicl44VOargLaDBJ_STBH0JgWGovEMuAs-xnp4vxsAS8B",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "vikalp dhakad",
                "uri": "https://maps.google.com/maps/contrib/104581531175539293312",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocISuPmI1g7dJoMyCBbaVQfi2GkGmiEA8q1p6zas_AsE-8GDyDyR=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNwyNRAz1UNRh4Ct_QmenIqYaMszNQLTVrXT9ym&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNwyNRAz1UNRh4Ct_QmenIqYaMszNQLTVrXT9ym!2e10!4m2!3m1!1s0x880e2d10b8882887:0x4bccfbb3e54fc8c7"
          },
          {
            "name": "places/ChIJhyiIuBAtDogRx8hP5bP7zEs/photos/AdDdOWqkkQTCX9-Zp-y8j_ntiNdw7EIy1f-r5WpUaAKk4A2lsJPOiQl4SSG_T3-TMXq_FGoNwVmHZF5ZYKVPMeTaabHZ5QntU9_vR0QNX2wqjKHN_5cxxNAqcu8rJPW2oDA34Ql2xyJWJ7jSoZwY_5N15LbOtIorM1G9ueor",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "Sadaf Sharfaei",
                "uri": "https://maps.google.com/maps/contrib/109485037872597854423",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWRDqgoxl10TX5DoOR6Q5EXEdikUP3wq5biff77roAH_BlcbnJa=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOvgbOUHjORXjn8oWizAiZ26d9cMWm1x0yb0T91&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOvgbOUHjORXjn8oWizAiZ26d9cMWm1x0yb0T91!2e10!4m2!3m1!1s0x880e2d10b8882887:0x4bccfbb3e54fc8c7"
          },
          {
            "name": "places/ChIJhyiIuBAtDogRx8hP5bP7zEs/photos/AdDdOWqUzE8i8iOJIY9_TCtsKUuW0eb1-BvOsratjVyVkJIBp_ed178YYnw2C2liG7xolCnfFbY8coaws3h3bz8iwOavFiqqEvaD9TQ2Igt_ct6g2EVKQswcflhvVX3IvsZSfjowUBMuwzT2jPtzpYjnjdhaJ34foMvNNV3w",
            "widthPx": 1908,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "shubhankar nanda",
                "uri": "https://maps.google.com/maps/contrib/100978473970718509875",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLG1grXmZdNk-gxmThBvOluAGcArEPamva3Rfrm0OrxTvth7Q=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPRlJwfpp20uJ4jM8PNTPo0aNvSiS64W4DAUf6a&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPRlJwfpp20uJ4jM8PNTPo0aNvSiS64W4DAUf6a!2e10!4m2!3m1!1s0x880e2d10b8882887:0x4bccfbb3e54fc8c7"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleRestroom": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "50"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "100"
          }
        }
      },
      {
        "id": "ChIJX9_UQBgtDogR8ecG4-PC0f4",
        "types": [
          "night_club",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "25 W Hubbard St, Chicago, IL 60654, USA",
        "location": {
          "latitude": 41.889824399999995,
          "longitude": -87.6290975
        },
        "rating": 2.2,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 131,
        "displayName": {
          "text": "ROCBAR",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWriRZCmorp3peJsXb9mBZK3n6IEAptLheXh6XnLacbwMoQXT4pZlef0bAN2JVd_Kn0DQYGjKk6hLM8zXY9g-3vMw6k9ZVJnRzs82gRG0v_hfIzifBt2V4Tb5eaN_XKFh3aNQjSs_CqDX78ozaYaEC28iZ-lacRRBpXc",
            "widthPx": 4000,
            "heightPx": 1868,
            "authorAttributions": [
              {
                "displayName": "Aleks Ruso",
                "uri": "https://maps.google.com/maps/contrib/106939725390452795235",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVA3VxVgYmR3zsQsG0E2FED6ctmLd32vnexsljedKzvI5jFwgXe1g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOFHUFPtYsRC6NKnIwBpZudCtc1hbyK6kJHbHTT&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOFHUFPtYsRC6NKnIwBpZudCtc1hbyK6kJHbHTT!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          },
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWqdieALbJolB9dA_SzzM88Sh8na267v53DN85YhvKl2psdTADOKEb837w2MUhQS1-dGdzzDB4-U9Jnw4qQaMCeKa69Ab43RdEIHdcbhQgAE4CyZ2DAsO_O9nVQg8LLDkHiV29QeRVrNFioxlLidRKKYKNpdh_0imLFV",
            "widthPx": 3000,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Ahsan Mustafa",
                "uri": "https://maps.google.com/maps/contrib/118292218136143226507",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLzNKFaNme9ZIsUsTmWWz49e1VeaThI1UuOJcUIfB3aHbp9Zg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNM2jjZfIsUHiUaj_XT9XVesInTmKk5GERqwL9o&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNM2jjZfIsUHiUaj_XT9XVesInTmKk5GERqwL9o!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          },
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWqapj75j3GN4mf4pFpRWnS9jCl3P3zSIOdXFa7NjQ7rGyOJaDL8PFgVwGyZec4d_wj88wrIqSNR77wwJBXcYjXQYsKxm-PhMke0czfOjLmht9vrqkVIVsctCRVI2Q2akEQIJcqwXlZ_nBYm7qp5E9cOGvl1vFmQfaM7",
            "widthPx": 2316,
            "heightPx": 1688,
            "authorAttributions": [
              {
                "displayName": "Jimmy K",
                "uri": "https://maps.google.com/maps/contrib/110054719977975899444",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLh6Jfz8KMFNjwkKiyqt7Zjes5vH68kHq7FLOUIGTRGyPUjNg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP_ftc09j_14GvSfk_5oN1pp3dqaX2uPiH8mV9R&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP_ftc09j_14GvSfk_5oN1pp3dqaX2uPiH8mV9R!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          },
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWpuywdaSM6QU_snxhz6qDurNKFXhBRMcdGq8ZEpjzWWmkHi-8pC985ebIfrdk49l5ht_NFNYDKncfyyhctJ_F1ybI-I9AokYDmPzyIhNiznCW8RVAbPQ5l-n6K0LkmtYSBQKM9Xp4HXxgpWMwIf1LHInL4Uiix8FFMA",
            "widthPx": 4000,
            "heightPx": 3000,
            "authorAttributions": [
              {
                "displayName": "Ahsan Mustafa",
                "uri": "https://maps.google.com/maps/contrib/118292218136143226507",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLzNKFaNme9ZIsUsTmWWz49e1VeaThI1UuOJcUIfB3aHbp9Zg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPdxS7270WrV4jvop2Pya2DOlLeHUco0iS2wN_p&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPdxS7270WrV4jvop2Pya2DOlLeHUco0iS2wN_p!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          },
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWpg6u4wpwQRw2iQgXpgV0vKCu-2ryhPTofQBeH-akXdnZByMpmvAdD1wvgdVy4rg5sIfN2OgghPrjkUpAVs8u_1sBmHk-JZUmDwBwx1pfXi6vl-fJkIf-PpyUOGFylXtRHQ3OAkr52ORFjOvKJNddFHyHsWbU_aaKNE",
            "widthPx": 550,
            "heightPx": 413,
            "authorAttributions": [
              {
                "displayName": "Jennifer Russo",
                "uri": "https://maps.google.com/maps/contrib/117640790751831708750",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKFEkiuz1bMtx1Cr7gzsXCtxxNhlLRJg1X5ughRpRzEPhZxLg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPAPdr_RT2X-oSZF57KNUB0tLK9MV7gdMynViZq&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPAPdr_RT2X-oSZF57KNUB0tLK9MV7gdMynViZq!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          },
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWq0alK4Aqp0C8IWu97eTafDlUZug1vsg9-Rc4RNDZKFpYS4Qia1YkocQBGTwZBeaiNqB2y4fytjEa670a0DY3YyHl9blqQ4-U__d2Sr-CNA01exG1gCQwKu-v6ALY7i_Ha6YQ7mN1D0BErNuHw1Ybf0gT_gw7qwHfvE",
            "widthPx": 1284,
            "heightPx": 2778,
            "authorAttributions": [
              {
                "displayName": "Jenny Ismailova",
                "uri": "https://maps.google.com/maps/contrib/108822302840322368367",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUUp7ZHPuN9wuWSAcgNZ_fEBFii4axtIkKuWt8Hag0FjlnPSCxl=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMj2KARZXI1OHhvx3I8jxiT4NDLnJJ9nnoEgnyj&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMj2KARZXI1OHhvx3I8jxiT4NDLnJJ9nnoEgnyj!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          },
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWqeBq7oTmfLtrpOySkJHDtNuE_d5a6R_u6QQ77KXU1ONeBsTcaKpVMs82pkJonwCVcUkwVo4muAg5L03cKAaikbLxwAqxxvQoIBvjP7gkpdnx4wWKbjZYSosanyQMMUeBTr1mYtZWMlcWLOavW7OD0Hq5jy6Big4dS-",
            "widthPx": 2464,
            "heightPx": 3280,
            "authorAttributions": [
              {
                "displayName": "Syed AS",
                "uri": "https://maps.google.com/maps/contrib/112479804003143237236",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLdn-O6GsQ63ck-0KxugHnTMAoTsETycW0GVyzbY-s0AdGGNA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPVSVJ-P1Lgeb-xxUuskGBow_jHfhDG1OFaKWcI&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPVSVJ-P1Lgeb-xxUuskGBow_jHfhDG1OFaKWcI!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          },
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWrgTZBET2v1Jj7iph2VrKBUY6FIqOSFAi3R7kHDnJoNLHbRfCrmsUCQAoYvHgZIhTheF96JJLk5x3kLCkc4ep78lDtLU-SgvhY_yE6pOphxhyZvDT23xgpVyanUPCRlwffoRg0YQ_GhKwNB7VNShUqhxj3uhW4ZUvih",
            "widthPx": 1216,
            "heightPx": 1820,
            "authorAttributions": [
              {
                "displayName": "Nate Alpert",
                "uri": "https://maps.google.com/maps/contrib/104167433182736489490",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUp_WhWFqmjyEtZPlGslwKx-hJQztIkuFkmOKZ7qrPw8PCmywndEw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOWcsF4BnB4hAn_Uclj9TO_3W5m6dWuQAGwc0Ut&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOWcsF4BnB4hAn_Uclj9TO_3W5m6dWuQAGwc0Ut!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          },
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWpzC1Q1NL-ppsztQOoBrm6ZTQ2yskEAukgjuKvd6uiyMdy-2sxouMqMCpvkSTQezp4hNPlrjPYFy0j78goGbtq0o984uWOGefGPUVMdJDiRL2nGb2sIhLtaTmY3ebNfSTak-vLCxi3CqrQeVvaAjOXOz2Lvzs5FKeSM",
            "widthPx": 560,
            "heightPx": 400,
            "authorAttributions": [
              {
                "displayName": "Jennifer Russo",
                "uri": "https://maps.google.com/maps/contrib/117640790751831708750",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKFEkiuz1bMtx1Cr7gzsXCtxxNhlLRJg1X5ughRpRzEPhZxLg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOWWzwpfcInE7H01Onjh0vyaYjeJyuw6_47M-US&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOWWzwpfcInE7H01Onjh0vyaYjeJyuw6_47M-US!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          },
          {
            "name": "places/ChIJX9_UQBgtDogR8ecG4-PC0f4/photos/AdDdOWo39FlrXnUyexeocLqLmcOw6fO2kdi2ghEhphreuuXTSQkhOw-1crEtkWRlQ-i-0wQ1Qz2ScLyYqn--qECwzcXwA3I8Tqi8KQ87weJanhB6lDyDpzv24VMQpQlyqVq3pQ2u1S9tjUhO0HD7NT2RoqxTl5PSatUK4GCZ",
            "widthPx": 348,
            "heightPx": 348,
            "authorAttributions": [
              {
                "displayName": "Jennifer Russo",
                "uri": "https://maps.google.com/maps/contrib/117640790751831708750",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKFEkiuz1bMtx1Cr7gzsXCtxxNhlLRJg1X5ughRpRzEPhZxLg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOIdXArF5tUOodkaGWxFeJZw8tfzUcNnB0bQPmR&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOIdXArF5tUOodkaGWxFeJZw8tfzUcNnB0bQPmR!2e10!4m2!3m1!1s0x880e2d1840d4df5f:0xfed1c2e3e306e7f1"
          }
        ],
        "restroom": true,
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "50"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "100"
          }
        }
      },
      {
        "id": "ChIJmw1Fu6ItDogRnnF4QLWGMys",
        "types": [
          "night_club",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "58 W Kinzie St, Chicago, IL 60654, USA",
        "location": {
          "latitude": 41.8893717,
          "longitude": -87.6302161
        },
        "rating": 4,
        "businessStatus": "CLOSED_TEMPORARILY",
        "userRatingCount": 1,
        "displayName": {
          "text": "Dance Studio",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJmw1Fu6ItDogRnnF4QLWGMys/photos/AdDdOWqy6yzzHnXdvsf7ipX06qB-3PPHNv1tmBOy6tO9t1oI3dJni7yDJBZQmTs-1aoJnB9Wo0970tOzBIV_ZZgm0lka-c6zY2pK97-sgu-R8Od3Iiqc6aqc_VMyi1zs8u27GyvDJLvY9weyJ1c0oQ9_MWMUIe3ZzkJBKmN5",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "Ashley Przybysz",
                "uri": "https://maps.google.com/maps/contrib/101812492927636364290",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVCLqh6Dm34yvvwS2jptzG7wBxnV3svbxyAvxyptx2gxHPgMKz-qg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipO_SJbo-2zp9jg8bFEPhVqacqJFxR2fLKyZWPHh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipO_SJbo-2zp9jg8bFEPhVqacqJFxR2fLKyZWPHh!2e10!4m2!3m1!1s0x880e2da2bb450d9b:0x2b3386b54078719e"
          }
        ]
      },
      {
        "id": "ChIJKylS97EsDogR0HiUSKYR8-g",
        "types": [
          "night_club",
          "bar",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "25 W Hubbard St, Chicago, IL 60654, USA",
        "location": {
          "latitude": 41.8899444,
          "longitude": -87.6290861
        },
        "rating": 2.8,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 271,
        "displayName": {
          "text": "Social Twenty-Five",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWok4_2VPSUcN-iRGPY8jojjtNYjwc-SHLUehJo47JG9kr7wvymJLAi_H6coKGanwYxNohF_L18AtQsuI7MsJNokaFLrfJi7L1N4ZWwbarDhu4u2kl7N3xogcdPTybRLzH3-_Zbrkwf5asV0Xo-EaVyEGBvNbEEBsxk7",
            "widthPx": 4160,
            "heightPx": 3120,
            "authorAttributions": [
              {
                "displayName": "Antonio Quintana",
                "uri": "https://maps.google.com/maps/contrib/107153037049812778353",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWTmJaUzytXa6bGLJc8743BqEBoyfQI3g0glsw2Ap_jaJDMUznRMA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOl0ePvT8lPzL-42Xs_j6bMs0VLopm8Y8mnVLXS&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOl0ePvT8lPzL-42Xs_j6bMs0VLopm8Y8mnVLXS!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          },
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWqSRDX5RMfZf3F8WzSxKaSNbW4do8SJpLLZixDt5R151kC6h1QC31DSaIotZYJO8qCBPg7qzRWQb94keyIwHCDVoSuefsGWC0NVT9CEvf0I7-m-Q54QfGM9R7bU6iiw2RXyTEWMbWZNoG-2zXAAgjTrsANI5kScdo60",
            "widthPx": 1836,
            "heightPx": 3264,
            "authorAttributions": [
              {
                "displayName": "Nicholas Pellecchia",
                "uri": "https://maps.google.com/maps/contrib/111652343337698468237",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWNr92HCDdLKcs-CbC6Zhj7CsCVqOsFacZdGXPA6DMFgZ6GhOgk=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPaX3zw5Wq8TAwwiAj7EzTxrwzJPPhN6-7JrGfh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPaX3zw5Wq8TAwwiAj7EzTxrwzJPPhN6-7JrGfh!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          },
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWpcXqytnQxXlaNC_26cMVrTEf9g7lawi1Ua0K2b5RXMKGjtmPuzkrAxQDCrl5L3Zd5GTB7uDFYdKaReZ7TQ-Q2RhyDz8VVM17cm3CY6duDpbvjsy3pV6sipsiI5JyJLOSfhcmXB-7RSqr5RwXG51AY50yTtakIAJ7uB",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Kevin Sauer",
                "uri": "https://maps.google.com/maps/contrib/107450904999463240042",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocL3EWhu2XoRI7p-6SARs6tCq9DC3pcWrLB5CQzTIWuVxifm3g=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNn88hno00KhRtjwjr3Q5KWbVO9Lnrxi26C9i05&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNn88hno00KhRtjwjr3Q5KWbVO9Lnrxi26C9i05!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          },
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWpvkXpOtGOkdITAeV0yJGszlQe5kZzVeehyAC86stQGXPv3NRcWIxj6jvfX8wgqbe_3Ef6TQbsUF-gdpG9X1AjGg7alsBaTX5K6fmVkytStV2Q--E-nHPDsDVDnU2qgtF745FEIis_dmEvZ3W_VY8V3OuLvXAd1GQEs",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "overlooked & underrated",
                "uri": "https://maps.google.com/maps/contrib/109106086671951597425",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjX3i4tVybxzrOFUGkko4zA9ngnHkvFVUK_f1jAupjybsHQWkLQL=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOW-tb-ayk-fF_13-lT0FTEBmEi2DfVDkCYsmYw&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOW-tb-ayk-fF_13-lT0FTEBmEi2DfVDkCYsmYw!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          },
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWqeGQHAAwP8ZAGw-EHbd3E-wWGzj-neChL3RShvvQAcQkYz9CMF4krGHXv7t9BNNOh4wnRH3w8LnS_WW5RgqRg5E4Ulqcla0D-3L_lc3SMRV4CQm5YsNVsNgCwwVCWJcHbik1nyDsQVy-xIPa3gNvTm6H4vg1IYbL3i",
            "widthPx": 3200,
            "heightPx": 2368,
            "authorAttributions": [
              {
                "displayName": "Mike Kelley",
                "uri": "https://maps.google.com/maps/contrib/118355006558358021713",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVlOkWME8K8EAEfEN3KpsoLc7-K0vV4ONrBKSrAmzYNdMysT2mAyg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOgVtlv7L5iszHpDdrJLp-ZQfqv7wIWmMDKh5bx&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOgVtlv7L5iszHpDdrJLp-ZQfqv7wIWmMDKh5bx!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          },
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWo49bH1mxaODbn7U3eQVTUjByEBBuJlNPwBQmU_9KPACQgdCs6_F-hlr6cOnfEDKf0417KyldPAG5RtyXNXYWaqbIEaLq3xdIdKrxGW4S8T9OnJ4RJxfYKDKKyZcXugiWzFKhRWAPhvuHOd-OtGC8p5dMfKhl8eoACO",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "219critical",
                "uri": "https://maps.google.com/maps/contrib/110165808813219813831",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjU9keVzvqqVha2dvB20fGQZ0GBdYQg5X9f-Iveeczl43Q5-jSpL=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipORtnxNsL6a1ojrZ8xI7d5hWMSSFaacTknQ-I2E&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipORtnxNsL6a1ojrZ8xI7d5hWMSSFaacTknQ-I2E!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          },
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWpBKVEDA0JH4kf-LHd77gyNYfpdt21w47IAmMpoC1OKHXEwoycXCnjYd3kC5ix1KkrqcL2mQf4ACF2Q-fBxgXZ2K4cSgITZnS9tqFZCGRoo3l7fAdu2qeQcxWZIQjadk1N0y-cp2Fbxunbi80Skzs9RNVhdIMB4kRp8",
            "widthPx": 3480,
            "heightPx": 4640,
            "authorAttributions": [
              {
                "displayName": "Chris Szikszoy",
                "uri": "https://maps.google.com/maps/contrib/103486912177549101251",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVHikeCo64pOl4PvZ8j4nGRljKbDAT69drS4POzbqQzm4d29fupxA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMJZWhF0kL5LL6PdEmrXLOJ9z_5yqRbSo4C91ml&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMJZWhF0kL5LL6PdEmrXLOJ9z_5yqRbSo4C91ml!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          },
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWqqO1ZdCcC2Dj20okbRfDoDX-YryBs-j-wKZR39Glsg_490pm7ofYk5AoupALE-5YlkHifJ1pPTShVDwXOwc1vUV8xPtT0EvF9ptSbna5GN5XCl4IEQIEUnXBqRamwrlHOJcdy9cr4_whpB_hl1jWMH_bvEDYy1Tu8P",
            "widthPx": 612,
            "heightPx": 816,
            "authorAttributions": [
              {
                "displayName": "Demond Williams",
                "uri": "https://maps.google.com/maps/contrib/112494214286730747679",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUc0jIA26DQyQCyif4kTRgvaVoCPs8jsiLCqRf6M9Iekz8gfZqv=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOlPuPAWVhYH2dlgcanvpPd8R3gxW70xefOhUAo&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOlPuPAWVhYH2dlgcanvpPd8R3gxW70xefOhUAo!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          },
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWqvVpqpbjCRybalifPVFVbaMjrGLj3I4mfUKZfagn-PBiE3sQpMpKgncqLDkJzww_5Z-xNku8jynDjuhzPvRJ6-m91wbyD4QYBoymwUNedmHDzk2EUMUr3IqYh0_jEVVn-Fd0ALIOB2wYNy213Pca3P25Ap__3DzE3H",
            "widthPx": 1960,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Michael",
                "uri": "https://maps.google.com/maps/contrib/108830139905699635894",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocKozXt13ZDFqtxMsGMPdRjkC4h5Nf1P06c7VALgGmL7kvFjNQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMXvjiXgg91pANGQxMi2qpdZY2vmQwZ2F6dSo-0&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMXvjiXgg91pANGQxMi2qpdZY2vmQwZ2F6dSo-0!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          },
          {
            "name": "places/ChIJKylS97EsDogR0HiUSKYR8-g/photos/AdDdOWovSXbbSPCfjrP1kITAZ3BJzEEkXz4Y0DzSbWk-iZH4gS8Y8ZkEvYlPzpNFZCNm_I_UXKE6pHvsIaE-5_s9NwOfrwXu0cKaFgDKqtOmrwojKfRP6YgF6xcszOuGILGx7MRwCmb17oh6q-NlRKZ6qijVVCCkEOMAgMyZ",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Amber Bartolo",
                "uri": "https://maps.google.com/maps/contrib/109744680408867978182",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXbelm8iu9-_4_3SqlrjBKsXUArhOL_ZorcysBZCSH54C7wFTI=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP8kVNppg3YNNTHFJFbTsEOIcummL5KKU_U3OHw&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP8kVNppg3YNNTHFJFbTsEOIcummL5KKU_U3OHw!2e10!4m2!3m1!1s0x880e2cb1f752292b:0xe8f311a6489478d0"
          }
        ],
        "restroom": true
      },
      {
        "id": "ChIJvcUG4h0tDogR-qBgsorSEbI",
        "types": [
          "night_club",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "345 N La Salle Dr, Chicago, IL 60654, USA",
        "location": {
          "latitude": 41.8886348,
          "longitude": -87.6321646
        },
        "rating": 5,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 3,
        "displayName": {
          "text": "Sunset Lounge",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJvcUG4h0tDogR-qBgsorSEbI/photos/AdDdOWoG_Q1axC9TxS88n0MY0WvINZ_5k6tLBaTaYq1uTeADKj5i9iRIbYHo5l5zTf60PoxjV6_xJRSB9YmNl-5GKsYLo__zXV5C8GooYq8WTPEyYI9oaWGiXgoTYMkxsn7-8nYFdU2NpAmm4tUOzGh6jybYGFfd0KD004Y",
            "widthPx": 4800,
            "heightPx": 2453,
            "authorAttributions": [
              {
                "displayName": "Robert Kittinger",
                "uri": "https://maps.google.com/maps/contrib/100931369644410795947",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVRJ5Btj7CigVamUK19sOV0K53eCVv57JD-X79sJUwqgbQ7gLW9=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNwPWbEZg_3bsI0h31iv8fG8wi11A8AQ5O-zFI&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNwPWbEZg_3bsI0h31iv8fG8wi11A8AQ5O-zFI!2e10!4m2!3m1!1s0x880e2d1de206c5bd:0xb211d28ab260a0fa"
          },
          {
            "name": "places/ChIJvcUG4h0tDogR-qBgsorSEbI/photos/AdDdOWruFyYsn342lWv4GAQK0WQiWsGP6YXQPJtPPBqI3UbBad4SG1Llyvku3gxJIXrv9prZb7nqO-Zbt9s2600G8PnDEwyXylitqchDShDes5dGzfYXDjl_K2PVwkIzItD04PMVoljfYTPJxo_fksMJ_0sqLVXVV1nBa1k",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Robert Kittinger",
                "uri": "https://maps.google.com/maps/contrib/100931369644410795947",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVRJ5Btj7CigVamUK19sOV0K53eCVv57JD-X79sJUwqgbQ7gLW9=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPpIq2DjW8aijRua5NredDS-2_jduixk7doR_Q&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPpIq2DjW8aijRua5NredDS-2_jduixk7doR_Q!2e10!4m2!3m1!1s0x880e2d1de206c5bd:0xb211d28ab260a0fa"
          },
          {
            "name": "places/ChIJvcUG4h0tDogR-qBgsorSEbI/photos/AdDdOWrNfFJM3Jv86cfbaBeVGWvrXElyzCNjPQp6Q6UOSXiHY4Z-5lyMrRA2_OUmc4Rhad3BYjD9uU2XICtGRV7K6vNJlCdaK602bNM6-lgYGW02SHtN8x7SeWaP4qFdh8h9FymfeI2I6KQX6b_D9Bc7MfQdt7_nNzujFns",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Robert Kittinger",
                "uri": "https://maps.google.com/maps/contrib/100931369644410795947",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVRJ5Btj7CigVamUK19sOV0K53eCVv57JD-X79sJUwqgbQ7gLW9=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNP3ebqZr3H6PcPihEfK9kdnXSs5qDnsAf4bDk&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNP3ebqZr3H6PcPihEfK9kdnXSs5qDnsAf4bDk!2e10!4m2!3m1!1s0x880e2d1de206c5bd:0xb211d28ab260a0fa"
          },
          {
            "name": "places/ChIJvcUG4h0tDogR-qBgsorSEbI/photos/AdDdOWr6L0KXpcCjkV_lRrOU54O2k0pazPFzJVUt3gYKft-WI-sJ7U0iMLAVS9ZKP6HI59a-yyaC3F_RAFmIXLz1UAOkHH46DVLLxltGn7YJPNvI7xyi17Ju5C2SNAyW_AD3o-U33Umf3XZGO1ghjTder68IL-yAyIIgC-c",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Robert Kittinger",
                "uri": "https://maps.google.com/maps/contrib/100931369644410795947",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVRJ5Btj7CigVamUK19sOV0K53eCVv57JD-X79sJUwqgbQ7gLW9=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMFuh6IajNEKHT0Pf7LTt95Q2jw3qYdM_BoLXU&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMFuh6IajNEKHT0Pf7LTt95Q2jw3qYdM_BoLXU!2e10!4m2!3m1!1s0x880e2d1de206c5bd:0xb211d28ab260a0fa"
          }
        ],
        "restroom": true
      },
      {
        "id": "ChIJc08qw1UrDogRVCCFCLQ-9yE",
        "types": [
          "night_club",
          "bar",
          "event_venue",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "465 N McClurg Ct, Chicago, IL 60611, USA",
        "location": {
          "latitude": 41.890802699999995,
          "longitude": -87.6172033
        },
        "rating": 4.6,
        "businessStatus": "OPERATIONAL",
        "priceLevel": "PRICE_LEVEL_MODERATE",
        "userRatingCount": 727,
        "displayName": {
          "text": "Winter's Jazz Club",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWqslnw4RpXerNi4aQSVPQrezOCOd_a68uRUGM-a0vrRcD9bDGG4oPQlabnhCIlA4r9zfCoRmt2FOcnexPl7CkzNY_Wu1yzVA4XPgaocVSmjqrYv9jbt5hEOq9dAHxWHbQC5tgmGgExyUujYPuWmtM8wbVc_sJjY3cR9",
            "widthPx": 2048,
            "heightPx": 1360,
            "authorAttributions": [
              {
                "displayName": "Winter's Jazz Club",
                "uri": "https://maps.google.com/maps/contrib/100583235123075970134",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXYjmDrgPeoDBDLs459GiKTJN6dufN4LNVB8GzoPYhXCLCfUzs=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipM5ZSTAXy20ccdDxKvhXxTH0gZeyiILAM3PWJLW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipM5ZSTAXy20ccdDxKvhXxTH0gZeyiILAM3PWJLW!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          },
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWoyPB__WnR8x2tM99X_ef2nsCoZXaeIe3mBvuvDmmJuDByJo36rz05GDTHbDdNOIkJ-6CexrAk11eq3UF9dVZjW6JHOhUfqSifPNdwVIWhVJVq6DUOqs7-eJturC3pxOGpznsmD-HVPmRcgP2pu2_7rOwEA588G-c21",
            "widthPx": 4096,
            "heightPx": 2304,
            "authorAttributions": [
              {
                "displayName": "Bruce Johnson",
                "uri": "https://maps.google.com/maps/contrib/110259458177978635508",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVFpQy1uJU5Sdxh7F4egsfyvjsH9VySnzIdLIUeSIdOUiglFwoqWQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPQx16kTxwhFWBQePfT7SeHJmPHq-vLw8Oa5zfa&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPQx16kTxwhFWBQePfT7SeHJmPHq-vLw8Oa5zfa!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          },
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWrt0a73ie5ahzu7mcEpGchOQSF27krjQgL3Ke2F4XJMjrvdMgSl083z3jY8keB9jK2g4OGGHu7J_4XwdQCNMNGjNsFm9G62giHENu3Vd2mlEJF4NfdKuDYZ-kMALSWn17YVV_cMrRu58GgOrBebAlNJX6VNvAdXvL6U",
            "widthPx": 4032,
            "heightPx": 3024,
            "authorAttributions": [
              {
                "displayName": "Vlad Polik",
                "uri": "https://maps.google.com/maps/contrib/105395253666893264073",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUtjoQ_T4oHB9x0X-HDeMK1clHicTMjhdvhZfd7VY7LHEOkIYop=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOraThelvE96D4jJiJ-IlAj4Il6YAdvOjwqmGS7&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOraThelvE96D4jJiJ-IlAj4Il6YAdvOjwqmGS7!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          },
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWogHHBiv14n2U-FfqVcH2m5wT7IAMQGffK1GjiBE1hhLjLpvAx4b4RRVaTpN9fX9_FKboKex-yUtRBNGyfMGDaQFT4tFtBPowTvW4AP3Vr0KFjrCPaZzh-ipN1vwYlHLbi5cj16xNGdKesEUCtM0SO5xrNO2eSuNmeB",
            "widthPx": 4096,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Bruce Johnson",
                "uri": "https://maps.google.com/maps/contrib/110259458177978635508",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVFpQy1uJU5Sdxh7F4egsfyvjsH9VySnzIdLIUeSIdOUiglFwoqWQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPXKxjWatgXH6YZW4jttT_G12TcTvFcpv3Csajs&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPXKxjWatgXH6YZW4jttT_G12TcTvFcpv3Csajs!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          },
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWqKmoSySGc5JxtyuCYtChAQY0aS1zRWifUZzEtyPfrBjBEI3ZBPSdTronYvsu2M-f7z80VVRI5Xk5SXMwTi1IauKEGfme-SuhPFzHWbHxiChHjGbdwzVYLg0Lg088Es7_0u58H6CntChQX6psFIHc3wbIddFuGeoMpI",
            "widthPx": 3599,
            "heightPx": 4800,
            "authorAttributions": [
              {
                "displayName": "Natalia Regan",
                "uri": "https://maps.google.com/maps/contrib/102914248206222783230",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWRtj5LdMujcO9oQORDOIhl9I2SxoVBma6HNClv1kzisD9FeYBlxA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOIL7D-1eQxfjbrZarQD20WCtOwKdVg1XPVdwhP&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOIL7D-1eQxfjbrZarQD20WCtOwKdVg1XPVdwhP!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          },
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWpczfsYSdIIm0U7Mokr4VC2Bbn6A_C1cn79cH5fhG26Mt7n0FwHPZq0E322YWuvLYr1baWyyPkhrYm1xL_yvla66nacDYwgH6lBBvRYLBGZ9FU76pnkdNDAkjyW8Bbq7mHCOH2sXun46gcm_7IKYZF9vfiLN1V-oXop",
            "widthPx": 4080,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Steve Nieckarz",
                "uri": "https://maps.google.com/maps/contrib/114335760205284857179",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWMeP4G6FcP6URxBv28WEXHEvBgXbYJ6sd4ugZWQ88GA6u0nwg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPzsftgRfQ-vtbrQsakWClLBHU6x7KOWWgPxk5Y&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPzsftgRfQ-vtbrQsakWClLBHU6x7KOWWgPxk5Y!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          },
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWoZKtJ7E1e81vLGmnc1alQZag-wqd2gV0_69TqG1BQV_70q1gOHiFgPIrRJU4p1DcdgZ0GKbl83_BZBCOQpYs4XX8owdSNFhZK6Cefk5IEdQJ-96S36sPoyWoN33IO8Ih-Fiir9iE0po1___3inHbEdoK_Utr_XtlTp",
            "widthPx": 4096,
            "heightPx": 3072,
            "authorAttributions": [
              {
                "displayName": "Bruce Johnson",
                "uri": "https://maps.google.com/maps/contrib/110259458177978635508",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVFpQy1uJU5Sdxh7F4egsfyvjsH9VySnzIdLIUeSIdOUiglFwoqWQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNP6UyUIjE4C80zsrtFIJNzpb9LP5QZjwq8EIyg&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNP6UyUIjE4C80zsrtFIJNzpb9LP5QZjwq8EIyg!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          },
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWp3mYrLFCT6DINgBETFLTIRJM0t5lt9WVec2nwAgP4WxhB025zDc0TceYBhQ0BU4NEbp6hWN80yGOvpMHYbCUWeErcvYBUJPMsujgim_fdGg1jZpI2Lbt0ztK0gmbkTTQONepqnznF43iQ6-J_rzsHkyRZLNrOnWoeV",
            "widthPx": 4080,
            "heightPx": 3060,
            "authorAttributions": [
              {
                "displayName": "Jesus Chavez",
                "uri": "https://maps.google.com/maps/contrib/112928977537557850998",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWxfEf-JHTSfROMTjYJnju0Ji0mcU0Gbfm1_RxdncZ7R9SoLbowhQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNjictxDkZnDSSSZGC8f7khEPhG-3hQp3cOqCS0&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNjictxDkZnDSSSZGC8f7khEPhG-3hQp3cOqCS0!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          },
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWp7UW9Ar9C7wqsSh-otlAK1F1510_DO7-FwlTa7R-Xb4YZtCBeb66ymVCpp_o_tAC0yHqxUlMofS-nrMOMwy2-UCPwBPzB-UsS-fE7MjSR7KIAS7VZDxwB09EL05Iu8fLf6Xv3GBOLu-3JOy7AOl3APeOBrYS5bn55O",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Natalia Regan",
                "uri": "https://maps.google.com/maps/contrib/102914248206222783230",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWRtj5LdMujcO9oQORDOIhl9I2SxoVBma6HNClv1kzisD9FeYBlxA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMUDaAoFzXiHHRoNr70l4p0I-O-piXepVAwXu96&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMUDaAoFzXiHHRoNr70l4p0I-O-piXepVAwXu96!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          },
          {
            "name": "places/ChIJc08qw1UrDogRVCCFCLQ-9yE/photos/AdDdOWoutB6q40hec6hIx3a89ltzeWAnRL3xadSqPGe0Y8Ug0T8RtgyWrQm_QmeJw8WmhQinizRMgAzibeqCMtfCATw60OMclbrzVsas5rqvathy92e7y7nP37JpqROf9_tUEZyk53evFU7GhA0jown8zpu1v1V3C827r1HB",
            "widthPx": 4096,
            "heightPx": 2304,
            "authorAttributions": [
              {
                "displayName": "Bruce Johnson",
                "uri": "https://maps.google.com/maps/contrib/110259458177978635508",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjVFpQy1uJU5Sdxh7F4egsfyvjsH9VySnzIdLIUeSIdOUiglFwoqWQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPwWYcsIHC6VzU7q7CQvFpeAU4hohCNFJ7_1jSA&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPwWYcsIHC6VzU7q7CQvFpeAU4hohCNFJ7_1jSA!2e10!4m2!3m1!1s0x880e2b55c32a4f73:0x21f73eb408852054"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "30"
          },
          "endPrice": {
            "currencyCode": "USD",
            "units": "50"
          }
        }
      },
      {
        "id": "ChIJt-RpZbEsDogRdKrEm0eT-74",
        "types": [
          "night_club",
          "sports_club",
          "point_of_interest",
          "establishment"
        ],
        "formattedAddress": "111 W Hubbard St 3rd floor, Chicago, IL 60654, USA",
        "location": {
          "latitude": 41.8897818,
          "longitude": -87.6316126
        },
        "rating": 3.6,
        "businessStatus": "OPERATIONAL",
        "userRatingCount": 119,
        "displayName": {
          "text": "DISCO",
          "languageCode": "en"
        },
        "photos": [
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWrug70MtYVow9U5bKJlsHUw04X7DWmxE4kz1q_E7Re_AZmZfudeX6X4_gkwnsNR4MOka0kQaLFHaoVtyrDdOtg_-7-SrRpgj64TrRTVtRnlhKRz4vtw4JQPJmdwhFoaMjgIdiXs_lrsnYqmI491EHZ2vLa19XW3M86H",
            "widthPx": 4800,
            "heightPx": 3200,
            "authorAttributions": [
              {
                "displayName": "DISCO",
                "uri": "https://maps.google.com/maps/contrib/103786824401429393567",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUWgN4ntnntAid7HYJP64nFWOTSYRXPMw3DkjnoShWcObGdJIw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPW__e_HP3h9PovaIigfQOtpVGj7JtMhGZWLZE3&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPW__e_HP3h9PovaIigfQOtpVGj7JtMhGZWLZE3!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          },
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWpYkzSGQvpJXYgbD2yGZN8u_yYZUrUBXEgiky09qH1OMxIbHeOOOqRAyDbBVzus_VbxQHG5_AqM0ZQkFLBDHKX4MLOTohPdvvfoCzU52yPaJHg76f7jik8LZ7mo5yMM9gikR5Mj9VF9QvwWcpfpPSP2nUNAChg55rkV",
            "widthPx": 1868,
            "heightPx": 4000,
            "authorAttributions": [
              {
                "displayName": "Derrick",
                "uri": "https://maps.google.com/maps/contrib/105705700495991837961",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWIuuVlrqGIYMJ76ztiJ3XM6Xi8tIItJjW9EHbmJncke2h9CCdzFg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNsbW73mcylK3-a8wpVIsqx5loZkfFps2U0B8YS&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNsbW73mcylK3-a8wpVIsqx5loZkfFps2U0B8YS!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          },
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWonWb3_GF37u5_paADC8CsoVyJGN07z_E69qBLuUKHGth0v6wEeitxCZnZsFJcSbstdmOOkNPcXf4pN5TbuZWJwojUkXkcAoe21JSMmwrLt2oeMybPyS1BwSgvrMEsyZIoO2_5iOG-g2WJ1wNdkj0DD7Qi8OmjK00R1",
            "widthPx": 3024,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Ramakanth K V",
                "uri": "https://maps.google.com/maps/contrib/101040877408843461425",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocLfaENbxvdVZGPfb6NgwNor7i2FrCf5eehoTDH09OsnD7WeJg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMRuAsEUZqkyCOm_aBjrtXPV4Jjwlt1iDBkz-nW&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMRuAsEUZqkyCOm_aBjrtXPV4Jjwlt1iDBkz-nW!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          },
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWo320D-LlcqQAHTcoqThcFQNSGwvJQaOx6U5ckIYpiiThJgfIrFtrhSZvNuEshL58vJDP4yXJlLqc77E-xNh62q63MwHM3eo01y7ikcoZ0ohI7Bh9DbhTPnfbvdDHew4vzs8tn15zRE2eI732KsevotNXq6LqM5Xe11",
            "widthPx": 4032,
            "heightPx": 2268,
            "authorAttributions": [
              {
                "displayName": "Mathieu Coquelet Ruiz",
                "uri": "https://maps.google.com/maps/contrib/104738410362682257701",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXmoGuEM_6zLSBbWMKQx1XrbZdY03L4AwhngXjEt7QsZpxX5XowMA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOc0eigRzOdpVguh8YyQdQYb_ijWQ6FCXF8mbCn&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOc0eigRzOdpVguh8YyQdQYb_ijWQ6FCXF8mbCn!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          },
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWq7SAzuFkV1dGsiYDKilnWUrXHHCAN2rDDGr6ekR9Z-ldTpCbMmkvHbx6DvpaLSywLWPJ_DXR-_5GUb2yxBepCdFNvE9bEaAVkUvnzO2KW47c-eQwAGPm573_e4ydV953bGPT3vWw9nLcr7RJcJEhlzVl8tQHmoauIz",
            "widthPx": 750,
            "heightPx": 487,
            "authorAttributions": [
              {
                "displayName": "Samantha Morrison",
                "uri": "https://maps.google.com/maps/contrib/100160848246234108857",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIdO0XW4xJlK-syledEQDlSUffHbwK1vd0EuDm8icBA4N50zQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipP79Y4gjj8djfeoWk19-t9Y72QqYGQ4_2U0k903&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipP79Y4gjj8djfeoWk19-t9Y72QqYGQ4_2U0k903!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          },
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWp2N3qEH_uaez-4XmGLtBjW5rKu_DlYR886UqphImSHJoYCXi4NmgIHAWFTpvQKEPSwr5TXVYYju-oVcr2xWRY4ZL-k87o895-wVo-hCvXXJ11lXd9Qid0NiciuIM9J7_ssM7JM4TXc-_4ama4XQ133qw9QWFiICxq8",
            "widthPx": 2670,
            "heightPx": 1780,
            "authorAttributions": [
              {
                "displayName": "DISCO",
                "uri": "https://maps.google.com/maps/contrib/103786824401429393567",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUWgN4ntnntAid7HYJP64nFWOTSYRXPMw3DkjnoShWcObGdJIw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipNvucvfJdPRlkCKTkJDFNIXN5LB-Id33H5_NwCh&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipNvucvfJdPRlkCKTkJDFNIXN5LB-Id33H5_NwCh!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          },
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWrUInuq8hs2SoH0pkXKfy2YoteEPNCJarPJjoSD4rM_2fsFAlP5K8pbw2vOMgd-P7IM9IICkGw_VRqjq4r_Oyjk0eFfcgcjFRckXA8MxgoPS6BYcsVlTLPe2urihnBvvzP_X-I1PMnVazOaDfa2bVIOj85QHOdDU0rs",
            "widthPx": 4000,
            "heightPx": 1868,
            "authorAttributions": [
              {
                "displayName": "Derrick",
                "uri": "https://maps.google.com/maps/contrib/105705700495991837961",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjWIuuVlrqGIYMJ76ztiJ3XM6Xi8tIItJjW9EHbmJncke2h9CCdzFg=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipOxiiYYwDS2Hw6Tv7IQZ3p2EFdEIELWC1bkdyNE&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipOxiiYYwDS2Hw6Tv7IQZ3p2EFdEIELWC1bkdyNE!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          },
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWpfV2jcpPA2yOy5BFTJ_49bJTNzjocjqqxPp1QpqyA0Z-XmyahajXKYEXuj8VrdOVP_tWhKNDaM7biZl-Y6FiDu7ZiHllrfKbF55pY0DHRYF4DTdERbVSGdyB3C4nBwiPCOc-WQNlVOjjiJnukool06ozPkYfTaQRJh",
            "widthPx": 3685,
            "heightPx": 2457,
            "authorAttributions": [
              {
                "displayName": "DISCO",
                "uri": "https://maps.google.com/maps/contrib/103786824401429393567",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjUWgN4ntnntAid7HYJP64nFWOTSYRXPMw3DkjnoShWcObGdJIw=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipMXSbTLsgTpexBOYDKN9HOjyin40qnGTczF18-D&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipMXSbTLsgTpexBOYDKN9HOjyin40qnGTczF18-D!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          },
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWoqQOznTbVdlVIgzcNzXZ9szQ3ZL2MTOlI8gZIehmLkIlcf-ekIYfmKAD4Yg_Gh_-0rRvsAGG25HQxRlspGAhWQYC9uaGQO0hzhzO2wbgod56fYhlmZxcP167PLwrYjMzwd15r44F7zZgrmA47Pm9woYeLClmPrV9Zd",
            "widthPx": 1200,
            "heightPx": 801,
            "authorAttributions": [
              {
                "displayName": "Samantha Morrison",
                "uri": "https://maps.google.com/maps/contrib/100160848246234108857",
                "photoUri": "https://lh3.googleusercontent.com/a/ACg8ocIdO0XW4xJlK-syledEQDlSUffHbwK1vd0EuDm8icBA4N50zQ=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipPj7PDmmzpxxxzzXz6Ygf4cRdb-Y7zYKdsgpFKM&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipPj7PDmmzpxxxzzXz6Ygf4cRdb-Y7zYKdsgpFKM!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          },
          {
            "name": "places/ChIJt-RpZbEsDogRdKrEm0eT-74/photos/AdDdOWpd9_2VV78M_G3DIY2dDktdjARD1WjRn27dhM8vjwdCLwnJbnPwZmDqSfGU1ypoLOTtp0itCs6jHlWCit-Ucj88h8b_DatiqK_-Ela9_e8P86MkADCWyGgALn7I3FDpkW-Cmf0AJpaErX-OU_A2QIwulv6hz9GaUxa6",
            "widthPx": 2268,
            "heightPx": 4032,
            "authorAttributions": [
              {
                "displayName": "Mathieu Coquelet Ruiz",
                "uri": "https://maps.google.com/maps/contrib/104738410362682257701",
                "photoUri": "https://lh3.googleusercontent.com/a-/ALV-UjXmoGuEM_6zLSBbWMKQx1XrbZdY03L4AwhngXjEt7QsZpxX5XowMA=s100-p-k-no-mo"
              }
            ],
            "flagContentUri": "https://www.google.com/local/imagery/report/?cb_client=maps_api_places.places_api&image_key=!1e10!2sAF1QipObCkI9w4P81dehNfsF8tNXeO-T6fH30dm9r5xU&hl=en-US",
            "googleMapsUri": "https://www.google.com/maps/place//data=!3m4!1e2!3m2!1sAF1QipObCkI9w4P81dehNfsF8tNXeO-T6fH30dm9r5xU!2e10!4m2!3m1!1s0x880e2cb16569e4b7:0xbefb93479bc4aa74"
          }
        ],
        "restroom": true,
        "accessibilityOptions": {
          "wheelchairAccessibleEntrance": true,
          "wheelchairAccessibleRestroom": true,
          "wheelchairAccessibleSeating": true
        },
        "priceRange": {
          "startPrice": {
            "currencyCode": "USD",
            "units": "100"
          }
        }
      }
    ]
  }
]